// ==========================================
// FRÉQUENCES D'ABONNEMENT
// ==========================================
// Recharge stocke une fréquence + une unité ('day' | 'week' | 'month'). Le portail
// ne propose que des semaines, mais les abonnements créés au checkout peuvent être
// en jours (« 28 jours ») ou en mois. Traiter la fréquence sans son unité transforme
// « 28 jours » en « 28 semaines » — d'où ces deux helpers, partagés entre les blocs
// DOMContentLoaded qui n'ont pas de scope commun.
function intervalInDays(frequency, unit) {
    const freq = parseInt(frequency, 10);
    if (!freq) return null;
    // 'month' est approximé à 30 jours : sert uniquement à comparer des rythmes,
    // jamais à calculer une date (voir addInterval, qui utilise setMonth).
    const perUnit = { day: 1, week: 7, month: 30 };
    return freq * (perUnit[unit] || perUnit.week);
}

function addInterval(date, frequency, unit) {
    // parseInt obligatoire : `setMonth(getMonth() + '4')` concatène au lieu d'additionner.
    const freq = parseInt(frequency, 10);
    const result = new Date(date);
    if (!freq) return result;
    if (unit === 'month') {
        result.setMonth(result.getMonth() + freq);
    } else {
        result.setDate(result.getDate() + freq * (unit === 'day' ? 1 : 7));
    }
    return result;
}

// ==========================================
// MODAL FRÉQUENCE : MODE MODIFICATION / CRÉATION
// ==========================================
// `#frequency-modal` sert aux deux flux. Seul le titre change en JS ; les boutons de
// validation sont masqués en création par la classe .mode-creation (voir
// recharge-subscription.css).
// Top-level parce que les deux blocs DOMContentLoaded concernés n'ont pas de scope
// commun : celui du flux modification remet le mode à false, celui de la création le
// passe à true.
function setFrequencyModalMode(isCreation) {
    const modal = document.getElementById('frequency-modal');
    if (!modal) return;

    modal.classList.toggle('mode-creation', !!isCreation);

    const title = modal.querySelector('.modal-title');
    if (title) {
        title.textContent = isCreation
            ? 'Choisissez la fréquence de livraison'
            : 'Modifier ma fréquence';
    }
}

// ==========================================
// VARIABLES GLOBALES POUR LES MODALS
// ==========================================
window.subscriptionCreationContext = {
    selectedProduct: null,
    selectedFrequency: null,
    isCreatingNewSubscription: false
};

window.PortalNavigation = {
    initialized: false,

    init() {
        if (this.initialized) {
            console.log('[Navigation] Déjà initialisée, skip');
            return;
        }

        console.log('[Navigation] Initialisation...');

        const navButtons = document.querySelectorAll('.nav-button');
        const tabPanels = document.querySelectorAll('.tab-panel');
        const cardLinks = document.querySelectorAll('[data-link-tab]');

        console.log('[Navigation] Boutons trouvés:', navButtons.length);
        console.log('[Navigation] Panneaux trouvés:', tabPanels.length);

        // Fonction de changement de panneau
        this.switchTab = (tabName) => {
            console.log('[Navigation] Changement vers:', tabName);

            // Retirer active de tous les boutons
            navButtons.forEach(btn => {
                btn.classList.remove('active');
                if (btn.getAttribute('data-tab') === tabName) {
                    btn.classList.add('active');
                }
            });

            // Cacher tous les panneaux, afficher le bon
            tabPanels.forEach(panel => {
                panel.classList.remove('active');
                if (panel.getAttribute('data-panel') === tabName) {
                    panel.classList.add('active');
                }
            });

            // Si on passe sur l'onglet Historique, générer l'historique des commandes
            if (tabName === 'historique' && window.rechargePortal) {
                console.log('[Navigation] Génération de l\'historique...');
                window.rechargePortal.renderOrdersHistory();
            }

            // Si on passe sur l'onglet Mes animaux, charger + afficher les animaux
            if (tabName === 'animaux' && window.rechargePortal) {
                console.log('[Navigation] Ouverture de l\'onglet Mes animaux...');
                window.rechargePortal.openPetsTab();
            }

            // Mettre à jour l'URL
            const url = new URL(window.location);
            url.searchParams.set('tab', tabName);
            window.history.replaceState({}, '', url);
        };

        // Attacher les événements (UNE SEULE FOIS)
        navButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                const tabName = button.getAttribute('data-tab');
                if (tabName) {
                    this.switchTab(tabName);
                }
            });
        });

        // Gérer les liens dans les cartes
        cardLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const tabName = link.getAttribute('data-link-tab');
                if (tabName) {
                    this.switchTab(tabName);
                }
            });
        });

        // Vérifier l'URL au chargement - tab par défaut: abonnement
        const urlParams = new URLSearchParams(window.location.search);
        const tabParam = urlParams.get('tab') || 'abonnement';
        this.switchTab(tabParam);

        this.initialized = true;
        console.log('[Navigation] ✅ Initialisée avec succès');

        // Exposer globalement pour usage externe
        window.switchTab = this.switchTab.bind(this);
    }
};

// ==========================================
// DONNÉES SHOPIFY (VRAIES DONNÉES NON MASQUÉES)
// ==========================================
// NOTE: L'injection de window.shopifyCustomerData est maintenant faite
// dans le template (templates/page.portal.liquid) car {{ customer }}
// n'est pas disponible dans les sections.
// Le code ci-dessous utilise window.shopifyCustomerData si disponible.

// ==========================================
// CLASSE RECHARGE PORTAL (NE TOUCHE PLUS À LA NAVIGATION)
// ==========================================

class RechargePortal {
    constructor() {
        this.initialized = false;
        this.subscription = null;
        this.subscriptions = []; // NOUVEAU: Toutes les subscriptions
        this.activeSubscriptions = []; // NOUVEAU: Seulement les subscriptions actives
        // Annulations de lignes d'abonnement déjà envoyées à Recharge mais pas encore
        // reflétées dans activeSubscriptions (rafraîchi seulement après l'aller-retour API).
        // Sans ce suivi, deux clics rapides sur deux corbeilles voient tous les deux
        // « il reste 2 lignes » et vident l'abonnement en contournant le désabonnement.
        this._cancelsInFlight = new Set();
        this.customer = null;
        this.apiToken = null;
        this.customerId = null;
        this.customerEmail = null;

        // ÉTAT EXPLICITE DU PORTAIL
        // dataState : 'loading' | 'ok' | 'shopify-only' | 'session-expired' | 'load-error'
        // loadResults : résultat de chaque loader ('ok' | 'error' | 'auth') pour
        // distinguer "l'API a échoué" de "l'API a répondu vide" — sans ça, une
        // panne réseau s'affichait comme "abonnement désactivé".
        this.dataState = 'loading';
        this.loadResults = {};
        this.paymentIssue = false;
        this._initStarted = false;
        this._stateResolved = false;
        this._watchdogTimer = null;

        // Forfait de livraison historique (clients migrés de l'ancien site,
        // 5,90€ sur le palier standard). L'appartenance est une donnée
        // SERVER-SIDE : le portail ne fait que la refléter pour afficher le bon
        // prix. `false` par défaut = grille normale, comportement historique.
        this.legacyFlatShipping = false;
        this._shippingProfileLoaded = false;

        this.init();
    }

    async init() {
        console.log('[RechargePortal] Initialisation...');

        // Garde anti double-init : le batch d'appels API ne doit JAMAIS partir deux fois
        if (this._initStarted) {
            console.warn('[RechargePortal] ⚠️ init() déjà lancé, appel ignoré');
            return;
        }
        this._initStarted = true;

        // Watchdog : si aucun état terminal après 25s, afficher l'écran d'erreur.
        // Ne relance RIEN (aucune requête) : bascule uniquement l'UI.
        this._watchdogTimer = setTimeout(() => {
            if (!this._stateResolved) {
                console.error('[RechargePortal] ⏱️ Watchdog 25s : chargement bloqué, affichage écran erreur');
                this.setPortalState('load-error');
            }
        }, 25000);

        try {
            console.time('[RechargePortal] Temps de chargement total');

            // Attendre que Recharge SDK soit prêt
            await this.waitForRecharge();

            // Restaurer la session depuis sessionStorage si nécessaire
            await this.restoreSessionFromStorage();

            // 🔍 SI CLIENT SHOPIFY-ONLY, ARRÊTER ICI
            if (this.isShopifyOnly === true) {
                console.log('[RechargePortal] ✅ Client Shopify-only détecté, affichage du message');
                await this.updateUI(); // Afficher le message Shopify-only
                this.setPortalState('shopify-only');
                return; // Arrêter l'initialisation
            }

            // 🚫 SI SESSION SOFT (client Recharge sans token d'écriture), BLOQUER ICI.
            // Aucun chargement de données : on n'affiche jamais le dashboard dégradé.
            if (this.isSoftSession === true) {
                console.log('[RechargePortal] 🚫 Session soft détectée → écran de blocage');
                this.setPortalState('soft-session');
                return;
            }

            // TOUT charger en parallèle. Seules dépendances réelles :
            // - loadCustomer utilise this.addresses (fallback nom/email)
            // - loadOnetimes a besoin de addresses[0].id
            // → elles s'enchaînent derrière loadAddresses, tout le reste part
            // immédiatement (gain : un étage réseau complet vs l'ancien
            // enchaînement addresses → customer → batch).
            // Animaux : nécessaires à l'onglet abonnement (chips "Pour : Rex"), donc
            // chargés dès maintenant — mais SANS être attendus. La majorité des
            // clients n'a encore aucun animal, et rien à l'écran ne dépend de cette
            // réponse : la mettre dans le Promise.all ci-dessous ferait dépendre
            // l'affichage de TOUT le portail de la disponibilité du micro-service
            // Vercel (un fetch sans timeout qui traîne = écran d'erreur au bout des
            // 25 s du watchdog, pour un client qui n'a même pas de fiche animal).
            // Les chips apparaissent au retour, via un re-render ciblé.
            this.loadPets().then(() => {
                if (this.petChipsEnabled()) this.renderSubscriptionProducts();
            });

            console.time('[RechargePortal] Chargement données parallèle');
            await Promise.all([
                this.loadAddresses().then(() => Promise.all([
                    this.loadCustomer(),
                    this.loadOnetimes(),
                    // Forfait historique : nécessaire AVANT l'ouverture du modal
                    // de livraison, sinon le client y verrait la grille normale.
                    // Timeout propre + échec silencieux : ne peut pas bloquer
                    // l'init (cf. loadShippingProfile).
                    this.loadShippingProfile()
                ])),
                this.loadSubscriptions(),
                this.loadOrders(),
                this.loadNextCharge(),
                this.loadErrorCharges()
            ]);
            console.timeEnd('[RechargePortal] Chargement données parallèle');

            // Détection d'un problème de paiement (carte invalide/expirée) :
            // une charge en erreur OU un abonnement actif sans aucune échéance
            // planifiée (symptôme d'un prélèvement bloqué côté Recharge).
            this.computePaymentIssue();

            // RÉSOLUTION DE L'ÉTAT DU PORTAIL à partir des résultats des loaders.
            // États d'erreur = écran dédié, on n'affiche PAS le dashboard
            // (sinon un échec API s'affiche comme "abonnement désactivé").
            const resolvedState = this.resolvePortalState();
            if (resolvedState === 'session-expired' || resolvedState === 'load-error') {
                console.error(`[RechargePortal] ❌ État terminal: ${resolvedState}`);
                this.setPortalState(resolvedState);
                console.timeEnd('[RechargePortal] Temps de chargement total');
                return;
            }

            // Si l'utilisateur est déjà sur l'onglet Historique (clic avant la fin
            // du chargement), re-render maintenant que this.orders est disponible
            const activePanel = document.querySelector('.tab-panel.active');
            if (activePanel?.getAttribute('data-panel') === 'historique') {
                console.log('[RechargePortal] Onglet historique déjà actif, re-render des commandes');
                this.renderOrdersHistory();
            }

            // Mettre à jour l'interface avec les données
            await this.updateUI();

            // La recommandation dépend ENTIÈREMENT du catalogue Shopify, chargé en
            // parallèle par portal-catalog-bootstrap. Les deux courses n'ont aucun
            // ordre garanti : si le catalogue arrive après ce premier rendu, le bloc
            // resterait vide jusqu'à la prochaine mutation de la box. On le repasse
            // une fois, sans attendre — non bloquant, et sans effet s'il était déjà là.
            //
            // Les puces « Ce produit est pour : » ont le même besoin depuis que
            // productSpecies() se replie sur le catalogue : une ligne rendue
            // avant son arrivée proposerait encore les deux espèces. On ne
            // repasse que si des lignes sont DÉJÀ à l'écran et que les chips
            // sont actives — sinon le rendu normal s'en chargera, et un rendu
            // anticipé afficherait une liste de produits vide.
            if (window.portalCatalogReady?.then) {
                window.portalCatalogReady
                    .then(() => {
                        const lines = (this.activeSubscriptions || []).length
                            + (this.onetimes || []).length;
                        // renderSubscriptionProducts() repasse la reco lui-même :
                        // l'appeler en plus la rendrait deux fois.
                        if (lines && this.petChipsEnabled()) this.renderSubscriptionProducts();
                        else this.renderRecommendation();
                    })
                    .catch(err => console.warn('[Reco] Catalogue indisponible:', err));
            }

            // Contrôles shipping post-chargement :
            //  - relais dont le prix est périmé (seuil 19 kg franchi depuis le
            //    choix, ex. via un ajout de produits une session précédente) ;
            //  - mode relais écrit mais aucun point relais choisi (picker fermé).
            await this.autoRepriceStalePickup();
            this.warnIfPickupWithoutRelay();
            // Miroir client vs catalogue serveur : maintenant que la charge est
            // chargée, les deux sont comparables.
            this.warnIfShippingMirrorDrifted(this._shippingProfileRaw);

            // VÉRIFIER SI LE CLIENT DOIT CRÉER UN MOT DE PASSE SHOPIFY
            // Les clients créés via Recharge OTP n'ont pas de mot de passe Shopify
            // On les redirige vers /account/recover pour en créer un
            const shouldCreatePassword = sessionStorage.getItem('recharge_should_create_password');
            if (shouldCreatePassword === 'true') {
                console.log('[RechargePortal] 🔐 Client OTP détecté, création de mot de passe requise');
                const customerEmail = this.customer?.email;
                if (customerEmail) {
                    console.log('[RechargePortal] → Redirection vers /account/recover avec email:', customerEmail);
                    sessionStorage.removeItem('recharge_should_create_password');
                    window.location.href = `/account/recover?email=${encodeURIComponent(customerEmail)}`;
                    return;
                }
            }

            // ⚠️ MODIFICATION : Ne plus cacher le panneau "Gérer mon abonnement" pour les clients désabonnés
            // On garde les onglets visibles pour permettre aux clients de se réabonner
            if (this.activeSubscriptions.length === 0 && this.onetimes.length === 0) {
                console.log('[RechargePortal] ⚠️ Aucun abonnement actif ni produit one-time détecté');
                console.log('[RechargePortal] ✅ Mais on garde "Gérer mon abonnement" visible pour permettre le réabonnement');

                // ❌ NE PLUS MASQUER les onglets "Abonnement" et "Facturation"
                // Commenté pour permettre aux clients de créer un nouvel abonnement
                // this.hideSubscriptionTabs();

                // Activer automatiquement l'onglet "Historique"
                // ❌ DÉSACTIVÉ : On ne force plus l'affichage de l'historique
                // if (window.PortalNavigation) {
                //     window.PortalNavigation.switchTab('historique');
                // }

                // Continuer l'initialisation normalement
                // Le client désabonné pourra quand même accéder à "Gérer mon abonnement"
                // et ajouter des produits en abonnement pour se réabonner
            }

            console.log('[RechargePortal] ✅ Initialisation du portail (tous les onglets disponibles)');

            // Attacher les événements pour les actions Recharge
            this.bindEvents();

            this.initialized = true;
            this.setPortalState('ok');
            console.timeEnd('[RechargePortal] Temps de chargement total');
            console.log('[RechargePortal] ✅ Initialisation complète');
        } catch (error) {
            console.error('[RechargePortal] ❌ Erreur initialisation:', error);
            // Erreur inattendue (SDK absent, exception hors loaders...) :
            // écran d'erreur avec bouton Réessayer, jamais de retry automatique.
            this.setPortalState('load-error');
        }
    }

    // ==========================================
    // MACHINE À ÉTATS DU PORTAIL
    // ==========================================

    // Classifie une erreur de loader : 'auth' (session expirée/invalide) ou 'error'.
    // La forme des erreurs du SDK Recharge n'est pas garantie → vérification
    // défensive du status HTTP puis du message.
    classifyError(error) {
        const status = error?.status || error?.statusCode || error?.response?.status;
        if (status === 401 || status === 403) return 'auth';
        const msg = String(error?.message || '').toLowerCase();
        if (/unauthorized|forbidden|not authenticated|invalid[^a-z]*token|token[^a-z]*invalid|token[^a-z]*expired|expired[^a-z]*token|no api token/.test(msg)) {
            return 'auth';
        }
        return 'error';
    }

    // Calcule l'état terminal à partir de this.loadResults.
    // Règle clé : "désactivé" exige une preuve positive (API OK + 0 abonnement).
    // Un échec API ne doit JAMAIS être présenté comme un désabonnement.
    resolvePortalState() {
        const critical = ['addresses', 'customer', 'subscriptions'];
        if (critical.some(k => this.loadResults[k] === 'auth')) {
            return 'session-expired';
        }
        if (this.loadResults.subscriptions === 'error') {
            return 'load-error';
        }
        // Les échecs non critiques (orders, onetimes, nextCharge) n'empêchent pas
        // l'affichage : le dashboard rend ce qu'il a, champs manquants en fallback.
        return 'ok';
    }

    // SEUL point d'entrée pour basculer l'UI d'état (overlay, écrans d'erreur).
    // Ne déclenche aucune requête réseau.
    setPortalState(state) {
        console.log(`[RechargePortal] 🎛️ setPortalState: ${this.dataState} → ${state}`);
        this.dataState = state;
        this._stateResolved = state !== 'loading';

        if (this._watchdogTimer && this._stateResolved) {
            clearTimeout(this._watchdogTimer);
            this._watchdogTimer = null;
        }

        const overlay = document.getElementById('portal-status-overlay');
        if (!overlay) {
            console.warn('[RechargePortal] ⚠️ #portal-status-overlay introuvable');
            return;
        }

        const showDashboard = state === 'ok' || state === 'shopify-only';
        overlay.hidden = showDashboard;
        overlay.querySelectorAll('.portal-status').forEach(el => {
            el.hidden = el.getAttribute('data-status') !== state;
        });

        // Session expirée : purger les tokens UNE fois, la reconnexion
        // n'a lieu que sur clic utilisateur (pas de redirection auto → pas de boucle).
        if (state === 'session-expired') {
            sessionStorage.removeItem('recharge_api_token');
            sessionStorage.removeItem('recharge_customer_id');
            sessionStorage.removeItem('recharge_customer_email');
        }

        this.updatePaymentIssueBanner();
    }

    // Bandeau rouge "moyen de paiement invalide" : visible uniquement si le
    // dashboard est affiché ET qu'un problème de paiement est détecté.
    updatePaymentIssueBanner() {
        const banner = document.getElementById('payment-issue-banner');
        if (!banner) return;
        banner.hidden = !(this.dataState === 'ok' && this.paymentIssue === true);
    }

    // Pré-vérification LOCALE avant une action d'écriture (0 requête réseau) :
    // refuse l'action et affiche l'écran de reconnexion si le token a disparu
    // (purgé par un autre onglet, précédent état session-expired...).
    // L'expiration côté serveur n'est PAS vérifiée ici : elle est détectée par
    // handleAuthError() sur la réponse de l'action elle-même — l'action sert de
    // validation, jamais de requête dédiée.
    requireSession() {
        const hasToken = !!(this.session?.apiToken) && !!sessionStorage.getItem('recharge_api_token');
        if (!hasToken) {
            console.warn('[RechargePortal] 🔒 Action bloquée : session absente → reconnexion requise');
            this.setPortalState('session-expired');
        }
        return hasToken;
    }

    // À appeler en tête des catch d'actions : retourne true si l'erreur est une
    // erreur d'auth (token expiré/invalide) et bascule alors sur l'écran de
    // reconnexion — au lieu du toast générique "Veuillez réessayer", mensonger
    // avec une session morte (un retry ne peut jamais réussir).
    handleAuthError(error) {
        if (this.classifyError(error) !== 'auth') return false;
        console.warn('[RechargePortal] 🔒 Session expirée détectée pendant une action');
        this.setPortalState('session-expired');
        return true;
    }


    waitForRecharge() {
        return new Promise((resolve, reject) => {
            if (window.recharge) {
                console.log('[RechargePortal] SDK Recharge détecté');
                resolve();
            } else {
                console.log('[RechargePortal] En attente du SDK Recharge...');
                let attempts = 0;
                const checkRecharge = setInterval(() => {
                    attempts++;
                    if (window.recharge) {
                        clearInterval(checkRecharge);
                        console.log('[RechargePortal] SDK Recharge prêt');
                        resolve();
                    } else if (attempts > 30) {
                        clearInterval(checkRecharge);
                        reject(new Error('SDK Recharge non disponible après 30 secondes'));
                    }
                }, 1000);
            }
        });
    }

    async restoreSessionFromStorage() {
        console.log('[RechargePortal] 🔍 Vérification session...');

        try {
            // Vérifier si on a déjà un token stocké dans sessionStorage
            let storedToken = sessionStorage.getItem('recharge_api_token');
            let storedCustomerId = sessionStorage.getItem('recharge_customer_id');
            let storedEmail = sessionStorage.getItem('recharge_customer_email');

            // 🔍 DÉTECTION DE CONFLIT DE SESSION
            // PRIORITÉ À LA SESSION RECHARGE si elle existe
            if (storedToken && storedEmail && window.shopifyCustomerData && window.shopifyCustomerData.email) {
                const shopifyEmail = window.shopifyCustomerData.email.toLowerCase();
                const rechargeEmail = storedEmail.toLowerCase();

                if (shopifyEmail !== rechargeEmail) {
                    console.warn('[RechargePortal] ⚠️ Conflit détecté !');
                    console.warn('[RechargePortal] → Session Recharge (priorité):', rechargeEmail);
                    console.warn('[RechargePortal] → Session Shopify (ignorée):', shopifyEmail);
                    console.warn('[RechargePortal] → La session Recharge sera utilisée');
                    // On continue avec la session Recharge, on ignore window.shopifyCustomerData
                }
            }

            let apiToken, customerId, customerEmail;

            if (storedToken && storedCustomerId) {
                // On a déjà un token stocké, on le réutilise
                console.log('[RechargePortal] 💾 Token trouvé dans sessionStorage');
                apiToken = storedToken;
                customerId = parseInt(storedCustomerId);
                customerEmail = storedEmail;
            } else {
                // Pas de token stocké, on fait le login
                console.log('[RechargePortal] 🔐 Login via App Proxy...');

                // Attendre un peu si on vient juste de se connecter
                const loginTime = sessionStorage.getItem('recharge_login_time');
                const justLoggedIn = loginTime && (Date.now() - parseInt(loginTime)) < 5000;
                if (justLoggedIn) {
                    console.log('[RechargePortal] ⏰ Connexion récente, attente de 2 secondes...');
                    await new Promise(resolve => setTimeout(resolve, 2000));
                }

                const loginResult = await window.recharge.auth.loginShopifyAppProxy();
                console.log('[RechargePortal] Login result:', loginResult);

                apiToken = loginResult.apiToken;
                customerId = loginResult.customerId;
                customerEmail = storedEmail || '';

                // Vérifier si customerId est null (client Shopify sans Recharge)
                if (!customerId || customerId === null) {
                    console.warn('[RechargePortal] ⚠️ customerId est null → Client Shopify sans abonnement Recharge');
                    throw new Error('No Recharge customer ID - Shopify-only customer');
                }

                // 🚫 SESSION SOFT SUR UN CLIENT RECHARGE
                // loginShopifyAppProxy ne délivre JAMAIS un token d'écriture : PII masquée
                // + toute modification renvoie 403. On atteint cette branche uniquement
                // sans token stocké (login OTP → token HARD dans sessionStorage → branche
                // cache-hit). Donc customerId non-null ici = client Recharge en session soft.
                // On NE stocke PAS ce token et on bloque proprement (écran 'soft-session'),
                // plutôt que d'afficher un dashboard dégradé (nom en ***, boutons morts).
                this.isSoftSession = true;
                console.warn('[RechargePortal] 🚫 Session soft (App Proxy) sur client Recharge → blocage');
                return;
            }

            // FORCER la session SDK (solution au problème "No API token defined on session")
            console.log('[RechargePortal] 🔧 Configuration de la session SDK...');

            // SOLUTION RADICALE : Réinitialiser le SDK avec le token
            // Le SDK a été initialisé dans theme.liquid SANS token, il faut le réinitialiser
            console.log('[RechargePortal] 🔄 Réinitialisation du SDK avec token...');

            try {
                await window.recharge.init({
                    storeIdentifier: window.RECHARGE_CONFIG.shopDomain,
                    storefrontAccessToken: 'strfnt_4b3137bebd60c5ac919b04e0440e73c879494b989459fd8914411eb099159d0e',
                    appName: 'pettywell-portal',
                    appVersion: '1.0.0',
                    useDirectApi: true,
                    sessionStorage: true,
                    session: {
                        apiToken: apiToken,
                        customerId: customerId
                    }
                });
                console.log('[RechargePortal] ✅ SDK réinitialisé avec session');
            } catch (reinitError) {
                console.warn('[RechargePortal] ⚠️ Réinit échouée, forçage manuel:', reinitError.message);

                // Fallback : Forçage manuel si la réinit échoue
                if (!window.recharge.session) {
                    window.recharge.session = {};
                }
                window.recharge.session.apiToken = apiToken;
                window.recharge.session.customerId = customerId;
                window.recharge._apiToken = apiToken;
                window.recharge._customerId = customerId;
            }

            this.customerId = customerId;
            this.customerEmail = customerEmail;
            this.apiToken = apiToken;

            // CRITIQUE : Stocker l'objet session pour le passer aux méthodes SDK
            this.session = {
                apiToken: apiToken,
                customerId: customerId
            };

            console.log('[RechargePortal] ✅ Session SDK configurée:', {
                hasSession: !!this.session,
                tokenLength: this.session.apiToken?.length,
                customerId: this.session.customerId
            });

            // Tester que tout fonctionne (non-bloquant)
            console.log('[RechargePortal] 🧪 Test de l\'API...');
            try {
                // PASSER LA SESSION EN PREMIER ARGUMENT (c'est la clé!)
                const testSubs = await window.recharge.subscription.listSubscriptions(this.session, { limit: 1 });
                console.log('[RechargePortal] ✅ API opérationnelle! Subscriptions:', testSubs.subscriptions?.length || 0);
            } catch (testError) {
                console.error('[RechargePortal] ⚠️ Test échoué (mais on continue):', testError.message);
                console.error('[RechargePortal] Détails:', testError);
                // Ne pas throw - on continue quand même
            }

        } catch (error) {
            console.error('[RechargePortal] ❌ Erreur critique lors de la restauration de session:', error);

            // Nettoyer le cache si ça a échoué
            sessionStorage.removeItem('recharge_api_token');
            sessionStorage.removeItem('recharge_customer_id');
            sessionStorage.removeItem('recharge_customer_email');

            // 🔍 DÉTECTION CLIENT SHOPIFY-ONLY
            // Si l'utilisateur est connecté à Shopify mais n'a pas d'abonnement Recharge
            if (window.shopifyCustomerData && window.shopifyCustomerData.email) {
                console.warn('[RechargePortal] ⚠️ Client Shopify sans abonnement Recharge détecté');
                console.warn('[RechargePortal] → Email:', window.shopifyCustomerData.email);
                console.warn('[RechargePortal] → Affichage dashboard Shopify-only...');

                // Créer un objet client basique avec les données Shopify
                this.customer = {
                    id: window.shopifyCustomerData.id,
                    email: window.shopifyCustomerData.email,
                    first_name: window.shopifyCustomerData.firstName,
                    last_name: window.shopifyCustomerData.lastName
                };

                // Marquer comme client Shopify-only (pas d'abonnement)
                this.isShopifyOnly = true;

                console.log('[RechargePortal] ✅ Client Shopify-only configuré:', this.customer);
                return; // Sortir sans erreur
            }

            // Si pas connecté du tout, rediriger vers login
            console.log('[RechargePortal] → Pas de session Shopify non plus. Redirection vers login...');
            sessionStorage.setItem('recharge_return_url', window.location.pathname);
            window.location.href = '/pages/recharge-login';
        }
    }


    async loadCustomer() {
        console.log('[RechargePortal] Chargement client...');
        this.loadResults.customer = 'ok'; // optimiste, écrasé en cas d'erreur
        try {
            // PRIORITÉ 1 : Utiliser la ressource Customer de Recharge API
            // C'est LA source correcte pour les données client (pas addresses)
            console.log('[RechargePortal] 🔍 Tentative customer.getCustomer()...');
            try {
                const customerResponse = await window.recharge.customer.getCustomer(this.session);
                console.log('[RechargePortal] 📦 Réponse reçue:', customerResponse);

                if (customerResponse && customerResponse.customer) {
                    this.customer = customerResponse.customer;
                    console.log('[RechargePortal] ✅ Client chargé via customer.getCustomer():', this.customer);

                    // Vérifier si les données sont masquées
                    if (this.customer.first_name && this.customer.first_name.includes('*')) {
                        console.warn('[RechargePortal] ⚠️ Données client MASQUÉES par flag PII Recharge');
                        console.warn('[RechargePortal] → Vérifie l\'option "Redact customer data" dans Recharge Settings');
                        console.warn('[RechargePortal] → Ou contacte support@rechargeapps.com pour désactiver le flag');
                    } else {
                        console.log('[RechargePortal] ✅ Données client NON MASQUÉES !');
                    }
                    return;
                } else {
                    console.warn('[RechargePortal] ⚠️ customer.getCustomer() retourne null ou customerResponse.customer manquant');
                    console.log('[RechargePortal] → customerResponse:', customerResponse);
                    console.log('[RechargePortal] → Fallback sur addresses...');
                }
            } catch (customerError) {
                console.error('[RechargePortal] ❌ customer.getCustomer() a levé une exception:', customerError);
                console.error('[RechargePortal] → Message:', customerError.message);
                console.error('[RechargePortal] → Stack:', customerError.stack);
                // NB : pas de marquage 'auth' ici — getCustomer() échoue parfois
                // pour des raisons de scope même avec une session valide (d'où le
                // fallback addresses). Une vraie session morte sera détectée par
                // les loaders addresses/subscriptions.
                console.log('[RechargePortal] → Fallback sur addresses...');
            }

            // PRIORITÉ 2 : Fallback sur addresses (TOUJOURS masquées côté Storefront)
            if (this.addresses && this.addresses.length > 0 && this.addresses[0].first_name) {
                // Pour l'email, déterminer la source prioritaire
                let email = this.addresses[0].email; // Email de l'adresse Recharge (peut être masqué)

                // PRIORITÉ 1 : Email de la session Recharge (OTP login)
                // Si l'utilisateur s'est connecté via OTP, cet email est le bon
                if (this.customerEmail && this.customerEmail !== '') {
                    email = this.customerEmail;
                    console.log('[RechargePortal] ✅ Utilisation email session Recharge (OTP):', email);
                }
                // PRIORITÉ 2 : Email Shopify (si pas de session Recharge)
                else if (window.shopifyCustomerData && window.shopifyCustomerData.email) {
                    email = window.shopifyCustomerData.email;
                    console.log('[RechargePortal] ✅ Utilisation email Shopify (non masqué):', email);
                }
                // PRIORITÉ 3 : Email Recharge non masqué
                else if (this.addresses[0].email && !this.addresses[0].email.includes('*')) {
                    email = this.addresses[0].email;
                    console.log('[RechargePortal] ✅ Utilisation email Recharge:', email);
                }
                // FALLBACK : Email masqué
                else {
                    console.warn('[RechargePortal] ⚠️ Email masqué, utilisation sessionStorage si disponible');
                    email = this.customerEmail || this.addresses[0].email;
                }

                this.customer = {
                    id: this.addresses[0].customer_id,
                    first_name: this.addresses[0].first_name,
                    last_name: this.addresses[0].last_name,
                    email: email
                };
                console.log('[RechargePortal] ✅ Client chargé via addresses:', this.customer);
                console.warn('[RechargePortal] ⚠️ Les addresses sont masquées par design Recharge Storefront');
                return;
            }

            // PRIORITÉ 3 : Fallback sur les orders
            console.log('[RechargePortal] → Fallback sur orders...');
            const ordersResponse = await window.recharge.order.listOrders(this.session, { limit: 1 });
            if (ordersResponse.orders && ordersResponse.orders[0] && ordersResponse.orders[0].customer) {
                this.customer = ordersResponse.orders[0].customer;
                console.log('[RechargePortal] ✅ Client chargé via orders:', this.customer);
            } else {
                this.customer = null;
                console.log('[RechargePortal] ⚠️ Aucune commande trouvée pour charger les infos client');
            }
        } catch (error) {
            console.error('[RechargePortal] ❌ Erreur chargement client:', error);
            console.error('[RechargePortal] Détails:', error.message);
            this.customer = null;
            this.loadResults.customer = this.classifyError(error);
        }
    }

    async loadSubscriptions() {
        console.log('[RechargePortal] 📦 Chargement subscriptions...');

        // FORCER le customerId avant l'appel (au cas où un autre script l'aurait écrasé)
        if (!this.session.customerId) {
            const storedCustomerId = sessionStorage.getItem('recharge_customer_id');
            if (storedCustomerId) {
                console.log('[RechargePortal] ⚠️ customerId manquant, restauration depuis sessionStorage:', storedCustomerId);
                this.session.customerId = parseInt(storedCustomerId);
                this.customerId = parseInt(storedCustomerId);
            }
        }

        try {
            // CRITIQUE : Passer this.session en premier argument
            const response = await window.recharge.subscription.listSubscriptions(this.session, { limit: 50, sort_by: 'id-asc' });

            // Stocker TOUTES les subscriptions
            this.subscriptions = response.subscriptions || [];

            // Filtrer uniquement les subscriptions ACTIVES
            this.activeSubscriptions = this.subscriptions.filter(sub => sub.status === 'active' || sub.status === 'ACTIVE');

            // Garder la première subscription active pour la compatibilité avec le code existant
            this.subscription = this.activeSubscriptions[0] || null;

            this.loadResults.subscriptions = 'ok';
            console.log('[RechargePortal] ✅ Total abonnements:', this.subscriptions.length);
            console.log('[RechargePortal] ✅ Abonnements actifs:', this.activeSubscriptions.length);
            console.log('[RechargePortal] ✅ Abonnement principal:', this.subscription);
        } catch (error) {
            console.error('[RechargePortal] ❌ Erreur chargement abonnements:', error);
            console.error('[RechargePortal] Détails:', error.message);
            this.subscription = null;
            this.subscriptions = [];
            this.activeSubscriptions = [];
            this.loadResults.subscriptions = this.classifyError(error);
        }
    }

    // Retourne toutes les subscriptions actives du MÊME abonnement (même address_id)
    // Un abonnement = plusieurs subscriptions Recharge (une par produit) partageant address_id.
    // Permet d'appliquer fréquence/date à TOUTES les lignes, pas seulement la première.
    getCurrentAbonnementSubs() {
        if (!this.subscription) return [];
        const subs = this.activeSubscriptions || [];
        const addressId = this.subscription.address_id;
        const sameAddress = subs.filter(s => s.address_id === addressId);
        return sameAddress.length > 0 ? sameAddress : [this.subscription];
    }

    // Après un échec d'écriture : relire Recharge et réafficher. Un lot a pu passer
    // avant l'erreur (au-delà de 20 produits, ou si Recharge applique partiellement),
    // et le client doit voir l'état réel, pas celui d'avant sa tentative.
    // N'échoue jamais : on est déjà dans un chemin d'erreur.
    async refreshAfterFailedWrite() {
        try {
            await this.loadSubscriptions();
            this.updateSubscriptionData();
        } catch (e) {
            console.warn('[RechargePortal] Relecture après échec impossible:', e);
        }
    }

    // Limite Recharge par appel groupé (le SDK accepte 21 par erreur de borne).
    static BULK_UPDATE_LIMIT = 20;

    // Applique les mêmes champs à toutes les subscriptions d'un abonnement, en un
    // appel groupé par tranche de 20 au lieu d'un appel par produit.
    //
    // Au-delà de la vitesse, c'est surtout plus sûr : avec la boucle, un échec au
    // 2e produit laissait le 1er à la nouvelle date et les autres à l'ancienne,
    // soit deux prélèvements et deux colis.
    //
    // `commit: true` est indispensable : sans lui (défaut du SDK), Recharge met à
    // jour les subscriptions sans régénérer tout de suite le prélèvement en attente.
    // Vérifié sur un abonnement de 5 produits (septembre 2026) : un appel, un seul
    // prélèvement à la bonne date avec les 5 produits, et un changement de
    // fréquence qui ne déplace pas la date — comme l'appel unitaire.
    static async updateSubscriptionsBulk(session, subs, fields) {
        if (!subs || subs.length === 0) return;
        const addressId = subs[0].address_id;
        // Cas quasi inexistant (20 produits distincts), mais le seul où l'écriture
        // redevient multiple : si un lot échoue après un autre, l'abonnement peut
        // se retrouver sur deux dates. Trace pour le support.
        if (subs.length > RechargePortal.BULK_UPDATE_LIMIT) {
            console.warn(
                `[RechargePortal] ⚠️ ${subs.length} produits sur l'adresse ${addressId} : `
                + `mise à jour en ${Math.ceil(subs.length / RechargePortal.BULK_UPDATE_LIMIT)} lots de `
                + `${RechargePortal.BULK_UPDATE_LIMIT}, sans garantie tout-ou-rien entre les lots.`
            );
        }
        for (let i = 0; i < subs.length; i += RechargePortal.BULK_UPDATE_LIMIT) {
            const batch = subs
                .slice(i, i + RechargePortal.BULK_UPDATE_LIMIT)
                .map(sub => ({ id: sub.id, ...fields }));
            await window.recharge.subscription.updateSubscriptions(session, addressId, batch, { commit: true });
        }
    }

    // ==========================================
    // DATES : livraison (ce que le client choisit) ↔ prélèvement (ce que Recharge sait)
    // ==========================================
    //
    // Le client raisonne en date de LIVRAISON. Recharge ne connaît qu'une date de
    // prélèvement (next_charge_scheduled_at). Les deux constantes ci-dessous ne
    // sont pas la même chose et ne doivent jamais être confondues :
    //
    //   CHARGE_OFFSET_DAYS  : ce qu'on retranche pour ÉCRIRE next_charge_scheduled_at
    //   DISPLAY_OFFSET_DAYS : le jour où le client voit RÉELLEMENT le débit, celui
    //                         qu'on lui annonce (« prélevée le … »)
    //
    // Le jour d'écart entre les deux est mesuré, pas supposé. Le batch Recharge
    // traite les charges à 3 h du matin (heure de Paris) le LENDEMAIN de la date
    // planifiée — 1534 charges récurrentes observées sur 90 jours, cf. la section
    // « Mesure du décalage de prélèvement » de PLAN_DELIVERY_DATE.md. Une charge
    // planifiée au 15 est donc débitée le 16, et le client vit bien un prélèvement
    // 3 jours avant sa livraison du 19, alors qu'on a écrit 4 jours avant.
    static CHARGE_OFFSET_DAYS = 4;
    static DISPLAY_OFFSET_DAYS = 3;

    // Parse 'YYYY-MM-DD' (ou un ISO complet) en Date locale à minuit.
    // On ne passe JAMAIS par `new Date(iso)` sur une date nue : le moteur
    // l'interprète en UTC et la France se retrouve la veille.
    static parseLocalDate(value) {
        if (!value) return null;
        const [y, m, d] = String(value).split('T')[0].split('-').map(Number);
        if (!y || !m || !d) return null;
        return new Date(y, m - 1, d);
    }

    // Format attendu par l'API Recharge. Construit à partir des composants LOCAUX :
    // toISOString() convertirait minuit local en UTC et renverrait la veille.
    static formatYMD(date) {
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${date.getFullYear()}-${m}-${d}`;
    }

    static addDays(date, days) {
        const out = new Date(date.getTime());
        out.setDate(out.getDate() + days);
        return out;
    }

    // Pas de livraison le dimanche : on glisse au lundi.
    static skipSunday(date) {
        return date.getDay() === 0 ? RechargePortal.addDays(date, 1) : date;
    }

    // Prélèvement Recharge → date de livraison à afficher.
    static chargeToDelivery(chargeDateStr) {
        const charge = RechargePortal.parseLocalDate(chargeDateStr);
        if (!charge) return null;
        return RechargePortal.skipSunday(RechargePortal.addDays(charge, RechargePortal.CHARGE_OFFSET_DAYS));
    }

    // Date de livraison choisie → prélèvement à écrire dans Recharge.
    //
    // ⚠️ SEUL endroit où l'offset est retranché. L'appliquer une seconde fois
    // ferait reculer la date de 4 jours à chaque enregistrement : un client qui
    // ouvre le modal et valide sans rien changer verrait sa livraison avancer.
    static deliveryToCharge(deliveryDate) {
        return RechargePortal.formatYMD(
            RechargePortal.addDays(deliveryDate, -RechargePortal.CHARGE_OFFSET_DAYS)
        );
    }

    // Première date de livraison sélectionnable : le prélèvement correspondant
    // doit tomber demain au plus tôt, jamais dans le passé.
    static minSelectableDelivery() {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        return RechargePortal.skipSunday(
            RechargePortal.addDays(today, 1 + RechargePortal.CHARGE_OFFSET_DAYS)
        );
    }

    static MAX_DELAY_MONTHS = 4;

    // Dernière date de livraison sélectionnable : aujourd'hui + 4 mois. Compté
    // depuis aujourd'hui, pas depuis la livraison en cours : sinon un client
    // pourrait repousser de 4 mois, rouvrir, et repousser encore indéfiniment.
    // Jour borné à la fin du mois cible (31 oct. → 28/29 févr., pas 3 mars).
    static maxSelectableDelivery() {
        const now = new Date();
        const y = now.getFullYear();
        const m = now.getMonth() + RechargePortal.MAX_DELAY_MONTHS;
        const lastDayOfTarget = new Date(y, m + 1, 0).getDate();
        return new Date(y, m, Math.min(now.getDate(), lastDayOfTarget));
    }

    static formatLongDate(date, withYear = false) {
        return date.toLocaleDateString('fr-FR', {
            weekday: 'long', day: 'numeric', month: 'long',
            ...(withYear ? { year: 'numeric' } : {})
        });
    }

    // Date de livraison à partir d'une date de PRÉLÈVEMENT Recharge.
    // Point d'entrée pour tout ce qui lit next_charge_scheduled_at sans passer
    // par le calendrier (card abonnement, one-times).
    //
    // Une fourchette J-1 / J+1 était affichée à côté de cette date. Retirée : la
    // date seule, annoncée comme estimation, dit la même chose sans donner trois
    // dates à retenir pour un seul colis.
    estimatedDeliveryDate(chargeDateStr) {
        const delivery = RechargePortal.chargeToDelivery(chargeDateStr);
        return delivery ? RechargePortal.formatLongDate(delivery) : null;
    }

    async loadOrders() {
        console.log('[RechargePortal] Chargement commandes...');
        try {
            // CRITIQUE : Passer this.session en premier argument
            // Note : sort_by n'est pas supporté par listOrders, retirer ce paramètre
            const response = await window.recharge.order.listOrders(this.session, { limit: 10 });
            this.orders = response.orders || [];
            this.loadResults.orders = 'ok';
            console.log('[RechargePortal] ✅ Commandes chargées:', this.orders);
        } catch (error) {
            console.error('[RechargePortal] ❌ Erreur chargement commandes:', error);
            console.error('[RechargePortal] Détails:', error.message);
            this.orders = [];
            this.loadResults.orders = this.classifyError(error);
        } finally {
            // Marqueur pour distinguer "pas encore chargé" de "aucune commande"
            this.ordersLoaded = true;
        }
    }

    async loadNextCharge() {
        console.log('[RechargePortal] 📦 Chargement prochaine charge (pour remises)...');
        try {
            const response = await window.recharge.charge.listCharges(this.session, {
                status: 'queued',
                limit: 1
            });
            this.nextCharge = (response.charges && response.charges[0]) || null;
            this.loadResults.nextCharge = 'ok';
            if (this.nextCharge) {
                console.log('[RechargePortal] ✅ Prochaine charge:', this.nextCharge.id);
                if (this.nextCharge.discounts && this.nextCharge.discounts.length > 0) {
                    console.log('[RechargePortal] 🏷️ Remises détectées:', this.nextCharge.discounts);
                    console.log('[RechargePortal] 🏷️ Total remises:', this.nextCharge.total_discounts);
                } else {
                    console.log('[RechargePortal] Aucune remise sur la prochaine charge');
                }
            } else {
                console.log('[RechargePortal] Aucune charge à venir trouvée');
            }
        } catch (error) {
            console.error('[RechargePortal] ❌ Erreur chargement prochaine charge:', error);
            this.nextCharge = null;
            this.loadResults.nextCharge = this.classifyError(error);
        }
    }

    // Charges en erreur = paiement refusé/bloqué. Une requête par chargement de
    // page (deux au maximum si le filtre status est rejeté par le SDK — fallback
    // unique, jamais de retry en boucle).
    async loadErrorCharges() {
        console.log('[RechargePortal] 📦 Vérification charges en erreur (santé paiement)...');
        try {
            const response = await window.recharge.charge.listCharges(this.session, {
                status: 'error',
                limit: 1
            });
            this.errorCharges = response.charges || [];
            this.loadResults.errorCharges = 'ok';
        } catch (error) {
            console.warn('[RechargePortal] ⚠️ Filtre status=error refusé, fallback scan:', error.message);
            try {
                const response = await window.recharge.charge.listCharges(this.session, { limit: 5 });
                this.errorCharges = (response.charges || [])
                    .filter(c => String(c.status).toLowerCase() === 'error');
                this.loadResults.errorCharges = 'ok';
            } catch (fallbackError) {
                console.error('[RechargePortal] ❌ Erreur chargement charges en erreur:', fallbackError);
                this.errorCharges = [];
                this.loadResults.errorCharges = this.classifyError(fallbackError);
            }
        }
        console.log('[RechargePortal] Charges en erreur trouvées:', (this.errorCharges || []).length);
    }

    // Détermine this.paymentIssue à partir des données déjà chargées (0 requête).
    // Pré-requis : un abonnement ACTIF — une vieille charge en erreur ne doit pas
    // afficher "box bloquée" à un client désabonné.
    // Signal 1 : au moins une charge en statut error (paiement refusé).
    // Signal 2 : aucune date planifiée ni charge en file d'attente — exactement
    //            le symptôme observé quand la carte est bloquée.
    computePaymentIssue() {
        const hasActiveSub = !!(
            this.subscription
            && String(this.subscription.status).toLowerCase() === 'active'
        );
        const hasErrorCharge = (this.errorCharges || []).length > 0;
        const noSchedule = hasActiveSub
            && !this.subscription.next_charge_scheduled_at
            && !this.nextCharge;

        this.paymentIssue = hasActiveSub && (hasErrorCharge || noSchedule);

        if (this.paymentIssue) {
            console.warn('[RechargePortal] 💳 Problème de paiement détecté:', {
                hasErrorCharge,
                noSchedule
            });
        } else {
            console.log('[RechargePortal] 💳 Paiement OK (aucun signal d\'anomalie)');
        }
    }

    // Endpoint backend qui écrit la shipping_line Manual (le SDK storefront ne
    // peut PAS écrire de shipping_line). Projet Vercel dédié : dossier
    // vercel-set-shipping/ — si le projet est déployé sous un autre nom,
    // mettre à jour cette URL.
    static SET_SHIPPING_API_URL = 'https://pettywell-set-shipping.vercel.app/api/set-shipping';

    // Même projet Vercel, en LECTURE : renvoie le menu réellement applicable au
    // client (dont son éventuel forfait historique), qu'un miroir statique ne
    // peut pas connaître.
    static SHIPPING_OPTIONS_API_URL = 'https://pettywell-set-shipping.vercel.app/api/shipping-options';

    // Anciennes factures Chargebee (pré-migration Recharge), matchées par
    // email côté serveur. Projet Vercel dédié : dossier vercel-chargebee-invoices/
    // — si déployé sous un autre nom, mettre à jour cette URL.
    static CHARGEBEE_INVOICES_API_URL = 'https://vercel-chargebee-invoices.vercel.app/api/chargebee-invoices';

    // Miroir CLIENT du catalogue de vercel-set-shipping/lib/shipping.js —
    // AFFICHAGE UNIQUEMENT (liste du modal). Le prix/titre réellement écrits
    // sont re-dérivés server-side par set-shipping (zip + poids de la charge).
    // À garder synchronisé avec lib/shipping.js.
    static SHIPPING_HEAVY_THRESHOLD_GRAMS = 19000; // >= 19 kg -> relais en 2 colis
    // `label` = affichage plein (mode actuel, option unique île) ;
    // `carrier` + `delay` = affichage dans les boutons du modal à deux niveaux.
    static SHIPPING_OPTIONS = [
        { type: 'pickup', label: 'Point relais (3-4 jours)', carrier: 'Point relais', delay: '3-4 jours', price: 2.90, priceHeavy: 5.80, heavyNote: 'Expédition en 2 colis (commande de 19 kg ou plus)', serverTitle: 'Point relais (choix du point relais après le paiement)' },
        { type: 'home_dpd', label: 'À domicile - DPD (1 à 3 jours)', carrier: 'DPD', delay: '1 à 3 jours', price: 4.90, serverTitle: 'A domicile (DPD)' },
        { type: 'home_gls', label: 'À domicile - GLS (1 à 3 jours)', carrier: 'GLS', delay: '1 à 3 jours', price: 5.90, serverTitle: 'A domicile (GLS)' },
        { type: 'home_colissimo', label: 'À domicile - Colissimo (1 à 3 jours)', carrier: 'Colissimo', delay: '1 à 3 jours', price: 6.90, serverTitle: 'A domicile (Colissimo)' },
        { type: 'express', label: 'Express - TNT (1 à 2 jours)', carrier: 'Express TNT', delay: '1 à 2 jours', price: 7.90, serverTitle: 'Express (TNT)' },
    ];
    // Miroir de LEGACY_PRICE (lib/shipping.js) : forfait historique des clients
    // migrés de l'ancien site. Ne redéfinit que le palier standard — Colissimo
    // et Express restent à la grille normale, donc absents de cette table.
    // Le relais y est insensible au poids : pas de palier 19 kg.
    static SHIPPING_LEGACY_PRICE = { pickup: 5.90, home_dpd: 5.90, home_gls: 5.90 };
    // Corse (20000-20999) + îles desservies uniquement par Colissimo domicile.
    static SHIPPING_ISLAND_ZIPS = new Set([
        17111, 17123, 17190, 17310, 17370, 17410, 17480, 17550, 17580, 17590,
        17630, 17650, 17670, 17740, 17840, 17880, 17940, 22870, 29242, 29253,
        29259, 29980, 29990, 56360, 56590, 56780, 56840, 85350,
    ]);

    static isCityOnIsland(zip) {
        // Code postal FR = 5 chiffres ; tolère espaces / préfixes ("2A 20090").
        const m = String(zip ?? '').match(/\d{5}/);
        if (!m) return false;
        const z = parseInt(m[0], 10);
        if (z >= 20000 && z <= 20999) return true; // Corse
        return RechargePortal.SHIPPING_ISLAND_ZIPS.has(z);
    }

    // Adresse Recharge = point relais ? (le relais VIT dans l'adresse : company /
    // address2 posés par le widget Chronopost). Sert à la visibilité du bouton
    // "Choisir un point relais" ET au flux domicile (relais -> domicile impose la
    // saisie de la vraie adresse, sinon le colis "domicile" partirait au relais).
    // Un code relais entre parenthèses en fin de libellé : "POINT PRESSE
    // E.LECLERC LE CANNET (3213V)", "Tabac le refuge (7243V)". Les clients
    // pré-migration n'ont QUE cette forme — ni "Chronopost" ni "Point Relais"
    // dans leur adresse — et restaient donc invisibles à cette détection : le
    // portail les traitait comme des domiciles et effaçait leur relais.
    static RELAY_CODE_RE = /\(\s*\d{3,6}[A-Z]\s*\)/i;

    // Libellé du relais pour le CLIENT : le code technique ("(7243V)") ne lui
    // parle pas et alourdit l'affichage. Il reste écrit tel quel dans Recharge —
    // c'est le transporteur qui en a besoin, pas le lecteur.
    static displayCompany(company) {
        if (!company) return '';
        return String(company).replace(RechargePortal.RELAY_CODE_RE, '').replace(/\s{2,}/g, ' ').trim();
    }

    static isRelayAddress(address) {
        if (!address) return false;
        const marks = (v) => !!v && (
            v.includes('Chronopost') ||
            v.includes('Point Relais') ||
            v.includes('Point relais') ||
            RechargePortal.RELAY_CODE_RE.test(v)
        );
        return marks(address.company) || marks(address.address2);
    }

    // Poids (grams) de la prochaine commande, depuis la charge queued déjà
    // chargée (grams × quantity). 0 si charge absente ou grams non renseignés
    // -> tarif relais léger affiché (le serveur recalcule de toute façon).
    getOrderWeightGrams() {
        const items = this.nextCharge?.line_items || [];
        return items.reduce((sum, li) => sum + (Number(li.grams) || 0) * (Number(li.quantity) || 1), 0);
    }

    // Adresse "effective" servant au calcul des options : l'adresse enregistrée
    // chez Recharge, éventuellement RECOUVERTE par une saisie en attente de
    // confirmation (`window.pendingAddress`). Une modification d'adresse n'est
    // écrite qu'au clic sur "Mettre à jour" du modal de livraison ; entre-temps
    // les options doivent déjà refléter le nouveau ZIP (île -> Colissimo seul),
    // sans quoi le client confirmerait un transporteur calculé sur l'ancienne
    // adresse.
    getEffectiveAddress() {
        const saved = this.addresses?.[0] || null;
        const pending = window.pendingAddress?.address || null;
        if (!pending) return saved;
        return { ...(saved || {}), ...pending };
    }

    // Options affichables dans le modal pour l'adresse effective :
    //   île  -> Colissimo domicile uniquement (6,90€), forfait historique inclus
    //   sinon -> les 5 options, prix du relais selon le poids (2,90€ / 5,80€),
    //            ou 5,90€ sur le palier standard pour un client legacy.
    //
    // Reste SYNCHRONE : appelée au rendu du modal, et doit pouvoir tarifer une
    // adresse SAISIE mais pas encore enregistrée (le serveur ne la connaît pas).
    // D'où le miroir local, aligné sur le profil chargé par loadShippingProfile().
    getShippingOptionsForDisplay() {
        const zip = this.getEffectiveAddress()?.zip;
        const heavy = this.getOrderWeightGrams() >= RechargePortal.SHIPPING_HEAVY_THRESHOLD_GRAMS;
        const all = RechargePortal.SHIPPING_OPTIONS;
        if (RechargePortal.isCityOnIsland(zip)) {
            // Colissimo n'est pas dans la grille legacy : 6,90€ pour tout le monde.
            return all.filter(o => o.type === 'home_colissimo').map(o => ({ ...o, note: 'Seule option disponible pour votre adresse (île)' }));
        }
        return all.map(o => {
            const legacyPrice = this.legacyFlatShipping
                ? RechargePortal.SHIPPING_LEGACY_PRICE[o.type]
                : undefined;
            // Le forfait couvre le relais quel que soit le poids : le prix ne
            // bouge pas, mais la mention "2 colis" reste vraie et doit rester
            // affichée — elle décrit le colis, pas le tarif.
            if (legacyPrice != null) {
                return (o.type === 'pickup' && heavy)
                    ? { ...o, price: legacyPrice, note: o.heavyNote }
                    : { ...o, price: legacyPrice };
            }
            return (o.type === 'pickup' && heavy)
                ? { ...o, price: o.priceHeavy, note: o.heavyNote }
                : { ...o };
        });
    }

    // Profil de livraison server-side : le portail ne peut pas deviner qu'un
    // client bénéficie du forfait historique (la liste vit côté serveur). Sans
    // cet appel, le modal annoncerait 2,90€ là où l'écriture pose 5,90€.
    //
    // Non bloquant pour le portail : timeout court, et tout échec retombe sur la
    // grille normale (comportement historique). Le flag est ensuite reconfirmé à
    // chaque écriture via la réponse de set-shipping.
    async loadShippingProfile() {
        if (this.isShopifyOnly === true) return;
        if (!this.apiToken || !this.customerId) return;

        const ctrl = new AbortController();
        const timer = setTimeout(() => ctrl.abort(), 8000);
        try {
            const url = new URL(RechargePortal.SHIPPING_OPTIONS_API_URL);
            url.searchParams.set('recharge_customer_id', this.customerId);
            const addressId = this.addresses?.[0]?.id;
            if (addressId) url.searchParams.set('address_id', addressId);

            const res = await fetch(url, {
                headers: { 'Authorization': `Bearer ${this.apiToken}` },
                signal: ctrl.signal,
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();

            this.legacyFlatShipping = data.legacy === true;
            this._shippingProfileLoaded = true;
            // Conservé pour le contrôle de dérive, joué plus tard : ici la
            // charge queued n'est pas encore forcément chargée, donc les poids
            // ne seraient pas comparables.
            this._shippingProfileRaw = data;
            if (this.legacyFlatShipping) {
                console.log('[Shipping] Forfait historique actif (5,90€ sur le palier standard)');
            }
        } catch (e) {
            // Grille normale par défaut. L'écriture reste correcte de toute
            // façon (le prix est dérivé server-side) : le risque est un prix
            // affiché trop bas, corrigé dès la première écriture.
            console.warn('[Shipping] Profil de livraison indisponible, grille normale affichée:', e.message);
        } finally {
            clearTimeout(timer);
        }
    }

    // Détecteur de dérive du miroir : SHIPPING_OPTIONS / SHIPPING_LEGACY_PRICE
    // sont des copies manuelles de vercel-set-shipping/lib/shipping.js. Si les
    // deux catalogues divergent, le client voit un prix et en paie un autre.
    // On compare ce que le serveur vient de renvoyer à ce que le miroir aurait
    // calculé, et on le crie en console plutôt que de le découvrir en SAV.
    // Comparaison seulement quand le serveur a tarifé la MÊME adresse que nous
    // (pas de saisie en attente, même zip).
    warnIfShippingMirrorDrifted(data) {
        if (window.pendingAddress) return;
        if (!Array.isArray(data?.options)) return;
        if (String(data.zip || '') !== String(this.getEffectiveAddress()?.zip || '')) return;
        if (Number(data.weight_grams) !== this.getOrderWeightGrams()) return;

        const mine = new Map(this.getShippingOptionsForDisplay().map(o => [o.type, o]));
        for (const srv of data.options) {
            const local = mine.get(srv.type);
            if (!local) {
                console.error(`[Shipping] ⚠️ DÉRIVE : option "${srv.type}" servie mais absente du miroir client`);
                continue;
            }
            if (Math.abs(Number(local.price) - Number(srv.price)) >= 0.005) {
                console.error(`[Shipping] ⚠️ DÉRIVE de prix sur "${srv.type}" : miroir ${local.price}€, serveur ${srv.price}€ — resynchroniser SHIPPING_OPTIONS avec lib/shipping.js`);
            }
            if (local.serverTitle !== srv.title) {
                console.error(`[Shipping] ⚠️ DÉRIVE de titre sur "${srv.type}" : miroir "${local.serverTitle}", serveur "${srv.title}"`);
            }
        }
    }

    // Signature "quelles lignes, en quelle quantité" d'une charge et de l'état local.
    // Sert UNIQUEMENT à détecter une charge périmée, jamais à calculer un prix.
    // Les line_items de charge portent purchase_item_id (API 2021-11) ou
    // subscription_id ; si aucun des deux n'est exposé, on retombe sur un
    // comparateur grossier (nombre de lignes + quantité totale), qui suffit à
    // repérer un ajout, une suppression ou un +/-.
    chargeLineSignature() {
        const items = this.nextCharge?.line_items || [];
        const ids = items.map(li => li.purchase_item_id ?? li.subscription_id ?? null);
        if (ids.some(id => id == null)) {
            const totalQty = items.reduce((s, li) => s + (Number(li.quantity) || 1), 0);
            return `coarse:${items.length}:${totalQty}`;
        }
        return items.map((li, i) => `${ids[i]}:${Number(li.quantity) || 1}`).sort().join('|');
    }

    localLineSignature(coarse = false) {
        const lines = [
            ...(this.activeSubscriptions || []),
            ...(this.onetimes || [])
        ];
        if (coarse) {
            const totalQty = lines.reduce((s, l) => s + (Number(l.quantity) || 1), 0);
            return `coarse:${lines.length}:${totalQty}`;
        }
        return lines.map(l => `${l.id}:${Number(l.quantity) || 1}`).sort().join('|');
    }

    // Somme des lignes TELLES QU'AFFICHÉES (prix Recharge de chaque ligne × quantité).
    // C'est le montant que le client peut refaire de tête depuis l'écran ; le
    // récapitulatif doit tomber dessus, sinon il ne veut rien dire.
    localNetSubtotal() {
        const sum = (lines) => lines.reduce(
            (s, l) => s + (parseFloat(l.price) || 0) * (Number(l.quantity) || 1), 0);
        return sum(this.activeSubscriptions || []) + sum(this.onetimes || []);
    }

    // Poids de la commande calculé depuis les LIGNES (catalogue Shopify), et non
    // depuis la charge : pendant un reprice, la charge est justement périmée.
    localOrderWeightGrams() {
        const lines = [...(this.activeSubscriptions || []), ...(this.onetimes || [])];
        return lines.reduce(
            (sum, l) => sum + (this.getVariantGrams(l) || 0) * (Number(l.quantity) || 1), 0);
    }

    // TOTAL calculable sans Recharge ? Uniquement quand il ne reste QUE de
    // l'arithmétique sur les lignes : total = somme des lignes + frais connus.
    // Refusé dès qu'un élément échappe au navigateur :
    //   - un code promo (un % suivrait le sous-total, un montant fixe non, et
    //     l'ordre d'application appartient à Recharge) ;
    //   - de la TVA ;
    //   - des frais inconnus (aucune charge encore vue dans cette session) ;
    //   - un point relais dont le tarif va basculer avec le seuil 19 kg (hors client
    //     legacy, dont le forfait est plat et ne bascule donc jamais).
    // Retourne { total, shipping } ou null (→ « recalcul en cours »).
    localTotalIfSafe() {
        const extras = this._chargeExtras;
        if (!extras) return null;
        if (extras.discounts > 0 || extras.tax > 0) return null;

        const pickupOpt = RechargePortal.SHIPPING_OPTIONS.find(o => o.type === 'pickup');
        // Le forfait legacy est PLAT (SHIPPING_LEGACY_PRICE) : il ne bascule pas au
        // seuil 19 kg, donc le port mémorisé reste valable et il n'y a rien à vérifier.
        // Sans ce garde, la comparaison portait sur la grille actuelle (2,90 / 5,80) et
        // ne pouvait jamais tomber juste face aux 5,90 d'un client legacy : son total
        // restait indéfiniment « en cours de calcul ». Même garde que autoRepriceStalePickup().
        if (!this.legacyFlatShipping && extras.shippingTitle === pickupOpt.serverTitle) {
            const weight = this.localOrderWeightGrams();
            if (!weight) return null; // poids inconnu : on ne parie pas sur le tarif
            const expected = weight >= RechargePortal.SHIPPING_HEAVY_THRESHOLD_GRAMS
                ? pickupOpt.priceHeavy
                : pickupOpt.price;
            if (Math.abs(expected - extras.shipping) > 0.005) return null; // tarif sur le point de changer
        }

        return { total: this.localNetSubtotal() + extras.shipping, shipping: extras.shipping };
    }

    // La charge queued décrit-elle bien l'abonnement tel qu'il est MAINTENANT ?
    // Pendant un reprice, Recharge SUPPRIME puis recrée la charge queued : une
    // lecture tombant dans cette fenêtre n'en trouve aucune. Sans ce cas, le
    // récapitulatif disparaissait derrière « votre prochaine commande n'a pas pu
    // être préparée » alors que tout allait bien.
    chargeReflectsLocalState() {
        const hasActiveLines = (this.activeSubscriptions?.length || 0) > 0
            || (this.onetimes?.length || 0) > 0;
        if (!this.nextCharge) return !hasActiveLines;
        const chargeSig = this.chargeLineSignature();
        return chargeSig === this.localLineSignature(chargeSig.startsWith('coarse:'));
    }

    // À appeler après TOUTE mutation produit (quantité, ajout, suppression) :
    // recharge la charge queued (totaux + poids à jour), re-render, puis corrige
    // le prix du point relais si le franchissement du seuil 19 kg l'a périmé.
    //
    // Recharge reprice la charge de façon ASYNCHRONE (même asynchronie que pour les
    // shipping_lines, cf applyShippingType). Relue dans la foulée d'une mutation,
    // elle porte encore les ANCIENNES lignes. Le récapitulatif mélangeait alors un
    // prix plein recalculé sur les abonnements à jour et un subtotal périmé : la
    // ligne "Remise abonnement" devenait fantaisiste et le TOTAL affiché était celui
    // d'avant la modification. On attend donc que la charge décrive l'état courant,
    // dans une limite de temps bornée, et on n'affiche aucun chiffre en attendant.
    // Nombre de requêtes BORNÉ : au pire CHARGE_SYNC_ATTEMPTS lectures rapprochées
    // puis CHARGE_RECHECK_DELAYS relectures espacées, et une seule synchro vivante à
    // la fois. Les boutons +/- redeviennent cliquables dès le premier rendu : sans le
    // compteur de génération, cinq clics rapides lanceraient cinq boucles en
    // parallèle, qui se disputeraient l'affichage en multipliant les appels. Une
    // mutation plus récente périme la précédente, qui s'arrête immédiatement.
    //
    // L'affichage, lui, n'attend RIEN : il est calculé depuis les lignes dès le
    // premier rendu. Ces lectures ne servent qu'à récupérer frais/promo/TVA à jour.
    async syncChargeAfterMutation() {
        const run = (this._chargeSyncRun = (this._chargeSyncRun || 0) + 1);
        const superseded = () => run !== this._chargeSyncRun;

        // Les relances programmées par la synchro précédente portent sur un état
        // périmé : celle-ci les remplace, et rouvre le droit à des relances.
        clearTimeout(this._chargeRecheckTimer);
        this._chargeRecheckActive = false;
        this._chargeConvergenceGivenUp = false;

        try {
            this._chargeSyncPolling = true;
            this.renderSubscriptionProducts(); // lignes + récap recalculés localement

            for (let attempt = 0; attempt < RechargePortal.CHARGE_SYNC_ATTEMPTS; attempt++) {
                await this.loadNextCharge();
                if (superseded()) return;
                if (this.chargeReflectsLocalState()) break;
                console.log(`[RechargePortal] Charge pas encore repricée (essai ${attempt + 1}) — nouvelle lecture`);
                await new Promise(r => setTimeout(r, RechargePortal.CHARGE_SYNC_DELAY_MS));
                if (superseded()) return;
            }

            // Drapeau maintenu pendant ce rendu : c'est la ligne suivante qui décide
            // des relances, pas le rendu (qui en réclamerait une redondante).
            this.renderSubscriptionProducts();

            if (!this.chargeReflectsLocalState()) {
                // Reprice long (observé : ~30 s). On espace les relectures au lieu
                // d'abandonner : sans elles le client devrait recharger la page pour
                // voir ses frais et son total réapparaître.
                console.warn('[RechargePortal] Charge toujours périmée — relances espacées');
                this.scheduleChargeRecheck([...RechargePortal.CHARGE_RECHECK_DELAYS], run);
                return;
            }

            await this.autoRepriceStalePickup();
        } catch (e) {
            console.warn('[RechargePortal] syncChargeAfterMutation:', e);
            this._chargeSyncPolling = false;
            this.renderSubscriptionProducts();
        } finally {
            // Sortie par superseded() : le drapeau appartient alors à la synchro
            // suivante, qui l'a déjà remis à true. On ne le baisse que si c'est
            // toujours la nôtre qui pilote.
            if (!superseded()) this._chargeSyncPolling = false;
        }
    }

    // Relectures espacées, NOMBRE FIXÉ par le tableau passé en argument : la chaîne se
    // consomme (`rest`), elle ne peut pas se prolonger elle-même. Elle s'arrête à la
    // première charge alignée, à une mutation plus récente, ou à court de délais.
    scheduleChargeRecheck(delays, run) {
        if (!delays.length) {
            // Épuisé : plus aucune relance tant qu'une nouvelle mutation n'a pas lieu.
            // Sans ce drapeau, le rendu suivant en redemanderait une, indéfiniment.
            this._chargeRecheckActive = false;
            this._chargeConvergenceGivenUp = true;
            return;
        }
        const [delay, ...rest] = delays;
        this._chargeRecheckActive = true;
        clearTimeout(this._chargeRecheckTimer);
        this._chargeRecheckTimer = setTimeout(async () => {
            if (run !== this._chargeSyncRun) return;
            await this.loadNextCharge();
            if (run !== this._chargeSyncRun) return;
            this.renderSubscriptionProducts();
            if (this.chargeReflectsLocalState()) {
                this._chargeRecheckActive = false;
                await this.autoRepriceStalePickup();
                return;
            }
            this.scheduleChargeRecheck(rest, run);
        }, delay);
    }

    // Charge périmée constatée à un rendu hors mutation (chargement de page, par
    // exemple) : on relance la convergence, une chaîne à la fois.
    // N'INCRÉMENTE PAS la génération : ce rendu vient souvent de la boucle de synchro
    // elle-même, qu'un incrément ferait s'auto-périmer (elle s'arrêterait au prochain
    // await, remplaçant des lectures rapprochées par des relances à 5 s).
    // Et tant que cette boucle interroge Recharge, une chaîne parallèle ne servirait
    // qu'à doubler les requêtes.
    ensureChargeConvergence() {
        if (this._chargeSyncPolling || this._chargeRecheckActive || this._chargeConvergenceGivenUp) return;
        this.scheduleChargeRecheck([...RechargePortal.CHARGE_RECHECK_DELAYS], this._chargeSyncRun || 0);
    }

    // ~4 s de lectures rapprochées (le cas normal), puis 5 s / 15 s / 30 s : un reprice
    // Recharge peut prendre une trentaine de secondes. Au pire 9 lectures par mutation.
    static CHARGE_SYNC_ATTEMPTS = 6;
    static CHARGE_SYNC_DELAY_MS = 700;
    static CHARGE_RECHECK_DELAYS = [5000, 15000, 30000];

    // Le prix relais est figé dans l'override Manual au moment du choix. Si la
    // commande a depuis franchi le seuil des 19 kg (dans un sens ou l'autre), on
    // réécrit le mode pickup : le serveur rederive le tarif (2,90€ / 5,80€) du
    // poids RÉEL de la charge. Garde-fous :
    //   - ne touche que si le titre est exactement notre rate relais ;
    //   - ne touche que si le prix actuel est l'un de nos deux tarifs connus
    //     (un tarif historique "Retain original" différent n'est JAMAIS réécrit) ;
    //   - poids client à 0/inconnu -> on ne décide rien ;
    //   - un seul appel à la fois, pas de retry en cas d'échec (sera retenté au
    //     prochain rendu/mutation).
    async autoRepriceStalePickup() {
        if (this._repricingPickup) return;
        const line = this.nextCharge?.shipping_lines?.[0];
        if (!line) return;

        // Île : pas de relais du tout — la bascule vers Colissimo est gérée par
        // le guard île (changement d'adresse), pas par le repricing poids (toast
        // "poids" mensonger sinon, le serveur coercerait vers Colissimo).
        if (RechargePortal.isCityOnIsland(this.addresses?.[0]?.zip)) return;

        // Forfait historique : le relais est à 5,90€ quel que soit le poids, il
        // n'y a donc pas de prix "périmé" à recalculer. Sortie explicite — le
        // garde-fou sur les tarifs connus ci-dessous suffirait aujourd'hui, mais
        // par coïncidence (5,90 n'est ni 2,90 ni 5,80), pas par intention.
        if (this.legacyFlatShipping) return;

        const pickupOpt = RechargePortal.SHIPPING_OPTIONS.find(o => o.type === 'pickup');
        if (line.title !== pickupOpt.serverTitle) return;

        const current = parseFloat(line.price);
        if (Number.isNaN(current)) return;
        const near = (a, b) => Math.abs(a - b) < 0.005;
        if (!near(current, pickupOpt.price) && !near(current, pickupOpt.priceHeavy)) return;

        const weight = this.getOrderWeightGrams();
        if (!weight) return; // grams indisponibles côté charge : ne pas décider
        const expected = weight >= RechargePortal.SHIPPING_HEAVY_THRESHOLD_GRAMS
            ? pickupOpt.priceHeavy
            : pickupOpt.price;
        if (near(current, expected)) return;

        this._repricingPickup = true;
        try {
            console.log(`[Shipping] Prix relais périmé (${current}€, attendu ${expected}€ pour ${weight}g) → recalcul server-side`);
            const result = await this.applyShippingType('pickup');
            if (result.ok) {
                showNotification(
                    'ℹ️ Frais de livraison Point relais recalculés selon le poids de votre commande',
                    'success',
                    6000
                );
            } else {
                console.warn('[Shipping] Recalcul relais échoué (pas de retry):', result.error);
            }
        } finally {
            this._repricingPickup = false;
        }
    }

    // Mode "Point relais" écrit mais adresse ≠ relais (picker Chronopost fermé
    // sans choisir) : rappel une fois par session + bouton visible.
    warnIfPickupWithoutRelay() {
        if (this._relayReminderShown) return;
        const pickupOpt = RechargePortal.SHIPPING_OPTIONS.find(o => o.type === 'pickup');
        const title = this.nextCharge?.shipping_lines?.[0]?.title;
        if (title !== pickupOpt.serverTitle) return;
        if (!this.addresses?.length || RechargePortal.isRelayAddress(this.addresses[0])) return;

        this._relayReminderShown = true;
        const btn = document.getElementById('btn-choose-pickup-point');
        if (btn) btn.style.display = 'block';
        showNotification(
            '⚠️ Livraison en point relais sélectionnée, mais aucun point relais choisi. Cliquez sur « Choisir un point relais ».',
            'error',
            8000
        );
    }

    // Applique un mode de livraison (pickup | home_dpd | home_gls |
    // home_colissimo | express) côté Recharge. On n'envoie QUE le type :
    // prix + titre sont dérivés SERVER-SIDE à partir du ZIP et du poids de la
    // charge queued (jamais de prix depuis le navigateur). Sur une île, le
    // serveur force Colissimo domicile quel que soit le type demandé.
    // L'écriture reprice automatiquement la charge queued -> on la relit et on
    // re-render : l'affichage reflète alors la VÉRITÉ Recharge (pas un label posé
    // à la main). Retourne { ok, applied? , error? }.
    async applyShippingType(type, addressId = null) {
        if (this.isShopifyOnly === true) return { ok: false, error: 'shopify_only' };
        if (!this.apiToken || !this.customerId) return { ok: false, error: 'no_session' };

        const targetAddressId = addressId || this.addresses?.[0]?.id || null;
        try {
            const res = await fetch(RechargePortal.SET_SHIPPING_API_URL, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    recharge_customer_id: this.customerId,
                    type,
                    ...(targetAddressId ? { address_id: targetAddressId } : {}),
                }),
            });
            if (!res.ok) {
                const body = await res.text().catch(() => '');
                // 409 weight_unavailable : le serveur a refusé d'écrire un tarif
                // relais sans connaître le poids (jamais de 2,90€ au hasard).
                if (res.status === 409 && body.includes('weight_unavailable')) {
                    console.warn('[Shipping] Poids indisponible côté serveur, écriture refusée');
                    return { ok: false, error: 'weight_unavailable' };
                }
                const err = new Error(`HTTP ${res.status} ${body}`);
                err.status = res.status;
                throw err;
            }
            const data = await res.json();

            // Le serveur reconfirme le forfait à chaque écriture : si le profil
            // n'avait pas pu être chargé à l'init (réseau), le portail se
            // resynchronise ici et les prochains rendus affichent le bon prix.
            if (typeof data.legacy === 'boolean') {
                this.legacyFlatShipping = data.legacy;
                this._shippingProfileLoaded = true;
            }

            // Recharge reprice la charge de façon ASYNCHRONE : une relecture
            // immédiate renvoie souvent l'ancienne shipping_line (symptôme :
            // "il faut changer deux fois pour voir la mise à jour"). La réponse
            // du serveur contient la ligne réellement écrite (vérité) -> on
            // relit, et si la lecture est encore périmée on patche localement
            // puis on programme UNE relecture différée pour converger.
            const appliedLine =
                data.applied?.find(a => String(a.address_id) === String(targetAddressId))?.shipping_line
                || data.applied?.[0]?.shipping_line
                || null;

            await this.loadNextCharge();
            this.reconcileChargeShippingLine(appliedLine);
            this.renderSubscriptionProducts();

            console.log('[Shipping] ✅ Mode appliqué:', type, data.applied);
            return { ok: true, applied: data.applied };
        } catch (e) {
            console.error('[Shipping] ❌ set-shipping échec:', e);
            // Session morte : écran de reconnexion (via handleAuthError), pas de
            // toast "réessayer" mensonger côté appelant.
            if (this.handleAuthError(e)) return { ok: false, error: 'auth' };
            return { ok: false, error: e.message };
        }
    }

    // Onglet Historique : lien "Voir mes factures précédentes" -> anciennes
    // factures Chargebee (avant migration Recharge), matchées par email
    // dérivé server-side du token de session (jamais envoyé par le
    // navigateur, cf. vercel-chargebee-invoices/api/chargebee-invoices.js).
    // Déclenché au clic UNIQUEMENT — jamais au chargement de l'onglet.
    async loadLegacyInvoices(button) {
        // requireSession() (et pas un return muet) : si le token a disparu, le
        // client voit l'écran de reconnexion au lieu d'un bouton sans effet.
        if (!this.requireSession()) return;

        // Verrou + cooldown, calqués sur sendPaymentUpdateEmail() : le bouton
        // est déjà désactivé pendant l'appel, mais rien n'empêche de le
        // recliquer aussitôt la réponse revenue. Pire cas : 1 appel / 10 s.
        if (this._legacyInvoicesInFlight) {
            console.log('[LegacyInvoices] ⏳ Chargement déjà en cours, clic ignoré');
            return;
        }
        if (Date.now() < (this._legacyInvoicesCooldownUntil || 0)) {
            console.log('[LegacyInvoices] 🕐 Cooldown actif, clic ignoré (résultats déjà affichés)');
            return;
        }

        const container = document.querySelector('[data-recharge="legacy_invoices"]');
        if (!container) return;

        this._legacyInvoicesInFlight = true;
        // innerHTML : le bouton contient une icône SVG que textContent
        // effacerait définitivement au premier clic.
        const originalMarkup = button?.innerHTML;
        if (button) {
            button.disabled = true;
            button.textContent = 'Recherche en cours...';
        }

        try {
            const res = await fetch(RechargePortal.CHARGEBEE_INVOICES_API_URL, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ recharge_customer_id: this.customerId }),
            });
            if (!res.ok) {
                const err = new Error(`HTTP ${res.status}`);
                err.status = res.status;
                throw err;
            }
            const data = await res.json();
            // Cooldown armé sur SUCCÈS seulement : après une erreur, le client
            // doit pouvoir réessayer tout de suite.
            this._legacyInvoicesCooldownUntil = Date.now() + RechargePortal.LEGACY_INVOICES_COOLDOWN_MS;
            this.renderLegacyInvoices(data.invoices || []);
        } catch (e) {
            console.error('[LegacyInvoices] ❌ Échec chargement:', e);
            if (this.handleAuthError(e)) return;
            if (e.status === 429) {
                showNotification('⏳ Trop de demandes. Patientez une minute avant de réessayer.', 'error');
                return;
            }
            showNotification('❌ Impossible de récupérer vos anciennes factures pour le moment.', 'error');
        } finally {
            this._legacyInvoicesInFlight = false;
            if (button) {
                button.disabled = false;
                button.innerHTML = originalMarkup;
            }
        }
    }

    // Cooldown après un chargement réussi de la liste (résultats déjà à l'écran).
    static LEGACY_INVOICES_COOLDOWN_MS = 10000;

    // Marge avant expiration en dessous de laquelle un lien PDF mis en cache
    // n'est plus réutilisé (le lien Chargebee vit 60 min).
    static LEGACY_PDF_REUSE_MARGIN_MS = 120000;

    // Date Chargebee (unix s) -> "15 mars 2025". Même format que l'historique
    // des commandes (cf. formattedDate dans renderOrdersHistory).
    static formatLegacyDate(unixSeconds) {
        return new Date(unixSeconds * 1000).toLocaleDateString('fr-FR', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        });
    }

    // Montants Chargebee en unité mineure (centimes) -> "49,00 €".
    static formatLegacyAmount(totalMinorUnits, currency) {
        const amount = (Number(totalMinorUnits) || 0) / 100;
        try {
            return new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: currency || 'EUR',
            }).format(amount);
        } catch {
            // Code devise inattendu : repli lisible plutôt qu'une exception.
            return `${amount.toFixed(2)} ${currency || ''}`.trim();
        }
    }

    // Rendu : date / montant / statut / bouton de téléchargement. Le lien PDF
    // n'est PAS généré ici — il l'est au clic (cf. downloadLegacyInvoice).
    renderLegacyInvoices(invoices) {
        const container = document.querySelector('[data-recharge="legacy_invoices"]');
        if (!container) return;

        if (!invoices.length) {
            container.innerHTML = '<p class="orders-subtitle">Aucune facture antérieure trouvée pour votre compte.</p>';
            return;
        }

        // Pas de colonne statut : le serveur ne renvoie que des factures payées.
        // Classes reprises telles quelles de l'historique des commandes
        // (.order-date / .order-total / .btn-order-action.btn-invoice) : même
        // typo, même pilule, même icône que le bouton « Ma facture » existant.
        // Ici un <button> et non un <a> — le lien PDF n'existe qu'après le clic.
        container.innerHTML = invoices.map(inv => `
            <div class="legacy-invoice-row">
                <span class="order-date">${RechargePortal.formatLegacyDate(inv.date)}</span>
                <span class="order-total">${this.escapeHtml(RechargePortal.formatLegacyAmount(inv.total, inv.currency))}</span>
                <button class="btn-order-action btn-invoice" data-recharge-action="download-legacy-invoice" data-invoice-id="${this.escapeHtml(inv.id)}" title="Télécharger ma facture (PDF)">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 3v12m0 0l-4-4m4 4l4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5 21h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Ma facture
                </button>
            </div>
        `).join('');
    }

    // Génère le lien PDF signé À LA DEMANDE (le serveur revérifie que la
    // facture appartient bien au client avant de le produire), puis l'ouvre.
    //
    // La fenêtre est ouverte SYNCHRONEMENT, dans le geste utilisateur : un
    // window.open() après un await est bloqué comme pop-up par les navigateurs.
    async downloadLegacyInvoice(button) {
        if (!this.requireSession()) return;

        const invoiceId = button?.getAttribute('data-invoice-id');
        if (!invoiceId) return;

        // Verrou par facture : deux clics sur la même ligne ne génèrent pas
        // deux liens (le bouton est désactivé pendant l'appel, mais la garde
        // couvre aussi un déclenchement programmatique).
        this._legacyPdfInFlight = this._legacyPdfInFlight || new Set();
        if (this._legacyPdfInFlight.has(invoiceId)) {
            console.log('[LegacyInvoices] ⏳ Lien déjà en cours de génération, clic ignoré');
            return;
        }

        // Le lien Chargebee vit 60 min : tant qu'il est valide on le réutilise
        // au lieu d'en redemander un à chaque clic (1 appel par facture et par
        // heure au maximum, quel que soit le nombre de clics).
        this._legacyPdfUrls = this._legacyPdfUrls || new Map();
        const cached = this._legacyPdfUrls.get(invoiceId);
        if (cached && cached.expiresAt - Date.now() > RechargePortal.LEGACY_PDF_REUSE_MARGIN_MS) {
            console.log('[LegacyInvoices] ♻️ Lien encore valide, réutilisé');
            window.open(cached.url, '_blank', 'noopener');
            return;
        }

        const win = window.open('', '_blank');
        // innerHTML et pas textContent : le bouton contient l'icône SVG, que
        // textContent effacerait définitivement dès le premier clic.
        const originalMarkup = button.innerHTML;
        this._legacyPdfInFlight.add(invoiceId);
        button.disabled = true;
        button.textContent = 'Préparation...';

        try {
            const res = await fetch(RechargePortal.CHARGEBEE_INVOICES_API_URL, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    recharge_customer_id: this.customerId,
                    invoice_id: invoiceId,
                }),
            });
            if (!res.ok) {
                const err = new Error(`HTTP ${res.status}`);
                err.status = res.status;
                throw err;
            }
            const data = await res.json();
            if (!data.download_url) throw new Error('No download_url in response');

            // Mémorise le lien pour les clics suivants (valid_till en secondes
            // unix ; sans lui on ne met rien en cache plutôt que de deviner).
            if (data.valid_till) {
                this._legacyPdfUrls.set(invoiceId, {
                    url: data.download_url,
                    expiresAt: data.valid_till * 1000,
                });
            }

            if (win) win.location = data.download_url;
            else window.location.href = data.download_url; // pop-up bloquée
        } catch (e) {
            if (win) win.close();
            console.error('[LegacyInvoices] ❌ Échec téléchargement:', e);
            if (this.handleAuthError(e)) return;
            if (e.status === 429) {
                showNotification('⏳ Trop de demandes. Patientez une minute avant de réessayer.', 'error');
                return;
            }
            if (e.status === 404) {
                showNotification('❌ Cette facture n\'est plus disponible.', 'error');
                return;
            }
            showNotification('❌ Impossible de télécharger cette facture pour le moment.', 'error');
        } finally {
            this._legacyPdfInFlight.delete(invoiceId);
            button.disabled = false;
            button.innerHTML = originalMarkup;
        }
    }

    // Si la charge relue ne porte pas encore la shipping_line écrite (reprice
    // Recharge asynchrone), patche localement la ligne + le total (invariant
    // total = subtotal - discounts + shipping + tax, validé T3) et programme
    // UNE relecture différée — jamais de boucle de polling.
    reconcileChargeShippingLine(appliedLine) {
        // Invalider TOUJOURS la relecture différée précédente : elle capture
        // l'appliedLine d'une écriture antérieure et re-patcherait un mode déjà
        // remplacé (changement A puis B rapprochés -> l'affichage reviendrait à A).
        if (this._shippingReconcileTimer) {
            clearTimeout(this._shippingReconcileTimer);
            this._shippingReconcileTimer = null;
        }
        if (!appliedLine || !this.nextCharge) return;

        const read = this.nextCharge.shipping_lines?.[0];
        const readPrice = parseFloat(read?.price);
        const appliedPrice = Number(appliedLine.price);
        const upToDate = read
            && read.title === appliedLine.title
            && !Number.isNaN(readPrice)
            && Math.abs(readPrice - appliedPrice) < 0.005;
        if (upToDate) return;

        console.warn('[Shipping] Charge relue encore périmée → patch local + relecture différée');
        const patch = (charge) => {
            const oldShipping = (charge.shipping_lines || [])
                .reduce((s, l) => s + (parseFloat(l.price) || 0), 0);
            charge.shipping_lines = [{
                code: appliedLine.code,
                title: appliedLine.title,
                price: appliedPrice.toFixed(2),
            }];
            const total = parseFloat(charge.total_price);
            if (!Number.isNaN(total)) {
                charge.total_price = (total - oldShipping + appliedPrice).toFixed(2);
            }
        };
        patch(this.nextCharge);

        // Convergence : une seule relecture différée. Si Recharge est encore en
        // retard, on re-patche (l'état local reste la vérité écrite) — le
        // prochain chargement de page relira de toute façon.
        this._shippingReconcileTimer = setTimeout(async () => {
            this._shippingReconcileTimer = null;
            try {
                await this.loadNextCharge();
                const line = this.nextCharge?.shipping_lines?.[0];
                if (line && (line.title !== appliedLine.title
                    || Math.abs((parseFloat(line.price) || 0) - appliedPrice) >= 0.005)) {
                    patch(this.nextCharge);
                }
                this.renderSubscriptionProducts();
            } catch (e) {
                console.warn('[Shipping] Relecture différée échouée:', e);
            }
        }, 2500);
    }

    async loadOnetimes() {
        console.log('[RechargePortal] 📦 Chargement onetimes...');

        if (!this.addresses || this.addresses.length === 0) {
            console.warn('[RechargePortal] Pas d\'adresse disponible pour charger les onetimes');
            this.onetimes = [];
            this.loadResults.onetimes = 'ok'; // pas un échec : simplement rien à charger
            return;
        }

        try {
            const addressId = this.addresses[0].id;
            console.log('[RechargePortal] 🔍 Address ID pour one-times:', addressId);

            const response = await window.recharge.onetime.listOnetimes(this.session, {
                address_id: addressId
            });

            console.log('[RechargePortal] 🔍 Réponse API one-times:', response);
            this.onetimes = response.onetimes || [];
            this.loadResults.onetimes = 'ok';
            console.log('[RechargePortal] ✅ Onetimes chargés:', this.onetimes.length);

            if (this.onetimes.length > 0) {
                console.log('[RechargePortal] 📋 Liste des one-times:');
                this.onetimes.forEach((ot, i) => {
                    console.log(`  [${i}]:`, {
                        id: ot.id,
                        product_title: ot.product_title,
                        status: ot.status,
                        quantity: ot.quantity,
                        price: ot.price
                    });
                });
            }
        } catch (error) {
            console.error('[RechargePortal] ❌ Erreur chargement onetimes:', error);
            console.error('[RechargePortal] Détails de l\'erreur:', error.message);
            this.onetimes = [];
            this.loadResults.onetimes = this.classifyError(error);
        }
    }

    async loadAddresses() {
        console.log('[RechargePortal] Chargement adresses...');
        try {
            // CRITIQUE : Passer this.session en premier argument
            const response = await window.recharge.address.listAddresses(this.session);
            this.addresses = response.addresses || [];
            this.loadResults.addresses = 'ok';
            console.log('[RechargePortal] ✅ Adresses chargées:', this.addresses);

            // IMPORTANT : Vérifier si l'email de l'adresse est différent de l'email Shopify
            if (this.addresses.length > 0 && window.shopifyCustomerData && window.shopifyCustomerData.email) {
                if (this.addresses[0].email && this.addresses[0].email !== window.shopifyCustomerData.email) {
                    console.warn('[RechargePortal] ⚠️ EMAIL DIFFÉRENT détecté !');
                    console.warn('[RechargePortal] → Email Recharge Address:', this.addresses[0].email);
                    console.warn('[RechargePortal] → Email Shopify Customer:', window.shopifyCustomerData.email);
                    console.warn('[RechargePortal] → L\'email Shopify sera utilisé en priorité dans l\'affichage');
                }
            }
        } catch (error) {
            console.error('[RechargePortal] ❌ Erreur chargement adresses:', error);
            console.error('[RechargePortal] Détails:', error.message);
            this.addresses = [];
            this.loadResults.addresses = this.classifyError(error);
        }
    }

    async updateUI() {
        console.log('[RechargePortal] Mise à jour interface...');

        // 🔍 AFFICHAGE SPÉCIAL POUR CLIENTS SHOPIFY-ONLY
        if (this.isShopifyOnly === true) {
            console.log('[RechargePortal] → Mode Shopify-only, affichage message');
            await this.displayShopifyOnlyMessage();
            return; // Ne pas continuer avec le reste de l'UI
        }

        // Mettre à jour le nom dans la sidebar
        if (this.customer) {
            const sidebarNameEl = document.querySelector('[data-recharge="sidebar_name"]');
            if (sidebarNameEl) {
                if (this.customer.first_name) {
                    sidebarNameEl.textContent = this.customer.first_name;
                    console.log('[RechargePortal] ✅ Nom affiché:', this.customer.first_name);
                } else if (this.customer.email) {
                    // Fallback sur l'email si first_name n'existe pas
                    const emailName = this.customer.email.split('@')[0];
                    sidebarNameEl.textContent = emailName;
                    console.log('[RechargePortal] ⚠️ first_name manquant, affichage email:', emailName);
                }
            } else {
                console.warn('[RechargePortal] ⚠️ Element [data-recharge="sidebar_name"] non trouvé');
            }
        } else {
            console.warn('[RechargePortal] ⚠️ Pas de customer disponible pour updateUI');
        }

        // Mettre à jour les données d'abonnement
        // IMPORTANT : Appeler même sans subscription active pour afficher les one-times !
        this.updateSubscriptionData();

        // Mettre à jour la card "Dernière commande" dans le panneau Mon compte
        if (this.orders && this.orders.length > 0) {
            this.updateLastOrderCard();
        }

        // Bandeau de suivi en tête de la première page. Volontairement non
        // attendu : le rendu du dashboard ne doit pas dépendre d'un appel réseau
        // à un service tiers.
        this.renderTrackingBanner();

        // Mettre à jour la card "Mes coordonnées" dans le panneau Mon compte
        if (this.customer || (this.addresses && this.addresses.length > 0)) {
            this.updateContactCard();
        }

        // Mettre à jour l'adresse de livraison
        if (this.addresses && this.addresses.length > 0) {
            this.updateAddressData();
        }

        // Mettre à jour les infos de paiement
        if (this.orders && this.orders.length > 0) {
            this.updatePaymentData();
        }

        // Mettre à jour les commandes
        if (this.orders) {
            this.updateOrdersData();
        }

        console.log('[RechargePortal] Interface mise à jour');
    }

    updateSubscriptionData() {
        // DEBUG : Afficher l'état de la subscription
        console.log('[RechargePortal] 🔍 DEBUG updateSubscriptionData:');
        console.log('[RechargePortal] - this.subscription:', this.subscription);
        console.log('[RechargePortal] - this.activeSubscriptions:', this.activeSubscriptions);
        console.log('[RechargePortal] - this.subscriptions:', this.subscriptions);
        console.log('[RechargePortal] - this.onetimes:', this.onetimes);

        // Vérifier si l'abonnement est actif
        const isActive = this.subscription && (this.subscription.status === 'active' || this.subscription.status === 'ACTIVE');

        console.log('[RechargePortal] - isActive:', isActive);

        // Gérer le bandeau d'information pour abonnement désactivé
        const inactiveBanner = document.getElementById('subscription-inactive-banner');

        if (!isActive) {
            console.log('[RechargePortal] ⚠️ Abonnement non actif - Affichage message de désabonnement');

            // Afficher le bandeau d'information
            if (inactiveBanner) {
                inactiveBanner.style.display = 'block';
            }

            // Mettre à jour le statut de l'abonnement dans le panneau principal
            const statusEls = document.querySelectorAll('[data-recharge="subscription_status"]');
            statusEls.forEach(el => {
                el.textContent = 'désactivé';
                el.style.color = '#856404';
            });

            // Masquer ou afficher un message pour la prochaine commande
            const nextShipmentEls = document.querySelectorAll('[data-recharge="delivery_date"], [data-recharge="delivery_date_modal"]');
            nextShipmentEls.forEach(el => {
                el.textContent = 'Aucune livraison programmée';
                el.style.fontStyle = 'italic';
                el.style.opacity = '0.6';
            });

            // Masquer ou afficher un message pour la fréquence
            const frequencyEls = document.querySelectorAll('[data-recharge="frequency"]');
            frequencyEls.forEach(el => {
                el.textContent = 'Aucun abonnement actif';
                el.style.fontStyle = 'italic';
                el.style.opacity = '0.6';
            });

            // Masquer les boutons "Modifier" des cards de livraison et fréquence
            const shipmentCard = document.querySelector('.card-shipment');
            const frequencyCard = document.querySelector('.card-frequency');

            if (shipmentCard) {
                const modifyBtn = shipmentCard.querySelector('.btn-modify');
                if (modifyBtn) modifyBtn.style.display = 'none';
            }

            if (frequencyCard) {
                const modifyBtn = frequencyCard.querySelector('.btn-modify');
                if (modifyBtn) modifyBtn.style.display = 'none';
            }

            // Basculer le lien de la card : "Personnaliser" → "Réactiver"
            const linkCustomize = document.getElementById('link-customize-subscription');
            const linkReactivate = document.getElementById('link-reactivate-subscription');
            if (linkCustomize) linkCustomize.style.setProperty('display', 'none', 'important');
            if (linkReactivate) linkReactivate.style.setProperty('display', 'block', 'important');

            console.log('[RechargePortal] ✅ Messages de désabonnement affichés');

            // IMPORTANT : Générer quand même les produits (pour afficher les one-times)
            this.renderSubscriptionProducts();
            console.log('[RechargePortal] Données abonnement mises à jour (mode inactif avec one-times)');
            return;
        }

        // Masquer le bandeau si l'abonnement est actif
        if (inactiveBanner) {
            inactiveBanner.style.display = 'none';
        }

        // Remettre les liens de la card abonnement
        const linkCustomize = document.getElementById('link-customize-subscription');
        const linkReactivate = document.getElementById('link-reactivate-subscription');
        if (linkCustomize) linkCustomize.style.setProperty('display', 'block', 'important');
        if (linkReactivate) linkReactivate.style.setProperty('display', 'none', 'important');

        // Remettre le statut "en cours" si l'abonnement est actif
        const statusEls = document.querySelectorAll('[data-recharge="subscription_status"]');
        statusEls.forEach(el => {
            el.textContent = 'en cours';
            el.style.color = '';
        });

        // Si l'abonnement est actif, afficher normalement
        // Prochaine commande - Mettre à jour TOUS les éléments avec cet attribut
        if (this.subscription && this.subscription.next_charge_scheduled_at) {
            // DATE DE LIVRAISON = next_charge_scheduled_at + CHARGE_OFFSET_DAYS.
            // C'est la seule date montrée au client : le prélèvement n'apparaît
            // plus nulle part dans l'UI, seulement dans la phrase explicative.
            const deliveryDate = RechargePortal.chargeToDelivery(this.subscription.next_charge_scheduled_at);
            const deliveryFormatted = RechargePortal.formatLongDate(deliveryDate, true);
            const deliveryEls = document.querySelectorAll('[data-recharge="delivery_date"]');
            deliveryEls.forEach(el => {
                el.textContent = deliveryFormatted;
                el.style.fontStyle = 'normal';
                el.style.opacity = '1';
            });

            console.log(`[RechargePortal] ✅ Livraison: ${deliveryFormatted} | prélèvement Recharge: ${this.subscription.next_charge_scheduled_at}`);
        } else if (this.subscription) {
            // Abonnement actif mais AUCUNE date renvoyée par Recharge (cas typique :
            // prélèvement bloqué car moyen de paiement invalide). Ne pas laisser
            // les placeholders : afficher un statut explicite.
            const noDateText = this.paymentIssue
                ? 'En attente de mise à jour du paiement'
                : 'Non planifiée';
            const dateEls = document.querySelectorAll(
                '[data-recharge="delivery_date"], [data-recharge="delivery_date_modal"]'
            );
            dateEls.forEach(el => {
                el.textContent = noDateText;
                el.style.fontStyle = 'italic';
                el.style.opacity = '0.8';
            });
            console.warn(`[RechargePortal] ⚠️ Abonnement actif sans next_charge_scheduled_at → "${noDateText}"`);
        }

        // Fréquence - Mettre à jour TOUS les éléments avec cet attribut
        if (this.subscription && this.subscription.order_interval_frequency) {
            const frequencyEls = document.querySelectorAll('[data-recharge="frequency"]');
            if (frequencyEls.length > 0) {
                const freq = this.subscription.order_interval_frequency;
                const unitMap = {
                    day: { article: 'tous les', label: freq > 1 ? 'jours' : 'jour' },
                    week: { article: 'toutes les', label: freq > 1 ? 'semaines' : 'semaine' },
                    month: { article: 'tous les', label: 'mois' }
                };
                const u = unitMap[this.subscription.order_interval_unit] || unitMap.month;
                const frequencyText = `Livraison ${u.article} ${freq} ${u.label}`;
                frequencyEls.forEach(el => {
                    el.textContent = frequencyText;
                    el.style.fontStyle = 'normal';
                    el.style.opacity = '1';
                });
                console.log(`[RechargePortal] ✅ ${frequencyEls.length} élément(s) "frequency" mis à jour: ${frequencyText}`);
            }
        }

        // Réafficher les boutons "Modifier" si l'abonnement est actif
        const shipmentCard = document.querySelector('.card-shipment');
        const frequencyCard = document.querySelector('.card-frequency');

        if (shipmentCard) {
            const modifyBtn = shipmentCard.querySelector('.btn-modify');
            if (modifyBtn) modifyBtn.style.display = '';
        }

        if (frequencyCard) {
            const modifyBtn = frequencyCard.querySelector('.btn-modify');
            if (modifyBtn) modifyBtn.style.display = '';
        }

        // Générer les produits d'abonnement
        this.renderSubscriptionProducts();

        // Autres données...
        console.log('[RechargePortal] Données abonnement mises à jour');
    }

    updateLastOrderCard() {
        console.log('[RechargePortal] Mise à jour card "Dernière commande"...');

        if (!this.orders || this.orders.length === 0) {
            console.warn('[RechargePortal] Pas de commandes pour la card');
            return;
        }

        const lastOrder = this.orders[0]; // La dernière commande

        // 1. Numéro et date de commande (header)
        const orderInfoEl = document.querySelector('[data-recharge="last_order_info"]');
        if (orderInfoEl && lastOrder.id && lastOrder.scheduled_at) {
            const orderDate = new Date(lastOrder.scheduled_at);
            const formattedDate = orderDate.toLocaleDateString('fr-FR', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });
            orderInfoEl.textContent = `N° ${lastOrder.id} du ${formattedDate}`;
        }

        // 2. Statut de la commande
        const statusEl = document.querySelector('[data-recharge="last_order_status"]');
        if (statusEl && lastOrder.status) {
            const statusMap = {
                'queued': 'En attente',
                'success': 'Traitée',
                'error': 'Erreur',
                'refunded': 'Remboursée',
                'partially_refunded': 'Partiellement remboursée',
                'skipped': 'Passée'
            };
            statusEl.textContent = statusMap[lastOrder.status] || 'En cours de préparation';
        }

        // 3. Montant total
        const amountEl = document.querySelector('[data-recharge="last_order_amount"]');
        if (amountEl && lastOrder.total_price) {
            amountEl.textContent = `${parseFloat(lastOrder.total_price).toFixed(2)} €`;
        }

        // 4. Date de livraison estimée — même règle que partout ailleurs.
        // Avant : +4 jours en dur, sans règle dimanche, donc un résultat qui
        // pouvait contredire la date annoncée sur la card abonnement.
        const deliveryDateEl = document.querySelector('[data-recharge="last_order_delivery_date"]');
        if (deliveryDateEl && lastOrder.scheduled_at) {
            const delivery = RechargePortal.chargeToDelivery(lastOrder.scheduled_at);
            if (delivery) deliveryDateEl.textContent = RechargePortal.formatLongDate(delivery, true);
        }

        // 5. Suivi de colis (API Shopify via Vercel) — boutons "Suivre mon colis"
        const trackingEl = document.querySelector('[data-recharge="last_order_tracking"]');
        if (trackingEl) {
            this.fetchLatestTracking().then(order => {
                trackingEl.innerHTML = this.buildTrackingButtonsHTML(order?.tracking) || '';
            });
        }

        console.log('[RechargePortal] ✅ Card "Dernière commande" mise à jour');
    }

    updateContactCard() {
        console.log('[RechargePortal] Mise à jour card "Mes coordonnées"...');

        // 1. Nom complet
        const nameEl = document.querySelector('[data-recharge="contact_name"]');
        if (nameEl && this.customer) {
            const fullName = `${this.customer.first_name || ''} ${this.customer.last_name || ''}`.trim();
            nameEl.textContent = fullName || 'Non renseigné';
        }

        // 2. Email
        const emailEl = document.querySelector('[data-recharge="contact_email"]');
        if (emailEl && this.customer && this.customer.email) {
            emailEl.textContent = this.customer.email;
        }

        // 3. Adresse (ville, code postal)
        const addressEl = document.querySelector('[data-recharge="contact_address"]');
        if (addressEl && this.addresses && this.addresses.length > 0) {
            const addr = this.addresses[0];
            let addressText = '';
            if (addr.city) addressText += addr.city;
            if (addr.zip) addressText += `, ${addr.zip}`;
            if (addr.country) addressText += `, ${addr.country}`;
            addressEl.textContent = addressText.trim() || 'Non renseignée';
        }

        console.log('[RechargePortal] ✅ Card "Mes coordonnées" mise à jour');
    }

    // ======================================================================
    // RECOMMANDATION EN PAGE
    // Un produit proposé directement dans l'abonnement, ajoutable en un clic,
    // sans passer par le modal. Le modal reste le catalogue ; ceci est
    // l'étalage à côté de la caisse.
    // ======================================================================

    // Variant ids réellement abonnés. Même source que le modal
    // (external_variant_id.ecommerce, avec shopify_variant_id en repli).
    subscribedVariantIdSet() {
        return new Set(
            (this.activeSubscriptions || [])
                .map(sub => String(sub.external_variant_id?.ecommerce || sub.shopify_variant_id || ''))
                .filter(Boolean)
        );
    }

    // Espèces présentes DANS LA BOX, déduites des produits abonnés et NON des
    // animaux déclarés. Un client peut avoir un chat enregistré et n'acheter que
    // des croquettes chien, ou l'inverse : ce qu'il achète est un signal plus sûr
    // que ce qu'il a rempli dans un formulaire. Renvoie un Set de 'Chien'/'Chat',
    // éventuellement les deux, éventuellement vide (box uniquement composée de
    // produits universels, ou catalogue pas encore chargé).
    subscribedSpecies() {
        const catalog = window.shopifyAllProducts || [];
        const ids = this.subscribedVariantIdSet();
        const species = new Set();
        if (!catalog.length || !ids.size) return species;

        catalog.forEach(product => {
            const animal = this.productAnimalType(product);
            if (!animal) return;
            if ((product.variants || []).some(v => ids.has(String(v.id)))) {
                species.add(animal);
            }
        });
        return species;
    }

    // Catégorie de recommandation d'un produit, déduite du HANDLE de sa
    // collection et non de `collection_name` : friandises, litière et extras
    // partagent volontairement le même nom d'affichage pour ne former qu'une
    // section dans le modal, mais proposer une friandise après des croquettes
    // n'est pas proposer un sac de litière. Renvoie null pour tout ce qui n'a
    // pas sa place dans une suggestion (« Autres », collection inconnue).
    //
    // Préfixe et non égalité stricte : les handles déclinent l'espèce en
    // suffixe, et ce suffixe n'est pas régulier (`patees-chiens` au pluriel,
    // `patees-chat` au singulier). Une nouvelle collection par espèce est donc
    // reconnue sans toucher à cette méthode — il reste à l'ajouter à
    // `window.shopifyProductCollections` dans portal-catalog-bootstrap.liquid,
    // qui seule décide de ce qui est chargé.
    //
    // La collection `litieres-huiles` s'appelle en réalité « Friandises,
    // Litières, Huiles - Chat » : elle contient les trois. Il n'existe AUCUNE
    // collection de friandises chat, ses friandises sont là. La collection ne
    // permet donc pas de trancher et c'est le handle du PRODUIT qui départage —
    // seul repli disponible tant que les friandises chat n'ont pas leur propre
    // collection.
    productCategory(product) {
        const collection = (product && product.collection_handle) || '';
        const handle = (product && product.handle) || '';

        if (collection.startsWith('croquettes')) return 'croquettes';
        if (collection.startsWith('patees')) return 'patees';
        if (collection.startsWith('friandises')) return 'friandises';

        // Le repli sur le handle du produit est CONFINÉ aux deux collections
        // fourre-tout : ailleurs, la collection fait foi.
        if (collection === 'litieres-huiles' || collection === 'extras') {
            return handle.startsWith('friandises') ? 'friandises' : 'extras';
        }

        // « Autres » (rattrapage produit-en-abonnement) et toute collection
        // inconnue : pas de place dans une suggestion.
        return null;
    }

    // Espèce d'un produit. Chaîne vide = universel : proposé à tout le monde,
    // masqué par aucun filtre espèce, placé en fin de groupe dans la reco.
    // Source unique pour la reco ET pour le modal — la même fiche ne peut pas
    // être « chien » d'un côté et « sans espèce » de l'autre.
    //
    // `animal_type` vient des collections produits-chiens / produits-chats, et
    // ce rangement a deux trous, opposés :
    //
    //   1. Sur-typage. L'huile de saumon « chien et chat » n'est rangée que
    //      dans produits-chats alors qu'elle convient aux deux ; son handle le
    //      dit noir sur blanc, il prime sur tout le reste.
    //   2. Sous-typage. Des fiches ne sont dans AUCUNE des deux collections —
    //      « Coffret Pâtées Chiot », les « Kit Découverte ». `animal_type` est
    //      alors vide, donc « universel », donc ces produits chien restaient
    //      affichés sous le filtre Chat.
    //
    // Le sous-typage se rattrape en deux temps, du signal le plus fiable au
    // moins fiable :
    //
    //   a. Le RAYON. `patees-chiens` ne laisse aucun doute sur l'espèce visée.
    //      C'est de la donnée structurée, elle passe en premier.
    //   b. Le NOM du produit, à défaut. Les fiches arrivées par le fourre-tout
    //      `produit-en-abonnement` (section « Autres ») n'ont pas de rayon qui
    //      les qualifie : « Kit Découverte - Croquettes Chien » n'est lisible
    //      que dans son titre. Frontières de mots obligatoires — sans elles,
    //      « achat » contient « chat ».
    //
    // Dans les deux cas, un texte qui nomme les DEUX espèces ne prouve rien et
    // laisse le produit universel : `croquettes-chiens-chats` existe en rayon,
    // et un titre « pour chien et chat » existe en boutique.
    //
    // Tous ces replis disparaissent le jour où chaque fiche est correctement
    // rangée dans produits-chiens / produits-chats.
    productAnimalType(product) {
        const handle = (product && product.handle) || '';
        if (handle.includes('chien-et-chat')) return '';

        const declared = (product && product.animal_type) || '';
        if (declared) return declared;

        // Une espèce nommée dans un texte, ou rien si les deux le sont.
        const named = text => {
            const dog = /\b(chiens?|chiots?)\b/i.test(text);
            const cat = /\b(chats?|chatons?)\b/i.test(text);
            if (dog && cat) return '';
            if (dog) return 'Chien';
            if (cat) return 'Chat';
            return '';
        };

        const fromAisle = named((product && product.collection_handle) || '');
        if (fromAisle) return fromAisle;

        return named(`${(product && product.title) || ''} ${handle}`);
    }

    // Ce que la box contient DÉJÀ, en catégories. Même principe que
    // subscribedSpecies() : c'est l'abonnement réel qui parle, pas le profil
    // déclaré.
    subscribedCategories() {
        const catalog = window.shopifyAllProducts || [];
        const ids = this.subscribedVariantIdSet();
        const categories = new Set();
        if (!catalog.length || !ids.size) return categories;

        catalog.forEach(product => {
            const category = this.productCategory(product);
            if (!category) return;
            if ((product.variants || []).some(v => ids.has(String(v.id)))) {
                categories.add(category);
            }
        });
        return categories;
    }

    // Le mapping : ce que la box contient -> ce qu'on propose, dans l'ordre.
    // Une seule règle par cas, lisible de haut en bas ; c'est ici que se règle
    // le merchandising de la reco, nulle part ailleurs.
    recommendationCategoryOrder() {
        const owned = this.subscribedCategories();

        // Des croquettes : la pâtée est le complément naturel (bi-nutrition),
        // la friandise vient juste après. Vrai aussi quand la box contient déjà
        // de la pâtée — les recettes non souscrites restent à découvrir.
        if (owned.has('croquettes')) return ['patees', 'friandises', 'extras'];

        // De la pâtée mais pas de croquettes : c'est la croquette qui manque.
        if (owned.has('patees')) return ['croquettes', 'friandises', 'extras'];

        // Ni l'un ni l'autre — box d'accessoires seuls, ou catalogue pas encore
        // chargé au moment de l'appel : on repart de l'aliment.
        return ['croquettes', 'patees', 'friandises', 'extras'];
    }

    // Ordre des sections du modal « Ajouter un produit ». Même priorité que la
    // reco : l'aliment manquant en tête, « Compléter ma box » en queue. Avant,
    // l'ordre venait de window.shopifyProductCollections, où « Compléter ma
    // box » est déclarée en premier — la première chose proposée à qui veut
    // ajouter un produit était donc la litière et les chaussettes.
    //
    // Une différence assumée avec la reco : le modal n'exclut rien, il classe.
    // Les croquettes que la reco écarte parce qu'elles sont déjà dans la box
    // restent parcourables, simplement après les pâtées.
    //
    // Le rang se déduit du HANDLE des collections et non d'un produit tiré au
    // sort : trois collections partagent le nom « Compléter ma box », et la
    // section prend le rang de la MOINS prioritaire d'entre elles — sans ça,
    // ses friandises la feraient remonter devant les croquettes, c'est-à-dire
    // exactement ce qu'on retire ici.
    modalSectionOrder() {
        const collections = window.shopifyProductCollections || [];

        // recommendationCategoryOrder() commence toujours par un aliment ; on
        // reprend son verdict et on remet l'autre aliment juste derrière, là où
        // la reco le retirait.
        const categories = this.recommendationCategoryOrder()[0] === 'patees'
            ? ['patees', 'croquettes', 'friandises', 'extras']
            : ['croquettes', 'patees', 'friandises', 'extras'];

        // Espèce de la box devant l'autre. Foyer mixte ou espèce inconnue :
        // aucune préférence, l'ordre du catalogue tranche (chien puis chat).
        const species = this.subscribedSpecies();
        const preferred = species.size === 1 ? [...species][0] : '';

        const speciesRank = handle => {
            const animal = /chien/.test(handle) ? 'Chien' : /chat/.test(handle) ? 'Chat' : '';
            if (!preferred || !animal) return 1;
            return animal === preferred ? 0 : 2;
        };

        const ranks = new Map();
        collections.forEach((col, index) => {
            const category = this.productCategory({ collection_handle: col.handle });
            const categoryRank = categories.indexOf(category);
            const score = (categoryRank === -1 ? categories.length : categoryRank) * 1000
                + speciesRank(col.handle) * 100
                + index;

            const current = ranks.get(col.name);
            if (current === undefined || score > current) ranks.set(col.name, score);
        });

        return [...ranks.entries()]
            .sort((a, b) => a[1] - b[1])
            .map(([name]) => name);
    }

    // Les produits à proposer, dans l'ordre du rail : au plus trois par
    // catégorie (cf. PER_CATEGORY_LIMIT plus bas), les catégories elles-mêmes
    // ordonnées par recommendationCategoryOrder().
    // Tableau vide s'il n'y a rien d'honnête à proposer.
    recommendedProducts() {
        const catalog = window.shopifyAllProducts || [];
        if (!catalog.length) return [];

        // Rien à COMPLÉTER s'il n'y a pas de box : le parcours d'un client sans
        // abonnement actif est la création, pas l'ajout.
        if (!(this.activeSubscriptions || []).length) return [];

        const subscribed = this.subscribedVariantIdSet();
        const species = this.subscribedSpecies();
        const order = this.recommendationCategoryOrder();

        // Hors alimentation : n'a rien à faire dans une suggestion de box.
        // (Le modal « Ajouter un produit » les propose toujours, lui.)
        const excluded = /chaussette/i;

        const candidates = catalog.filter(product => {
            if (!order.includes(this.productCategory(product))) return false;
            if (excluded.test(product.title || '')) return false;
            if (!product.available) return false;

            // Déjà dans la box : ce n'est plus une découverte.
            if ((product.variants || []).some(v => subscribed.has(String(v.id)))) return false;

            // Incompatibilité PROUVÉE seulement. Les produits universels — huile
            // de saumon « chien et chat », accessoires — n'ont pas d'espèce et
            // restent proposés : les écarter viderait la moitié du vivier.
            const animal = this.productAnimalType(product);
            if (animal && species.size && !species.has(animal)) return false;

            return true;
        });

        // Le moins cher d'abord à l'intérieur d'un groupe : ce sont des achats
        // d'impulsion, pas des décisions. Déterministe, donc stable d'une visite
        // à l'autre — et la sélection se renouvelle d'elle-même dès qu'un
        // produit proposé est ajouté, puisqu'il sort alors des candidats.
        const byPrice = (a, b) => (a.price_min || a.price || 0) - (b.price_min || b.price || 0);

        const arrange = group => {
            group.sort(byPrice);

            // Les produits nommés pour une espèce passent devant les universels
            // (huile, litière) : c'est ça, « les produits de son animal en
            // priorité ».
            const named = group.filter(p => this.productAnimalType(p));
            const universal = group.filter(p => !this.productAnimalType(p));
            if (species.size < 2) return named.concat(universal);

            // Foyer chien ET chat : on alterne les deux espèces au lieu de
            // servir tous les chiens d'abord. Le rail défile horizontalement —
            // enterrer une espèce en fin de liste revient à ne pas la proposer.
            const dogs = named.filter(p => this.productAnimalType(p) === 'Chien');
            const cats = named.filter(p => this.productAnimalType(p) === 'Chat');
            const alternated = [];
            for (let i = 0; i < Math.max(dogs.length, cats.length); i++) {
                if (dogs[i]) alternated.push(dogs[i]);
                if (cats[i]) alternated.push(cats[i]);
            }
            return alternated.concat(universal);
        };

        // L'ordre des catégories EST l'ordre d'affichage, et chacune est plafonnée :
        // au-delà de trois références d'affilée, le rail devient un rayon de
        // pâtées et la catégorie suivante n'est jamais atteinte. Le plafond
        // s'applique APRÈS le tri, donc ce sont les trois moins chères qui
        // passent — et en foyer mixte, l'alternance garantit que les deux
        // espèces tiennent dans ces trois places.
        const PER_CATEGORY_LIMIT = 3;

        return order.flatMap(category =>
            arrange(candidates.filter(p => this.productCategory(p) === category))
                .slice(0, PER_CATEGORY_LIMIT)
        );
    }

    // Titre unique, sans mention d'espèce : la sélection est déjà filtrée par
    // espèce en amont, la nommer dans le titre n'ajoutait rien.
    recommendationHeading() {
        return 'Produits fréquemment achetés ensemble';
    }

    renderRecommendation() {
        const slot = document.querySelector('[data-recharge="reco_slot"]');
        if (!slot) return;

        // Paiement en échec : la prochaine charge est déjà bloquée. Proposer un
        // ajout de plus n'aiderait personne (même règle que le modal).
        const products = this.paymentIssue === true ? [] : this.recommendedProducts();

        if (!products.length) {
            slot.innerHTML = '';
            slot.hidden = true;
            return;
        }

        const cards = products.map(product => {
            const variant = this.recommendedVariantFor(product);
            if (!variant) return '';

            const image = product.featured_image || PRODUCT_IMAGE_FALLBACK;

            // Ligne de contexte : accroche du produit, puis l'espèce quand elle
            // est connue. Le format n'y figure plus : quand il y en a plusieurs,
            // c'est le menu qui le porte.
            //
            // productAnimalType() et non animal_type brut : sans ça, l'huile de
            // saumon proposée à un foyer chien s'afficherait « · Chat ».
            const bits = [];
            if (product.subtitle) bits.push(this.escapeHtml(product.subtitle));
            const animal = this.productAnimalType(product);
            if (animal) bits.push(this.escapeHtml(animal));
            const meta = bits.length ? `<p class="reco-meta">${bits.join(' · ')}</p>` : '';

            // Choix du format dans la carte, comme dans les lignes du modal :
            // sans lui, « Ajouter » imposerait le plus petit format en silence.
            // Classe propre et NON `.variant-selector` : celle-ci est ramassée
            // par le querySelectorAll global du modal, dont le handler cherche
            // une `.product-item-modal` qui n'existe pas ici.
            const selectableVariants = (product.variants || []).filter(v => v.available);
            const select = selectableVariants.length > 1
                ? `<select class="reco-select" data-product-id="${product.id}" aria-label="Format — ${this.escapeHtml(product.title)}">
                                ${selectableVariants.map(v => `<option value="${v.id}" data-price="${v.price}" data-compare="${v.compare_at_price || ''}"${String(v.id) === String(variant.id) ? ' selected' : ''}>${this.escapeHtml(v.title)}</option>`).join('')}
                            </select>`
                : '';

            return `
                    <article class="reco-card" data-reco-product-id="${product.id}">
                        <img class="reco-img" src="${image}" alt="${this.escapeHtml(product.title)}" loading="lazy">
                        <div class="reco-text">
                            <h4 class="reco-title">${this.escapeHtml(product.title)}</h4>
                            ${meta}
                            ${select}
                            <div class="reco-foot">
                                <p class="reco-price">${this.recoPriceHTML(variant)}</p>
                                <button type="button"
                                        class="reco-add"
                                        data-recharge-action="add-recommended-product"
                                        data-product-id="${product.id}"
                                        data-variant-id="${variant.id}"
                                        aria-label="Ajouter ${this.escapeHtml(product.title)} à ma box">Ajouter</button>
                            </div>
                        </div>
                    </article>`;
        }).join('');

        slot.hidden = false;
        slot.innerHTML = `
            <section class="reco" aria-label="Suggestions pour votre box">
                <div class="reco-head">
                    <div class="reco-head-text">
                        <h3 class="reco-heading">${this.recommendationHeading()}</h3>
                    </div>
                    <button type="button" class="reco-all" data-recharge-action="add-subscription-product">Voir tout le catalogue →</button>
                </div>
                <div class="reco-carousel">
                    <button type="button" class="reco-arrow reco-arrow--prev" data-reco-prev aria-label="Produits précédents">‹</button>
                    <div class="reco-scroller" role="list">${cards}</div>
                    <button type="button" class="reco-arrow reco-arrow--next" data-reco-next aria-label="Produits suivants">›</button>
                </div>
            </section>`;

        this.attachRecommendationListeners(slot);

        // Le rail vient d'être recréé : état des flèches et suivi de position
        // sont à reposer sur CE nœud-là.
        const scroller = slot.querySelector('.reco-scroller');
        if (scroller) {
            scroller.addEventListener('scroll', () => this.updateRecoArrows(slot), { passive: true });
            this.updateRecoArrows(slot);
            // La largeur des cartes dépend du viewport : un redimensionnement
            // peut rendre le rail entièrement visible, donc les flèches inutiles.
            window.addEventListener('resize', () => this.updateRecoArrows(slot), { passive: true });
        }
    }

    // Flèches masquées quand il n'y a rien à faire défiler, désactivées à chaque
    // extrémité. Une flèche qui ne fait rien est pire que pas de flèche.
    updateRecoArrows(slot) {
        const scroller = slot.querySelector('.reco-scroller');
        const carousel = slot.querySelector('.reco-carousel');
        if (!scroller || !carousel) return;

        // 2px de tolérance : les navigateurs rendent des largeurs fractionnaires,
        // et scrollLeft n'atteint jamais exactement la borne.
        const overflow = scroller.scrollWidth - scroller.clientWidth;
        carousel.classList.toggle('is-scrollable', overflow > 2);

        const prev = slot.querySelector('[data-reco-prev]');
        const next = slot.querySelector('[data-reco-next]');
        if (prev) prev.disabled = scroller.scrollLeft <= 2;
        if (next) next.disabled = scroller.scrollLeft >= overflow - 2;
    }

    // Un cran = une carte. Mesuré sur le DOM plutôt qu'en dur : la largeur des
    // cartes change avec le viewport (78vw sous 640px).
    scrollRecoBy(slot, direction) {
        const scroller = slot.querySelector('.reco-scroller');
        if (!scroller) return;
        const card = scroller.querySelector('.reco-card');
        const gap = parseFloat(getComputedStyle(scroller).columnGap || '12') || 12;
        const step = card ? card.getBoundingClientRect().width + gap : scroller.clientWidth * 0.8;
        scroller.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    // Remise abonné AFFICHÉE : un taux fixe de 15 % appliqué au prix catalogue
    // Shopify. Ce n'est délibérément PAS la remise que Recharge facturera —
    // celle-là varie par client et par produit, et n'est connue qu'après l'ajout
    // (cf. le commentaire de renderDetailFooter). C'est un affichage commercial
    // volontairement uniforme, réservé aux surfaces d'AJOUT : le modal et
    // l'encart de recommandation. Ne pas l'étendre au récapitulatif ni aux
    // lignes de « Ma box », qui montrent ce qui est réellement facturé.
    static SUBSCRIBER_DISCOUNT_RATE = 0.15;

    // Écrit EXACTEMENT comme la pastille de « Ma box » (`-${pct}%`) : trait
    // d'union, pas d'espace. Même classe CSS, même couleur, même graphie.
    static SUBSCRIBER_DISCOUNT_LABEL = '-15%';

    // Arrondi au centime, en centimes : 1990 × 0,85 = 1691,5 → 1692, soit 16,92 €.
    // Faire le calcul en euros flottants ferait apparaître des 16,914999…
    static subscriberPriceCents(cents) {
        return Math.round(cents * (1 - RechargePortal.SUBSCRIBER_DISCOUNT_RATE));
    }

    // Même composition que la ligne du modal d'ajout : prix abonné, prix
    // catalogue barré, pastille. Le barré vaut TOUJOURS le prix catalogue et
    // jamais `compare_at_price` — deux barrés sur une carte aussi étroite
    // rendraient la remise annoncée illisible.
    recoPriceHTML(variant) {
        const fmt = cents => (cents / 100).toFixed(2).replace('.', ',') + ' €';
        const member = fmt(RechargePortal.subscriberPriceCents(variant.price));
        const was = `<span class="reco-was">${fmt(variant.price)}</span>`;
        const badge = `<span class="discount-badge">${RechargePortal.SUBSCRIBER_DISCOUNT_LABEL}</span>`;
        return member + was + badge;
    }

    // Délégué sur le conteneur : il est réécrit en entier à chaque rendu, donc
    // un listener par menu mourrait avec lui et il faudrait les rattacher à
    // chaque fois. Le conteneur, lui, ne change pas d'identité.
    attachRecommendationListeners(slot) {
        if (slot._recoBound) return;
        slot._recoBound = true;

        slot.addEventListener('click', (event) => {
            const arrow = event.target.closest?.('[data-reco-prev], [data-reco-next]');
            if (!arrow) return;
            this.scrollRecoBy(slot, arrow.hasAttribute('data-reco-next') ? 1 : -1);
        });

        slot.addEventListener('change', (event) => {
            const select = event.target.closest?.('.reco-select');
            if (!select) return;

            const card = select.closest('.reco-card');
            const option = select.options[select.selectedIndex];
            if (!card || !option) return;

            const priceEl = card.querySelector('.reco-price');
            if (priceEl) {
                priceEl.innerHTML = this.recoPriceHTML({
                    price: parseInt(option.getAttribute('data-price'), 10)
                });
            }

            // Le bouton porte la variante à ajouter : sans cette ligne, changer
            // de format modifierait le prix affiché et ajouterait l'autre.
            const button = card.querySelector('.reco-add');
            if (button) button.setAttribute('data-variant-id', select.value);
        });
    }

    // Format proposé : le moins cher disponible. Un produit d'impulsion se
    // propose dans sa plus petite contenance, pas dans son multipack.
    recommendedVariantFor(product) {
        const available = (product.variants || []).filter(v => v.available);
        if (!available.length) return null;
        return available.reduce((cheapest, v) => (v.price < cheapest.price ? v : cheapest), available[0]);
    }

    // Ajout direct, sans modal : c'est tout l'intérêt du bloc.
    async addRecommendedProduct(button) {
        if (this.paymentIssue === true) {
            if (typeof showNotification === 'function') {
                showNotification(
                    'Votre moyen de paiement doit être mis à jour avant d\'ajouter un produit.',
                    'error',
                    6000
                );
            }
            document.getElementById('payment-issue-banner')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
        }

        const subscription = (this.activeSubscriptions || [])[0];
        const productId = parseInt(button.getAttribute('data-product-id'), 10);
        const variantId = parseInt(button.getAttribute('data-variant-id'), 10);
        const product = (window.shopifyAllProducts || []).find(p => p.id === productId);

        if (!subscription || !product || !variantId) {
            console.error('[Reco] Contexte incomplet', { subscription: !!subscription, product: !!product, variantId });
            if (typeof showNotification === 'function') {
                showNotification('❌ Ajout impossible. Rechargez la page.', 'error');
            }
            return;
        }

        button.disabled = true;
        button.textContent = 'Ajout en cours…';

        try {
            await window.addProductToRechargeSubscription(
                { ...product, selectedVariantId: variantId },
                subscription.order_interval_frequency,
                subscription.next_charge_scheduled_at,
                {
                    intervalUnit: subscription.order_interval_unit,
                    chargeIntervalFrequency: subscription.charge_interval_frequency
                }
            );

            if (typeof showNotification === 'function') {
                showNotification(`✅ ${product.title} ajouté à votre box !`, 'success', 4000);
            }

            // Rechargement : renderSubscriptionProducts() en découle, donc le bloc
            // se recalcule et proposera autre chose (celui-ci est maintenant dans
            // la box, il sort des candidats).
            await this.loadSubscriptions();
            await this.loadOnetimes();
            this.updateSubscriptionData();
            await this.syncChargeAfterMutation();
        } catch (error) {
            console.error('[Reco] Échec de l\'ajout:', error);
            if (typeof showNotification === 'function') {
                showNotification(`Ajout impossible : ${error?.message || 'erreur inconnue'}`, 'error', 6000);
            }
            // Le bouton n'a pas été remplacé par un re-rendu (l'erreur est venue
            // avant) : il faut le rendre à nouveau cliquable.
            if (button.isConnected) {
                button.disabled = false;
                button.textContent = 'Ajouter à ma box';
            }
        }
    }

    renderSubscriptionProducts() {
        console.log('[RechargePortal] Génération HTML des produits d\'abonnement et onetimes...');

        const productsList = document.getElementById('subscription-products-list');

        if (!productsList) {
            console.error('[RechargePortal] ❌ Conteneur #subscription-products-list non trouvé');
            return;
        }

        console.log('[RechargePortal] ✅ Subscriptions actives:', this.activeSubscriptions?.length || 0);
        console.log('[RechargePortal] ✅ Onetimes:', this.onetimes?.length || 0);

        // Remis à zéro à CHAQUE rendu : sans ça, la note d'exclusivité resterait
        // affichée après la suppression d'un animal, alors que plus aucune ligne
        // n'offre de choix.
        this._petChipsRendered = false;
        // Idem pour la variante multi-animaux de la note : elle ne vaut que tant
        // qu'une ligne est livrée en plusieurs exemplaires.
        this._petChipsMulti = false;

        // ===========================
        // SECTION 1: PRODUITS EN ABONNEMENT
        // ===========================
        let subscriptionProductsHTML = '';

        // Dernière ligne d'abonnement : la corbeille devient un bouton "Remplacer".
        // Supprimer cette ligne annulerait le dernier abonnement (chaque produit EST
        // une subscription Recharge) : le client sortirait sans passer par le parcours
        // de désabonnement. La quantité n'entre pas en compte, seul le nombre de lignes.
        // Une ligne dont l'annulation est déjà partie ne compte plus comme survivante :
        // sans ça, la dernière ligne restante garde sa corbeille pendant l'aller-retour
        // API — le clic est bien bloqué, mais l'icône dit le contraire. La ligne en cours
        // d'annulation, elle, n'affiche plus de bouton : elle disparaît dans l'instant.
        const isPendingRemoval = (sub) => this._cancelsInFlight?.has(String(sub.id)) || false;
        const isSoloSubscription = (this.activeSubscriptions || []).filter(sub => !isPendingRemoval(sub)).length === 1;

        if (this.activeSubscriptions && this.activeSubscriptions.length > 0) {
            this.activeSubscriptions.forEach((subscription, index) => {
                // Récupérer les infos du produit depuis la subscription
                const productTitle = subscription.product_title || subscription.shopify_product_title || `Produit ${index + 1}`;
                const quantity = subscription.quantity || 1;

                // Récupérer l'image du produit (multi-sources)
                let imageUrl = null;

                // Source 1 : Direct depuis la subscription
                if (subscription.shopify_product_image_url) {
                    imageUrl = subscription.shopify_product_image_url;
                }

                // Source 2 : Chercher dans l'historique Recharge via external_product_id
                if (!imageUrl && subscription.external_product_id?.ecommerce) {
                    // Chercher dans toutes les subscriptions (même cancelled) pour trouver l'image
                    const allSubs = this.subscriptions || [];
                    const matchingSub = allSubs.find(sub =>
                        sub.external_product_id?.ecommerce == subscription.external_product_id.ecommerce &&
                        sub.shopify_product_image_url
                    );
                    if (matchingSub) {
                        imageUrl = matchingSub.shopify_product_image_url;
                        console.log(`[RechargePortal] ✅ Image trouvée via autre subscription pour "${productTitle}"`);
                    }
                }

                // Source 3 : Chercher dans les orders RÉCENTES par product_id
                if (!imageUrl && subscription.external_product_id?.ecommerce && this.orders && this.orders.length > 0) {
                    // Parcourir les orders de la plus récente à la plus ancienne
                    for (const order of this.orders) {
                        if (order.line_items && order.line_items.length > 0) {
                            const matchingItem = order.line_items.find(item =>
                                item.external_product_id?.ecommerce == subscription.external_product_id.ecommerce
                            );

                            if (matchingItem) {
                                imageUrl = matchingItem.images?.large ||
                                    matchingItem.images?.original ||
                                    matchingItem.shopify_product_image_url ||
                                    matchingItem.product_image_url;
                                if (imageUrl) {
                                    console.log(`[RechargePortal] ✅ Image trouvée via orders (product_id) pour "${productTitle}"`);
                                    break;
                                }
                            }
                        }
                    }
                }

                // Source 3 : Chercher dans window.shopifyAllProducts par shopify_variant_id
                if (!imageUrl && subscription.shopify_variant_id && window.shopifyAllProducts) {
                    for (const product of window.shopifyAllProducts) {
                        if (product.variants && product.variants.length > 0) {
                            const matchingVariant = product.variants.find(v => v.id == subscription.shopify_variant_id);
                            if (matchingVariant) {
                                imageUrl = product.featured_image;
                                if (imageUrl) break;
                            }
                        }
                    }
                }

                // Source 4 : Chercher dans window.shopifyAllProducts par external_variant_id (nouvelles subscriptions)
                if (!imageUrl && subscription.external_variant_id?.ecommerce && window.shopifyAllProducts) {
                    for (const product of window.shopifyAllProducts) {
                        if (product.variants && product.variants.length > 0) {
                            const matchingVariant = product.variants.find(v => String(v.id) === String(subscription.external_variant_id.ecommerce));
                            if (matchingVariant) {
                                imageUrl = product.featured_image;
                                console.log(`[RechargePortal] ✅ Image trouvée via external_variant_id pour "${productTitle}":`, imageUrl);
                                if (imageUrl) break;
                            }
                        }
                    }
                }

                // Fallback : Image placeholder SVG
                if (!imageUrl) {
                    imageUrl = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='84' height='84'%3E%3Crect fill='%23f0f0f0' width='84' height='84'/%3E%3Ctext fill='%2347605B' font-family='sans-serif' font-size='14' x='50%25' y='50%25' text-anchor='middle' dy='.3em'%3EProduit%3C/text%3E%3C/svg%3E";
                }

                console.log(`[RechargePortal] Produit ${index + 1} - Image trouvée:`, imageUrl ? '✅' : '❌');
                console.log(`[RechargePortal] Produit ${index + 1} - URL complète:`, imageUrl);
                console.log(`[RechargePortal] Produit ${index + 1} - Subscription data:`, {
                    shopify_product_image_url: subscription.shopify_product_image_url,
                    shopify_variant_id: subscription.shopify_variant_id,
                    product_title: subscription.product_title
                });

                // Texte de fréquence
                const subFreq = subscription.order_interval_frequency;
                const subUnitMap = {
                    day: { article: 'tous les', label: subFreq > 1 ? 'jours' : 'jour' },
                    week: { article: 'toutes les', label: subFreq > 1 ? 'semaines' : 'semaine' },
                    month: { article: 'tous les', label: 'mois' }
                };
                const subU = subUnitMap[subscription.order_interval_unit] || subUnitMap.month;
                const frequencyText = `Livraison ${subU.article} ${subFreq} ${subU.label}`;

                // Poids / conditionnement : variant_title Recharge ("6 x 400g", "1,5 kg"...),
                // sinon poids exact du variant depuis le catalogue Shopify
                const variantGrams = this.getVariantGrams(subscription);
                let packagingText = (subscription.variant_title && subscription.variant_title !== 'Default Title')
                    ? subscription.variant_title
                    : this.formatWeight(variantGrams);
                // Ligne quantité explicite + poids total si calculable
                let quantityLine = `Quantité : ${quantity}`;
                if (variantGrams) {
                    quantityLine += ` — ${this.formatWeight(variantGrams * quantity)} au total`;
                }

                // Calculer le prix pour ce produit
                const pricePerUnit = parseFloat(subscription.price) || 0;
                const totalPrice = (pricePerUnit * quantity).toFixed(2);

                // Prix barré si le prix Shopify original est supérieur
                const originalPrice = this.getOriginalShopifyPrice(subscription);
                let priceHTML = `<span class="product-price">${totalPrice}€</span>`;
                if (originalPrice && originalPrice > pricePerUnit) {
                    const originalTotal = (originalPrice * quantity).toFixed(2);
                    const pct = Math.round((1 - pricePerUnit / originalPrice) * 100);
                    priceHTML = `
                        <div class="product-price-wrapper">
                            <div class="product-price-top">
                                <span class="price-old">${originalTotal}€</span>
                                <span class="discount-badge">-${pct}%</span>
                            </div>
                            <span class="product-price">${totalPrice}€</span>
                        </div>`;
                }

                subscriptionProductsHTML += `
                    <div class="product-row" data-recharge="subscription_item_${index + 1}" data-product-index="${index}" data-subscription-id="${subscription.id}">
                        <div class="product-item">
                            <img
                                src="${imageUrl}"
                                alt="${productTitle}"
                                width="84"
                                height="84"
                                loading="lazy"
                                class="product-image-loaded"
                                onerror="console.error('[Image Error] Échec chargement:', this.src); this.style.border='2px solid red';"
                                onload="console.log('[Image Success] Chargée:', this.src);">
                            <div class="product-info">
                                <h3 class="product-name">${productTitle}</h3>
                                ${packagingText ? `<p class="product-packaging">${packagingText}</p>` : ''}
                                <p class="product-quantity-line">${quantityLine}</p>
                                <p class="product-details">
                                    ${frequencyText}
                                </p>
                                ${this.renderPetChips(subscription)}
                            </div>
                        </div>
                        <div class="quantity-group-wrapper">
                            <div class="quantity-group" data-product-index="${index}" data-subscription-id="${subscription.id}">
                                <button class="qty-btn qty-minus" data-recharge-action="decrease-quantity" data-subscription-id="${subscription.id}">−</button>
                                <span class="qty-value" data-recharge="product_quantity_${index + 1}">${quantity}</span>
                                <button class="qty-btn qty-plus" data-recharge-action="increase-quantity" data-subscription-id="${subscription.id}">+</button>
                            </div>
                            ${isPendingRemoval(subscription) ? '' : isSoloSubscription ? `
                            <button class="btn-swap-product" data-recharge-action="swap-subscription-product" data-subscription-id="${subscription.id}" title="Remplacer ce produit" aria-label="Remplacer ce produit par un autre">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2 5.333h9.333L9 3M14 10.667H4.667L7 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span class="btn-swap-label">Remplacer</span>
                            </button>
                            ` : `
                            <button class="btn-delete-product" data-recharge-action="delete-subscription-product" data-subscription-id="${subscription.id}" title="Supprimer ce produit">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2 4h12M5.333 4V2.667a1.333 1.333 0 011.334-1.334h2.666a1.333 1.333 0 011.334 1.334V4m2 0v9.333a1.333 1.333 0 01-1.334 1.334H4.667a1.333 1.333 0 01-1.334-1.334V4h9.334z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M6.667 7.333v4M9.333 7.333v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                            `}
                            ${priceHTML}
                        </div>
                    </div>
                `;
            });
        }

        // ===========================
        // SECTION 2: PRODUITS EN ACHAT UNIQUE (ONETIMES)
        // ===========================
        let onetimeProductsHTML = '';
        let onetimeSectionTitleHTML = '';

        console.log('[RechargePortal] 🔍 DEBUG ONE-TIMES:');
        console.log('[RechargePortal] - this.onetimes:', this.onetimes);
        console.log('[RechargePortal] - Nombre de one-times:', this.onetimes?.length || 0);
        if (this.onetimes && this.onetimes.length > 0) {
            console.log('[RechargePortal] - Détails des one-times:');
            this.onetimes.forEach((ot, i) => {
                console.log(`  [${i}]:`, {
                    id: ot.id,
                    product_title: ot.product_title,
                    quantity: ot.quantity,
                    price: ot.price,
                    status: ot.status,
                    next_charge_scheduled_at: ot.next_charge_scheduled_at
                });
            });
        }

        if (this.onetimes && this.onetimes.length > 0) {
            // Ajouter le titre de séparation
            onetimeSectionTitleHTML = `
                    <div class="section-title-separator">
                        <h3>PRODUITS EN ACHAT UNIQUE :</h3>
                    </div>
                `;

            this.onetimes.forEach((onetime, index) => {
                const productTitle = onetime.product_title || `Produit one-time ${index + 1}`;
                const quantity = onetime.quantity || 1;
                const nextCharge = this.estimatedDeliveryDate(onetime.next_charge_scheduled_at) || 'Non défini';

                // Récupérer l'image du produit
                let imageUrl = null;

                // Chercher dans window.shopifyAllProducts
                if (onetime.external_variant_id?.ecommerce && window.shopifyAllProducts) {
                    for (const product of window.shopifyAllProducts) {
                        if (product.variants && product.variants.length > 0) {
                            const matchingVariant = product.variants.find(v => String(v.id) === String(onetime.external_variant_id.ecommerce));
                            if (matchingVariant) {
                                imageUrl = product.featured_image;
                                if (imageUrl) break;
                            }
                        }
                    }
                }

                // Fallback : Image placeholder SVG
                if (!imageUrl) {
                    imageUrl = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='84' height='84'%3E%3Crect fill='%23f0f0f0' width='84' height='84'/%3E%3Ctext fill='%2347605B' font-family='sans-serif' font-size='14' x='50%25' y='50%25' text-anchor='middle' dy='.3em'%3EProduit%3C/text%3E%3C/svg%3E";
                }

                // Calculer le prix pour ce produit onetime
                const pricePerUnit = parseFloat(onetime.price) || 0;
                const totalPrice = (pricePerUnit * quantity).toFixed(2);

                // Poids / conditionnement (même logique que les abonnements)
                const otGrams = this.getVariantGrams(onetime);
                const otPackaging = (onetime.variant_title && onetime.variant_title !== 'Default Title')
                    ? onetime.variant_title
                    : this.formatWeight(otGrams);
                const otWeightTotal = otGrams ? ` — ${this.formatWeight(otGrams * quantity)} au total` : '';

                // Créer une ligne complète avec produit + contrôles
                onetimeProductsHTML += `
                        <div class="product-row" data-recharge="onetime_item_${index + 1}">
                            <div class="product-item product-item-onetime" data-onetime-id="${onetime.id}" data-product-index="onetime-${index}">
                                <img
                                    src="${imageUrl}"
                                    alt="${productTitle}"
                                    width="84"
                                    height="84"
                                    loading="lazy"
                                    class="product-image-loaded">
                                <div class="product-info">
                                    <h3 class="product-name">${productTitle}</h3>
                                    ${otPackaging ? `<p class="product-packaging">${otPackaging}</p>` : ''}
                                    <p class="product-quantity-line">Quantité : ${quantity}${otWeightTotal}</p>
                                    <p class="product-details">
                                        Prochaine livraison: ${nextCharge}
                                    </p>
                                    ${this.renderPetChips(onetime)}
                                </div>
                            </div>
                            <div class="quantity-group-wrapper">
                                <div class="quantity-group" data-product-index="onetime-${index}" data-onetime-id="${onetime.id}">
                                    <button class="qty-btn qty-minus" data-recharge-action="decrease-onetime-quantity" data-onetime-id="${onetime.id}">−</button>
                                    <span class="qty-value">${quantity}</span>
                                    <button class="qty-btn qty-plus" data-recharge-action="increase-onetime-quantity" data-onetime-id="${onetime.id}">+</button>
                                </div>
                                <button class="btn-delete-product" data-recharge-action="delete-onetime-product" data-onetime-id="${onetime.id}" title="Supprimer ce produit">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2 4h12M5.333 4V2.667a1.333 1.333 0 011.334-1.334h2.666a1.333 1.333 0 011.334 1.334V4m2 0v9.333a1.333 1.333 0 01-1.334 1.334H4.667a1.333 1.333 0 01-1.334-1.334V4h9.334z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M6.667 7.333v4M9.333 7.333v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button>
                                <span class="product-price">${totalPrice}€</span>
                            </div>
                        </div>
                    `;
            });
        }

        // ===========================
        // SECTION 3: INSERTION DANS LE DOM
        // ===========================

        // Trouver le conteneur des boutons
        const addProductActions = productsList.querySelector('.add-product-actions');

        // Supprimer tous les anciens produits et séparateurs
        // (.product-pets-hint inclus : sans ça, la note s'empilerait à chaque rendu)
        const existingProducts = productsList.querySelectorAll('.product-row, .section-title-separator, .product-pets-hint');
        existingProducts.forEach(p => p.remove());

        // Note affichée une seule fois, et seulement si au moins une ligne propose
        // vraiment un choix (drapeau posé par renderPetChips pendant la construction
        // du HTML ci-dessus). Un chien + un chat n'offrent aucun choix : pas de note.
        // Formulée comme une consigne avec son bénéfice, pas comme une règle sèche :
        // rien ne pousse le client à cliquer sur des pastilles vides s'il ignore
        // pourquoi on le lui demande.
        // Le parenthétique suit la règle réellement appliquée : dès qu'une ligne est
        // livrée en plusieurs exemplaires, "un seul animal par produit" serait faux.
        const petsHintHTML = this._petChipsRendered
            ? `<p class="product-pets-hint">Pour affiner la ration conseillée, indiquez à quel animal chaque produit est destiné (${this._petChipsMulti ? 'autant d\'animaux que d\'exemplaires commandés' : 'un seul animal par produit'}).</p>`
            : '';

        // Pas de tuile « + Ajouter un produit » en fin de grille : le CTA est
        // désormais sur la ligne de titre de la section (`.btn-section-add`), au-dessus
        // des lignes plutôt qu'en dessous. Il y remplit le même rôle — être dans le flux
        // de lecture, et non après le récapitulatif de prix — sans coûter de hauteur, et
        // il est atteignable sans faire défiler toute la box. Garder les deux aurait fait
        // trois appels au même modal dans une seule section.

        // Construire le HTML complet : Note + Subscriptions + Titre séparateur + Onetimes
        const completeHTML = petsHintHTML + subscriptionProductsHTML + onetimeSectionTitleHTML + onetimeProductsHTML;

        console.log('[RechargePortal] 🔍 HTML à injecter:');
        console.log('[RechargePortal] - Subscriptions HTML length:', subscriptionProductsHTML.length);
        console.log('[RechargePortal] - One-times title HTML length:', onetimeSectionTitleHTML.length);
        console.log('[RechargePortal] - One-times HTML length:', onetimeProductsHTML.length);
        console.log('[RechargePortal] - Total HTML length:', completeHTML.length);

        // La recommandation se recalcule à chaque rendu : elle dépend de ce qui
        // est dans la box, qui vient précisément de changer.
        this.renderRecommendation();

        // Insérer les produits AVANT les boutons
        if (addProductActions) {
            addProductActions.insertAdjacentHTML('beforebegin', completeHTML);
            console.log('[RechargePortal] ✅ HTML inséré avant les boutons');
        } else {
            productsList.innerHTML = completeHTML;
            console.log('[RechargePortal] ✅ HTML inséré directement dans productsList');
        }

        // ===========================
        // SECTION 4: RÉCAPITULATIF DES PRIX
        // ===========================

        // SOURCE PREMIÈRE : les lignes affichées au-dessus. Sous-total et remise sont
        // de l'arithmétique sur des nombres déjà à l'écran — le client doit pouvoir les
        // refaire de tête, et ils ne dépendent d'aucun aller-retour.
        //
        // La charge Recharge n'intervient que pour ce que le navigateur ne peut pas
        // savoir : frais de livraison, code promo, TVA — donc le TOTAL. Et elle n'est
        // utilisée que si elle décrit BIEN les lignes courantes : Recharge la reprice en
        // tâche de fond, sans délai garanti, et une charge en retard porte les montants
        // d'un autre état (symptôme observé : sous-total à 5 × le prix unitaire alors
        // que 2 unités restaient à l'écran). Périmée, elle est ignorée, pas affichée.
        const R = this.getChargeTotals();
        const pricingSummaryContainer = document.querySelector('.pricing-summary-container');

        // Prix "plein" (catalogue) et prix net, tous deux reconstruits depuis les lignes.
        let gross = 0;
        let grossAvailable = true; // garde-fou #4 : un produit hors catalogue → pas de remise affichée

        (this.activeSubscriptions || []).forEach(subscription => {
            const subPrice = parseFloat(subscription.price) || 0;
            const qty = subscription.quantity || 1;
            const originalPrice = this.getOriginalShopifyPrice(subscription);
            if (originalPrice != null) {
                gross += Math.max(originalPrice, subPrice) * qty;
            } else {
                grossAvailable = false;
                gross += subPrice * qty;
            }
        });

        (this.onetimes || []).forEach(onetime => {
            gross += (parseFloat(onetime.price) || 0) * (onetime.quantity || 1);
        });

        const lineNet = this.localNetSubtotal();
        const remiseAbo = grossAvailable ? Math.max(0, gross - lineNet) : 0;
        const displaySubtotal = grossAvailable ? gross : lineNet;

        const hasLines = (this.activeSubscriptions?.length || 0) + (this.onetimes?.length || 0) > 0;
        const chargeAligned = !!R && this.chargeReflectsLocalState();

        // Mémo de ce que SEUL Recharge sait : frais, code promo, TVA. Alimenté par
        // TOUTE charge, même non alignée — ces champs sont portés par la charge, pas
        // par ses lignes : des frais de port ne changent pas parce qu'une quantité a
        // bougé (sauf bascule du seuil relais 19 kg, vérifiée par localTotalIfSafe à
        // partir du poids catalogue). Sans ça, un rechargement de page en plein reprice
        // repartait sans aucun frais connu et ne pouvait plus afficher de total.
        if (R) {
            this._chargeExtras = {
                shipping: R.shipping,
                shippingTitle: R.shippingTitle,
                discounts: R.discounts,
                tax: R.tax
            };
        }

        if (R && !chargeAligned) {
            console.warn('[Pricing] Charge non alignée sur les lignes — ignorée pour l\'affichage', {
                chargeId: R.chargeId,
                subtotalCharge: R.subtotal,
                sommeDesLignes: Number(lineNet.toFixed(2))
            });
        }

        // Relances bornées dès que la charge ne décrit pas les lignes — y compris
        // quand il n'y en a AUCUNE (Recharge la recrée) : sans ça, un rechargement de
        // page tombant dans cette fenêtre restait bloqué sur « en cours de calcul »
        // jusqu'à ce que le client recharge lui-même.
        if (hasLines && !chargeAligned) {
            this.ensureChargeConvergence();
        }

        // Garde-fou #1 : aucune charge exploitable ET aucune ligne → rien à totaliser.
        // Le message distingue l'échec de chargement, l'anomalie (abo actif sans charge
        // préparée : adresse/zip ou mode de livraison invalide) et le cas normal.
        if (!hasLines) {
            const chargeLoadFailed = this.loadResults?.nextCharge && this.loadResults.nextCharge !== 'ok';
            const emptyMsg = chargeLoadFailed
                ? 'Impossible de charger votre récapitulatif pour le moment. '
                  + 'Rechargez la page ; si le problème persiste, contactez-nous.'
                : 'Récapitulatif disponible à votre prochaine commande.';
            if (pricingSummaryContainer) {
                pricingSummaryContainer.innerHTML = `<div class="pricing-empty">${emptyMsg}</div>`;
            }
            if (chargeLoadFailed && !this._recapIssueWarned) {
                this._recapIssueWarned = true;
                showNotification('⚠️ Récapitulatif momentanément indisponible. Rechargez la page.', 'error', 8000);
            }
            return;
        }

        // ---- Bas du récapitulatif : frais, promo, TVA, TOTAL ----
        let tailHTML;

        if (chargeAligned) {
            // Réconciliation : Recharge tranche. Un écart signale qu'une hypothèse du
            // calcul local ne tient pas (remise par paliers, prix décidé côté Recharge).
            if (Math.abs(lineNet - R.subtotal) > 0.01) {
                console.warn('[Pricing] Somme des lignes ≠ subtotal Recharge', {
                    sommeDesLignes: Number(lineNet.toFixed(2)),
                    subtotalCharge: R.subtotal,
                    chargeId: R.chargeId
                });
            }
            if (this._lastLocalTotal != null && Math.abs(this._lastLocalTotal - R.total) > 0.01) {
                console.warn('[Pricing] Total provisoire corrigé par Recharge', {
                    provisoire: Number(this._lastLocalTotal.toFixed(2)),
                    recharge: R.total,
                    chargeId: R.chargeId
                });
            }
            this._lastLocalTotal = null;

            // Mode de livraison affiché = titre réel de la charge (source unique).
            this.applyShippingMethodDisplay(R.shippingTitle);

            // Invariant Recharge : subtotal - discounts + shipping + tax === total.
            const recomputed = R.subtotal - R.discounts + R.shipping + R.tax;
            if (Math.abs(recomputed - R.total) > 0.01) {
                console.warn('[Pricing] Réconciliation KO', {
                    recomputed: Number(recomputed.toFixed(2)),
                    total: R.total,
                    chargeId: R.chargeId
                });
            }

            let promoRowHTML = '';
            if (R.discounts > 0 && this.nextCharge.discounts && this.nextCharge.discounts.length > 0) {
                const promoLabel = this.nextCharge.discounts.map(d => {
                    const code = d.code || 'Remise auto';
                    if (d.value_type === 'percentage') return `${code} (-${d.value}%)`;
                    if (d.value_type === 'fixed_amount') return `${code} (-${d.value}€)`;
                    if (d.value_type === 'shipping') return `${code} (livraison offerte)`;
                    return code;
                }).join(', ');
                promoRowHTML = `
                <div class="discount-row">
                    <span class="discount-label">Code promo : ${promoLabel}</span>
                    <span class="discount-amount">-${R.discounts.toFixed(2)}€</span>
                </div>`;
            }

            const taxRowHTML = R.tax > 0 ? `
                <div class="tax-row">
                    <span class="tax-label">TVA :</span>
                    <span class="tax-amount">${R.tax.toFixed(2)}€</span>
                </div>` : '';

            tailHTML = `
                ${promoRowHTML}
                <div class="shipping-row">
                    <span class="shipping-label">Frais de livraison :</span>
                    <span class="shipping-amount">${R.shipping > 0 ? `${R.shipping.toFixed(2)}€` : 'Offerte'}</span>
                </div>
                ${taxRowHTML}
                <div class="total-price-row">
                    <span class="total-label">TOTAL :</span>
                    <span class="total-amount">${R.total.toFixed(2)}€</span>
                </div>`;

            console.log(`[RechargePortal] Sous-total: ${displaySubtotal.toFixed(2)}€, Frais: ${R.shipping.toFixed(2)}€, Total: ${R.total.toFixed(2)}€ (charge #${R.chargeId})`);
        } else {
            // Charge absente ou en retard : le TOTAL n'est affiché que s'il ne reste
            // qu'une addition (cf localTotalIfSafe). Sinon on le dit, sans inventer.
            const safe = this.localTotalIfSafe();
            this._lastLocalTotal = safe ? safe.total : null;

            tailHTML = safe ? `
                <div class="shipping-row">
                    <span class="shipping-label">Frais de livraison :</span>
                    <span class="shipping-amount">${safe.shipping > 0 ? `${safe.shipping.toFixed(2)}€` : 'Offerte'}</span>
                </div>
                <div class="total-price-row">
                    <span class="total-label">TOTAL :</span>
                    <span class="total-amount">${safe.total.toFixed(2)}€</span>
                </div>` : `
                <div class="pricing-recalc">${
                    // Relances épuisées SANS aucune charge : ce n'est plus un reprice en
                    // cours, c'est une commande que Recharge n'a pas pu préparer (zip ou
                    // mode de livraison invalide). Le dire, plutôt que « en cours » à vie.
                    (!R && this._chargeConvergenceGivenUp)
                        ? 'Frais et total indisponibles : votre prochaine commande n\'a pas pu être préparée. Vérifiez votre adresse et votre mode de livraison, ou contactez-nous.'
                        : 'Frais de livraison et total en cours de calcul…'
                }</div>`;

            console.log('[Pricing] Récapitulatif calculé depuis les lignes', {
                sousTotal: Number(displaySubtotal.toFixed(2)),
                remise: Number(remiseAbo.toFixed(2)),
                total: safe ? Number(safe.total.toFixed(2)) : 'en attente de Recharge'
            });
        }

        const aboDiscountRowHTML = remiseAbo > 0 ? `
                <div class="discount-row">
                    <span class="discount-label">Remise abonnement :</span>
                    <span class="discount-amount">-${remiseAbo.toFixed(2)}€</span>
                </div>` : '';

        if (pricingSummaryContainer) {
            pricingSummaryContainer.innerHTML = `
                <div class="subtotal-row">
                    <span class="subtotal-label">Sous-total :</span>
                    <span class="subtotal-amount">${displaySubtotal.toFixed(2)}€</span>
                </div>
                ${aboDiscountRowHTML}
                ${tailHTML}`;
        } else {
            console.error('[RechargePortal] ❌ Conteneur .pricing-summary-container non trouvé !');
        }

        console.log(`[RechargePortal] ✅ ${this.activeSubscriptions?.length || 0} abo(s) + ${this.onetimes?.length || 0} achat(s) unique(s)`);
    }

    getOriginalShopifyPrice(subscription) {
        if (!window.shopifyAllProducts) return null;
        const variantId = subscription.shopify_variant_id
            || subscription.external_variant_id?.ecommerce;
        if (!variantId) return null;
        for (const product of window.shopifyAllProducts) {
            if (!product.variants) continue;
            const match = product.variants.find(v => String(v.id) === String(variantId));
            if (match) return match.price / 100;
        }
        return null;
    }

    // Vérité de facturation normalisée depuis la prochaine charge Recharge (statut queued).
    // Retourne null si aucune charge à venir n'est disponible.
    getChargeTotals() {
        const c = this.nextCharge;
        if (!c) return null;
        const shippingLines = c.shipping_lines || [];
        const shipping = shippingLines.reduce((s, l) => s + (parseFloat(l.price) || 0), 0);
        return {
            subtotal:  parseFloat(c.subtotal_price)  || 0,
            shipping,
            discounts: parseFloat(c.total_discounts) || 0,
            tax:       parseFloat(c.total_tax)       || 0,
            total:     parseFloat(c.total_price)     || 0,
            shippingTitle: shippingLines[0]?.title || null,
            shippingLines,
            chargeId:  c.id
        };
    }

    // Écrit le mode de livraison (titre réel de la charge) dans tous les éléments d'affichage.
    // Source unique : supprime la divergence entre les 2 éléments shipping_method.
    applyShippingMethodDisplay(title) {
        if (!title) return;
        // Wording client (avec délais) quand le titre de la charge correspond à
        // une de nos options ; titre brut sinon (rate historique/inconnu). Le
        // dataset garde le titre BRUT (matching = vérité charge, pas l'affichage).
        const option = RechargePortal.SHIPPING_OPTIONS.find(o => o.serverTitle === title);
        const display = option ? option.label : title;
        document.querySelectorAll('[data-recharge="shipping_method"]').forEach(el => {
            el.textContent = display;
            el.dataset.shippingTitle = title;
        });
        const current = document.querySelector('[data-recharge="current_shipping_method"]');
        if (current) current.textContent = display;
    }

    updateProductImages() {
        // Cette méthode est maintenant obsolète car renderSubscriptionProducts() gère tout
        console.log('[RechargePortal] updateProductImages() appelée - utiliser renderSubscriptionProducts() à la place');
    }

    updateOrdersData() {
        console.log('[RechargePortal] Mise à jour des données commandes...');

        if (!this.orders || this.orders.length === 0) {
            console.warn('[RechargePortal] Pas de commandes disponibles');
            return;
        }

        // Parcourir toutes les commandes
        this.orders.forEach((order, orderIndex) => {
            console.log(`[RechargePortal] Commande ${orderIndex}:`, order);

            // Si la commande a des line_items avec des images
            if (order.line_items && order.line_items.length > 0) {
                order.line_items.forEach((item, itemIndex) => {
                    const imageUrl = item.images?.large || item.images?.original || item.shopify_product_image_url || item.product_image_url;

                    if (imageUrl) {
                        // Mettre à jour les miniatures (preview)
                        const previewImg = document.querySelector(`[data-order-id="${order.id}"] .product-thumb:nth-child(${itemIndex + 1}) img`);
                        if (previewImg) {
                            previewImg.src = imageUrl;
                            previewImg.alt = item.title || item.product_title || 'Produit';
                        }

                        // Mettre à jour les images dans les détails
                        const detailImg = document.querySelector(`#details-${order.id} .product-detail-item:nth-child(${itemIndex + 1}) img`);
                        if (detailImg) {
                            detailImg.src = imageUrl;
                            detailImg.alt = item.title || item.product_title || 'Produit';
                        }

                        // Mettre à jour les titres et infos produit dans les détails
                        const productNameEl = document.querySelector(`#details-${order.id} .product-detail-item:nth-child(${itemIndex + 1}) .product-name`);
                        if (productNameEl && item.title) {
                            productNameEl.textContent = item.title;
                        }

                        const productQuantityEl = document.querySelector(`#details-${order.id} .product-detail-item:nth-child(${itemIndex + 1}) .product-quantity`);
                        if (productQuantityEl && item.quantity) {
                            productQuantityEl.textContent = `Qté : ${item.quantity}`;
                        }

                        const productPriceEl = document.querySelector(`#details-${order.id} .product-detail-item:nth-child(${itemIndex + 1}) .product-price`);
                        if (productPriceEl && item.price) {
                            productPriceEl.textContent = `${item.price} €`;
                        }
                    }
                });
            }
        });

        console.log('[RechargePortal] ✅ Données commandes mises à jour');
    }

    // ==========================================
    // MES ANIMAUX
    // Stockage : metaobject Shopify "customer_pets" (1 entrée par client,
    // handle customer-<shopify id>), via endpoint Vercel
    // Auth : Bearer <recharge session token> + recharge_customer_id (même
    // pattern anti-IDOR que l'endpoint order-tracking)
    // ==========================================
    static PETS_API_URL = 'https://pets-info-phi.vercel.app/api/pets';
    static FEEDING_API_URL = 'https://pets-info-phi.vercel.app/api/feeding';
    static MAX_PETS = 5;

    static PET_LABELS = {
        species: { dog: 'Chien', cat: 'Chat' },
        sex: { male: 'Mâle', female: 'Femelle' },
        age_range: { '0_1': '0 à 1 an', '1_10': '1 à 10 ans', '10_15': '10 à 15 ans' },
        weight_range: { '1_5': '1 à 5 kg', '6_10': '6 à 10 kg', '11_15': '11 à 15 kg', '16_plus': '16 kg et +' },
        body_condition: { thin: 'Maigre', normal: 'Corpulence normale', overweight: 'Enrobé(e)' },
        activity: { low: 'Peu d\'activité', normal: 'Activité normale', high: 'Beaucoup d\'activité' },
        // Chat : mode de vie (remplace le niveau d'activité). Trois paliers, le
        // seuil discriminant étant 6h dehors par jour — "maison" vaut k2 = 1.0.
        activity_cat: { indoor: 'Chat d\'appartement', house: 'Chat de maison', outdoor: 'Chat d\'extérieur' },
        // Explications affichées sous le select chat : sans elles, "maison" et
        // "extérieur" ne se distinguent pas, et l'écart de ration atteint 20 %.
        activity_cat_help: {
            indoor: 'Mon chat vit à l\'intérieur',
            house: 'Mon chat sort de temps en temps (jusqu\'à 6h par jour)',
            outdoor: 'Mon chat vit essentiellement à l\'extérieur (plus de 6h par jour)'
        }
    };

    // Listes de races par espèce (dropdown). "Croisé" et "Autre race" sont
    // ajoutés automatiquement par petBreedSelect(). Les races qui influencent le
    // calcul calorique (facteur k1 côté serveur — recherche par sous-chaîne) sont
    // présentes avec l'orthographe attendue :
    //   chien : Husky sibérien, Terre-Neuve, Golden Retriever, Cocker*, Beagle,
    //           Labrador Retriever, Dogue allemand, Lévrier*, Whippet
    //   chat  : Abyssin, Sphynx
    static PET_BREEDS = {
        dog: [
            "Affenpinscher", "Airedale Terrier", "Akita américain", "Akita Inu",
            "American Pit Bull Terrier", "American Bully", "Pit bull",
            "American Staffordshire Terrier", "Ancien chien d'arrêt danois",
            "Anglo-Français de petite vénerie", "Ariégeois", "Azawakh", "Barbet",
            "Barbu tchèque", "Barzoï", "Basenji", "Basset artésien normand",
            "Basset de Westphalie", "Basset des Alpes", "Basset fauve de Bretagne",
            "Basset Hound", "Beagle", "Beagle-Harrier", "Bearded Collie", "Beauceron",
            "Bedlington Terrier", "Berger allemand", "Berger australien", "Berger belge",
            "Malinois", "Berger blanc suisse", "Berger catalan", "Berger d'Anatolie",
            "Berger d'Asie centrale", "Berger d'Islande", "Berger de Bergame",
            "Berger de Brie", "Berger de l'Atlas", "Berger de Maremme et des Abruzzes",
            "Berger de Picardie", "Berger de Russie", "Berger des Pyrénées",
            "Berger des Shetland", "Berger du Caucase", "Berger du massif du Karst",
            "Berger finnois de Laponie", "Berger hollandais", "Berger polonais de plaine",
            "Berger polonais de Podhale", "Berger portugais", "Berger yougoslave",
            "Bichon à poil frisé", "Bichon bolonais", "Bichon havanais", "Bichon maltais",
            "Billy", "Black and tan Coonhound", "Bleu de Gascogne", "Bobtail", "Boerboel",
            "Border Collie", "Border Terrier", "Bouledogue", "Bouledogue anglais",
            "Bouledogue français", "Bouvier bernois", "Bouvier d'Appenzell",
            "Bouvier d'Australie", "Bouvier de l'Entlebuch", "Bouvier des Ardennes",
            "Bouvier des Flandres", "Boxer", "Brachet allemand",
            "Brachet autrichien noir et feu", "Brachet de Styrie à poil dur",
            "Brachet polonais", "Brachet tyrolien", "Braque allemand à poil court",
            "Braque allemand à poil dur", "Braque allemand à poil raide",
            "Braque d'Auvergne", "Braque de Burgos", "Braque de l'Ariège",
            "Braque de Weimar", "Braque du Bourbonnais", "Braque français",
            "Braque hongrois à poil court", "Braque hongrois à poil dur", "Braque italien",
            "Braque Saint-Germain", "Braque slovaque à poil dur", "Briquet Griffon vendéen",
            "Broholmer", "Buhund norvégien", "Bull Terrier", "Bulldog", "Bulldog anglais",
            "Bulldog australien", "Bulldog américain", "Bulldog français", "Bullmastiff",
            "Cairn Terrier", "Cane Corso", "Caniche", "Caniche royal",
            "Cão de Castro Laboreiro", "Cão fila de São Miguel", "Carlin",
            "Cavalier King Charles Spaniel", "Chesapeake Bay Retriever",
            "Chien chinois à crête", "Chien courant d'Istrie à poil dur",
            "Chien courant d'Istrie à poil ras", "Chien courant de Bosnie à poil dur",
            "Chien courant de Halden", "Chien courant de Hygen", "Chien courant de Posavatz",
            "Chien courant de Transylvanie", "Chien courant espagnol", "Chien courant finnois",
            "Chien courant hellénique", "Chien courant italien", "Chien courant serbe",
            "Chien courant slovaque", "Chien courant suisse",
            "Chien courant yougoslave de montagne", "Chien courant yougoslave tricolore",
            "Chien d'arrêt allemand à poil long", "Chien d'arrêt portugais", "Chien d'Artois",
            "Chien d'eau américain", "Chien d'eau espagnol", "Chien d'eau frison",
            "Chien d'eau irlandais", "Chien d'eau portugais", "Chien d'eau romagnol",
            "Chien d'élan norvégien", "Chien d'élan suédois", "Chien d'ours de Carélie",
            "Chien d'Oysel", "Chien de berger de Croatie", "Chien de berger de Majorque",
            "Chien de Canaan", "Chien de montagne des Pyrénées", "Chien de montagne portugais",
            "Chien de Saint-Hubert", "Chien de Taïwan", "Chien du Groenland",
            "Chien du pharaon", "Chien finnois de Laponie", "Chien norvégien de Macareux",
            "Chien nu du Pérou", "Chien nu mexicain", "Chien rouge de Bavière",
            "Chien rouge de Hanovre", "Chien suédois de Laponie", "Chien thaïlandais",
            "Chien-loup de Saarloos", "Chien-loup tchèque", "Chihuahua", "Chow-Chow",
            "Cirneco de l'Etna", "Clumber Spaniel", "Cocker américain", "Cocker anglais",
            "Colley à poil court", "Colley à poil long", "Coton de Tuléar",
            "Curly-Coated Retriever", "Cursinu", "Dalmatien", "Dandie Dinmont Terrier",
            "Dobermann", "Dogo canario", "Dogue allemand", "Dogue argentin",
            "Dogue de Bordeaux", "Dogue de Majorque", "Dogue du Tibet", "Drever", "Dunker",
            "Épagneul à perdrix de Drente", "Épagneul bleu de Picardie", "Épagneul breton",
            "Épagneul de Pont-Audemer", "Épagneul français", "Épagneul japonais",
            "Épagneul nain continental", "Épagneul picard", "Épagneul tibétain", "Eurasier",
            "Field Spaniel", "Fila brasileiro", "Flat-Coated Retriever", "Fox-Terrier",
            "Foxhound américain", "Foxhound anglais", "Français blanc et noir",
            "Français blanc et orange", "Français tricolore", "Golden Retriever",
            "Grand Anglo-Français blanc et noir", "Grand Anglo-Français blanc et orange",
            "Grand Anglo-Français tricolore", "Grand Basset Griffon vendéen",
            "Grand bouvier suisse", "Grand Gascon saintongeois", "Grand Griffon vendéen",
            "Grand Münsterländer", "Greyhound", "Griffon à poil dur Korthals",
            "Griffon belge", "Griffon bruxellois", "Griffon fauve de Bretagne",
            "Griffon nivernais", "Hamilton stövare", "Harrier", "Hokkaido Ken", "Hovawart",
            "Husky sibérien", "Irish Glen of Imaal Terrier", "Irish Terrier",
            "Irish Terrier à poil doux", "Jack Russell Terrier", "Jagdterrier", "Kai",
            "Kelpie", "Kerry Blue Terrier", "King Charles Spaniel", "Kishu", "Komondor",
            "Korea Jindo dog", "Kromfohrländer", "Kuvasz", "Labrador Retriever",
            "Laika de Sibérie occidentale", "Laïka de Sibérie orientale",
            "Laïka russe européen", "Lakeland Terrier", "Landseer", "Leonberger",
            "Lévrier afghan", "Lévrier écossais", "Lévrier espagnol", "Lévrier hongrois",
            "Lévrier irlandais", "Lévrier polonais", "Lhassa Apso", "Malamute de l'Alaska",
            "Manchester Terrier", "Mastiff", "Mâtin des Pyrénées", "Mâtin espagnol",
            "Mâtin napolitain", "Mudi", "Norfolk Terrier et Norwich Terrier", "Otterhound",
            "Parson Russell Terrier", "Pékinois", "Petit Basset Griffon vendéen",
            "Petit brabançon", "Petit chien courant suisse",
            "Petit chien hollandais de chasse au gibier d'eau", "Petit chien lion",
            "Petit Gascon saintongeois", "Petit Lévrier italien", "Petit Münsterländer",
            "Pinscher", "Pinscher autrichien à poil court", "Podenco canario",
            "Podenco ibicenco", "Podenco portugais", "Pointer anglais", "Poitevin",
            "Pomeranian", "Porcelaine", "Pudelpointer", "Puli", "Pumi",
            "Rafeiro do Alentejo", "Retriever de la Nouvelle-Écosse", "Rhodesian Ridgeback",
            "Rottweiler", "Russkiy Toy", "Saint-Bernard", "Saluki", "Samoyède",
            "Schapendoes néerlandais", "Schiller stövare", "Schipperke", "Schnauzer",
            "Scottish Terrier", "Sealyham Terrier", "Setter anglais", "Setter Gordon",
            "Setter irlandais", "Setter irlandais rouge et blanc", "Shar Pei", "Shiba Inu",
            "Shih Tzu", "Shikoku", "Silky Terrier", "Skye Terrier", "Sloughi",
            "Slovensky cuvac", "Småland stövare", "Smous des Pays-Bas", "Spinone",
            "Spitz allemand", "Spitz de Norbotten", "Spitz des Wisigoths", "Spitz finlandais",
            "Spitz japonais", "Spitz nain", "Springer anglais", "Stabyhoun",
            "Staffordshire Bull Terrier", "Sussex Spaniel", "Teckel", "Terre-Neuve",
            "Terrier australien", "Terrier brésilien", "Terrier de Boston", "Terrier japonais",
            "Terrier noir russe", "Terrier tchèque", "Terrier tibétain", "Tosa",
            "Toy Terrier anglais noir et feu", "Volpino", "Welsh Corgi",
            "Welsh Springer Spaniel", "Welsh Terrier", "West Highland White Terrier",
            "Whippet", "Yorkshire Terrier"
        ],
        cat: [
            "Chat de maison à poil court", "Chat de maison à poil mi-long",
            "Chat de maison à poil long", "Chat de gouttière", "Abyssin",
            "Américain Bobtail", "Américain Curl", "Américain Shorthair", "Angora Turc",
            "Balinais", "Bengal", "Birman", "Bleu Russe", "Bobtail Japonais", "Bombay",
            "British Longhair", "British Shorthair", "Brumese", "Calico", "Chartreux",
            "Cornish Rex", "Devon Rex", "Ecaille de tortue", "Exotic Shorthair", "Européen",
            "Havana Brown", "Highland Fold", "Javanais", "Korat", "Maine Coon", "Mandarin",
            "Manx", "Mau Egyptien", "Munchkin", "Norvégien", "Oriental Shorthair", "Persan",
            "Pixie Bob", "Ragdoll", "Sacré de Birmanine", "Savannah", "Scottish Fold",
            "Siamois", "Sibérien", "Snow shoe", "Somali", "Sphynx", "Thaï", "Tonkinois",
            "Tricolore", "Turc de Van"
        ]
    };

    // <option> d'un select de races pour une espèce.
    // "Croisé" et "Autre race" sont placés EN HAUT (juste après le placeholder).
    petBreedSelect(species, current) {
        const list = RechargePortal.PET_BREEDS[species] || [];
        const options = ['Croisé', 'Autre race', ...list];
        const matched = !!current && options.includes(current);
        // Ancienne saisie libre hors liste : on ne la conserve PAS comme option
        // (sinon elle resterait une valeur "valide" qui re-bloquerait au prochain
        // passage). On retombe sur le placeholder pour forcer une vraie sélection.
        let html = `<option value="" ${matched ? '' : 'selected'}>—</option>`;
        for (const b of options) {
            html += `<option value="${this.escapeHtml(b)}" ${current === b ? 'selected' : ''}>${this.escapeHtml(b)}</option>`;
        }
        return html;
    }

    // Race "confirmée" = choisie dans la liste déroulante actuelle (ou Croisé /
    // Autre race). Une ancienne saisie libre hors liste, ou l'absence de race,
    // n'est PAS confirmée : on invite l'utilisateur à la valider pour affiner le k1.
    isBreedConfirmed(pet) {
        if (!pet) return false;
        const b = (pet.breed || '').trim();
        if (!b) return false;
        if (b === 'Croisé' || b === 'Autre race') return true;
        const list = RechargePortal.PET_BREEDS[pet.species] || [];
        return list.includes(b);
    }

    // Légende des trois modes de vie du chat, sous le select.
    activityCatHint() {
        const L = RechargePortal.PET_LABELS;
        return Object.entries(L.activity_cat_help)
            .map(([key, help]) => `<li><strong>${L.activity_cat[key]}</strong> — ${help}</li>`)
            .join('');
    }

    // <option> d'un select depuis une map de labels
    petSelectOptions(map, current) {
        let html = `<option value="" ${!current ? 'selected' : ''}>—</option>`;
        for (const [val, label] of Object.entries(map)) {
            html += `<option value="${val}" ${current === val ? 'selected' : ''}>${label}</option>`;
        }
        return html;
    }

    escapeHtml(str) {
        return String(str ?? '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    // Âge en années, calculé à la volée depuis birthdate (pas de dérive).
    // Repli sur age_years pour les animaux enregistrés avant la date de naissance.
    petAgeYears(pet) {
        if (pet?.birthdate) {
            const d = new Date(pet.birthdate);
            if (!isNaN(d.getTime())) {
                const years = (Date.now() - d.getTime()) / (365.25 * 24 * 3600 * 1000);
                if (years >= 0) return Math.round(years * 100) / 100;
            }
        }
        return typeof pet?.age_years === 'number' ? pet.age_years : null;
    }

    petIconHTML(species) {
        const tpl = document.getElementById(species === 'cat' ? 'pet-icon-cat' : 'pet-icon-dog');
        return tpl ? tpl.innerHTML : '';
    }

    // Ouverture de l'onglet : lazy-load au premier affichage
    async openPetsTab() {
        const container = document.querySelector('[data-recharge="pets_container"]');
        if (!container) return;

        // Mode Shopify-only : pas de token Recharge → endpoint inaccessible
        if (this.isShopifyOnly === true) {
            container.innerHTML = `
                <div class="pets-empty">
                    <p>La gestion des animaux est disponible pour les clients abonnés.</p>
                </div>`;
            return;
        }

        if (!this.petsLoaded) {
            container.innerHTML = '<div class="pets-loading"><p>Chargement de vos animaux...</p></div>';
            await this.loadPets();
        }
        this.renderPetsTab();
    }

    loadPets() {
        // Promesse partagée : un toggle rapide d'onglets pendant le chargement
        // réutilise le fetch en vol au lieu d'en lancer un deuxième
        if (this._petsLoadingPromise) return this._petsLoadingPromise;

        this._petsLoadingPromise = (async () => {
            try {
                const url = `${RechargePortal.PETS_API_URL}?recharge_customer_id=${encodeURIComponent(this.customerId)}`;
                const res = await fetch(url, {
                    headers: { 'Authorization': `Bearer ${this.apiToken}` }
                });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const data = await res.json();
                this.pets = data.pets?.pets || [];
                this.petsError = false;
                console.log('[Pets] ✅ Animaux chargés:', this.pets.length);
            } catch (e) {
                console.error('[Pets] ❌ Erreur chargement:', e);
                this.pets = [];
                this.petsError = true;
            } finally {
                this.petsLoaded = true;
                this._petsLoadingPromise = null;
            }
        })();

        return this._petsLoadingPromise;
    }

    async savePets(newPets) {
        // Verrou : sérialise les écritures (double-clic supprimer / enregistrer)
        if (this._petsSaving) {
            throw new Error('Sauvegarde déjà en cours');
        }
        this._petsSaving = true;
        // Garde-fou : un fetch qui ne se termine jamais (connexion suspendue, cold
        // start bloqué) laisserait _petsSaving à true, et avec lui le verrou qui
        // sérialise les écritures — toute sauvegarde ultérieure serait refusée pour
        // le reste de la session, et la file d'attente de flushPetsSave tournerait
        // indéfiniment. Un abandon explicite vaut mieux qu'une attente sans fin.
        const controller = new AbortController();
        const abortTimer = setTimeout(() => controller.abort(), 15000);
        try {
            const res = await fetch(RechargePortal.PETS_API_URL, {
                method: 'POST',
                signal: controller.signal,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.apiToken}`
                },
                body: JSON.stringify({
                    recharge_customer_id: this.customerId,
                    pets: { version: 1, pets: newPets }
                })
            });
            const data = await res.json();
            if (!res.ok || !data.success) {
                throw new Error(data.error || `HTTP ${res.status}`);
            }
            this.pets = data.pets?.pets || newPets;
            // Les chips "Pour : ..." de l'onglet abonnement identifient l'animal par
            // sa POSITION dans this.pets. Une suppression décale les positions, un
            // ajout en crée une, un renommage change le libellé — et switchTab ne
            // fait que basculer des classes CSS, sans redessiner. Sans ce re-render,
            // un chip périmé écrirait sur le mauvais animal. Centralisé ici : toute
            // mutation d'animaux passe par savePets, présente et à venir.
            // Isolé : une erreur de rendu ne doit pas être prise pour un échec
            // d'écriture, ce qui provoquerait le rollback de données pourtant
            // enregistrées.
            try {
                this.renderSubscriptionProducts();
            } catch (e) {
                console.warn('[Pets] Rendu des produits après sauvegarde:', e);
            }
        } finally {
            clearTimeout(abortTimer);
            this._petsSaving = false;
        }
    }

    // ==========================================
    // LIEN ANIMAL <-> PRODUIT
    // Stocké côté animal (pet.foods), édité depuis l'onglet "Gérer mon abonnement"
    // en cochant des animaux sur une ligne produit.
    // Clé = product_id Shopify + taille de croquette. PAS variant_id : le
    // conditionnement (2/6/12 KG) change le variant sans rien changer d'autre, un
    // passage de 2KG à 12KG casserait donc le lien.
    // ==========================================

    // Taille de croquette portée par le titre du variant Recharge.
    // MÊME convention que resolveKcalPer100g côté serveur (_nutrition.js).
    foodSize(item) {
        const title = String(item?.variant_title || '').toLowerCase();
        if (/petite/.test(title)) return 'petite';
        if (/grande/.test(title)) return 'grande';
        return null;
    }

    // product_id Shopify d'un abonnement OU d'un achat unique (même forme d'objet).
    // Repli par le variant : les achats uniques n'exposent pas toujours le produit,
    // alors qu'ils portent toujours external_variant_id.
    foodProductId(item) {
        const id = item?.external_product_id?.ecommerce || item?.shopify_product_id;
        if (id) return String(id);

        const variantId = item?.external_variant_id?.ecommerce || item?.shopify_variant_id;
        if (!variantId || !window.shopifyAllProducts) return null;
        const product = window.shopifyAllProducts.find(p =>
            (p.variants || []).some(v => String(v.id) === String(variantId)));
        return product ? String(product.id) : null;
    }

    // Identité d'un aliment : le même produit en Petite et en Grande = deux aliments.
    foodKey(productId, size) {
        return `${productId}|${size || ''}`;
    }

    // Titre d'un aliment renvoyé par /api/feeding. On indexe par product_id + taille,
    // mais le serveur peut connaître une taille que nous ne voyons pas : sur les
    // doublons catalogue « Mig », elle est portée par le TITRE PRODUIT et non par le
    // variant_title (cf ALIASES dans _nutrition.js). Sa clé vaut alors `id|petite`
    // quand la nôtre vaut `id|`. On retombe donc sur la clé sans taille, puis sur
    // n'importe quelle taille du même produit, plutôt que d'afficher « Produit ».
    foodTitle(titleByFood, food) {
        const exact = titleByFood[this.foodKey(food.product_id, food.size)];
        if (exact) return exact;
        const sizeless = titleByFood[this.foodKey(food.product_id, null)];
        if (sizeless) return sizeless;
        const prefix = `${food.product_id}|`;
        const anySize = Object.keys(titleByFood).find(k => k.startsWith(prefix));
        return (anySize && titleByFood[anySize]) || 'Produit';
    }

    // Produits susceptibles de nourrir un animal : abonnements actifs + achats
    // uniques. Ceux affichés dans l'onglet sont ceux que le client reçoit.
    linkableItems() {
        return [
            ...(this.subscriptions || []).filter(sub => sub.status === 'active'),
            ...(this.onetimes || [])
        ];
    }

    // Une entrée `foods` correspond-elle à ce produit ? `size` absent d'un côté ou de
    // l'autre = "toute taille de ce produit". Prédicat unique, partagé par l'affichage
    // et par la bascule : les deux ne peuvent pas diverger.
    foodMatches(food, productId, size) {
        return String(food.product_id) === String(productId)
            && (!food.size || !size || food.size === size);
    }

    isFoodLinkedToPet(productId, size, pet) {
        if (!Array.isArray(pet?.foods)) return false;
        return pet.foods.some(f => this.foodMatches(f, productId, size));
    }

    // Index du catalogue par id de produit. Reconstruit uniquement quand le
    // TABLEAU change d'identité (chargement initial, rechargement) : sans cache,
    // chaque ligne d'abonnement rebalaierait le catalogue entier au rendu.
    catalogProduct(productId) {
        // Le tableau brut, sans `|| []` : un repli créerait un tableau NEUF à
        // chaque appel, l'identité changerait toujours et le cache serait
        // reconstruit à chaque ligne tant que le catalogue n'est pas là.
        const catalog = window.shopifyAllProducts;
        if (this._catalogIndexSource !== catalog) {
            this._catalogIndexSource = catalog;
            this._catalogIndex = new Map((catalog || []).map(p => [Number(p.id), p]));
        }
        return this._catalogIndex.get(Number(productId)) || null;
    }

    // Espèce d'un produit, en vocabulaire fiche animal ('dog' / 'cat' / null).
    // Deux sources, dans cet ordre :
    //
    //   1. Le CATALOGUE, dès qu'il est chargé : il porte la règle complète de
    //      productAnimalType() — override « chien et chat », puis animal_type,
    //      puis collection de rayon. C'est la même vérité que le modal et que la
    //      reco, ce qui évite qu'une ligne soit « chien » dans le modal et
    //      « chien ou chat » sous la puce « Ce produit est pour : ».
    //   2. À défaut, les Sets rendus en Liquid depuis produits-chiens /
    //      produits-chats. Ils sont là dès le parse, sans appel réseau : c'est
    //      ce qui répond tant que le catalogue Shopify n'est pas revenu. Ils
    //      contiennent des ids NUMÉRIQUES, d'où la conversion.
    //
    // null = espèce non prouvée -> aucun filtrage, tous les animaux proposés.
    productSpecies(productId) {
        const id = Number(productId);

        const product = this.catalogProduct(id);
        if (product) {
            const animal = this.productAnimalType(product);
            if (animal === 'Chien') return 'dog';
            if (animal === 'Chat') return 'cat';
            return null;
        }

        if (window.dogProductIds?.has(id)) return 'dog';
        if (window.catProductIds?.has(id)) return 'cat';
        return null;
    }

    // Animaux proposables sur une ligne produit. Espèce non prouvée (friandise,
    // accessoire, huile « chien et chat », produit absent du catalogue et de
    // toute collection d'espèce) -> tous les animaux : on ne retire que les
    // incompatibilités prouvées.
    // Le calcul de ration, lui, refiltre par espèce côté serveur (api/feeding.js) :
    // ce filtre-ci n'est qu'un confort d'affichage, il ne protège aucun calcul.
    petsForProduct(productId) {
        const pets = this.pets || [];
        const species = this.productSpecies(productId);
        return species ? pets.filter(pet => pet.species === species) : pets;
    }

    // À quel animal ce produit est-il destiné ? Règle unique de résolution :
    //   1. un lien explicite, posé par le client -> cet animal ;
    //   2. sinon, s'il n'existe qu'UN candidat de la bonne espèce -> lui, par
    //      déduction (c'est ce qu'affiche la mention statique) ;
    //   3. sinon -> null : la question est ouverte, seul le client peut trancher.
    //
    // Volontairement DÉRIVÉ à la lecture, jamais stocké. Écrire le cas 2 en base
    // figerait une déduction que le client n'a pas formulée : l'adoption d'un second
    // chien la rendrait fausse sans que rien ne la corrige. Recalculée, elle suit.
    // C'est aussi la règle que devra appliquer le tamponnage des étiquettes.
    resolvePetForProduct(item) {
        const productId = this.foodProductId(item);
        if (!productId) return null;

        const size = this.foodSize(item);
        const explicit = (this.pets || []).find(pet => this.isFoodLinkedToPet(productId, size, pet));
        if (explicit) return explicit;

        const candidates = this.petsForProduct(productId);
        return candidates.length === 1 ? candidates[0] : null;
    }

    // Court-circuit global : rien à afficher sans aucun animal, ni si le chargement a
    // échoué. Ne préjuge PAS du nombre de candidats par produit — c'est renderPetChips
    // qui tranche, produit par produit (un seul candidat -> mention statique).
    petChipsEnabled() {
        return !this.petsError && (this.pets || []).length >= 1;
    }

    // Ligne "Pour : ..." sous un produit, dans deux formes distinctes.
    //
    // UN SEUL animal possible (client mono-animal, ou chien + chat où le filtre
    // espèce ne laisse qu'un candidat) : mention STATIQUE, non cliquable, affichée
    // comme attribuée. Il n'y a aucun choix à faire — une pastille à cocher serait
    // du bruit — mais le client voit à qui le produit est destiné. Rien n'est écrit
    // en base : l'association reste implicite, et le calcul de ration s'appuie déjà
    // sur le filtrage par espèce.
    //
    // PLUSIEURS animaux possibles : pastilles cliquables, exclusives entre elles
    // tant que la ligne n'est livrée qu'en un exemplaire (cf `capacity` ci-dessous).
    renderPetChips(item) {
        if (!this.petChipsEnabled()) return '';

        const productId = this.foodProductId(item);
        if (!productId) return '';

        const pets = this.petsForProduct(productId);
        if (pets.length === 0) return '';

        if (pets.length === 1) {
            // Même règle que resolvePetForProduct : un seul candidat, donc déduit.
            const pet = this.resolvePetForProduct(item);
            if (!pet) return '';
            return `<div class="product-pets">
                        <span class="product-pets-label">Ce produit est pour :</span>
                        <span class="product-pet-chip selected product-pet-chip--static">
                            <span class="product-pet-chip-icon">${this.petIconHTML(pet.species)}</span>${this.escapeHtml(pet.name)}
                        </span>
                    </div>`;
        }

        // Sert à n'afficher la note d'exclusivité que si au moins une ligne propose
        // réellement un choix (cf renderSubscriptionProducts).
        this._petChipsRendered = true;

        // Nombre d'animaux attribuables sur cette ligne = nombre d'exemplaires
        // livrés. Un seul sac ne nourrit qu'un animal (choix exclusif), deux sacs
        // peuvent en nourrir deux. Le plafond est porté par le bouton : togglePetFood
        // n'a pas la ligne produit sous la main.
        const capacity = Math.max(1, parseInt(item?.quantity, 10) || 1);
        if (capacity > 1) this._petChipsMulti = true;

        const size = this.foodSize(item);
        const chips = pets.map((pet) => {
            const petIndex = this.pets.indexOf(pet);
            const linked = this.isFoodLinkedToPet(productId, size, pet);
            return `<button type="button" class="product-pet-chip${linked ? ' selected' : ''}"
                        data-recharge-action="toggle-pet-food"
                        data-pet-index="${petIndex}"
                        data-product-id="${productId}"
                        data-food-size="${size || ''}"
                        data-food-capacity="${capacity}"
                        aria-pressed="${linked}">
                        <span class="product-pet-chip-icon">${this.petIconHTML(pet.species)}</span>${this.escapeHtml(pet.name)}
                    </button>`;
        }).join('');

        return `<div class="product-pets">
                    <span class="product-pets-label">Ce produit est pour :</span>
                    ${chips}
                </div>`;
    }

    // Bascule le lien produit <-> animal. Affichage optimiste (this.pets fait foi à
    // l'écran), écriture débouncée : une rafale de clics = une seule requête.
    togglePetFood(button) {
        const petIndex = parseInt(button.dataset.petIndex, 10);
        const pet = (this.pets || [])[petIndex];
        if (!pet) return;

        const productId = button.dataset.productId;
        const size = button.dataset.foodSize || null;
        const capacity = Math.max(1, parseInt(button.dataset.foodCapacity, 10) || 1);
        const wasLinked = this.isFoodLinkedToPet(productId, size, pet);

        // Plafond : autant d'animaux que d'exemplaires livrés. Au-delà, on refuse
        // plutôt que de décocher quelqu'un d'autre — le client saurait pas lequel a
        // sauté. Le message dit comment débloquer (augmenter la quantité).
        if (!wasLinked && capacity > 1) {
            const linkedCount = (this.pets || [])
                .filter(other => this.isFoodLinkedToPet(productId, size, other)).length;
            if (linkedCount >= capacity) {
                if (typeof showNotification === 'function') {
                    showNotification(
                        `Ce produit est livré en ${capacity} exemplaires : il peut être attribué à ${capacity} animaux au maximum. Augmentez la quantité pour en ajouter un autre.`,
                        'error',
                        5000
                    );
                }
                return;
            }
        }

        // Snapshot pris au premier clic d'une rafale : sert au rollback si
        // l'écriture finale échoue.
        if (!this._petsBeforeEdit) {
            this._petsBeforeEdit = JSON.parse(JSON.stringify(this.pets));
        }
        // Compteur de bascules : permet à une écriture en vol de détecter, à son
        // retour, que l'écran a changé depuis l'envoi (cf flushPetsSave).
        this._petsEdits = (this._petsEdits || 0) + 1;

        // Exclusivité (un seul exemplaire livré) : le produit n'est destiné qu'à UN
        // animal. On le retire donc de tous les animaux, puis on le réattribue au seul
        // qui vient d'être coché. Cliquer l'animal déjà coché ne fait que retirer
        // (produit sans destinataire).
        // Plusieurs exemplaires : chaque pastille se coche indépendamment, dans la
        // limite du plafond vérifié plus haut — on ne touche donc pas aux autres.
        // Mutation EN PLACE du tableau : flushPetsSave garde une référence dessus pour
        // rattraper une bascule faite pendant une écriture.
        this.pets.forEach((other, i) => {
            if (!Array.isArray(other.foods)) return;
            if (capacity > 1 && i !== petIndex) return;
            const foods = other.foods.filter(f => !this.foodMatches(f, productId, size));
            if (foods.length !== other.foods.length) this.pets[i] = { ...other, foods };
        });

        if (!wasLinked) {
            const target = this.pets[petIndex];
            const foods = Array.isArray(target.foods) ? [...target.foods] : [];
            foods.push(size ? { product_id: productId, size } : { product_id: productId });
            this.pets[petIndex] = { ...target, foods };
        }

        this.renderSubscriptionProducts();

        clearTimeout(this._petsSaveTimer);
        this._petsSaveTimer = setTimeout(() => this.flushPetsSave(), 700);
    }

    // Une seule écriture en vol : savePets() refuse les appels concurrents ET
    // remplace this.pets par l'écho du serveur. Une bascule faite pendant le vol
    // n'est donc pas dans cet écho : sans le compteur, elle serait écrasée
    // silencieusement (écran juste, stockage faux).
    async flushPetsSave() {
        // Écriture déjà en cours (celle-ci ou celle du formulaire animal) :
        // réessayer plus tard plutôt que d'abandonner la bascule.
        // Nombre d'essais BORNÉ : sans plafond, une écriture qui ne se termine pas
        // laisserait _petsSaving à true et ce timer se reprogrammerait toutes les
        // 400 ms jusqu'à la fin de la session, sans jamais rien enregistrer ni rien
        // dire au client. Au bout du compte on échoue franchement (rollback + message).
        if (this._petsSaving) {
            this._petsRetries = (this._petsRetries || 0) + 1;
            if (this._petsRetries > 60) {   // ~24 s, au-delà du délai d'abandon de savePets
                this._petsRetries = 0;
                this.failPetsSave(this._petsBeforeEdit);
                return;
            }
            clearTimeout(this._petsSaveTimer);
            this._petsSaveTimer = setTimeout(() => this.flushPetsSave(), 400);
            return;
        }
        this._petsRetries = 0;

        const snapshot = this._petsBeforeEdit;
        const editsAtStart = this._petsEdits;
        const displayed = this.pets; // muté sur place par togglePetFood
        this._petsBeforeEdit = null;

        try {
            await this.savePets(this.pets);
        } catch (e) {
            console.error('[Pets] ❌ Association non enregistrée:', e);
            this.failPetsSave(snapshot);
            return;
        }

        if (this._petsEdits !== editsAtStart) {
            // L'écran a bougé pendant l'écriture : il fait foi, l'écho est périmé.
            this.pets = displayed;
            // Le point de retour reste celui d'AVANT la rafale de clics : si cette
            // seconde écriture échoue, il faut encore avoir un état enregistré où
            // revenir, sinon l'écran garderait une association jamais acceptée.
            if (snapshot) this._petsBeforeEdit = snapshot;
            this.flushPetsSave();
        }
        // Pas de re-render ici : savePets l'a déjà fait à partir de l'écho serveur,
        // donc l'écran ne peut pas afficher une association que le serveur a refusée.
    }

    // Échec d'écriture : l'écran revient à l'état d'avant la rafale de clics, et le
    // client est prévenu. Sans rollback il verrait une association que le serveur
    // n'a jamais acceptée.
    failPetsSave(snapshot) {
        this._petsBeforeEdit = null;
        if (snapshot) this.pets = snapshot;
        this.renderSubscriptionProducts();
        if (typeof showNotification === 'function') {
            showNotification('❌ Association non enregistrée. Veuillez réessayer.', 'error');
        }
    }

    renderPetsTab() {
        const container = document.querySelector('[data-recharge="pets_container"]');
        if (!container) return;

        if (this.petsError) {
            container.innerHTML = `
                <div class="pets-empty">
                    <p>Impossible de charger vos animaux.</p>
                    <button class="btn-pet-primary" data-pet-action="retry">Réessayer</button>
                </div>`;
            this.attachPetsListeners(container);
            return;
        }

        const pets = this.pets || [];
        let html = '';

        if (pets.length === 0) {
            html += `
                <div class="pets-empty">
                    <p>Ajoutez votre premier compagnon 🐾</p>
                </div>`;
        }

        html += '<div class="pets-grid">';
        pets.forEach((pet, i) => {
            const L = RechargePortal.PET_LABELS;
            const chips = [];
            chips.push(`<span class="pet-chip pet-chip--species-${pet.species}">${L.species[pet.species] || ''}</span>`);
            if (pet.breed) chips.push(`<span class="pet-chip">${this.escapeHtml(pet.breed)}</span>`);
            if (pet.sex) chips.push(`<span class="pet-chip">${L.sex[pet.sex]}</span>`);
            const ageY = this.petAgeYears(pet);
            if (ageY != null) { const a = Math.round(ageY); chips.push(`<span class="pet-chip">${a} an${a >= 2 ? 's' : ''}</span>`); }
            else if (pet.age_range) chips.push(`<span class="pet-chip">${L.age_range[pet.age_range]}</span>`);
            if (pet.weight_kg != null) chips.push(`<span class="pet-chip">${String(pet.weight_kg).replace('.', ',')} kg</span>`);
            else if (pet.weight_range) chips.push(`<span class="pet-chip">${L.weight_range[pet.weight_range]}</span>`);
            if (pet.body_condition) chips.push(`<span class="pet-chip">${L.body_condition[pet.body_condition]}</span>`);
            if (typeof pet.neutered === 'boolean') chips.push(`<span class="pet-chip">${pet.neutered ? 'Stérilisé(e)' : 'Non stérilisé(e)'}</span>`);
            const activityLabel = L.activity[pet.activity] || L.activity_cat[pet.activity];
            if (activityLabel) chips.push(`<span class="pet-chip">${activityLabel}</span>`);

            html += `
                <div class="pet-card pet-card--${pet.species}" data-pet-index="${i}">
                    <div class="pet-card-top">
                        <div class="pet-avatar pet-avatar--${pet.species}">${this.petIconHTML(pet.species)}</div>
                        <div class="pet-info">
                            <h3 class="pet-name">${this.escapeHtml(pet.name)}</h3>
                            <div class="pet-chips">${chips.join('')}</div>
                        </div>
                    </div>
                    <button type="button" class="btn-pet-upsell"
                            data-recharge-action="add-subscription-product"
                            data-portal-species="${pet.species === 'dog' || pet.species === 'cat' ? pet.species : ''}"
                            data-portal-goto-tab="abonnement">
                        Ajouter un produit pour ${this.escapeHtml(pet.name)}
                    </button>
                    <div class="pet-actions">
                        <button class="btn-pet-primary btn-pet-ration" data-pet-action="ration" data-pet-index="${i}">Ration conseillée</button>
                        <button class="btn-pet-secondary" data-pet-action="edit" data-pet-index="${i}">Modifier</button>
                        <button class="btn-pet-delete" data-pet-action="delete" data-pet-index="${i}" title="Supprimer">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2 4h12M5.333 4V2.667a1.333 1.333 0 011.334-1.334h2.666a1.333 1.333 0 011.334 1.334V4m2 0v9.333a1.333 1.333 0 01-1.334 1.334H4.667a1.333 1.333 0 01-1.334-1.334V4h9.334z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                </div>`;
        });

        if (pets.length < RechargePortal.MAX_PETS) {
            html += `
                <button class="pet-add-tile" data-pet-action="add">
                    <span class="pet-add-tile-plus">+</span>
                    <span>Ajouter un animal</span>
                </button>`;
        }
        html += '</div>';

        if (pets.length >= RechargePortal.MAX_PETS) {
            html += `<p class="pets-limit-note">Maximum ${RechargePortal.MAX_PETS} animaux atteint.</p>`;
        }

        container.innerHTML = html;
        this.attachPetsListeners(container);
    }

    // Formulaire inline (ajout si index === null, édition sinon)
    renderPetForm(index) {
        const container = document.querySelector('[data-recharge="pets_container"]');
        if (!container) return;

        const isEdit = index !== null;
        const pet = isEdit ? (this.pets[index] || {}) : {};
        const species = pet.species || '';

        container.innerHTML = `
            <form class="pet-form" data-pet-index="${isEdit ? index : ''}">
                <h3 class="pet-form-title">${isEdit ? 'Modifier' : 'Ajouter'} un animal</h3>

                <div class="pet-form-field">
                    <label>Espèce *</label>
                    <div class="pet-species-selector">
                        <button type="button" class="pet-species-btn ${species === 'dog' ? 'selected' : ''}" data-species="dog">
                            <span class="pet-species-icon">${this.petIconHTML('dog')}</span>
                            Chien
                        </button>
                        <button type="button" class="pet-species-btn ${species === 'cat' ? 'selected' : ''}" data-species="cat">
                            <span class="pet-species-icon">${this.petIconHTML('cat')}</span>
                            Chat
                        </button>
                    </div>
                </div>

                <div class="pet-form-row">
                    <div class="pet-form-field">
                        <label for="pet-name">Nom *</label>
                        <input type="text" id="pet-name" name="name" maxlength="40" required value="${this.escapeHtml(pet.name || '')}">
                    </div>
                    <div class="pet-form-field" data-species-field="dog">
                        <label for="pet-breed-dog">Race *</label>
                        <select id="pet-breed-dog" name="breed">${this.petBreedSelect('dog', pet.breed)}</select>
                    </div>
                    <div class="pet-form-field" data-species-field="cat">
                        <label for="pet-breed-cat">Race *</label>
                        <select id="pet-breed-cat" name="breed">${this.petBreedSelect('cat', pet.breed)}</select>
                    </div>
                </div>

                <div class="pet-form-row">
                    <div class="pet-form-field">
                        <label for="pet-sex">Mâle ou femelle *</label>
                        <select id="pet-sex" name="sex">${this.petSelectOptions(RechargePortal.PET_LABELS.sex, pet.sex)}</select>
                    </div>
                    <div class="pet-form-field">
                        <label for="pet-neutered">Stérilisé(e) *</label>
                        <select id="pet-neutered" name="neutered">
                            <option value="" ${pet.neutered === undefined ? 'selected' : ''}>—</option>
                            <option value="true" ${pet.neutered === true ? 'selected' : ''}>Oui</option>
                            <option value="false" ${pet.neutered === false ? 'selected' : ''}>Non</option>
                        </select>
                    </div>
                </div>

                <div class="pet-form-row">
                    <div class="pet-form-field">
                        <label for="pet-birthdate">Date de naissance *</label>
                        <input type="date" id="pet-birthdate" name="birthdate" min="2005-01-01" max="${new Date().toISOString().slice(0, 10)}" value="${pet.birthdate || ''}">
                    </div>
                    <div class="pet-form-field">
                        <label for="pet-weight">Poids (kg) *</label>
                        <input type="number" id="pet-weight" name="weight_kg" min="0.1" max="120" step="0.1" inputmode="decimal" placeholder="ex. 12,5" value="${pet.weight_kg != null ? pet.weight_kg : ''}">
                    </div>
                </div>

                <div class="pet-form-row">
                    <div class="pet-form-field">
                        <label for="pet-body">Corpulence *</label>
                        <select id="pet-body" name="body_condition">${this.petSelectOptions(RechargePortal.PET_LABELS.body_condition, pet.body_condition)}</select>
                    </div>
                    <div class="pet-form-field" data-species-field="dog">
                        <label for="pet-activity-dog">Niveau d'activité *</label>
                        <select id="pet-activity-dog" name="activity">${this.petSelectOptions(RechargePortal.PET_LABELS.activity, pet.activity)}</select>
                    </div>
                    <div class="pet-form-field" data-species-field="cat">
                        <label for="pet-activity-cat">Mode de vie *</label>
                        <select id="pet-activity-cat" name="activity">${this.petSelectOptions(RechargePortal.PET_LABELS.activity_cat, pet.activity)}</select>
                        <ul class="pet-form-hint">${this.activityCatHint()}</ul>
                    </div>
                </div>

                <p class="pet-form-error" style="display: none;"></p>

                <div class="pet-form-actions">
                    <button type="button" class="btn-pet-secondary" data-pet-action="cancel">Annuler</button>
                    <button type="submit" class="btn-pet-primary" data-pet-action="save">Enregistrer</button>
                </div>
            </form>`;

        // Champs dépendant de l'espèce (race, activité/mode de vie) : afficher
        // uniquement la variante de l'espèce sélectionnée.
        const applySpeciesFields = (sp) => {
            container.querySelectorAll('[data-species-field]').forEach(el => {
                el.style.display = (sp && el.dataset.speciesField === sp) ? '' : 'none';
            });
        };
        applySpeciesFields(species);

        // Sélecteur d'espèce
        container.querySelectorAll('.pet-species-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                container.querySelectorAll('.pet-species-btn').forEach(b => b.classList.remove('selected'));
                btn.classList.add('selected');
                applySpeciesFields(btn.dataset.species);
            });
        });

        container.querySelector('[data-pet-action="cancel"]').addEventListener('click', () => this.renderPetsTab());

        container.querySelector('.pet-form').addEventListener('submit', async (e) => {
            e.preventDefault();
            await this.handlePetFormSubmit(e.target, isEdit ? index : null);
        });
    }

    async handlePetFormSubmit(form, index) {
        const errorEl = form.querySelector('.pet-form-error');
        const speciesBtn = form.querySelector('.pet-species-btn.selected');
        const name = form.querySelector('[name="name"]').value.trim();

        if (!speciesBtn || !name) {
            errorEl.textContent = 'L\'espèce et le nom sont obligatoires.';
            errorEl.style.display = 'block';
            return;
        }

        const species = speciesBtn.dataset.species;
        const pet = { name: name.slice(0, 40), species };
        const L = RechargePortal.PET_LABELS;
        // Race + activité : lire la variante correspondant à l'espèce choisie.
        const speciesBlock = (name2) => form.querySelector(`[data-species-field="${species}"] [name="${name2}"]`);
        const breed = (speciesBlock('breed')?.value || '').trim();
        if (breed) pet.breed = breed.slice(0, 60);
        const sex = form.querySelector('[name="sex"]').value;
        if (L.sex[sex]) pet.sex = sex;
        const neutered = form.querySelector('[name="neutered"]').value;
        if (neutered === 'true') pet.neutered = true;
        if (neutered === 'false') pet.neutered = false;
        const birthdate = form.querySelector('[name="birthdate"]').value;
        if (/^\d{4}-\d{2}-\d{2}$/.test(birthdate) && !isNaN(new Date(birthdate).getTime()) && new Date(birthdate) <= new Date()) {
            pet.birthdate = birthdate;
        }
        const weightKg = parseFloat(String(form.querySelector('[name="weight_kg"]').value).replace(',', '.'));
        if (isFinite(weightKg) && weightKg > 0 && weightKg <= 120) pet.weight_kg = Math.round(weightKg * 10) / 10;
        const bodyCondition = form.querySelector('[name="body_condition"]').value;
        if (L.body_condition[bodyCondition]) pet.body_condition = bodyCondition;
        const activityMap = species === 'cat' ? L.activity_cat : L.activity;
        const activity = speciesBlock('activity')?.value;
        if (activity && activityMap[activity]) pet.activity = activity;

        // Tous les champs sont obligatoires (le profil complet est requis pour la
        // ration). La race doit être choisie dans la liste (cf isBreedConfirmed).
        const missing = [];
        if (!this.isBreedConfirmed(pet)) missing.push('la race');
        if (!pet.sex) missing.push('le sexe');
        if (typeof pet.neutered !== 'boolean') missing.push('la stérilisation');
        if (!pet.birthdate) missing.push('la date de naissance');
        if (pet.weight_kg == null) missing.push('le poids');
        if (!pet.body_condition) missing.push('la corpulence');
        if (!pet.activity) missing.push(species === 'cat' ? 'le mode de vie' : 'le niveau d\'activité');
        if (missing.length) {
            const list = missing.length > 1
                ? missing.slice(0, -1).join(', ') + ' et ' + missing[missing.length - 1]
                : missing[0];
            errorEl.textContent = `Merci de renseigner : ${list}.`;
            errorEl.style.display = 'block';
            return;
        }

        const newPets = [...(this.pets || [])];
        if (index !== null) {
            // Le formulaire reconstruit l'objet animal à partir de ses seuls champs :
            // sans ce report, éditer une fiche effacerait les produits qui lui sont
            // associés (ils ne sont pas dans le formulaire, ils viennent de l'onglet
            // abonnement).
            const previousFoods = newPets[index]?.foods;
            if (Array.isArray(previousFoods)) pet.foods = previousFoods;
            newPets[index] = pet;
        } else {
            newPets.push(pet);
        }

        const saveBtn = form.querySelector('[data-pet-action="save"]');
        saveBtn.disabled = true;
        saveBtn.textContent = 'Enregistrement...';

        try {
            await this.savePets(newPets);
            if (typeof showNotification === 'function') {
                showNotification(`✅ ${pet.name} a bien été enregistré !`, 'success');
            }
            this.renderPetsTab();
        } catch (e) {
            console.error('[Pets] ❌ Erreur sauvegarde:', e);
            errorEl.textContent = 'Erreur lors de l\'enregistrement. Veuillez réessayer.';
            errorEl.style.display = 'block';
            saveBtn.disabled = false;
            saveBtn.textContent = 'Enregistrer';
        }
    }

    attachPetsListeners(container) {
        container.querySelectorAll('[data-pet-action]').forEach(el => {
            const action = el.dataset.petAction;
            if (action === 'add') {
                el.addEventListener('click', () => this.renderPetForm(null));
            } else if (action === 'edit') {
                el.addEventListener('click', () => this.renderPetForm(parseInt(el.dataset.petIndex, 10)));
            } else if (action === 'ration') {
                el.addEventListener('click', () => this.openFeedingModal(parseInt(el.dataset.petIndex, 10)));
            } else if (action === 'retry') {
                el.addEventListener('click', async () => {
                    this.petsLoaded = false;
                    await this.openPetsTab();
                });
            } else if (action === 'delete') {
                el.addEventListener('click', async () => {
                    if (this._petsSaving) return; // écriture déjà en cours, ignorer
                    const i = parseInt(el.dataset.petIndex, 10);
                    const pet = this.pets[i];
                    if (!pet) return;
                    if (!confirm(`Supprimer ${pet.name} ?`)) return;
                    const newPets = this.pets.filter((_, idx) => idx !== i);
                    try {
                        await this.savePets(newPets);
                        if (typeof showNotification === 'function') {
                            showNotification('Animal supprimé.', 'success');
                        }
                    } catch (e) {
                        console.error('[Pets] ❌ Erreur suppression:', e);
                        if (typeof showNotification === 'function') {
                            showNotification('❌ Erreur lors de la suppression.', 'error');
                        }
                    }
                    this.renderPetsTab();
                });
            }
        });
    }

    // ==========================================
    // RATION CONSEILLÉE (feeding recommendation) — modal par animal
    // Le serveur (/api/feeding) renvoie le besoin calorique du jour (target_kcal)
    // + la densité (kcal/100g) des croquettes/pâtées ABONNÉES de la même espèce.
    // Le calcul des grammes / modes / curseur mix est fait ici, côté client :
    //   g/jour = target_kcal * 100 / kcal_per_100g
    // ==========================================

    // Injecte l'overlay du modal dans <body> une seule fois (fonctionne quel que
    // soit le template d'entrée du portail). Renvoie {overlay, panel, body}.
    ensureFeedingModalRoot() {
        let overlay = document.getElementById('feeding-modal-overlay');
        if (overlay) {
            return {
                overlay,
                panel: overlay.querySelector('.feeding-modal'),
                body: overlay.querySelector('.feeding-modal-body'),
            };
        }
        overlay = document.createElement('div');
        overlay.id = 'feeding-modal-overlay';
        overlay.className = 'feeding-modal-overlay';
        overlay.innerHTML = `
            <div class="feeding-modal" role="dialog" aria-modal="true" aria-labelledby="feeding-modal-title">
                <div class="feeding-modal-header">
                    <h3 class="feeding-modal-title" id="feeding-modal-title">Ration conseillée</h3>
                    <button type="button" class="feeding-modal-close" aria-label="Fermer">&times;</button>
                </div>
                <div class="feeding-modal-body"></div>
            </div>`;
        document.body.appendChild(overlay);

        const close = () => this.closeFeedingModal();
        overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
        overlay.querySelector('.feeding-modal-close').addEventListener('click', close);
        this._feedingEscHandler = (e) => { if (e.key === 'Escape') close(); };

        return {
            overlay,
            panel: overlay.querySelector('.feeding-modal'),
            body: overlay.querySelector('.feeding-modal-body'),
        };
    }

    closeFeedingModal() {
        const overlay = document.getElementById('feeding-modal-overlay');
        if (overlay) overlay.classList.remove('active');
        document.removeEventListener('keydown', this._feedingEscHandler || (() => {}));
    }

    async openFeedingModal(index) {
        const pet = (this.pets || [])[index];
        if (!pet) return;

        const { overlay, panel, body } = this.ensureFeedingModalRoot();
        panel.querySelector('.feeding-modal-title').textContent = `Ration conseillée — ${pet.name}`;
        overlay.classList.add('active');
        document.addEventListener('keydown', this._feedingEscHandler);

        // Garde 1 : le calcul exige un profil complet (mêmes champs que la formule).
        // La race, désormais issue d'une liste, doit être confirmée si elle vient
        // d'une ancienne saisie libre — pour une recommandation plus précise.
        const missing = [];
        if (pet.weight_kg == null) missing.push('le poids');
        if (this.petAgeYears(pet) == null) missing.push('la date de naissance');
        if (!this.isBreedConfirmed(pet)) missing.push('la race');
        if (typeof pet.neutered !== 'boolean') missing.push('la stérilisation');
        if (!pet.activity) missing.push('le niveau d\'activité');
        if (!pet.body_condition) missing.push('la corpulence');
        if (missing.length) {
            const list = missing.length > 1
                ? missing.slice(0, -1).join(', ') + ' et ' + missing[missing.length - 1]
                : missing[0];
            body.innerHTML = `
                <p class="feeding-note">Pour obtenir la recommandation la plus précise, complétez et confirmez le profil de <strong>${this.escapeHtml(pet.name)}</strong>.<br>À renseigner ou confirmer : ${this.escapeHtml(list)}.</p>
                <button class="btn-pet-primary" data-feeding-action="complete-profile">Compléter le profil</button>`;
            body.querySelector('[data-feeding-action="complete-profile"]').addEventListener('click', () => {
                this.closeFeedingModal();
                this.renderPetForm(index);
            });
            return;
        }

        // Abonnements actifs + achats uniques (le serveur filtre par espèce + type
        // food). Clé = product_id Shopify ; variant_title transporte la taille
        // (Petite/Grande) dont dépend le kcal — le serveur la résout (cf _nutrition.js).
        // Si l'animal a des produits associés, on n'envoie QUE les siens ; sinon on
        // envoie tout et le serveur filtre par espèce (comportement historique).
        const candidates = this.linkableItems();
        const declaredCount = Array.isArray(pet.foods) ? pet.foods.length : null;
        const linked = declaredCount
            ? candidates.filter(item => this.isFoodLinkedToPet(
                this.foodProductId(item), this.foodSize(item), pet))
            : [];

        let scoped;
        if (declaredCount === null) {
            scoped = candidates;      // jamais déclaré -> filtrage par espèce (historique)
        } else if (declaredCount === 0) {
            scoped = [];              // "aucun produit pour cet animal", choix explicite
        } else if (linked.length) {
            scoped = linked;          // déclaration valide
        } else {
            // Déclaration devenue caduque : les produits associés ont été supprimés de
            // l'abonnement. On retombe sur le filtrage par espèce plutôt que de priver
            // l'animal de toute recommandation alors qu'il reste de la nourriture
            // commandée. Les liens ne sont PAS purgés : re-commander le produit les
            // réactive.
            scoped = candidates;
        }

        const items = [];
        const titleByFood = {};
        scoped.forEach(item => {
            const productId = this.foodProductId(item);
            if (!productId) return;
            items.push({ product_id: productId, variant_title: item.variant_title || '' });
            titleByFood[this.foodKey(productId, this.foodSize(item))] = item.product_title || 'Produit';
        });

        body.innerHTML = '<p class="feeding-loading">Calcul de la ration…</p>';

        let data;
        try {
            const res = await fetch(RechargePortal.FEEDING_API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.apiToken}`,
                },
                body: JSON.stringify({
                    recharge_customer_id: this.customerId,
                    pet: {
                        species: pet.species,
                        weight_kg: pet.weight_kg,
                        age_years: this.petAgeYears(pet),
                        activity: pet.activity,
                        neutered: pet.neutered,
                        body_condition: pet.body_condition,
                        breed: pet.breed,
                    },
                    items,
                }),
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            data = await res.json();
            if (!data.success) throw new Error(data.error || 'unknown');
        } catch (e) {
            console.error('[Feeding] ❌ Erreur calcul:', e);
            body.innerHTML = `<p class="feeding-note feeding-error">Impossible de calculer la ration pour le moment.</p>
                <button class="btn-pet-primary" data-feeding-action="retry">Réessayer</button>`;
            body.querySelector('[data-feeding-action="retry"]').addEventListener('click', () => this.openFeedingModal(index));
            return;
        }

        // key = product_id + taille : le même produit en Petite et en Grande est
        // deux aliments distincts (kcal différent), donc deux choix distincts.
        const foods = (data.foods || []).map(f => {
            const key = this.foodKey(f.product_id, f.size);
            return { ...f, key, title: this.foodTitle(titleByFood, f) };
        });
        const croquettes = foods.filter(f => f.food_type === 'croquette');
        const patees = foods.filter(f => f.food_type === 'patee');

        // Garde 2 : aucun aliment exploitable. Deux causes distinctes, deux messages :
        // soit le client a explicitement décoché tous les produits de cet animal,
        // soit aucun produit commandé ne correspond à son espèce.
        if (croquettes.length === 0 && patees.length === 0) {
            const message = declaredCount === 0
                ? `Aucun produit n'est associé à ${this.escapeHtml(pet.name)}. Cochez son nom sous un produit depuis l'onglet « Gérer mon abonnement ».`
                : `Aucune croquette ou pâtée de votre abonnement ne correspond à ${this.escapeHtml(pet.name)}.`;
            body.innerHTML = `<p class="feeding-note">${message}</p>`;
            return;
        }

        // État du modal (mode + sélections + ratio du mix).
        const state = {
            pet,
            target_kcal: data.target_kcal,
            croquettes,
            patees,
            mode: croquettes.length ? 'croquette' : 'patee',
            croqSel: croquettes[0]?.key || null,
            pateeSel: patees[0]?.key || null,
            ratio: 0.5, // part calorique croquettes en mode mix
        };
        this.renderFeedingContent(body, state);
    }

    // g/jour = kcal cible ÷ (densité / 100)
    feedingGrams(kcal, density) {
        if (!density || density <= 0) return 0;
        return Math.round((kcal * 100) / density);
    }

    feedingFoodLine(food, kcal) {
        const grams = this.feedingGrams(kcal, food.kcal_per_100g);
        let out = `<strong>${grams} g</strong> / jour`;
        if (food.sachet_grams) {
            const sachets = Math.round((grams / food.sachet_grams) * 10) / 10;
            out += ` <span class="feeding-sachets">(≈ ${String(sachets).replace('.', ',')} sachet${sachets > 1 ? 's' : ''})</span>`;
        }
        return out;
    }

    // Radios plutôt qu'un <select> : le nom complet de la recette reste lisible
    // (le dropdown le tronquait) et la cible tactile est large sur mobile.
    feedingRecipeSelect(list, selectedId, dataAttr) {
        return list.map(f => {
            const id = f.key;
            const checked = id === selectedId ? 'checked' : '';
            return `<label class="feeding-radio ${checked ? 'is-selected' : ''}">
                        <input type="radio" name="feeding-${dataAttr}" value="${this.escapeHtml(id)}" data-feeding-select="${dataAttr}" ${checked}>
                        <span class="feeding-radio-text">${this.escapeHtml(f.title)}</span>
                    </label>`;
        }).join('');
    }

    // Bloc "recette" : liste de choix seulement s'il y en a plusieurs (>1 recette).
    // Une seule recette -> pas de sélecteur, on affiche directement le résultat.
    feedingPicker(label, list, selectedId, dataAttr) {
        if (list.length <= 1) return '';
        return `<div class="feeding-picker">
                    <label class="feeding-picker-label">${label}</label>
                    <div class="feeding-radios" role="radiogroup">${this.feedingRecipeSelect(list, selectedId, dataAttr)}</div>
                </div>`;
    }

    renderFeedingContent(body, state) {
        const { croquettes, patees, target_kcal } = state;
        const hasCroq = croquettes.length > 0;
        const hasPatee = patees.length > 0;
        const canMix = hasCroq && hasPatee;

        // Boutons de mode
        const modeBtn = (mode, label, enabled) =>
            `<button type="button" class="feeding-mode-btn ${state.mode === mode ? 'selected' : ''}" data-feeding-mode="${mode}" ${enabled ? '' : 'disabled'}>${label}</button>`;

        // Besoin énergétique quotidien (kcal) — affiché en tête du résultat.
        const kcalLine = `<div class="feeding-kcal">Besoin énergétique : <strong>${Math.round(target_kcal)} kcal</strong> / jour</div>`;

        // Nom de la recette au-dessus du résultat (le client doit savoir "X g DE QUOI").
        const foodName = (food) => `<div class="feeding-food-name">${this.escapeHtml(food.title)}</div>`;

        let controls = '';
        if (state.mode === 'croquette') {
            const food = croquettes.find(f => f.key === state.croqSel) || croquettes[0];
            controls = `
                ${this.feedingPicker('Choisir la recette', croquettes, state.croqSel, 'croq')}
                <div class="feeding-output"><span class="feeding-output-label">Quantité recommandée par jour</span>${foodName(food)}${this.feedingFoodLine(food, target_kcal)}${kcalLine}</div>`;
        } else if (state.mode === 'patee') {
            const food = patees.find(f => f.key === state.pateeSel) || patees[0];
            controls = `
                ${this.feedingPicker('Choisir la recette', patees, state.pateeSel, 'patee')}
                <div class="feeding-output"><span class="feeding-output-label">Quantité recommandée par jour</span>${foodName(food)}${this.feedingFoodLine(food, target_kcal)}${kcalLine}</div>`;
        } else { // mix
            const cFood = croquettes.find(f => f.key === state.croqSel) || croquettes[0];
            const pFood = patees.find(f => f.key === state.pateeSel) || patees[0];
            const pct = Math.round(state.ratio * 100);
            controls = `
                ${this.feedingPicker('Croquettes', croquettes, state.croqSel, 'croq')}
                ${this.feedingPicker('Pâtée', patees, state.pateeSel, 'patee')}
                <div class="feeding-slider-wrap">
                    <input type="range" class="feeding-slider" min="0" max="100" step="5" value="${pct}" style="--pct:${pct}%" data-feeding-slider>
                    <div class="feeding-slider-labels"><span>${pct}% croquettes</span><span>${100 - pct}% pâtée</span></div>
                </div>
                <div class="feeding-output">
                    <span class="feeding-output-label">Quantité recommandée par jour</span>
                    <div class="feeding-mix-line">${this.escapeHtml(cFood.title)} : ${this.feedingFoodLine(cFood, target_kcal * state.ratio)}</div>
                    <div class="feeding-mix-line">${this.escapeHtml(pFood.title)} : ${this.feedingFoodLine(pFood, target_kcal * (1 - state.ratio))}</div>
                    ${kcalLine}
                </div>`;
        }

        // Boutons de mode : seulement si un mix est possible (croquettes ET pâtée
        // présentes). Un seul type d'aliment -> pas de choix, on montre le résultat.
        const modesRow = canMix ? `
            <div class="feeding-modes">
                ${modeBtn('croquette', '100% croquettes', hasCroq)}
                ${modeBtn('patee', '100% pâtée', hasPatee)}
                ${modeBtn('mix', 'Mix cr. & pâtée', canMix)}
            </div>` : '';

        body.innerHTML = `
            ${modesRow}
            ${controls}
            <p class="feeding-disclaimer">Estimation à titre indicatif, à ajuster selon votre vétérinaire.</p>`;

        // Listeners → mettent à jour l'état puis re-render (recalcul instantané, sans appel réseau)
        body.querySelectorAll('[data-feeding-mode]').forEach(btn => {
            if (btn.disabled) return;
            btn.addEventListener('click', () => { state.mode = btn.dataset.feedingMode; this.renderFeedingContent(body, state); });
        });
        body.querySelectorAll('[data-feeding-select]').forEach(sel => {
            sel.addEventListener('change', () => {
                if (sel.dataset.feedingSelect === 'croq') state.croqSel = sel.value;
                else state.pateeSel = sel.value;
                this.renderFeedingContent(body, state);
            });
        });
        const slider = body.querySelector('[data-feeding-slider]');
        if (slider) {
            // Mise à jour en place (ne pas re-render : ça remplacerait le curseur
            // en plein glissement et casserait le drag).
            slider.addEventListener('input', () => {
                state.ratio = Number(slider.value) / 100;
                const pct = Math.round(state.ratio * 100);
                slider.style.setProperty('--pct', pct + '%');
                const labels = body.querySelector('.feeding-slider-labels');
                if (labels) labels.innerHTML = `<span>${pct}% croquettes</span><span>${100 - pct}% pâtée</span>`;
                const cFood = croquettes.find(f => f.key === state.croqSel) || croquettes[0];
                const pFood = patees.find(f => f.key === state.pateeSel) || patees[0];
                const lines = body.querySelectorAll('.feeding-mix-line');
                if (lines[0]) lines[0].innerHTML = `${this.escapeHtml(cFood.title)} : ${this.feedingFoodLine(cFood, target_kcal * state.ratio)}`;
                if (lines[1]) lines[1].innerHTML = `${this.escapeHtml(pFood.title)} : ${this.feedingFoodLine(pFood, target_kcal * (1 - state.ratio))}`;
            });
        }
    }

    // Retrouve le poids (grammes) d'un variant depuis le catalogue Shopify pré-chargé
    // (window.shopifyAllProducts, rempli via /collections/.../products.json)
    getVariantGrams(subscription) {
        const vid = subscription.external_variant_id?.ecommerce || subscription.shopify_variant_id;
        if (!vid || !window.shopifyAllProducts) return null;
        for (const p of window.shopifyAllProducts) {
            const v = (p.variants || []).find(v => String(v.id) === String(vid));
            if (v) return v.grams || null;
        }
        return null;
    }

    // Formate un poids en grammes → "800 g" / "1,5 kg" / "3 kg"
    formatWeight(grams) {
        if (!grams || grams <= 0) return '';
        if (grams < 1000) return `${grams} g`;
        const kg = grams / 1000;
        return `${(Math.round(kg * 100) / 100).toString().replace('.', ',')} kg`;
    }

    // Construit l'URL de facture PDF (Order Printer Pro) depuis une commande Recharge.
    // Fallback quand window.orderInvoiceLinks est absent (session Recharge OTP sans
    // session Shopify → Liquid ne voit pas {{ customer }} et ne rend pas la map).
    // BigInt obligatoire : order_id * 9370 dépasse la précision Number (2^53).
    buildInvoiceUrlFromRechargeOrder(order) {
        const shopifyOrderId = order.external_order_id?.ecommerce || order.shopify_order_id;
        if (!shopifyOrderId) return null;
        try {
            const idSegment = (BigInt(shopifyOrderId) * 9370n).toString();
            // Segment "nom" : équivalent JS du filtre Liquid handleize sur order.name
            const rawName = order.external_order_name?.ecommerce
                || order.external_order_number?.ecommerce
                || '';
            const nameSegment = String(rawName)
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/^-+|-+$/g, '');
            if (!nameSegment) return null;
            return `https://boutique.pettywell.com/apps/download-pdf/orders/5e28670662788574da72/${idSegment}/${nameSegment}.pdf`;
        } catch (e) {
            console.warn('[RechargePortal] Impossible de construire l\'URL facture:', e);
            return null;
        }
    }

    renderOrdersHistory() {
        console.log('[RechargePortal] Génération de l\'historique des commandes...');

        const ordersListEl = document.querySelector('[data-recharge="orders_list"]');
        const noOrdersEl = document.querySelector('[data-recharge="no_orders"]');

        if (!ordersListEl) {
            console.error('[RechargePortal] Element orders_list non trouvé');
            return;
        }

        // Mode Shopify-only : pas de commandes Recharge, déléguer au renderer Shopify
        // (sinon ordersLoaded reste false → loader infini au retour sur l'onglet)
        if (this.isShopifyOnly === true) {
            console.log('[RechargePortal] Mode Shopify-only, délégation à loadShopifyOrders');
            this.loadShopifyOrders();
            return;
        }

        // Chargement encore en cours → loader (le init() re-render à la fin du chargement)
        if (!this.ordersLoaded) {
            console.log('[RechargePortal] Commandes pas encore chargées, affichage du loader');
            if (noOrdersEl) {
                noOrdersEl.style.display = 'none';
            }
            ordersListEl.innerHTML = '<div style="text-align: center; padding: 40px;"><p>Chargement des commandes...</p></div>';
            return;
        }

        // Si pas de commandes, afficher le message "Aucune commande"
        if (!this.orders || this.orders.length === 0) {
            console.log('[RechargePortal] Aucune commande disponible');
            ordersListEl.innerHTML = '';
            if (noOrdersEl) {
                noOrdersEl.style.display = 'flex';
            }
            return;
        }

        // Cacher le message "Aucune commande"
        if (noOrdersEl) {
            noOrdersEl.style.display = 'none';
        }

        // Générer le HTML pour chaque commande
        let ordersHTML = '';

        this.orders.forEach((order, index) => {
            // Format de la date
            const orderDate = new Date(order.scheduled_at || order.created_at);
            const formattedDate = orderDate.toLocaleDateString('fr-FR', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });

            // Statut de la commande
            let statusBadge = '';
            let statusClass = '';
            if (order.status === 'SUCCESS') {
                statusBadge = 'Livrée ✓';
                statusClass = 'badge-delivered';
            } else if (order.status === 'QUEUED') {
                statusBadge = 'En cours';
                statusClass = 'badge-processing';
            } else {
                statusBadge = 'Payée ✓';
                statusClass = 'badge-paid';
            }

            // Produits (thumbnails)
            let productsHTML = '';
            let productsDetailHTML = '';
            const lineItems = order.line_items || [];
            const displayedItems = lineItems.slice(0, 3);
            const remainingCount = lineItems.length - 3;

            displayedItems.forEach((item) => {
                const imageUrl = item.images?.large || item.images?.original || item.shopify_product_image_url || "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50' height='50'%3E%3Crect fill='%23f0f0f0' width='50' height='50'/%3E%3C/svg%3E";
                productsHTML += `
                        <div class="product-thumb">
                            <img src="${imageUrl}" alt="${item.title || 'Produit'}">
                        </div>
                    `;
            });

            if (remainingCount > 0) {
                productsHTML += `<span class="more-products">+${remainingCount} produit${remainingCount > 1 ? 's' : ''}</span>`;
            }

            // Détails des produits
            lineItems.forEach((item) => {
                const imageUrl = item.images?.large || item.images?.original || item.shopify_product_image_url || "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60'%3E%3Crect fill='%23f0f0f0' width='60' height='60'/%3E%3C/svg%3E";
                const price = item.price ? `${item.price} €` : 'N/A';
                productsDetailHTML += `
                        <div class="product-detail-item">
                            <img src="${imageUrl}" alt="${item.title || 'Produit'}">
                            <div class="product-detail-info">
                                <p class="product-name">${item.title || 'Produit'}</p>
                                <p class="product-variant">${item.variant_title || ''}</p>
                                <p class="product-quantity">Qté : ${item.quantity || 1}</p>
                            </div>
                            <span class="product-price">${price}</span>
                        </div>
                    `;
            });

            // Prix total
            const totalPrice = order.total_price ? `${order.total_price} €` : 'N/A';

            // Lien facture PDF (Order Printer Pro) — map Liquid si session Shopify,
            // sinon construction client-side depuis les données Recharge (BigInt)
            const shopifyOrderId = order.external_order_id?.ecommerce || order.shopify_order_id;
            const shopifyOrderNumber = order.external_order_number?.ecommerce;
            const invoiceUrl = (window.orderInvoiceLinks || {})[shopifyOrderId]
                || (window.orderInvoiceLinks || {})[shopifyOrderNumber]
                || this.buildInvoiceUrlFromRechargeOrder(order);

            // Adresse de livraison
            let shippingAddressHTML = '';
            if (order.shipping_address) {
                const addr = order.shipping_address;
                shippingAddressHTML = `
                        <p class="info-text">${addr.first_name || ''} ${addr.last_name || ''}</p>
                        <p class="info-text">${addr.address1 || ''}</p>
                        ${addr.address2 ? `<p class="info-text">${addr.address2}</p>` : ''}
                        <p class="info-text">${addr.zip || ''} ${addr.city || ''}, ${addr.country || ''}</p>
                    `;
            } else {
                shippingAddressHTML = `<p class="info-text">Adresse non disponible</p>`;
            }

            // Génération du HTML de la commande
            ordersHTML += `
                    <div class="order-card" data-order-id="${order.id}">
                        <div class="order-header">
                            <div class="order-info-row">
                                <span class="order-date">${formattedDate}</span>
                                <span class="order-number">#${order.id}</span>
                                <span class="order-badge ${statusClass}">${statusBadge}</span>
                            </div>

                            <div class="order-preview">
                                <div class="order-products-preview">
                                    ${productsHTML}
                                </div>

                                <div class="order-actions-row">
                                    <span class="order-total">${totalPrice}</span>
                                    <div class="order-quick-actions">
                                        ${order.tracking_url ? `
                                            <button class="btn-order-action btn-track" onclick="window.open('${order.tracking_url}', '_blank')" title="Suivre mon colis">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M16 8L20 12L16 16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M4 12H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                Suivre
                                            </button>
                                        ` : ''}
                                        ${invoiceUrl ? `
                                            <a class="btn-order-action btn-invoice" href="${invoiceUrl}" target="_blank" rel="noopener" title="Télécharger ma facture (PDF)">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12 3v12m0 0l-4-4m4 4l4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M5 21h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                Ma facture
                                            </a>
                                        ` : ''}
                                    </div>
                                </div>
                            </div>

                            <button class="btn-toggle-details" data-toggle="details-${order.id}">
                                <span class="toggle-text">Voir les détails</span>
                                <svg class="toggle-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                        </div>

                        <div class="order-details" id="details-${order.id}">
                            <div class="details-grid">
                                <div class="details-section">
                                    <h4 class="details-section-title">Produits commandés</h4>
                                    <div class="products-detail-list">
                                        ${productsDetailHTML}
                                    </div>
                                </div>

                                <div class="details-section">
                                    <h4 class="details-section-title">Informations de livraison</h4>
                                    <div class="info-block">
                                        <p class="info-label">Adresse de livraison</p>
                                        ${shippingAddressHTML}
                                    </div>
                                </div>
                            </div>

                            <div class="order-summary">
                                <h4 class="details-section-title">Récapitulatif</h4>
                                <div class="summary-rows">
                                    <div class="summary-row summary-total">
                                        <span>Total</span>
                                        <span>${totalPrice}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                `;
        });

        // Injecter le HTML
        ordersListEl.innerHTML = ordersHTML;

        // Attacher les event listeners pour les boutons "Voir les détails"
        this.attachOrderToggleListeners();

        // Charger le suivi de colis (API Shopify via Vercel) et injecter les
        // boutons "Suivre mon colis" sur la commande la plus récente.
        this.injectTrackingButtons(ordersListEl);

        console.log(`[RechargePortal] ✅ ${this.orders.length} commande(s) générée(s)`);
    }

    // URL de la fonction Vercel.
    static TRACKING_API_URL = 'https://order-tracking-dashboard-six.vercel.app/api/get-order-tracking';

    // Récupère la dernière commande + suivi depuis la fonction Vercel.
    // L'identité est dérivée côté serveur du token de session : on n'envoie que
    // le customer id (validé contre le token), jamais d'info sur la commande.
    fetchLatestTracking() {
        // Mémoïsé : la card "Dernière commande" et l'onglet historique partagent
        // un seul appel API par chargement de page.
        if (this._trackingPromise) return this._trackingPromise;
        this._trackingPromise = (async () => {
            try {
                if (!this.apiToken || !this.customerId) return null;
                const res = await fetch(RechargePortal.TRACKING_API_URL, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.apiToken}`
                    },
                    body: JSON.stringify({ recharge_customer_id: this.customerId })
                });
                if (!res.ok) {
                    console.warn('[Tracking] API non OK:', res.status);
                    return null;
                }
                const data = await res.json();
                return data.order || null;
            } catch (e) {
                console.error('[Tracking] Erreur:', e);
                return null;
            }
        })();
        return this._trackingPromise;
    }

    // Construit le HTML des boutons "Suivre mon colis" (un par colis avec URL).
    buildTrackingButtonsHTML(tracking) {
        // Exclure les colis annulés (CANCELLED) et n'accepter que les URLs
        // http(s) — empêche un schéma javascript:/data: d'arriver dans onclick.
        const parcels = (tracking || []).filter(t => t && /^https?:\/\//i.test(t.url) && t.status !== 'CANCELLED');
        if (parcels.length === 0) return '';
        const multi = parcels.length > 1;
        const icon = `
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 8L20 12L16 16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4 12H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`;
        return parcels.map((t, i) => {
            const label = multi ? `Suivre mon colis ${i + 1}` : 'Suivre mon colis';
            // encodeURI pour éviter de casser l'attribut onclick avec des quotes.
            const safeUrl = encodeURI(t.url).replace(/'/g, '%27');
            return `<button class="btn-order-action btn-track" onclick="window.open('${safeUrl}', '_blank')" title="${label}">${icon}${label}</button>`;
        }).join('');
    }

    static escapeHtml(value) {
        return String(value == null ? '' : value)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    // Shopify ne dit pas si un colis est livré : displayFulfillmentStatus
    // s'arrête à FULFILLED et n'a pas d'état DELIVERED. Sans cette borne d'âge,
    // le bandeau « votre colis est en route » resterait affiché pour toujours.
    //
    // ⚠️ L'âge se mesure sur `order.processedAt` (traitement de la commande, donc
    // le prélèvement), PAS sur la date d'expédition : l'endpoint de suivi ne
    // remonte pas `fulfillments.createdAt`. Efilog traitant immédiatement, les
    // deux ne diffèrent que d'un jour au plus.
    //
    // La borne se règle par rapport à la livraison attendue, qui tombe vers
    // processedAt + 3 (cf. CHARGE_OFFSET_DAYS) : il faut assez de marge pour
    // couvrir un colis en retard, et assez peu pour ne pas annoncer « en route »
    // un colis posé sur le paillasson depuis des jours.
    static TRACKING_BANNER_MAX_AGE_DAYS = 7;

    // Bandeau de suivi en tête du dashboard.
    //
    // Il existe parce que la date de livraison affichée reste une estimation :
    // ~4 % des prélèvements partent en relance après échec, et tout glisse alors
    // de plusieurs jours. Quand un colis est réellement parti, le lien du
    // transporteur est la seule information qui ne peut pas mentir — elle mérite
    // mieux que d'être enterrée dans l'onglet Historique.
    async renderTrackingBanner() {
        // Un emplacement par panneau (accueil, abonnement) : le client doit voir
        // le suivi quel que soit l'onglet sur lequel il arrive. Les panneaux
        // s'excluent (une seule .tab-panel.active), donc jamais deux à l'écran.
        const banners = document.querySelectorAll('[data-recharge="tracking_banner"]');
        if (banners.length === 0) return;

        const order = await this.fetchLatestTracking();
        if (!order) return;

        const buttons = this.buildTrackingButtonsHTML(order.tracking);
        if (!buttons) return; // aucun colis exploitable

        const ageDays = order.processedAt
            ? Math.floor((Date.now() - Date.parse(order.processedAt)) / 86400000)
            : null;
        if (ageDays === null || Number.isNaN(ageDays) || ageDays > RechargePortal.TRACKING_BANNER_MAX_AGE_DAYS) {
            return;
        }

        const parcels = (order.tracking || []).filter(t => t && t.status !== 'CANCELLED');
        const company = parcels.find(t => t.company)?.company;
        const estimated = parcels.find(t => t.estimatedDeliveryAt)?.estimatedDeliveryAt;

        // Sous-titre : on n'affiche que ce qu'on sait réellement. Pas de
        // transporteur connu et pas d'estimation → pas de ligne inventée.
        const details = [];
        if (company) details.push(`Expédiée par ${RechargePortal.escapeHtml(company)}`);
        if (estimated) {
            const date = RechargePortal.parseLocalDate(estimated);
            if (date) details.push(`livraison estimée ${RechargePortal.formatLongDate(date)}`);
        }

        const html = `
            <div class="tracking-banner-content">
                <div class="tracking-banner-text">
                    <strong>Votre commande ${RechargePortal.escapeHtml(order.name || '')} est en route</strong>
                    ${details.length ? `<span>${details.join(' · ')}</span>` : ''}
                </div>
                <div class="tracking-banner-actions">${buttons}</div>
            </div>`;
        banners.forEach(banner => {
            banner.innerHTML = html;
            banner.style.display = 'block';
        });
        console.log(`[Tracking] Bandeau affiché sur ${banners.length} panneau(x) (commande ${order.name}, expédiée il y a ${ageDays} j)`);
    }

    // Récupère le suivi et injecte les boutons sur la carte de commande la plus
    // récente (this.orders[0] -> première .order-card du DOM).
    async injectTrackingButtons(ordersListEl) {
        const order = await this.fetchLatestTracking();
        if (!order) return;
        const html = this.buildTrackingButtonsHTML(order.tracking);
        if (!html) return;
        const firstCard = ordersListEl.querySelector('.order-card');
        const actions = firstCard?.querySelector('.order-quick-actions');
        if (actions) actions.innerHTML = html;
    }

    attachOrderToggleListeners() {
        const toggleButtons = document.querySelectorAll('.btn-toggle-details');
        toggleButtons.forEach(button => {
            button.addEventListener('click', function () {
                const detailsId = this.getAttribute('data-toggle');
                const detailsEl = document.getElementById(detailsId);
                const toggleText = this.querySelector('.toggle-text');

                if (detailsEl) {
                    const isOpen = detailsEl.classList.contains('active');
                    detailsEl.classList.toggle('active');
                    this.classList.toggle('active');
                    toggleText.textContent = isOpen ? 'Voir les détails' : 'Masquer les détails';
                }
            });
        });
    }

    updateAddressData() {
        console.log('[RechargePortal] Mise à jour de l\'adresse de livraison...');

        let address;

        // PRIORITÉ 1 : Utiliser l'adresse Recharge (source de vérité pour l'expédition)
        // C'est l'adresse mise à jour par le webhook Shopify → Recharge avec le point relais
        if (this.addresses && this.addresses.length > 0) {
            address = this.addresses[0];
            console.log('[RechargePortal] Utilisation adresse Recharge (expédition):', address);
        }
        // PRIORITÉ 2 : Fallback sur Shopify (adresse de facturation)
        else if (window.shopifyCustomerData && window.shopifyCustomerData.address) {
            address = window.shopifyCustomerData.address;
            console.log('[RechargePortal] Fallback adresse Shopify (facturation):', address);
        } else {
            console.warn('[RechargePortal] Pas d\'adresse disponible');
            return;
        }

        // Construire le texte de l'adresse.
        // `company` EN PREMIER : sur un point relais c'est l'identité du commerce
        // et son code ("Tabac le refuge (7243V)"). Sans cette ligne, un relais
        // s'affiche comme une adresse de particulier — le client croit être livré
        // chez lui et le transporteur refuse le colis.
        let addressText = '';
        const companyLabel = RechargePortal.displayCompany(address.company);
        if (companyLabel) addressText += companyLabel + '\n';
        if (address.address1) addressText += address.address1;
        if (address.address2) addressText += ', ' + address.address2;
        if (address.city) addressText += '\n' + address.city;
        if (address.zip) addressText += ' ' + address.zip;
        if (address.province) addressText += ', ' + address.province;
        if (address.country) addressText += '\n' + address.country;

        // Mettre à jour l'élément d'adresse dans le DOM
        const deliveryAddressEl = document.querySelector('[data-recharge="delivery_address"]');
        if (deliveryAddressEl) {
            deliveryAddressEl.textContent = addressText.trim();
            console.log('[RechargePortal] ✅ Adresse affichée:', addressText);
        } else {
            console.warn('[RechargePortal] ⚠️ Element [data-recharge="delivery_address"] non trouvé');
        }

        // Détecter et mettre à jour le mode de livraison
        this.detectAndUpdateShippingMode(address);

        console.log('[RechargePortal] ✅ Adresse de livraison mise à jour');
    }

    detectAndUpdateShippingMode(address) {
        console.log('[RechargePortal] Détection du mode de livraison...');
        console.log('[RechargePortal] Adresse reçue:', {
            company: address.company,
            address1: address.address1,
            address2: address.address2,
            city: address.city
        });

        // Vérifier si l'adresse contient des indices de point relais
        const isPickupPoint = RechargePortal.isRelayAddress(address);

        console.log('[RechargePortal] isPickupPoint =', isPickupPoint);

        const btnChoosePickup = document.getElementById('btn-choose-pickup-point');
        const shippingMethodEls = document.querySelectorAll('[data-recharge="shipping_method"]');

        console.log('[RechargePortal] Éléments trouvés:', {
            btnChoosePickup: btnChoosePickup ? 'OUI' : 'NON',
            shippingMethodEls: shippingMethodEls.length
        });

        // NOTE: le titre + le prix du mode de livraison sont dérivés de la charge
        // Recharge réelle (applyShippingMethodDisplay / getChargeTotals), et la
        // présélection du modal est faite par renderShippingOptions() à l'ouverture
        // (options dynamiques : île + poids). Cette méthode ne gère plus QUE la
        // visibilité du bouton "Choisir un point relais".
        if (isPickupPoint) {
            console.log('[RechargePortal] ✅ Adresse type point relais');
            if (btnChoosePickup) btnChoosePickup.style.display = 'block';
        } else {
            console.log('[RechargePortal] ✅ Adresse type domicile');
            if (btnChoosePickup) btnChoosePickup.style.display = 'none';
        }
    }

    // updatePaymentData() {
    //     console.log('[RechargePortal] Mise à jour des infos de paiement...');

    //     if (!this.orders || this.orders.length === 0) {
    //         console.warn('[RechargePortal] Pas de commande pour extraire les infos de paiement');
    //         return;
    //     }

    //     // Prendre la dernière commande (la plus récente)
    //     const lastOrder = this.orders[0];
    //     console.log('[RechargePortal] Dernière commande pour paiement:', lastOrder);

    //     // Extraire les infos de paiement depuis la commande
    //     if (lastOrder.charge && lastOrder.charge.payment_processor_name) {
    //         const paymentProcessor = lastOrder.charge.payment_processor_name;

    //         // Déterminer le type de carte (Visa, Mastercard, etc.)
    //         let cardType = 'Carte bancaire';
    //         if (paymentProcessor.includes('visa') || lastOrder.billing_address?.company?.includes('Visa')) {
    //             cardType = 'Visa';
    //         } else if (paymentProcessor.includes('mastercard')) {
    //             cardType = 'Mastercard';
    //         } else if (paymentProcessor.includes('amex')) {
    //             cardType = 'American Express';
    //         }

    //         // Mettre à jour le type de paiement
    //         const paymentTypeEl = document.querySelector('[data-recharge="payment_method_type"]');
    //         if (paymentTypeEl) {
    //             paymentTypeEl.textContent = cardType;
    //             console.log('[RechargePortal] ✅ Type de paiement:', cardType);
    //         }

    //         // Note: Les infos de carte (numéros, expiration) ne sont généralement pas disponibles
    //         // dans l'API Recharge pour des raisons de sécurité
    //         console.log('[RechargePortal] ⚠️ Infos détaillées de carte non disponibles (sécurité)');
    //     }

    //     console.log('[RechargePortal] ✅ Infos de paiement mises à jour');
    // }

    async updatePaymentData() {
        console.log('[RechargePortal] Mise à jour des infos de paiement...');

        const typeEl   = document.querySelector('[data-recharge="payment_method_type"]');
        const expiryEl = document.querySelector('[data-recharge="payment_expiry"]');
        const digitsEl = document.querySelector('[data-recharge="payment_last_digits"]');

        // Helper : mapping marque -> libellé
        const brandLabel = (b) => {
            if (!b) return 'Carte bancaire';
            b = b.toLowerCase();
            if (b.includes('visa')) return 'Visa';
            if (b.includes('master')) return 'Mastercard';
            if (b.includes('amex') || b.includes('american')) return 'American Express';
            return b.charAt(0).toUpperCase() + b.slice(1);
        };

        // 1) Tenter de réutiliser ce qui est déjà chargé (selon version API, payment_details
        //    peut être présent dans la charge de la dernière commande)
        let details = this.orders?.[0]?.charge?.payment_details || null;

        // 2) Sinon, récupérer le moyen de paiement (1 requête légère)
        if (!details || !details.last4) {
            try {
                const resp = await window.recharge.paymentMethod.listPaymentMethods(this.session);
                const pm = resp?.payment_methods?.[0];
                details = pm?.payment_details || details;
                if (pm) {
                    // brand peut aussi être au niveau du payment_method
                    details = { brand: pm.payment_details?.brand || pm.brand, ...details };
                }
            } catch (e) {
                console.warn('[RechargePortal] ⚠️ payment_methods indisponible:', e.message);
            }
        }

        if (details && (details.last4 || details.brand)) {
            if (typeEl)   typeEl.textContent   = brandLabel(details.brand);
            if (expiryEl) expiryEl.textContent = (details.exp_month && details.exp_year)
                ? `${details.exp_month}/${details.exp_year}` : '—';
            if (digitsEl) digitsEl.textContent = details.last4 || '—';
            console.log('[RechargePortal] ✅ Paiement réel affiché:', details.brand, details.last4);
        } else {
            // Fallback : au moins le type via le processor de la commande
            const proc = this.orders?.[0]?.charge?.payment_processor_name || '';
            if (typeEl) typeEl.textContent = brandLabel(proc);
            console.warn('[RechargePortal] Détails carte indisponibles, type seul affiché');
        }
    }

    // Masquer les onglets Abonnement et Facturation pour les clients sans abonnement
    hideSubscriptionTabs() {
        console.log('[RechargePortal] Masquage des onglets Abonnement et Facturation...');

        // Masquer les boutons de navigation pour Abonnement et Facturation
        const navButtons = document.querySelectorAll('.nav-button');
        navButtons.forEach(btn => {
            const tabName = btn.getAttribute('data-tab');
            if (tabName === 'abonnement' || tabName === 'facturation') {
                btn.style.display = 'none';
                console.log('[RechargePortal] ✅ Onglet masqué:', tabName);
            }
        });

        // Masquer aussi les panneaux correspondants
        const tabPanels = document.querySelectorAll('.tab-panel');
        tabPanels.forEach(panel => {
            const panelName = panel.getAttribute('data-panel');
            if (panelName === 'abonnement' || panelName === 'facturation') {
                panel.style.display = 'none';
            }
        });

        console.log('[RechargePortal] ✅ Mode "Historique uniquement" appliqué');
    }

    bindEvents() {
        // Éviter le double-binding si init() est appelé plusieurs fois
        if (this._eventsBound) {
            console.log('[RechargePortal] Événements déjà attachés, skip');
            return;
        }
        this._eventsBound = true;
        console.log('[RechargePortal] Attachement événements actions...');

        // Bouton de déconnexion
        document.querySelectorAll('.action-link--logout').forEach(link => {
            link.addEventListener('click', async (e) => {
                e.preventDefault();
                await this.logout();
            });
        });

        // Boutons de modification (edit-shipment, edit-frequency, etc.)
        document.addEventListener('click', async (e) => {
            if (e.target.closest('[data-recharge-action]')) {
                const button = e.target.closest('[data-recharge-action]');
                const action = button.getAttribute('data-recharge-action');
                await this.handleAction(action, button);
            }
        });

        console.log('[RechargePortal] Événements actions attachés');
    }

    async handleAction(action, button) {
        console.log('[RechargePortal] Action:', action);

        // Actions d'écriture Recharge : pré-vérification locale de session
        // (0 requête) avant de tenter l'appel API.
        const writeActions = [
            'increase-quantity', 'decrease-quantity',
            'increase-onetime-quantity', 'decrease-onetime-quantity',
            'delete-subscription-product', 'delete-onetime-product',
            'swap-subscription-product',
            'toggle-pet-food',
            'add-recommended-product'
        ];
        if (writeActions.includes(action) && !this.requireSession()) return;

        switch (action) {
            case 'edit-shipment':
                // Ouvrir modal de modification date
                break;
            case 'edit-frequency':
                // Ouvrir modal de modification fréquence
                break;
            case 'cancel-subscription':
                // Ouvrir le modal de confirmation d'annulation
                const cancelModal = document.getElementById('modal-cancel-subscription');
                const modalOverlayCancel = document.getElementById('modal-overlay');
                if (cancelModal) {
                    cancelModal.classList.add('active');
                    if (modalOverlayCancel) {
                        modalOverlayCancel.classList.add('active');
                    }
                    document.body.style.overflow = 'hidden';
                }
                break;
            case 'increase-quantity':
                await this.updateQuantity(button, 1);
                break;
            case 'decrease-quantity':
                await this.updateQuantity(button, -1);
                break;
            case 'increase-onetime-quantity':
                await this.updateOnetimeQuantity(button, 1);
                break;
            case 'decrease-onetime-quantity':
                await this.updateOnetimeQuantity(button, -1);
                break;
            case 'swap-subscription-product':
                // Remplacement du dernier produit : ouvre le catalogue en mode "swap"
                if (typeof window.openSwapProductModal === 'function') {
                    await window.openSwapProductModal(button.getAttribute('data-subscription-id'));
                } else {
                    console.error('[RechargePortal] openSwapProductModal indisponible');
                }
                break;
            case 'delete-subscription-product':
                await this.deleteSubscriptionProduct(button);
                break;
            case 'delete-onetime-product':
                await this.deleteOnetimeProduct(button);
                break;
            case 'toggle-pet-food':
                this.togglePetFood(button);
                break;
            case 'add-recommended-product':
                await this.addRecommendedProduct(button);
                break;
            case 'view-legacy-invoices':
                await this.loadLegacyInvoices(button);
                break;
            case 'download-legacy-invoice':
                await this.downloadLegacyInvoice(button);
                break;
            default:
                console.log('[RechargePortal] Action non gérée:', action);
        }
    }

    async updateQuantity(button, change) {
        try {
            // Récupérer l'ID de la subscription depuis le bouton
            const subscriptionId = button.getAttribute('data-subscription-id');
            const quantityGroup = button.closest('.quantity-group');
            const qtyValueEl = quantityGroup.querySelector('.qty-value');
            const currentQty = parseInt(qtyValueEl.textContent) || 1;
            const newQty = currentQty + change;

            // Ne pas descendre en dessous de 1
            if (newQty < 1) {
                console.warn('[RechargePortal] Quantité minimum atteinte (1)');
                return;
            }

            console.log(`[RechargePortal] Mise à jour quantité: ${currentQty} → ${newQty} (subscription ${subscriptionId})`);

            // Désactiver les boutons pendant l'appel API
            const plusBtn = quantityGroup.querySelector('.qty-plus');
            const minusBtn = quantityGroup.querySelector('.qty-minus');
            plusBtn.disabled = true;
            minusBtn.disabled = true;

            // Appeler l'API Recharge pour mettre à jour la quantité
            const response = await window.recharge.subscription.updateSubscription(
                this.session,
                subscriptionId,
                { quantity: newQty }
            );

            console.log('[RechargePortal] ✅ Quantité mise à jour:', response);

            // Mettre à jour l'objet subscription dans activeSubscriptions
            const subIndex = this.activeSubscriptions.findIndex(sub => sub.id == subscriptionId);
            if (subIndex !== -1) {
                if (response.subscription) {
                    this.activeSubscriptions[subIndex] = response.subscription;
                } else {
                    this.activeSubscriptions[subIndex].quantity = newQty;
                }
            }

            // Recharger la charge (totaux + poids), re-render, reprice relais si besoin
            await this.syncChargeAfterMutation();

            showNotification('✅ Quantité mise à jour avec succès !', 'success', 3000);

        } catch (error) {
            if (this.handleAuthError(error)) return;
            console.error('[RechargePortal] ❌ Erreur mise à jour quantité:', error);

            // Réactiver les boutons en cas d'erreur
            const quantityGroup = button.closest('.quantity-group');
            const plusBtn = quantityGroup.querySelector('.qty-plus');
            const minusBtn = quantityGroup.querySelector('.qty-minus');
            plusBtn.disabled = false;
            minusBtn.disabled = false;

            showNotification('❌ Erreur lors de la mise à jour. Veuillez réessayer.', 'error');
        }
    }

    async updateOnetimeQuantity(button, change) {
        try {
            // Récupérer l'ID du one-time depuis le bouton
            const onetimeId = button.getAttribute('data-onetime-id');
            const quantityGroup = button.closest('.quantity-group');
            const qtyValueEl = quantityGroup.querySelector('.qty-value');
            const currentQty = parseInt(qtyValueEl.textContent) || 1;
            const newQty = currentQty + change;

            console.log(`[RechargePortal] Modification quantité one-time: ${currentQty} → ${newQty} (one-time ${onetimeId})`);

            // Si la quantité atteindrait 0, afficher le modal de confirmation de suppression
            if (newQty <= 0) {
                console.log('[RechargePortal] Quantité = 0, affichage du modal de suppression');

                // Trouver le nom du produit via le data-onetime-id
                const productItem = document.querySelector(`.product-item-onetime[data-onetime-id="${onetimeId}"]`);
                const productName = productItem ? productItem.querySelector('.product-name').textContent : 'Produit';

                console.log('[RechargePortal] Produit trouvé:', productName);

                // Remplir le modal avec les informations du produit
                const deleteModal = document.getElementById('modal-delete-onetime');
                const productNameEl = document.getElementById('delete-onetime-product-name');

                console.log('[RechargePortal] 🔍 Debug modal:', {
                    deleteModal: deleteModal,
                    productNameEl: productNameEl
                });

                if (!deleteModal) {
                    console.error('[RechargePortal] ❌ Modal #modal-delete-onetime introuvable dans le DOM');
                    alert('Erreur : Le modal de suppression est introuvable. Veuillez rafraîchir la page.');
                    return;
                }

                if (productNameEl) {
                    productNameEl.textContent = productName;
                } else {
                    console.warn('[RechargePortal] ⚠️ Élément #delete-onetime-product-name introuvable');
                }

                // Stocker l'ID du one-time pour l'utiliser lors de la confirmation
                deleteModal.setAttribute('data-onetime-id', onetimeId);

                // Afficher le modal
                deleteModal.classList.add('active');
                document.body.style.overflow = 'hidden';
                return;
            }

            // Sinon, mettre à jour normalement la quantité
            console.log(`[RechargePortal] Mise à jour quantité one-time via API`);

            // Désactiver les boutons pendant l'appel API
            const plusBtn = quantityGroup.querySelector('.qty-plus');
            const minusBtn = quantityGroup.querySelector('.qty-minus');
            plusBtn.disabled = true;
            minusBtn.disabled = true;

            // Appeler l'API Recharge pour mettre à jour la quantité du one-time
            const response = await window.recharge.onetime.updateOnetime(
                this.session,
                onetimeId,
                { quantity: newQty }
            );

            console.log('[RechargePortal] ✅ Quantité one-time mise à jour:', response);

            // Mettre à jour l'affichage local
            qtyValueEl.textContent = newQty;

            // Mettre à jour l'objet onetime dans le tableau onetimes
            const onetimeIndex = this.onetimes.findIndex(ot => ot.id == onetimeId);
            if (onetimeIndex !== -1) {
                if (response.onetime) {
                    this.onetimes[onetimeIndex] = response.onetime;
                } else {
                    this.onetimes[onetimeIndex].quantity = newQty;
                }
            }

            // Recharger la charge (totaux + poids), re-render, reprice relais si besoin
            await this.syncChargeAfterMutation();

            showNotification('✅ Quantité mise à jour avec succès !', 'success', 3000);

        } catch (error) {
            if (this.handleAuthError(error)) return;
            console.error('[RechargePortal] ❌ Erreur mise à jour quantité one-time:', error);

            // Réactiver les boutons en cas d'erreur
            const quantityGroup = button.closest('.quantity-group');
            const plusBtn = quantityGroup.querySelector('.qty-plus');
            const minusBtn = quantityGroup.querySelector('.qty-minus');
            if (plusBtn) plusBtn.disabled = false;
            if (minusBtn) minusBtn.disabled = false;

            showNotification('❌ Erreur lors de la mise à jour. Veuillez réessayer.', 'error');
        }
    }

    async deleteOnetime(onetimeId) {
        try {
            console.log(`[RechargePortal] 🗑️ Suppression one-time ${onetimeId}...`);

            // Appeler l'API Recharge pour supprimer le one-time
            await window.recharge.onetime.deleteOnetime(this.session, onetimeId);

            console.log('[RechargePortal] ✅ One-time supprimé avec succès');

            // Supprimer le one-time du tableau local
            const onetimeIndex = this.onetimes.findIndex(ot => ot.id == onetimeId);
            if (onetimeIndex !== -1) {
                this.onetimes.splice(onetimeIndex, 1);
            }

            // Recharger la charge (totaux + poids), re-render, reprice relais si besoin
            await this.syncChargeAfterMutation();

            showNotification('✅ Commande supprimée avec succès !', 'success', 3000);

        } catch (error) {
            if (this.handleAuthError(error)) return;
            console.error('[RechargePortal] ❌ Erreur suppression one-time:', error);

            showNotification('❌ Erreur lors de la suppression. Veuillez réessayer.', 'error');
        }
    }

    async cancelSubscription() {
        try {
            console.log('[RechargePortal] 🚫 Annulation de TOUS les abonnements actifs...');
            console.log('[RechargePortal] Nombre d\'abonnements actifs:', this.activeSubscriptions.length);

            // Vérifier qu'il y a des abonnements à annuler
            if (!this.activeSubscriptions || this.activeSubscriptions.length === 0) {
                throw new Error('Aucun abonnement actif à annuler');
            }

            // Annuler les abonnements SÉQUENTIELLEMENT (un après l'autre)
            // Car l'API Recharge n'accepte pas les appels parallèles sur /cancel (erreur 409)
            const results = [];
            for (const subscription of this.activeSubscriptions) {
                console.log(`[RechargePortal] 🚫 Tentative annulation subscription ID: ${subscription.id}`);
                try {
                    const result = await window.recharge.subscription.cancelSubscription(
                        this.session,
                        subscription.id,
                        {
                            cancellation_reason: 'customer_request',
                            cancellation_reason_comments: 'Demande du client via le portail'
                        }
                    );
                    console.log(`[RechargePortal] ✅ Subscription ${subscription.id} annulée avec succès`, result);
                    results.push({ success: true, id: subscription.id, result });
                } catch (err) {
                    if (this.handleAuthError(err)) return;
                    console.error(`[RechargePortal] ❌ Échec annulation subscription ${subscription.id}:`, err);
                    results.push({ success: false, id: subscription.id, error: err });
                }
            }

            // Compter les succès et les échecs
            const successes = results.filter(r => r.success);
            const failures = results.filter(r => !r.success);

            console.log(`[RechargePortal] Résultat: ${successes.length} succès, ${failures.length} échecs`);

            if (failures.length > 0) {
                console.error('[RechargePortal] Abonnements non annulés:', failures.map(f => f.id));
            }

            // Afficher notification selon le résultat
            if (failures.length === 0) {
                showNotification(`✅ ${successes.length} abonnement(s) annulé(s) avec succès`, 'success');
            } else if (successes.length > 0) {
                showNotification(`⚠️ ${successes.length} abonnement(s) annulé(s), ${failures.length} échec(s). Veuillez réessayer.`, 'error');
            } else {
                showNotification('❌ Erreur lors de l\'annulation. Veuillez réessayer ou contacter le support.', 'error');
            }

            // Rafraîchir les données du dashboard pour afficher le statut mis à jour.
            // NB : plus via init() — la garde _initStarted en fait un no-op ;
            // on recharge uniquement les données et l'UI.
            console.log('[RechargePortal] Rafraîchissement des données...');
            await Promise.all([
                this.loadSubscriptions(),
                this.loadOnetimes(),
                this.loadNextCharge()
            ]);
            // Recalculer l'état paiement : plus d'abonnement actif = plus de
            // bandeau rouge (il exige un abonnement actif)
            this.computePaymentIssue();
            this.updatePaymentIssueBanner();
            await this.updateUI();

        } catch (error) {
            if (this.handleAuthError(error)) return;
            console.error('[RechargePortal] ❌ Erreur annulation:', error);

            showNotification('❌ Erreur lors de l\'annulation. Veuillez réessayer ou contacter le support.', 'error');
        }
    }

    // options : { subscriptionId, skipConfirm, force, cancellationReason, cancellationComments, successMessage }
    // Sert aussi au remplacement de produit (executeProductSwap) : même annulation,
    // mêmes rechargements, mêmes garde-fous — un seul endroit décide qu'une ligne
    // d'abonnement disparaît.
    async deleteSubscriptionProduct(button, options = {}) {
        const subscriptionId = options.subscriptionId || button?.getAttribute('data-subscription-id');
        let tracked = false;
        let cancelled = false;

        try {
            // Trouver l'abonnement à supprimer
            const subscription = this.activeSubscriptions.find(sub => sub.id == subscriptionId);
            if (!subscription) {
                console.error('[RechargePortal] Abonnement non trouvé:', subscriptionId);
                return;
            }

            const productTitle = subscription.product_title || subscription.shopify_product_title || 'ce produit';

            // Garde-fou : supprimer la dernière ligne reviendrait à annuler l'abonnement
            // sans passer par le parcours de désabonnement. Le rendu affiche déjà un bouton
            // "Remplacer" dans ce cas, mais un DOM périmé (deux onglets ouverts) ou deux clics
            // rapides sur deux corbeilles peuvent encore envoyer cette action.
            // On compte les lignes qui SURVIVRAIENT à cette suppression : activeSubscriptions
            // n'est rafraîchi qu'après l'aller-retour API, donc une annulation déjà partie y
            // figure toujours — d'où l'exclusion des ids présents dans _cancelsInFlight.
            const remaining = (this.activeSubscriptions || []).filter(sub =>
                sub.id != subscriptionId && !this._cancelsInFlight.has(String(sub.id))
            ).length;
            if (!options.force && remaining < 1) {
                console.warn('[RechargePortal] Suppression du dernier produit bloquée → remplacement');
                if (typeof window.openSwapProductModal === 'function') {
                    window.openSwapProductModal(subscriptionId);
                }
                return;
            }

            // Demander confirmation avant suppression (le remplacement a déjà sa propre validation)
            if (!options.skipConfirm) {
                const confirmed = confirm(`Êtes-vous sûr de vouloir supprimer "${productTitle}" de votre abonnement ?`);
                if (!confirmed) {
                    console.log('[RechargePortal] Suppression annulée par l\'utilisateur');
                    return;
                }
            }

            // Réserver la ligne AVANT tout await : le thread JS étant unique, toute autre
            // suppression démarrée ensuite la verra déjà condamnée et comptera sans elle.
            // La réservation couvre aussi la revalidation ci-dessous, sinon deux clics
            // entreraient tous les deux dedans et en ressortiraient tous les deux gagnants.
            // Le finally la libère si l'annulation n'a finalement pas lieu. Le remplacement
            // (force) réserve aussi : sa ligne ne doit pas compter comme survivante.
            this._cancelsInFlight.add(String(subscriptionId));
            tracked = true;

            // Re-render immédiat : la ligne condamnée perd son bouton et, s'il ne reste
            // plus qu'une survivante, sa corbeille devient "Remplacer" tout de suite —
            // sans attendre l'aller-retour. L'UI dit alors la même chose que la garde.
            this.updateSubscriptionData();

            // Avant-dernière ligne : l'état local peut dire « il reste des lignes » alors
            // que Recharge n'en a plus qu'une (second onglet, page ouverte depuis longtemps).
            // _cancelsInFlight ne couvre que cet onglet. Avant une annulation irréversible,
            // on revalide auprès de l'API — un aller-retour, uniquement dans ce cas précis.
            if (!options.force && remaining <= 1) {
                await this.loadSubscriptions();

                // loadSubscriptions() avale ses erreurs et vide activeSubscriptions :
                // sans état fiable on ne supprime pas. Une erreur d'auth suit le même
                // chemin que handleAuthError() (écran de reconnexion, pas de toast retry).
                if (this.loadResults.subscriptions === 'auth') {
                    console.warn('[RechargePortal] 🔒 Session expirée pendant la revalidation');
                    this.setPortalState('session-expired');
                    return;
                }
                if (this.loadResults.subscriptions !== 'ok') {
                    console.warn('[RechargePortal] Revalidation impossible → suppression abandonnée');
                    showNotification('❌ Impossible de vérifier votre abonnement. Réessayez dans un instant.', 'error');
                    return;
                }

                const stillActive = this.activeSubscriptions.some(sub => sub.id == subscriptionId);
                const freshRemaining = this.activeSubscriptions.filter(sub =>
                    sub.id != subscriptionId && !this._cancelsInFlight.has(String(sub.id))
                ).length;

                // L'affichage doit refléter ce que l'API vient de renvoyer, quelle que soit
                // l'issue : la corbeille peut devoir devenir "Remplacer".
                this.updateSubscriptionData();

                if (!stillActive) {
                    console.warn('[RechargePortal] Ligne déjà annulée ailleurs:', subscriptionId);
                    showNotification('ℹ️ Ce produit a déjà été retiré de votre abonnement.', 'info', 4000);
                    return;
                }

                if (freshRemaining < 1) {
                    console.warn('[RechargePortal] Suppression du dernier produit bloquée (revalidation) → remplacement');
                    if (typeof window.openSwapProductModal === 'function') {
                        window.openSwapProductModal(subscriptionId);
                    }
                    return;
                }
            }

            console.log(`[RechargePortal] Suppression de l'abonnement ${subscriptionId}...`);

            // Désactiver le bouton pendant la suppression (absent en appel programmatique)
            if (button) {
                button.disabled = true;
                button.style.opacity = '0.5';
            }

            // Appeler l'API Recharge pour annuler l'abonnement
            // Note: Recharge SDK utilise cancelSubscription() au lieu de deleteSubscription()
            await window.recharge.subscription.cancelSubscription(
                this.session,
                subscriptionId,
                {
                    cancellation_reason: options.cancellationReason || 'Suppression du produit par le client',
                    cancellation_reason_comments: options.cancellationComments || 'Client a supprimé le produit via le portail'
                }
            );

            cancelled = true;
            console.log('[RechargePortal] ✅ Abonnement supprimé');

            showNotification(options.successMessage || `✅ "${productTitle}" a été supprimé de votre abonnement`, 'success', 4000);

            // Recharger les données et mettre à jour l'interface
            await this.loadSubscriptions();
            await this.loadOnetimes();
            this.updateSubscriptionData();
            // Charge queued : totaux + poids à jour, reprice relais si besoin
            await this.syncChargeAfterMutation();

            console.log('[RechargePortal] ✅ Interface mise à jour après suppression');

        } catch (error) {
            if (this.handleAuthError(error)) return;
            console.error('[RechargePortal] Erreur suppression abonnement:', error);

            // Réactiver le bouton en cas d'erreur (absent en appel programmatique)
            if (button) {
                button.disabled = false;
                button.style.opacity = '1';
            }

            showNotification(options.errorMessage || `❌ Erreur lors de la suppression: ${error.message}`, 'error');
        } finally {
            // On libère l'id, sauf si l'annulation a réussi mais que le rafraîchissement
            // a échoué : la ligne resterait alors listée comme active à tort, et une
            // suppression suivante la compterait comme survivante.
            const stillListed = (this.activeSubscriptions || []).some(sub => sub.id == subscriptionId);
            if (tracked && !(cancelled && stillListed)) {
                this._cancelsInFlight.delete(String(subscriptionId));

                // La réservation avait retiré le bouton de la ligne : si l'annulation n'a
                // finalement pas eu lieu (revalidation négative, erreur API), il faut le
                // lui rendre — sinon elle reste sans corbeille jusqu'au prochain
                // rechargement. Après une annulation réussie, le rendu a déjà eu lieu
                // sur des données fraîches : on n'en rajoute pas.
                if (!cancelled) {
                    try {
                        this.updateSubscriptionData();
                    } catch (renderError) {
                        console.error('[RechargePortal] Erreur de rendu après libération:', renderError);
                    }
                }
            }
        }
    }

    async deleteOnetimeProduct(button) {
        try {
            const onetimeId = button.getAttribute('data-onetime-id');

            // Trouver le one-time à supprimer
            const onetime = this.onetimes.find(ot => ot.id == onetimeId);
            if (!onetime) {
                console.error('[RechargePortal] One-time non trouvé:', onetimeId);
                return;
            }

            const productTitle = onetime.product_title || onetime.shopify_product_title || 'ce produit';

            // Demander confirmation avant suppression
            const confirmed = confirm(`Êtes-vous sûr de vouloir supprimer "${productTitle}" de votre achat unique ?`);
            if (!confirmed) {
                console.log('[RechargePortal] Suppression annulée par l\'utilisateur');
                return;
            }

            console.log(`[RechargePortal] Suppression du one-time ${onetimeId}...`);

            // Désactiver le bouton pendant la suppression
            button.disabled = true;
            button.style.opacity = '0.5';

            // Appeler l'API Recharge pour supprimer le one-time
            await window.recharge.onetime.deleteOnetime(
                this.session,
                onetimeId
            );

            console.log('[RechargePortal] ✅ One-time supprimé');

            showNotification(`✅ "${productTitle}" a été supprimé de votre achat unique`, 'success', 4000);

            // Recharger les données et mettre à jour l'interface
            await this.loadSubscriptions();
            await this.loadOnetimes();
            this.updateSubscriptionData();
            // Charge queued : totaux + poids à jour, reprice relais si besoin
            await this.syncChargeAfterMutation();

            console.log('[RechargePortal] ✅ Interface mise à jour après suppression');

        } catch (error) {
            if (this.handleAuthError(error)) return;
            console.error('[RechargePortal] Erreur suppression one-time:', error);

            // Réactiver le bouton en cas d'erreur
            button.disabled = false;
            button.style.opacity = '1';

            showNotification(`❌ Erreur lors de la suppression: ${error.message}`, 'error');
        }
    }

    async logout() {
        try {
            console.log('[RechargePortal] Déconnexion...');

            // Nettoyer TOUTES les sessions Recharge
            sessionStorage.removeItem('recharge_api_token');
            sessionStorage.removeItem('recharge_customer_id');
            sessionStorage.removeItem('recharge_customer_email');
            sessionStorage.removeItem('recharge_login_time');

            console.log('[RechargePortal] ✅ Session nettoyée');

            // Déconnecter Shopify puis rediriger vers le portail
            window.location.href = '/account/logout?return_url=/pages/recharge-login';
        } catch (error) {
            console.error('[RechargePortal] Erreur déconnexion:', error);
            // En cas d'erreur, forcer la redirection quand même
            sessionStorage.clear();
            window.location.href = '/account/logout?return_url=/pages/recharge-login';
        }
    }

    async loadShopifyOrders() {
        // Garde anti-doublon : évite un double fetch quand renderOrdersHistory
        // (via switchTab) et displayShopifyOnlyMessage l'appellent quasi simultanément
        if (this._shopifyOrdersLoading) {
            console.log('[RechargePortal] loadShopifyOrders déjà en cours, skip');
            return;
        }

        console.log('[RechargePortal] Chargement des commandes Shopify...');

        const ordersListEl = document.querySelector('[data-recharge="orders_list"]');
        const noOrdersEl = document.querySelector('[data-recharge="no_orders"]');

        if (!ordersListEl) {
            console.error('[RechargePortal] Element orders_list non trouvé');
            return;
        }

        this._shopifyOrdersLoading = true;

        // Afficher un loader pendant le chargement
        ordersListEl.innerHTML = '<div style="text-align: center; padding: 40px;"><p>Chargement des commandes...</p></div>';

        try {
            // Récupérer les commandes depuis l'API Shopify
            const response = await fetch('/account?view=json');
            const data = await response.json();

            console.log('[RechargePortal] Commandes Shopify reçues:', data);

            // Si le endpoint JSON n'est pas disponible, utiliser les données Shopify statiques
            if (!data.orders || data.orders.length === 0) {
                console.log('[RechargePortal] Pas de commandes disponibles via API, affichage message');
                ordersListEl.innerHTML = '';
                if (noOrdersEl) {
                    noOrdersEl.style.display = 'flex';
                }
                return;
            }

            // Cacher le message "Aucune commande"
            if (noOrdersEl) {
                noOrdersEl.style.display = 'none';
            }

            // Générer le HTML pour chaque commande Shopify
            let ordersHTML = '';

            data.orders.forEach((order, index) => {
                const orderDate = new Date(order.created_at);
                const formattedDate = orderDate.toLocaleDateString('fr-FR', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                });

                // Statut de la commande
                let statusBadge = '';
                let statusClass = '';
                if (order.fulfillment_status === 'fulfilled') {
                    statusBadge = 'Livrée ✓';
                    statusClass = 'badge-delivered';
                } else if (order.fulfillment_status === 'partial') {
                    statusBadge = 'En cours';
                    statusClass = 'badge-processing';
                } else {
                    statusBadge = 'Payée ✓';
                    statusClass = 'badge-paid';
                }

                // Total de la commande
                const total = parseFloat(order.total_price);
                const formattedTotal = total.toFixed(2).replace('.', ',');

                // Lien facture PDF (Order Printer Pro) — map injectée côté Liquid (window.orderInvoiceLinks)
                const invoiceUrl = (window.orderInvoiceLinks || {})[order.id]
                    || (window.orderInvoiceLinks || {})[order.order_number];

                ordersHTML += `
                        <div class="order-item" data-order-index="${index}">
                            <div class="order-header">
                                <div class="order-info">
                                    <h3 class="order-number">Commande #${order.order_number}</h3>
                                    <p class="order-date">${formattedDate}</p>
                                </div>
                                <div class="order-meta">
                                    <span class="badge ${statusClass}">${statusBadge}</span>
                                    <span class="order-total">${formattedTotal} €</span>
                                    ${invoiceUrl ? `
                                        <a class="btn-order-action btn-invoice" href="${invoiceUrl}" target="_blank" rel="noopener" title="Télécharger ma facture (PDF)">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 3v12m0 0l-4-4m4 4l4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M5 21h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            Ma facture
                                        </a>
                                    ` : ''}
                                </div>
                            </div>
                            <div class="order-details" id="order-details-shopify-${index}">
                                <div class="products-list">
                                    ${order.line_items.map(item => `
                                        <div class="product-row">
                                            <div class="product-info-order">
                                                <p class="product-name-order">${item.title}</p>
                                                <p class="product-variant-order">${item.variant_title || ''}</p>
                                            </div>
                                            <div class="product-qty-order">
                                                <span>Qté: ${item.quantity}</span>
                                            </div>
                                        </div>
                                    `).join('')}
                                </div>
                            </div>
                            <button class="btn-toggle-details" data-toggle="order-details-shopify-${index}">
                                <span class="toggle-text">Voir les détails</span>
                            </button>
                        </div>
                    `;
            });

            ordersListEl.innerHTML = ordersHTML;

            // Réactiver les boutons toggle
            this.attachOrderToggleListeners();

        } catch (error) {
            console.error('[RechargePortal] Erreur lors du chargement des commandes Shopify:', error);
            ordersListEl.innerHTML = `
                    <div style="text-align: center; padding: 40px;">
                        <p style="color: #666; margin-bottom: 16px;">Impossible de charger vos commandes.</p>
                        <a href="/account" style="color: #47605B; text-decoration: underline;">
                            Voir mes commandes sur mon compte Shopify →
                        </a>
                    </div>
                `;
        } finally {
            this._shopifyOrdersLoading = false;
        }
    }

    async displayShopifyOnlyMessage() {
        console.log('[RechargePortal] Client Shopify-only, affichage du dashboard avec historique...');

        // Mettre à jour le nom dans la sidebar
        const sidebarNameEl = document.querySelector('[data-recharge="sidebar_name"]');
        if (sidebarNameEl && this.customer) {
            const name = this.customer.first_name || this.customer.email.split('@')[0];
            sidebarNameEl.textContent = name;
        }

        // Cacher le bouton "Gérer mon abonnement" dans la sidebar
        const navButtons = document.querySelectorAll('.nav-button');
        navButtons.forEach(btn => {
            if (btn.getAttribute('data-tab') === 'abonnement') {
                btn.style.display = 'none';
            }
        });

        // Mettre à jour la card "Mes coordonnées" avec les données Shopify
        await this.updateContactCardShopify();

        // Attendre que le DOM soit bien rendu avant de supprimer les cards
        setTimeout(() => {
            console.log('[RechargePortal] Tentative de suppression des cards (délai 500ms)...');
            this.hideSubscriptionCards();
        }, 500);

        // Switcher vers l'onglet "historique"
        if (window.switchTab) {
            console.log('[RechargePortal] Basculement vers onglet historique...');
            window.switchTab('historique');
        }

        // Charger les commandes Shopify dans l'historique
        this.loadShopifyOrders();
    }

    async updateContactCardShopify() {
        console.log('[RechargePortal] Mise à jour coordonnées Shopify...');

        const nameEl = document.querySelector('[data-recharge="contact_name"]');
        const emailEl = document.querySelector('[data-recharge="contact_email"]');
        const addressEl = document.querySelector('[data-recharge="contact_address"]');

        if (!window.shopifyCustomerData) {
            console.warn('[RechargePortal] ⚠️ window.shopifyCustomerData non disponible');
            return;
        }

        const customer = window.shopifyCustomerData;

        // Nom complet
        if (nameEl) {
            const fullName = `${customer.firstName || ''} ${customer.lastName || ''}`.trim();
            nameEl.textContent = fullName || 'Non renseigné';
        }

        // Email
        if (emailEl) {
            emailEl.textContent = customer.email || 'Non renseigné';
        }

        // Adresse - Essayer defaultAddress d'abord, sinon charger depuis les commandes
        if (addressEl) {
            let address = null;

            // Option 1 : defaultAddress
            if (customer.defaultAddress && customer.defaultAddress.address1) {
                address = customer.defaultAddress;
                console.log('[RechargePortal] ✅ Adresse trouvée dans defaultAddress');
            }
            // Option 2 : Récupérer depuis la dernière commande
            else {
                console.log('[RechargePortal] ⚠️ Pas de defaultAddress, recherche dans les commandes...');
                try {
                    const response = await fetch('/account?view=json');
                    const data = await response.json();

                    if (data.orders && data.orders.length > 0) {
                        // Prendre l'adresse de livraison de la dernière commande
                        const lastOrder = data.orders[0];
                        if (lastOrder.shipping_address) {
                            address = {
                                address1: lastOrder.shipping_address.address1,
                                address2: lastOrder.shipping_address.address2,
                                zip: lastOrder.shipping_address.zip,
                                city: lastOrder.shipping_address.city,
                                country: lastOrder.shipping_address.country
                            };
                            console.log('[RechargePortal] ✅ Adresse trouvée dans la dernière commande');
                        }
                    }
                } catch (error) {
                    console.error('[RechargePortal] ❌ Erreur lors de la récupération des commandes:', error);
                }
            }

            // Afficher l'adresse si trouvée
            if (address) {
                const addressParts = [
                    address.address1,
                    address.address2,
                    address.zip,
                    address.city,
                    address.country
                ].filter(Boolean);
                addressEl.textContent = addressParts.join(', ') || 'Non renseignée';
            } else {
                addressEl.textContent = 'Non renseignée';
            }
        }
    }

    hideSubscriptionCards() {
        console.log('[RechargePortal] Masquage des cards abonnement...');

        // Cacher la card "Mon abonnement en cours"
        const subscriptionCard = document.querySelector('.card-subscription');
        if (subscriptionCard) {
            subscriptionCard.remove(); // Supprimer complètement du DOM
            console.log('[RechargePortal] ✅ Card subscription supprimée');
        } else {
            console.warn('[RechargePortal] ⚠️ Card subscription introuvable');
        }

        // Cacher la card "Dernière commande" (pas d'historique Recharge)
        const lastOrderCard = document.querySelector('.card-order');
        if (lastOrderCard) {
            lastOrderCard.remove(); // Supprimer complètement du DOM
            console.log('[RechargePortal] ✅ Card order supprimée');
        } else {
            console.warn('[RechargePortal] ⚠️ Card order introuvable');
        }
    }
}

// ==========================================
// INITIALISATION AU CHARGEMENT DU DOM
// ==========================================

document.addEventListener('DOMContentLoaded', () => {
    console.log('[Portal] DOM chargé, initialisation...');

    // ÉTAPE 1 : Toujours initialiser la navigation (fonctionne sans Recharge SDK)
    window.PortalNavigation.init();

    // Boutons des écrans d'état (indépendants de l'instance RechargePortal pour
    // fonctionner même si le SDK ne se charge jamais). Une seule action réseau
    // possible, toujours sur clic, bouton désactivé aussitôt : pas de spam possible.
    const portalRetryBtn = document.getElementById('portal-retry-btn');
    if (portalRetryBtn) {
        portalRetryBtn.addEventListener('click', () => {
            portalRetryBtn.disabled = true;
            portalRetryBtn.textContent = 'Rechargement...';
            window.location.reload();
        });
    }
    const portalReloginBtn = document.getElementById('portal-relogin-btn');
    if (portalReloginBtn) {
        portalReloginBtn.addEventListener('click', () => {
            portalReloginBtn.disabled = true;
            portalReloginBtn.textContent = 'Redirection...';
            sessionStorage.setItem('recharge_return_url', window.location.pathname);
            window.location.href = '/pages/recharge-login';
        });
    }
    // Écran 'soft-session' : renvoie vers la connexion par code (OTP email/SMS),
    // seule voie vers un token d'écriture.
    const portalCodeLoginBtn = document.getElementById('portal-code-login-btn');
    if (portalCodeLoginBtn) {
        portalCodeLoginBtn.addEventListener('click', () => {
            portalCodeLoginBtn.disabled = true;
            portalCodeLoginBtn.textContent = 'Redirection...';
            sessionStorage.setItem('recharge_return_url', window.location.pathname);
            window.location.href = '/pages/recharge-login';
        });
    }

    // ÉTAPE 2 : Initialiser Recharge Portal si le portail est présent.
    // Instanciation inconditionnelle : waitForRecharge() attend le SDK jusqu'à
    // 30s (l'ancienne fenêtre de 50ms laissait la page morte si le SDK arrivait
    // plus tard). SDK jamais chargé → watchdog 25s puis reject → écran d'erreur.
    if (document.querySelector('.portal-container')) {
        console.log('[Portal] Initialisation du portail (attente SDK gérée par waitForRecharge)...');
        window.rechargePortal = new RechargePortal();
    }

    console.log('[Portal] ✅ Initialisation complète');
});

// Toggle détails des commandes
document.addEventListener('DOMContentLoaded', function () {
    const toggleButtons = document.querySelectorAll('.btn-toggle-details');

    toggleButtons.forEach(button => {
        button.addEventListener('click', function () {
            const detailsId = this.getAttribute('data-toggle');
            const detailsSection = document.getElementById(detailsId);
            const toggleText = this.querySelector('.toggle-text');
            const toggleIcon = this.querySelector('.toggle-icon');

            if (detailsSection.classList.contains('open')) {
                detailsSection.classList.remove('open');
                toggleText.textContent = 'Voir les détails';
                toggleIcon.style.transform = 'rotate(0deg)';
            } else {
                detailsSection.classList.add('open');
                toggleText.textContent = 'Masquer les détails';
                toggleIcon.style.transform = 'rotate(180deg)';
            }
        });
    });
});

// ==========================================
// MODAL: Modifier date de commande
// ==========================================
document.addEventListener('DOMContentLoaded', function () {
    const shipmentModal = document.getElementById('shipment-date-modal');
    const shipmentOverlay = document.getElementById('modal-overlay');
    const btnOpenShipment = document.querySelector('[data-recharge-action="edit-shipment"]');
    const btnCloseShipment = document.getElementById('close-shipment-modal');
    const btnCancelShipment = document.getElementById('cancel-shipment');

    console.log('[Modal] Initialisation modal shipment');
    console.log('[Modal] Bouton trouvé:', btnOpenShipment);

    // Ouvrir le modal
    if (btnOpenShipment) {
        btnOpenShipment.addEventListener('click', (e) => {
            e.preventDefault();
            console.log('[Modal] Ouverture du modal');

            // Se positionner sur la livraison ACTUELLE et la présélectionner.
            // Sans ça le calendrier reste sur le mois courant avec « demain »
            // sélectionné par défaut, et le client ne voit pas sa date en cours.
            openCalendarOnCurrentDelivery();

            shipmentModal.classList.add('active');
            shipmentOverlay.classList.add('active');
            document.body.style.overflow = 'hidden';
        });
    }

    // Fermer le modal (bouton X)
    if (btnCloseShipment) {
        btnCloseShipment.addEventListener('click', () => {
            shipmentModal.classList.remove('active');
            shipmentOverlay.classList.remove('active');
            document.body.style.overflow = '';

            // Si on ferme en mode création, réinitialiser le contexte
            if (window.subscriptionCreationContext && window.subscriptionCreationContext.isCreatingNewSubscription) {
                console.log('[Modal Shipment] Fermeture sans validation - Réinitialisation du contexte');
                window.subscriptionCreationContext.selectedProduct = null;
                window.subscriptionCreationContext.selectedFrequency = null;
                window.subscriptionCreationContext.isCreatingNewSubscription = false;
            }
        });
    }

    // Fermer le modal (bouton Annuler)
    if (btnCancelShipment) {
        btnCancelShipment.addEventListener('click', () => {
            shipmentModal.classList.remove('active');
            shipmentOverlay.classList.remove('active');
            document.body.style.overflow = '';

            // Si on ferme en mode création, réinitialiser le contexte
            if (window.subscriptionCreationContext && window.subscriptionCreationContext.isCreatingNewSubscription) {
                console.log('[Modal Shipment] Annulation - Réinitialisation du contexte');
                window.subscriptionCreationContext.selectedProduct = null;
                window.subscriptionCreationContext.selectedFrequency = null;
                window.subscriptionCreationContext.isCreatingNewSubscription = false;
            }
        });
    }

    // Fermer le modal (clic sur overlay)
    if (shipmentOverlay) {
        shipmentOverlay.addEventListener('click', () => {
            // Vérifier si c'est bien le modal de date qui est ouvert
            if (shipmentModal.classList.contains('active')) {
                shipmentModal.classList.remove('active');
                shipmentOverlay.classList.remove('active');
                document.body.style.overflow = '';

                // Si on ferme en mode création, réinitialiser le contexte
                if (window.subscriptionCreationContext && window.subscriptionCreationContext.isCreatingNewSubscription) {
                    console.log('[Modal Shipment] Fermeture overlay - Réinitialisation du contexte');
                    window.subscriptionCreationContext.selectedProduct = null;
                    window.subscriptionCreationContext.selectedFrequency = null;
                    window.subscriptionCreationContext.isCreatingNewSubscription = false;
                }
            }
        });
    }

    // ==========================================
    // Calendrier - Navigation et génération
    // ==========================================
    let currentDate = new Date();
    // La date de LIVRAISON choisie par le client. C'est l'état du modal : le
    // prélèvement n'en est déduit qu'au moment de valider.
    let selectedDelivery = null;
    // La livraison présélectionnée à l'ouverture et le prélèvement Recharge
    // dont elle vient. Nécessaires parce que chargeToDelivery() n'est pas
    // inversible : un prélèvement le mercredi donne +4 = dimanche, affiché au
    // lundi, et lundi - 4 = jeudi. Sans ce souvenir, valider sans rien changer
    // reculerait le prélèvement d'un jour à chaque fois.
    let initialDelivery = null;
    let initialCharge = null;
    const monthNames = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin',
        'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
    const weekDays = ['L', 'M', 'M', 'J', 'V', 'S', 'D'];

    const calendarMonthEl = document.querySelector('.calendar-month');
    const calendarGridEl = document.querySelector('.calendar-grid');
    const prevMonthBtn = document.querySelector('.calendar-nav:first-child');
    const nextMonthBtn = document.querySelector('.calendar-nav:last-child');

    const sameDay = (a, b) => a && b && a.getFullYear() === b.getFullYear()
        && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

    // Récrit le résumé du modal à partir de la date sélectionnée.
    // C'est le correctif du ticket : jusqu'ici le texte ne bougeait pas quand on
    // cliquait un autre jour, parce que rien ne le recalculait.
    // Prélèvement (YYYY-MM-DD) à écrire dans Recharge pour la date sélectionnée.
    // Seul point de conversion livraison → prélèvement du modal : l'affichage et
    // la validation passent tous deux par ici, et ne peuvent donc pas diverger.
    function chargeForSelection() {
        if (initialCharge && sameDay(selectedDelivery, initialDelivery)) return initialCharge;
        return RechargePortal.deliveryToCharge(selectedDelivery);
    }

    function renderModalDateSummary() {
        const dateEl = document.querySelector('[data-recharge="delivery_date_modal"]');
        // Le prélèvement, lui, se connaît au jour près. Mais ce n'est PAS la
        // valeur écrite dans next_charge_scheduled_at : Recharge débite le
        // lendemain vers 3 h. On annonce le jour que le client verra sur son
        // relevé, pas la date interne de planification.
        const chargeEl = document.querySelector('[data-recharge="charge_date_modal"]');

        if (!selectedDelivery) {
            if (dateEl) dateEl.textContent = 'Sélectionnez une date';
            if (chargeEl) chargeEl.textContent = '—';
            return;
        }
        if (dateEl) dateEl.textContent = RechargePortal.formatLongDate(selectedDelivery);
        if (chargeEl) {
            const debit = RechargePortal.addDays(
                RechargePortal.parseLocalDate(chargeForSelection()),
                RechargePortal.CHARGE_OFFSET_DAYS - RechargePortal.DISPLAY_OFFSET_DAYS
            );
            chargeEl.textContent = RechargePortal.formatLongDate(debit);
        }
    }

    // Ouvre le calendrier sur la livraison en cours, ou à défaut sur la première
    // date sélectionnable.
    //
    // Exposé globalement (voir plus bas) parce que le modal de date s'ouvre
    // depuis quatre endroits vivant dans des scopes différents : la card
    // « Ma prochaine livraison », les deux flux de création d'abonnement, et le
    // « Décaler la prochaine livraison » du modal d'annulation. Tous DOIVENT
    // passer par ici : vider `.selected` dans le DOM sans réinitialiser
    // `selectedDelivery` laisserait l'état JS et l'affichage en désaccord, et la
    // validation enregistrerait une date que le client n'a pas vue.
    function openCalendarOnCurrentDelivery() {
        // Rétablir le titre et le libellé par défaut. Les flux de création les
        // remplacent par « Première livraison » et les reposent APRÈS cet appel ;
        // sans ce retour à l'état canonique, un client qui crée un abonnement puis
        // modifie sa date retrouverait le libellé de création.
        const modalTitle = document.querySelector('#shipment-date-modal .modal-title');
        if (modalTitle) modalTitle.textContent = 'Modifier ma date de livraison';
        const modalLabel = document.querySelector('[data-recharge="delivery_date_label"]');
        if (modalLabel) modalLabel.textContent = 'Date de livraison :';

        const sub = window.rechargePortal?.subscription;
        const current = sub?.next_charge_scheduled_at
            ? RechargePortal.chargeToDelivery(sub.next_charge_scheduled_at)
            : null;
        const min = RechargePortal.minSelectableDelivery();

        // Une date passée (abonnement en échec de paiement depuis un moment) ne
        // doit pas être présélectionnée : elle n'est pas sélectionnable.
        //
        // Le prélèvement d'origine doit AUSSI tomber demain au plus tôt. Sinon,
        // via la règle du dimanche, un prélèvement du jour même (un mercredi →
        // livraison lundi = date minimale) serait gardé tel quel, et valider sans
        // changer renverrait à Recharge une date qui n'est plus dans le futur.
        const now = new Date();
        const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
        const originalCharge = RechargePortal.parseLocalDate(sub?.next_charge_scheduled_at);
        const keepCurrent = current && current >= min && originalCharge >= tomorrow;
        selectedDelivery = keepCurrent ? current : min;
        initialDelivery = keepCurrent ? current : null;
        initialCharge = keepCurrent ? String(sub.next_charge_scheduled_at).split('T')[0] : null;
        currentDate = new Date(selectedDelivery.getFullYear(), selectedDelivery.getMonth(), 1);
        generateCalendar(currentDate.getFullYear(), currentDate.getMonth());
        renderModalDateSummary();
    }

    function generateCalendar(year, month) {
        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
        const daysInMonth = lastDay.getDate();
        const startingDayOfWeek = firstDay.getDay();

        // Ajuster pour que lundi = 0 (au lieu de dimanche = 0)
        const adjustedStart = startingDayOfWeek === 0 ? 6 : startingDayOfWeek - 1;

        // Mettre à jour le titre du mois
        calendarMonthEl.textContent = `${monthNames[month]} ${year}`;

        // Vider la grille
        calendarGridEl.innerHTML = '';

        // Ajouter les jours de la semaine
        weekDays.forEach(day => {
            const weekdayEl = document.createElement('div');
            weekdayEl.className = 'calendar-weekday';
            weekdayEl.textContent = day;
            calendarGridEl.appendChild(weekdayEl);
        });

        // Ajouter les espaces vides avant le premier jour
        for (let i = 0; i < adjustedStart; i++) {
            const emptyEl = document.createElement('div');
            calendarGridEl.appendChild(emptyEl);
        }

        // Ajouter les jours du mois
        // `minDelivery` est recalculé à chaque rendu : un onglet laissé ouvert
        // toute la nuit ne doit pas continuer à proposer la veille.
        const minDelivery = RechargePortal.minSelectableDelivery();
        const maxDelivery = RechargePortal.maxSelectableDelivery();

        for (let day = 1; day <= daysInMonth; day++) {
            const dayEl = document.createElement('button');
            dayEl.className = 'calendar-day';
            dayEl.textContent = day;

            const dayDate = new Date(year, month, day);
            // Trois raisons de refuser un jour : trop tôt pour que le prélèvement
            // tombe demain au plus tôt, au-delà de 4 mois, ou dimanche.
            // La livraison déjà programmée reste sélectionnable même au-delà de
            // la limite (posée par le support) : valider sans rien changer ne
            // doit pas la déplacer.
            const tooSoon = dayDate < minDelivery;
            const tooLate = dayDate > maxDelivery && !sameDay(dayDate, initialDelivery);
            const isSunday = dayDate.getDay() === 0;

            if (tooSoon || tooLate || isSunday) {
                dayEl.disabled = true;
                dayEl.style.opacity = '0.3';
                dayEl.style.cursor = 'not-allowed';
                if (tooLate) dayEl.title = 'Décalage limité à 4 mois';
                else if (isSunday && !tooSoon) dayEl.title = 'Pas de livraison le dimanche';
            } else {
                if (sameDay(dayDate, selectedDelivery)) dayEl.classList.add('selected');

                dayEl.addEventListener('click', () => {
                    document.querySelectorAll('.calendar-day').forEach(d => d.classList.remove('selected'));
                    dayEl.classList.add('selected');
                    selectedDelivery = dayDate;
                    renderModalDateSummary();
                });
            }

            calendarGridEl.appendChild(dayEl);
        }
    }

    // Navigation - Mois précédent
    if (prevMonthBtn) {
        prevMonthBtn.addEventListener('click', () => {
            const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);

            // Ne pas remonter avant le mois de la première livraison possible :
            // tous les jours y seraient désactivés.
            const min = RechargePortal.minSelectableDelivery();
            if (newDate >= new Date(min.getFullYear(), min.getMonth(), 1)) {
                currentDate = newDate;
                generateCalendar(currentDate.getFullYear(), currentDate.getMonth());
            }
        });
    }

    // Navigation - Mois suivant
    if (nextMonthBtn) {
        nextMonthBtn.addEventListener('click', () => {
            const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);

            // Ne pas dépasser le mois de la dernière livraison possible (ou celui
            // de la livraison en cours si elle est déjà au-delà).
            const max = RechargePortal.maxSelectableDelivery();
            const last = initialDelivery && initialDelivery > max ? initialDelivery : max;
            if (newDate <= new Date(last.getFullYear(), last.getMonth(), 1)) {
                currentDate = newDate;
                generateCalendar(currentDate.getFullYear(), currentDate.getMonth());
            }
        });
    }

    // Rendu initial. Il est refait à chaque ouverture du modal par
    // openCalendarOnCurrentDelivery(), qui a besoin des données de l'abonnement —
    // pas encore chargées à ce stade.
    currentDate = new Date();
    generateCalendar(currentDate.getFullYear(), currentDate.getMonth());

    // Seul point d'entrée pour les ouvertures venant d'autres scopes.
    window.openShipmentCalendar = openCalendarOnCurrentDelivery;

    // ==========================================
    // Bouton Confirmer - Sauvegarder la nouvelle date
    // ==========================================
    const btnConfirmShipment = document.getElementById('confirm-shipment');

    if (btnConfirmShipment) {
        btnConfirmShipment.addEventListener('click', async () => {
            if (!selectedDelivery) {
                alert('Veuillez sélectionner une date');
                return;
            }

            // Bloqué jusqu'à la fin de l'enregistrement : un double clic lançait
            // deux séries d'updateSubscription en parallèle sur les mêmes
            // subscriptions. La première passait, la seconde était rejetée par
            // Recharge → alerte d'erreur alors que la date était bien enregistrée.
            const originalLabel = btnConfirmShipment.textContent;
            btnConfirmShipment.disabled = true;
            btnConfirmShipment.textContent = 'Mise à jour…';

            try {
                console.log('[Modal Shipment] Sauvegarde de la nouvelle date...');

                // Le client a choisi une date de LIVRAISON ; Recharge attend une
                // date de prélèvement. Conversion via chargeForSelection() — la
                // même fonction que le texte affiché, et la seule.
                const selectedDate = selectedDelivery;
                const formattedDate = chargeForSelection();

                console.log(
                    `[Modal Shipment] Livraison choisie: ${RechargePortal.formatYMD(selectedDelivery)}`
                    + ` → prélèvement Recharge: ${formattedDate}`
                );

                // NOUVEAU : Si on est en train de créer un nouvel abonnement, créer l'abonnement avec cette date
                if (window.subscriptionCreationContext.isCreatingNewSubscription &&
                    window.subscriptionCreationContext.selectedProduct &&
                    window.subscriptionCreationContext.selectedFrequency) {
                    console.log('[Modal Shipment] Création nouvel abonnement avec date choisie');

                    // Fermer le modal
                    shipmentModal.classList.remove('active');
                    shipmentOverlay.classList.remove('active');
                    document.body.style.overflow = '';

                    // Restaurer le titre original du modal
                    const modalTitle = shipmentModal.querySelector('.modal-title');
                    if (modalTitle) {
                        modalTitle.textContent = 'Modifier ma date de livraison';
                    }

                    // Message de chargement persistant (durée 0), style neutre ('info')
                    showNotification('Création de l\'abonnement...', 'info', 0);

                    try {
                        // Créer l'abonnement avec la date et fréquence choisies
                        await window.addProductToRechargeSubscription(
                            window.subscriptionCreationContext.selectedProduct,
                            window.subscriptionCreationContext.selectedFrequency,
                            formattedDate
                        );

                        showNotification('✅ Abonnement créé avec succès !', 'success', 4000);

                        // Recharger les données
                        if (window.rechargePortal) {
                            await window.rechargePortal.loadSubscriptions();
                            await window.rechargePortal.loadOnetimes();
                            window.rechargePortal.updateSubscriptionData();
                            // Charge queued : totaux + poids à jour, reprice relais si besoin
                            await window.rechargePortal.syncChargeAfterMutation();
                            console.log('[Modal Shipment] ✅ Données mises à jour');
                        }

                        // Réinitialiser les variables globales ET locales
                        window.subscriptionCreationContext.selectedProduct = null;
                        window.subscriptionCreationContext.selectedFrequency = null;
                        window.subscriptionCreationContext.isCreatingNewSubscription = false;
                        selectedProduct = null;
                        selectedProductId = null;

                        console.log('[Modal Shipment] ✅ Abonnement créé et variables réinitialisées');

                    } catch (error) {
                        console.error('[Modal Shipment] Erreur création abonnement:', error);
                        showNotification(`❌ Erreur: ${error.message}`, 'error', 4000);

                        // Réinitialiser quand même le contexte en cas d'erreur
                        window.subscriptionCreationContext.selectedProduct = null;
                        window.subscriptionCreationContext.selectedFrequency = null;
                        window.subscriptionCreationContext.isCreatingNewSubscription = false;
                        selectedProduct = null;
                        selectedProductId = null;
                    }

                    return; // Sortir de la fonction, ne pas exécuter le code de modification d'abonnement existant
                }

                // Appeler l'API Recharge pour mettre à jour la date du prochain shipment
                if (window.rechargePortal && window.rechargePortal.session && window.rechargePortal.subscription) {
                    const session = window.rechargePortal.session;

                    // FIX: appliquer la date à TOUTES les subscriptions de l'abonnement
                    // (une subscription Recharge par produit, partageant le même address_id),
                    // pas seulement à la première.
                    const subsToUpdate = window.rechargePortal.getCurrentAbonnementSubs();
                    console.log(`[Modal Shipment] Appel API Recharge sur ${subsToUpdate.length} subscription(s)...`);

                    await RechargePortal.updateSubscriptionsBulk(session, subsToUpdate, {
                        next_charge_scheduled_at: formattedDate
                    });
                    console.log(`[Modal Shipment] ✅ ${subsToUpdate.length} subscription(s) mise(s) à jour`);

                    // Recharger toutes les subscriptions pour refléter l'état réel
                    await window.rechargePortal.loadSubscriptions();
                    window.rechargePortal.updateSubscriptionData();
                    console.log('[Modal Shipment] ✅ Données rechargées et affichage mis à jour');
                } else {
                    console.warn('[Modal Shipment] ⚠️ Session ou subscription non disponible, affichage uniquement');

                    // Mise à jour locale de l'affichage uniquement
                    const displayDate = RechargePortal.formatLongDate(selectedDate, true);
                    document.querySelectorAll('[data-recharge="delivery_date"]').forEach(el => {
                        el.textContent = displayDate;
                    });
                }

                // Fermer le modal
                shipmentModal.classList.remove('active');
                shipmentOverlay.classList.remove('active');
                document.body.style.overflow = '';

                showNotification('✅ Date de livraison mise à jour avec succès !', 'success', 4000);

            } catch (error) {
                if (window.rechargePortal?.handleAuthError(error)) return;
                console.error('[Modal Shipment] Erreur:', error);
                await window.rechargePortal?.refreshAfterFailedWrite?.();
                alert('Erreur lors de la mise à jour de la date. Veuillez réessayer.');
            } finally {
                btnConfirmShipment.disabled = false;
                btnConfirmShipment.textContent = originalLabel;
            }
        });
    }
});

// ==========================================
// MODAL: Modifier fréquence
// ==========================================
document.addEventListener('DOMContentLoaded', function () {
    const frequencyModal = document.getElementById('frequency-modal');
    const modalOverlay = document.getElementById('modal-overlay');
    const btnOpenFrequency = document.querySelector('[data-recharge-action="edit-frequency"]');
    const btnCloseFrequency = document.getElementById('close-frequency-modal');
    const btnCancelFrequency = document.getElementById('cancel-frequency');
    const frequencyOptions = document.querySelectorAll('.frequency-option');

    console.log('[Modal Frequency] Initialisation');
    console.log('[Modal Frequency] Bouton trouvé:', btnOpenFrequency);

    // Ouvrir le modal
    if (btnOpenFrequency) {
        btnOpenFrequency.addEventListener('click', (e) => {
            e.preventDefault();
            console.log('[Modal Frequency] Ouverture');

            // Flux modification : rétablir l'affichage complet (titre, avertissement,
            // boutons). Un flux de création abandonné a pu laisser .mode-creation posée.
            setFrequencyModalMode(false);

            // Pré-sélectionner la fréquence actuelle.
            // Comparaison en JOURS et non sur le libellé affiché : un abonnement créé
            // au checkout en « 28 jours » a le même rythme que l'option « 4 semaines »,
            // mais un texte différent — comparer les chaînes ne sélectionnait rien.
            const currentSub = window.rechargePortal?.subscription;
            const currentDays = currentSub ? intervalInDays(
                currentSub.order_interval_frequency,
                currentSub.order_interval_unit
            ) : null;
            console.log('[Modal Frequency] Fréquence actuelle (jours):', currentDays);

            // Retirer toutes les sélections
            frequencyOptions.forEach(opt => opt.classList.remove('selected'));

            // Marquer comme sélectionnée l'option qui correspond à la fréquence actuelle
            frequencyOptions.forEach(option => {
                const optionDays = parseInt(option.dataset.frequency, 10) * 7;
                if (currentDays !== null && optionDays === currentDays) {
                    option.classList.add('selected');
                    console.log('[Modal Frequency] Option pré-sélectionnée:', option.textContent.trim());
                }
            });

            frequencyModal.classList.add('active');
            modalOverlay.classList.add('active');
            document.body.style.overflow = 'hidden';
        });
    }

    // Fermer le modal (bouton X)
    if (btnCloseFrequency) {
        btnCloseFrequency.addEventListener('click', () => {
            frequencyModal.classList.remove('active');
            modalOverlay.classList.remove('active');
            document.body.style.overflow = '';
        });
    }

    // Fermer le modal (bouton Annuler)
    if (btnCancelFrequency) {
        btnCancelFrequency.addEventListener('click', () => {
            frequencyModal.classList.remove('active');
            modalOverlay.classList.remove('active');
            document.body.style.overflow = '';
        });
    }

    // Fermer le modal (clic sur overlay)
    if (modalOverlay) {
        modalOverlay.addEventListener('click', () => {
            // Si le modal d'ajout de produit est ouvert avec des produits sélectionnés,
            // ne pas fermer directement — laisser la confirmation gérer
            const addProductModalEl = document.getElementById('add-product-modal');
            if (addProductModalEl && addProductModalEl.classList.contains('active') && window._addProductSelectedProducts && window._addProductSelectedProducts.length > 0) {
                return;
            }

            // Vérifier si on ferme le modal de fréquence en mode création
            const frequencyModalActive = document.getElementById('frequency-modal')?.classList.contains('active');
            if (frequencyModalActive && window.subscriptionCreationContext && window.subscriptionCreationContext.isCreatingNewSubscription) {
                console.log('[Modal Frequency] Fermeture overlay - Réinitialisation du contexte');
                window.subscriptionCreationContext.selectedProduct = null;
                window.subscriptionCreationContext.selectedFrequency = null;
                window.subscriptionCreationContext.isCreatingNewSubscription = false;
            }

            // Abandon par overlay = annulation : purger les contextes de flux
            // shipping/adresse (sinon flags périmés -> réouverture intempestive
            // du modal livraison ou changement de mode fantôme au prochain
            // passage par le modal d'adresse).
            delete window.reopenShippingAfterAddress;
            delete window.pendingHomeDelivery;
            const addressModalEl = document.getElementById('address-modal');
            if (addressModalEl) addressModalEl.dataset.isHomeDelivery = 'false';

            // Fermer tous les modals ouverts
            document.querySelectorAll('.side-modal.active').forEach(modal => {
                modal.classList.remove('active');
            });
            modalOverlay.classList.remove('active');
            document.body.style.overflow = '';
        });
    }

    // Gestion de la sélection de fréquence (uniquement pour modification d'abonnement existant)
    frequencyOptions.forEach(option => {
        option.addEventListener('click', () => {
            // Ne gérer la sélection visuelle que si on N'est PAS en mode création
            // En mode création, le listener de la ligne 3909 gère tout
            if (window.subscriptionCreationContext && window.subscriptionCreationContext.isCreatingNewSubscription) {
                return; // Skip si en mode création
            }

            frequencyOptions.forEach(opt => opt.classList.remove('selected'));
            option.classList.add('selected');
        });
    });

    // ==========================================
    // Bouton Confirmer - Sauvegarder la nouvelle fréquence
    // ==========================================
    const btnConfirmFrequency = document.getElementById('confirm-frequency');

    if (btnConfirmFrequency) {
        btnConfirmFrequency.addEventListener('click', async () => {
            const selectedOption = document.querySelector('.frequency-option.selected');

            if (!selectedOption) {
                alert('Veuillez sélectionner une fréquence');
                return;
            }

            // IMPORTANT : Si on est en train de créer un nouvel abonnement, gérer différemment
            if (window.subscriptionCreationContext && window.subscriptionCreationContext.isCreatingNewSubscription) {
                console.log('[Modal Frequency] Mode création détecté - passage au modal de date');

                // Stocker la fréquence dans le contexte
                const frequencyValue = selectedOption.dataset.frequency;
                window.subscriptionCreationContext.selectedFrequency = parseInt(frequencyValue);
                console.log('[Frequency Modal] Fréquence stockée:', window.subscriptionCreationContext.selectedFrequency);

                // Fermer le modal de fréquence
                closeFrequencyModal();

                // Ouvrir le modal de date
                console.log('[Frequency Modal] Ouverture du modal de date');
                const shipmentModal = document.getElementById('shipment-date-modal');
                const shipmentOverlay = document.getElementById('modal-overlay');

                if (shipmentModal) {
                    // Réinitialise l'état ET l'affichage du calendrier.
                    window.openShipmentCalendar?.();

                    shipmentModal.classList.add('active');
                    if (shipmentOverlay) {
                        shipmentOverlay.classList.add('active');
                    }
                    document.body.style.overflow = 'hidden';

                    // Mettre à jour le titre
                    const modalTitle = shipmentModal.querySelector('.modal-title');
                    if (modalTitle) {
                        modalTitle.textContent = 'Choisir ma date de première livraison';
                    }

                    // Seul le LIBELLÉ change. Réécrire tout le paragraphe
                    // supprimerait le span data-recharge="delivery_date_modal",
                    // et le résumé de date ne s'afficherait plus jamais ensuite.
                    const modalLabel = shipmentModal.querySelector('[data-recharge="delivery_date_label"]');
                    if (modalLabel) {
                        modalLabel.textContent = 'Première livraison :';
                    }
                }

                return; // Sortir pour ne pas exécuter le reste
            }

            // Même garde que le bouton de date. Ici le double clic faisait pire :
            // les deux exécutions ouvraient chacune le calendrier après coup.
            // Le bouton reste bloqué jusqu'à ce que le calendrier soit affiché.
            const originalLabel = btnConfirmFrequency.textContent;
            btnConfirmFrequency.disabled = true;
            btnConfirmFrequency.textContent = 'Mise à jour…';

            try {
                console.log('[Modal Frequency] Sauvegarde de la nouvelle fréquence...');

                // Récupérer la fréquence sélectionnée
                const frequencyText = selectedOption.textContent.trim();
                const frequencyValue = selectedOption.dataset.frequency; // ex: "4" pour 4 semaines

                console.log('[Modal Frequency] Fréquence sélectionnée:', frequencyText, frequencyValue);

                // Appeler l'API Recharge pour mettre à jour la fréquence
                if (window.rechargePortal && window.rechargePortal.session && window.rechargePortal.subscription) {
                    const session = window.rechargePortal.session;

                    // FIX: appliquer la fréquence à TOUTES les subscriptions de l'abonnement
                    // (une subscription Recharge par produit, partageant le même address_id),
                    // pas seulement à la première.
                    const subsToUpdate = window.rechargePortal.getCurrentAbonnementSubs();
                    console.log(`[Modal Frequency] Appel API Recharge sur ${subsToUpdate.length} subscription(s)...`);

                    await RechargePortal.updateSubscriptionsBulk(session, subsToUpdate, {
                        order_interval_frequency: parseInt(frequencyValue),
                        order_interval_unit: 'week',
                        charge_interval_frequency: parseInt(frequencyValue)
                    });
                    console.log(`[Modal Frequency] ✅ ${subsToUpdate.length} subscription(s) mise(s) à jour`);

                    // Recharger toutes les subscriptions pour refléter l'état réel.
                    // Seule la fréquence a changé : mesuré sur ce compte, Recharge
                    // NE recalcule PAS next_charge_scheduled_at sur un update via
                    // l'API Storefront, contrairement à ce qu'annonce sa doc.
                    await window.rechargePortal.loadSubscriptions();
                    window.rechargePortal.updateSubscriptionData();
                    console.log('[Modal Frequency] ✅ Données rechargées et affichage mis à jour');
                } else {
                    console.warn('[Modal Frequency] ⚠️ Session ou subscription non disponible, affichage uniquement');

                    // Mise à jour locale de l'affichage uniquement
                    const frequencyEl = document.querySelector('[data-recharge="frequency"]');
                    if (frequencyEl) {
                        frequencyEl.textContent = frequencyText;
                    }
                }

                // Fermer le modal
                frequencyModal.classList.remove('active');
                modalOverlay.classList.remove('active');
                document.body.style.overflow = '';

                showNotification(`✅ Fréquence mise à jour : ${frequencyText}`, 'success', 4000);

                // Changer la fréquence ne touche PAS la prochaine livraison : la
                // nouvelle cadence ne s'applique qu'à partir de celle d'après. Or un
                // client qui passe de 6 à 8 semaines veut presque toujours décaler la
                // prochaine box, pas la suivante — sans le calendrier ici, il repart
                // en croyant avoir agi et reçoit sa commande à la date inchangée.
                // Le calendrier est la seule chose qui rende le changement immédiat.
                //
                // L'ouverture doit venir APRÈS loadSubscriptions() ci-dessus, sinon
                // le calendrier présélectionnerait une date périmée.
                const btnOpenShipment = document.querySelector('[data-recharge-action="edit-shipment"]');
                if (btnOpenShipment) {
                    btnOpenShipment.click();
                } else {
                    console.warn('[Modal Frequency] ⚠️ Bouton de modification de date introuvable');
                }

            } catch (error) {
                if (window.rechargePortal?.handleAuthError(error)) return;
                console.error('[Modal Frequency] Erreur:', error);
                await window.rechargePortal?.refreshAfterFailedWrite?.();
                alert('Erreur lors de la mise à jour de la fréquence. Veuillez réessayer.');
            } finally {
                btnConfirmFrequency.disabled = false;
                btnConfirmFrequency.textContent = originalLabel;
            }
        });
    }
});

// ==========================================
// MODAL: Modifier adresse de livraison
// ==========================================
document.addEventListener('DOMContentLoaded', function () {
    const addressModal = document.getElementById('address-modal');
    const modalOverlay = document.getElementById('modal-overlay');
    const btnOpenAddressFromCard = document.querySelector('[data-recharge-action="open-address-modal"]');
    const btnCloseAddress = document.getElementById('close-address-modal');
    const btnCancelAddress = document.getElementById('cancel-address');
    const addressForm = document.querySelector('.address-form');

    console.log('[Modal Address] Initialisation');
    console.log('[Modal Address] Bouton card coordonnées trouvé:', btnOpenAddressFromCard);

    // Fonction pour pré-remplir le modal avec les vraies données
    function prefillAddressModal() {
        console.log('[Modal Address] Pré-remplissage avec vraies données...');

        // Repartir d'un formulaire vide. Le préremplissage ci-dessous n'écrit
        // QUE les champs non vides (`if (address.company) ...`) : sans reset, une
        // valeur d'une ouverture précédente survivrait dans un champ que la
        // nouvelle adresse laisse vide, et serait renvoyée telle quelle à Recharge.
        addressForm?.reset();
        if (addressForm) delete addressForm.dataset.relayCleared;

        if (!window.rechargePortal) {
            console.warn('[Modal Address] window.rechargePortal non disponible');
            return;
        }

        const customer = window.rechargePortal.customer;
        // Saisie en attente prioritaire : rouvrir le formulaire depuis le modal de
        // livraison doit rendre ce que le client vient de taper, pas l'adresse
        // encore enregistrée chez Recharge (sinon sa saisie semble perdue).
        const address = window.rechargePortal.getEffectiveAddress();

        if (customer) {
            // Prénom et nom
            if (customer.first_name) document.getElementById('first-name').value = customer.first_name;
            if (customer.last_name) document.getElementById('last-name').value = customer.last_name;
        }

        if (address) {
            // Téléphone
            if (address.phone) document.getElementById('phone').value = address.phone;

            // Société
            if (address.company) document.getElementById('company').value = address.company;

            // Adresse
            if (address.address1) document.getElementById('address').value = address.address1;
            if (address.address2) document.getElementById('address2').value = address.address2;

            // Ville
            if (address.city) document.getElementById('city').value = address.city;

            // Province
            if (address.province) document.getElementById('province').value = address.province;

            // Code postal
            if (address.zip) document.getElementById('postal-code').value = address.zip;

            // Pays
            if (address.country_code) document.getElementById('country').value = address.country_code;
        }

        // Empreinte de l'adresse au moment de l'ouverture : elle sert à détecter
        // un déménagement en cours de saisie (cf. clearRelayIdentityOnMove).
        if (addressForm) {
            addressForm.dataset.originAddress1 = document.getElementById('address')?.value.trim() || '';
            addressForm.dataset.originZip = document.getElementById('postal-code')?.value.trim() || '';
        }

        console.log('[Modal Address] ✅ Modal pré-rempli avec vraies données');
    }

    // Un point relais n'accompagne PAS un déménagement. `company` / `address2`
    // portent l'identité du relais ("Tabac le refuge (7243V)", "Point Relais") ;
    // si le client change de rue ou de code postal, cette identité devient fausse.
    // Sans ce nettoyage, quelqu'un qui déménage de Troyes à Lyon garde le nom du
    // relais troyen sur sa nouvelle adresse : le colis part vers un commerce qui
    // n'a plus rien à voir avec lui, et l'erreur est invisible.
    //
    // Ne touche QU'À une identité de relais : un vrai nom de société sur une
    // adresse professionnelle est conservé.
    function clearRelayIdentityOnMove() {
        if (!addressForm || addressForm.dataset.relayCleared === '1') return;

        const companyEl = document.getElementById('company');
        const address2El = document.getElementById('address2');
        const address1El = document.getElementById('address');
        const zipEl = document.getElementById('postal-code');
        if (!companyEl || !address2El || !address1El || !zipEl) return;

        const aBouge = address1El.value.trim() !== (addressForm.dataset.originAddress1 || '')
                    || zipEl.value.trim() !== (addressForm.dataset.originZip || '');
        if (!aBouge) return;
        if (!RechargePortal.isRelayAddress({ company: companyEl.value, address2: address2El.value })) return;

        companyEl.value = '';
        address2El.value = '';
        addressForm.dataset.relayCleared = '1';
        console.log('[Modal Address] Adresse modifiée → identité du point relais retirée');
        showNotification(
            'ℹ️ Vous avez modifié votre adresse : le point relais précédent a été retiré. '
            + 'Choisissez « Point relais » puis un nouveau point si vous souhaitez ce mode de livraison.',
            'info',
            8000
        );
    }

    ['address', 'postal-code'].forEach((id) => {
        document.getElementById(id)?.addEventListener('input', clearRelayIdentityOnMove);
    });

    // Purge le contexte "livraison à domicile" : une édition d'adresse ordinaire
    // ne doit JAMAIS déclencher un changement de mode de livraison (flag resté
    // de l'ouverture précédente via le modal shipping puis annulé).
    function clearHomeDeliveryContext() {
        addressModal.dataset.isHomeDelivery = 'false';
        delete window.pendingHomeDelivery;
    }

    // Aucune saisie d'adresse ne survit à un rechargement de page : le tampon est
    // volontairement en mémoire seule. Purge explicite au cas où un script tiers
    // l'aurait laissé traîner.
    window.pendingAddress = null;

    // Ouverture directe du modal d'adresse (fallback uniquement : voir
    // openAddressEditFlow ci-dessous — le chemin normal passe par la livraison).
    function openAddressModalDirect() {
        delete window.reopenShippingAfterAddress;
        clearHomeDeliveryContext();
        prefillAddressModal();
        addressModal.classList.add('active');
        modalOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    // Toute modification d'adresse passe OBLIGATOIREMENT par le modal de livraison.
    // Raison : l'adresse détermine les options de transport (ZIP insulaire ->
    // Colissimo domicile uniquement). Ouvrir le formulaire d'adresse en direct
    // permettait de déménager sans repasser par le choix du mode, et donc de finir
    // avec un transporteur incohérent avec la nouvelle adresse (ex. île + DPD).
    // Ces entrées ouvrent donc le modal de livraison, d'où part le bouton
    // "Modifier l'adresse" (btnEditAddressFromShipping), qui y ramène après
    // enregistrement OU annulation avec les options recalculées.
    function openAddressEditFlow(source) {
        console.log('[Modal Address] Entrée adresse redirigée vers le modal de livraison:', source);
        const editShippingTrigger = document.querySelector('[data-recharge-action="edit-shipping"]');
        if (!editShippingTrigger) {
            // Modal de livraison indisponible (markup absent) : ne pas laisser le
            // client sans aucun moyen de corriger son adresse.
            console.warn('[Modal Address] Déclencheur "edit-shipping" introuvable → ouverture directe du formulaire');
            openAddressModalDirect();
            return;
        }
        delete window.reopenShippingAfterAddress;
        clearHomeDeliveryContext();
        editShippingTrigger.click();
    }

    // Ouvrir depuis la card "Mes coordonnées"
    if (btnOpenAddressFromCard) {
        btnOpenAddressFromCard.addEventListener('click', (e) => {
            e.preventDefault();
            openAddressEditFlow('card Mes coordonnées');
        });
    }

    // Ouvrir le modal depuis le modal de livraison ("Modifier l'adresse") :
    // édition d'adresse ORDINAIRE (pas de changement de mode), mais on revient
    // au modal de livraison ensuite — sauvegarde OU annulation — avec les
    // options recalculées pour le nouveau ZIP (île / poids).
    const btnEditAddressFromShipping = document.getElementById('btn-edit-address-from-shipping');
    if (btnEditAddressFromShipping) {
        btnEditAddressFromShipping.addEventListener('click', (e) => {
            e.preventDefault();
            console.log('[Modal Address] Ouverture depuis le modal de livraison');
            window.reopenShippingAfterAddress = true;
            const shippingModal = document.getElementById('shipping-method-modal');
            if (shippingModal) shippingModal.classList.remove('active');
            clearHomeDeliveryContext();
            prefillAddressModal();
            addressModal.classList.add('active');
            modalOverlay.classList.add('active');
            document.body.style.overflow = 'hidden';
        });
    }

    // Retour au modal de livraison (flux "Modifier l'adresse" ci-dessus).
    // Rejoue le bouton d'ouverture officiel -> renderShippingOptions() recalcule
    // la liste avec l'adresse à jour.
    function reopenShippingModalIfPending() {
        if (!window.reopenShippingAfterAddress) return;
        delete window.reopenShippingAfterAddress;
        setTimeout(() => {
            document.querySelector('[data-recharge-action="edit-shipping"]')?.click();
        }, 300);
    }
    // Exposé pour le handler de sauvegarde (updateAddressOnRecharge, autre bloc).
    window.reopenShippingModalIfPending = reopenShippingModalIfPending;

    // Fermer le modal (bouton X) — annule aussi un éventuel changement de mode en attente
    if (btnCloseAddress) {
        btnCloseAddress.addEventListener('click', () => {
            clearHomeDeliveryContext();
            addressModal.classList.remove('active');
            modalOverlay.classList.remove('active');
            document.body.style.overflow = '';
            reopenShippingModalIfPending();
        });
    }

    // Fermer le modal (bouton Annuler) — idem : abandonne le changement de mode
    if (btnCancelAddress) {
        btnCancelAddress.addEventListener('click', () => {
            clearHomeDeliveryContext();
            addressModal.classList.remove('active');
            modalOverlay.classList.remove('active');
            document.body.style.overflow = '';
            reopenShippingModalIfPending();
        });
    }

    // Soumettre le formulaire
    if (addressForm) {
        addressForm.addEventListener('submit', (e) => {
            e.preventDefault();
            console.log('[Modal Address] Formulaire soumis');

            // Récupérer les valeurs du formulaire
            const formData = {
                firstName: document.getElementById('first-name').value,
                lastName: document.getElementById('last-name').value,
                phone: document.getElementById('phone').value,
                company: document.getElementById('company').value,
                address: document.getElementById('address').value,
                address2: document.getElementById('address2').value,
                city: document.getElementById('city').value,
                province: document.getElementById('province').value,
                postalCode: document.getElementById('postal-code').value.trim(),
                country: document.getElementById('country').value
            };

            console.log('[Modal Address] Données:', formData);

            // Validation du code postal AVANT tout PUT : un zip invalide passe
            // parfois côté Recharge mais empêche ensuite le calcul de la charge
            // (récapitulatif vide sans explication). France = 5 chiffres.
            const zipOk = formData.country && formData.country !== 'FR'
                ? formData.postalCode.length > 0
                : /^\d{5}$/.test(formData.postalCode);
            if (!zipOk) {
                showNotification('❌ Code postal invalide : 5 chiffres attendus (ex. 75011). Corrigez-le avant de valider.', 'error', 6000);
                const zipField = document.getElementById('postal-code');
                if (zipField) zipField.focus();
                return; // modal laissé ouvert pour correction
            }

            // Vérifier si c'est pour une livraison à domicile
            const addressModal = document.getElementById('address-modal');
            const isHomeDelivery = addressModal.dataset.isHomeDelivery === 'true';

            if (isHomeDelivery) {
                console.log('[Modal Address] ✅ Mode livraison à domicile détecté');
                // Flux relais -> domicile : le transporteur a DÉJÀ été confirmé
                // dans le modal de livraison. L'adresse et la shipping_line sont
                // donc écrites tout de suite (rien de plus à confirmer).
                formData.isHomeDelivery = true;
                updateAddressOnRecharge(formData);
                return;
            }

            // Édition ordinaire lancée depuis le modal de livraison : on N'ÉCRIT PAS
            // encore. La saisie est mise en attente et ne partira chez Recharge qu'au
            // clic sur "Mettre à jour" du modal de livraison, en même temps que le
            // transporteur. Objectif : il devient impossible de changer d'adresse
            // sans revalider le mode de livraison (ex. déménagement vers une île en
            // conservant DPD).
            if (window.reopenShippingAfterAddress) {
                window.pendingAddress = { formData, address: mapFormDataToAddress(formData) };
                console.log('[Modal Address] Saisie mise en attente de confirmation (zip:', formData.postalCode, ')');
                addressModal.classList.remove('active');
                modalOverlay.classList.remove('active');
                document.body.style.overflow = '';
                window.reopenShippingModalIfPending?.();
                return;
            }

            // Chemin de repli (modal de livraison absent du DOM) : écriture directe,
            // sinon le client n'aurait aucun moyen de corriger son adresse.
            updateAddressOnRecharge(formData);
        });
    }

    // Mapping formulaire -> champs d'adresse Recharge. Extrait pour être partagé
    // entre l'écriture directe et la mise en attente (l'aperçu du modal de
    // livraison lit ces champs-là).
    function mapFormDataToAddress(formData) {
        return {
            first_name: formData.firstName,
            last_name: formData.lastName,
            phone: formData.phone,
            company: formData.company,
            address1: formData.address,
            address2: formData.address2,
            city: formData.city,
            province: formData.province,
            zip: formData.postalCode,
            country_code: formData.country,
        };
    }

    // Écrit l'adresse en attente chez Recharge. Appelée par le bouton
    // "Mettre à jour" du modal de livraison, AVANT l'écriture de la shipping_line
    // (set-shipping relit le ZIP côté serveur : l'adresse doit être à jour d'abord).
    // Ne vide le tampon qu'en cas de succès — un échec laisse la saisie récupérable.
    async function commitPendingAddress() {
        const pending = window.pendingAddress;
        if (!pending) return { ok: true, skipped: true };

        const portal = window.rechargePortal;
        const session = portal?.session;
        const addressId = portal?.addresses?.[0]?.id;
        if (!session || !addressId) {
            console.error('[API] Commit adresse impossible : session ou adresse absente');
            return { ok: false, error: 'session' };
        }

        try {
            console.log('[API] Écriture de l\'adresse en attente...');
            const response = await window.recharge.address.updateAddress(session, addressId, pending.address);
            await portal.loadAddresses();

            // Lecture-après-écriture Recharge parfois périmée : la réponse du PUT
            // fait foi (même correctif que le flux d'écriture directe).
            const updatedAddress = response?.address || response;
            if (updatedAddress?.id && Array.isArray(portal.addresses)) {
                const idx = portal.addresses.findIndex(a => String(a.id) === String(updatedAddress.id));
                if (idx !== -1) {
                    portal.addresses[idx] = { ...portal.addresses[idx], ...updatedAddress };
                }
            }
            await portal.loadCustomer();
            await portal.updateUI();

            window.pendingAddress = null; // succès : le tampon n'a plus lieu d'être
            console.log('[API] ✅ Adresse en attente écrite');
            return { ok: true };
        } catch (error) {
            console.error('[API] ❌ Échec écriture adresse en attente:', error);
            return { ok: false, error: 'network' };
        }
    }
    window.commitPendingAddress = commitPendingAddress;

    // ==========================================
    // FONCTION: Mettre à jour l'adresse sur Recharge API
    // ==========================================
    async function updateAddressOnRecharge(formData) {
        console.log('[API] Mise à jour adresse Recharge...');
        console.log('[API] FormData reçu:', formData);

        // Vérifier que window.rechargePortal existe
        if (!window.rechargePortal) {
            console.error('[API] ❌ window.rechargePortal non disponible');
            alert('Erreur: Session Recharge non disponible. Veuillez vous reconnecter.');
            return;
        }

        const session = window.rechargePortal.session;
        const address = window.rechargePortal.addresses?.[0];

        if (!session) {
            console.error('[API] ❌ Session Recharge non disponible');
            alert('Erreur: Session non valide. Veuillez vous reconnecter.');
            return;
        }

        if (!address || !address.id) {
            console.error('[API] ❌ Aucune adresse trouvée');
            alert('Erreur: Aucune adresse à mettre à jour.');
            return;
        }

        const addressId = address.id;
        console.log('[API] Adresse ID:', addressId);

        // Mapper les données du formulaire au format Recharge API
        const updateData = {
            first_name: formData.firstName,
            last_name: formData.lastName,
            phone: formData.phone,
            company: formData.company,
            address1: formData.address,
            address2: formData.address2,
            city: formData.city,
            province: formData.province,
            zip: formData.postalCode,
            country_code: formData.country
        };

        console.log('[API] Données à envoyer:', updateData);

        try {
            // Appeler l'API Recharge pour mettre à jour l'adresse
            console.log('[API] Appel window.recharge.address.updateAddress()...');
            const response = await window.recharge.address.updateAddress(session, addressId, updateData);
            console.log('[API] ✅ Réponse Recharge:', response);

            // Rafraîchir les données du portail
            console.log('[API] Rafraîchissement des données...');
            await window.rechargePortal.loadAddresses();

            // Lecture-après-écriture Recharge parfois périmée : listAddresses peut
            // renvoyer l'ANCIENNE adresse (symptôme : zip Corse saisi mais options
            // île non filtrées). La réponse du PUT fait foi -> on écrase localement.
            const updatedAddress = response?.address || response;
            if (updatedAddress?.id && Array.isArray(window.rechargePortal.addresses)) {
                const idx = window.rechargePortal.addresses.findIndex(a => String(a.id) === String(updatedAddress.id));
                if (idx !== -1) {
                    window.rechargePortal.addresses[idx] = { ...window.rechargePortal.addresses[idx], ...updatedAddress };
                    console.log('[API] Adresse locale synchronisée depuis la réponse PUT (zip:', updatedAddress.zip, ')');
                }
            }
            await window.rechargePortal.loadCustomer(); // Recharger le customer car le nom peut avoir changé
            await window.rechargePortal.updateUI();
            console.log('[API] ✅ Affichage mis à jour dans les deux panneaux');

            // Si c'était pour une livraison à domicile / express : l'adresse (donc
            // le ZIP) est maintenant à jour -> écrire la shipping_line du transporteur
            // choisi dans le modal côté Recharge. Prix + titre dérivés server-side
            // (île -> Colissimo forcé). set-shipping relit la charge et re-render :
            // l'affichage (titre + prix + total) reflète la VÉRITÉ Recharge.
            if (formData.isHomeDelivery && window.pendingHomeDelivery) {
                console.log('[API] ✅ Écriture du mode de livraison à domicile (server-side)');

                const shippingType = window.pendingHomeDelivery.type || 'home_dpd';
                const result = await window.rechargePortal.applyShippingType(shippingType, addressId);
                if (result.ok) {
                    // Adresse saisie sur une île -> le serveur a coercé vers Colissimo :
                    // l'annoncer clairement plutôt qu'un toast générique.
                    const appliedLine = result.applied?.[0]?.shipping_line;
                    const chosenOpt = RechargePortal.SHIPPING_OPTIONS.find(o => o.type === shippingType);
                    if (appliedLine && chosenOpt && appliedLine.title !== chosenOpt.serverTitle) {
                        showNotification(
                            `ℹ️ Votre adresse est sur une île : livraison ajustée en Domicile - Colissimo (${Number(appliedLine.price).toFixed(2).replace('.', ',')}€), seule option disponible.`,
                            'success',
                            10000
                        );
                    } else {
                        showNotification('✅ Mode de livraison mis à jour', 'success');
                    }
                    // Masquer le lien "Choisir un point relais" (on est en domicile).
                    const btnChoosePickup = document.getElementById('btn-choose-pickup-point');
                    if (btnChoosePickup) btnChoosePickup.style.display = 'none';
                } else if (result.error !== 'auth') {
                    // 'auth' : l'écran de reconnexion est déjà affiché, pas de toast.
                    showNotification('❌ Échec de la mise à jour du mode de livraison', 'error');
                }

                // Nettoyer le flag
                delete window.pendingHomeDelivery;
                addressModal.dataset.isHomeDelivery = 'false';
            } else if (window.rechargePortal) {
                // Édition d'adresse SANS changement de mode : si la nouvelle adresse
                // est sur une île et que le mode actuel n'est pas Colissimo domicile,
                // on l'applique d'office — c'est la SEULE option desservie, il n'y a
                // aucun choix à confirmer (règle métier ; le serveur coerce de toute
                // façon toute écriture ultérieure).
                const portal = window.rechargePortal;
                const newAddr = portal.addresses?.[0];
                const colissimoTitle = RechargePortal.SHIPPING_OPTIONS.find(o => o.type === 'home_colissimo').serverTitle;
                const currentShipTitle = portal.nextCharge?.shipping_lines?.[0]?.title;
                if (RechargePortal.isCityOnIsland(newAddr?.zip) && currentShipTitle && currentShipTitle !== colissimoTitle) {
                    console.log('[API] Adresse île détectée → bascule automatique en Colissimo domicile');
                    const islandResult = await portal.applyShippingType('home_colissimo', newAddr.id);
                    if (islandResult.ok) {
                        showNotification(
                            'ℹ️ Votre adresse est sur une île : votre livraison passe en Domicile - Colissimo (6,90€), seule option disponible.',
                            'success',
                            10000
                        );
                        const btnChoosePickup = document.getElementById('btn-choose-pickup-point');
                        if (btnChoosePickup) btnChoosePickup.style.display = 'none';
                    } else if (islandResult.error !== 'auth') {
                        // Pas de retry : le serveur coercera au prochain set-shipping.
                        console.warn('[API] Bascule île → Colissimo échouée:', islandResult.error);
                    }
                }
            }

            // Fermer le modal
            addressModal.classList.remove('active');
            modalOverlay.classList.remove('active');
            document.body.style.overflow = '';

            // Flux "Modifier l'adresse" depuis le modal de livraison : y revenir,
            // options recalculées avec le nouveau ZIP (les adresses viennent
            // d'être rechargées ci-dessus).
            window.reopenShippingModalIfPending?.();

            showNotification(
                formData.isHomeDelivery
                    ? '✅ Adresse de livraison mise à jour avec succès !'
                    : '✅ Coordonnées mises à jour avec succès !',
                'success',
                4000
            );

            console.log('[API] ✅ Processus de mise à jour terminé');

        } catch (error) {
            if (window.rechargePortal?.handleAuthError(error)) return;
            console.error('[API] ❌ Erreur lors de la mise à jour de l\'adresse:', error);
            console.error('[API] Détails de l\'erreur:', {
                message: error.message,
                stack: error.stack,
                error: error
            });

            showNotification('❌ Erreur lors de la mise à jour. Veuillez réessayer.', 'error');
        }
    }
});

// ==========================================
// MODAL: Modifier mode de livraison
// ==========================================
document.addEventListener('DOMContentLoaded', function () {
    const shippingMethodModal = document.getElementById('shipping-method-modal');
    const modalOverlay = document.getElementById('modal-overlay');
    const btnOpenShippingMethod = document.querySelector('[data-recharge-action="edit-shipping"]');
    const btnCloseShippingMethod = document.getElementById('close-shipping-method-modal');
    const btnCancelShippingMethod = document.getElementById('cancel-shipping-method');
    const btnConfirmShippingMethod = document.getElementById('confirm-shipping-method');
    const shippingOptionGroup = document.getElementById('shipping-option-group');

    console.log('[Modal Shipping] Initialisation');
    console.log('[Modal Shipping] Bouton trouvé:', btnOpenShippingMethod);

    // (Re)construit la liste des options au moment de l'ouverture : elle dépend
    // de l'adresse courante (île -> Colissimo uniquement) et du poids de la
    // charge queued (relais 2,90€ / 5,80€). Présélectionne l'option qui matche
    // le titre de la shipping_line actuelle (vérité charge), sinon la première.
    // Écriture de l'adresse en attente : la fonction vit dans le bloc du modal
    // d'adresse, exposée sur window. Absente = markup d'adresse non chargé.
    async function commitPendingAddressSafely() {
        if (typeof window.commitPendingAddress !== 'function') {
            console.error('[Modal Shipping] commitPendingAddress indisponible');
            return { ok: false, error: 'unavailable' };
        }
        return window.commitPendingAddress();
    }

    // Abandon d'une saisie d'adresse non confirmée (fermeture du modal de
    // livraison sans "Mettre à jour"). Le client doit être prévenu : de son point
    // de vue il a déjà validé le formulaire d'adresse.
    function discardPendingAddress() {
        if (!window.pendingAddress) return;
        window.pendingAddress = null;
        console.log('[Modal Shipping] Saisie d\'adresse abandonnée (non confirmée)');
        showNotification(
            'ℹ️ Modification d\'adresse abandonnée : elle n\'a pas été enregistrée. Recommencez et validez avec "Mettre à jour".',
            'info',
            8000
        );
    }

    function renderShippingOptions() {
        if (!shippingOptionGroup) return;
        const portal = window.rechargePortal;
        if (!portal) {
            shippingOptionGroup.innerHTML = '<p class="shipping-options-loading">Options indisponibles</p>';
            return;
        }

        // Le profil n'a pas pu être chargé à l'init (réseau) : on retente une
        // fois, ici, parce que c'est le seul écran où le prix compte. Le rendu
        // ci-dessous n'attend pas — il affiche la grille normale, et se rejoue
        // si la réponse arrive avec un forfait différent.
        if (!portal._shippingProfileLoaded && !portal._shippingProfileRetried) {
            portal._shippingProfileRetried = true;
            portal.loadShippingProfile().then(() => {
                if (portal.legacyFlatShipping) renderShippingOptions();
            });
        }

        // Adresse en tête de modal : elle détermine les options (île, poids).
        // Saisie en attente prioritaire -> le client voit les options de la
        // nouvelle adresse avant de confirmer.
        const addr = portal.getEffectiveAddress();
        const addressEl = document.getElementById('shipping-modal-address');
        if (addressEl) {
            if (addr) {
                // Une ligne par composant (white-space: pre-line côté CSS) pour
                // que le client puisse vérifier son adresse d'un coup d'œil.
                const parts = [RechargePortal.displayCompany(addr.company), addr.address1, addr.address2, `${addr.zip || ''} ${addr.city || ''}`.trim()].filter(Boolean);
                // Saisie non encore écrite : le dire, sinon le client croit que
                // c'est déjà enregistré et peut fermer le modal en la perdant.
                if (window.pendingAddress) {
                    parts.push('⚠️ Nouvelle adresse — non enregistrée tant que vous n\'avez pas cliqué sur "Mettre à jour"');
                }
                addressEl.textContent = parts.join('\n');
            } else {
                addressEl.textContent = 'Adresse indisponible';
            }
        }

        const options = portal.getShippingOptionsForDisplay();
        const currentTitle = portal.nextCharge?.shipping_lines?.[0]?.title || '';
        const match = options.find(o => o.serverTitle === currentTitle) || null;

        // Diagnostic : ce qui a déterminé la liste (zip -> île, poids -> tarif relais).
        console.log('[Modal Shipping] Options calculées:', {
            zip: addr?.zip ?? null,
            island: RechargePortal.isCityOnIsland(addr?.zip),
            weightGrams: portal.getOrderWeightGrams(),
            count: options.length,
            currentTitle,
            selected: match?.type ?? null,
        });

        const fmt = (p) => `${Number(p).toFixed(2).replace('.', ',')}€`;

        // Bouton-choix générique : radio natif caché + rond radio dessiné en CSS
        // (compréhension immédiate) + corps titre/sous-titre/prix.
        const btnBody = (title, sub, price) => `
            <span class="shipping-btn-radio" aria-hidden="true"></span>
            <span class="shipping-btn-body">
                <span class="shipping-btn-title">${title}</span>
                ${sub ? `<span class="shipping-btn-sub">${sub}</span>` : ''}
                <span class="shipping-btn-price">${price}</span>
            </span>`;

        const btnHTML = (opt, { checked, sub, extraClass = '' } = {}) => `
            <label class="shipping-btn${extraClass}${checked ? ' selected' : ''}" for="shipping-${opt.type}">
                <input
                    type="radio"
                    id="shipping-${opt.type}"
                    name="shipping-method"
                    value="${opt.type}"
                    class="shipping-radio"
                    ${checked ? 'checked' : ''}
                >
                ${btnBody(opt.carrier || opt.label, sub, fmt(opt.price))}
            </label>`;

        // Île (ou toute liste à option unique) : un seul bouton pleine largeur.
        if (options.length === 1) {
            const only = options[0];
            shippingOptionGroup.innerHTML = `
                <div class="shipping-level shipping-level--single">
                    ${btnHTML(only, { checked: true, sub: [only.delay, only.note].filter(Boolean).join(' · ') })}
                </div>`;
            return;
        }

        // Deux niveaux, même design de boutons :
        //   niveau 1 : [ Point relais ] [ À domicile ]
        //   niveau 2 (si À domicile) : [ DPD ] [ GLS ] [ Colissimo ] [ Express TNT ]
        const pickup = options.find(o => o.type === 'pickup');
        const homeChildren = options.filter(o => o.type !== 'pickup');
        const selectedType = match ? match.type : 'pickup';
        const homeSelected = homeChildren.some(o => o.type === selectedType);
        // Transporteur précoché : le mode actuel s'il est domicile, sinon le moins cher.
        const checkedChild = homeSelected ? selectedType : homeChildren[0].type;
        const minHomePrice = Math.min(...homeChildren.map(o => o.price));

        const pickupSub = pickup
            ? [pickup.delay, pickup.note ? 'en 2 colis (≥ 19 kg)' : ''].filter(Boolean).join(' · ')
            : '';

        shippingOptionGroup.innerHTML = `
            <div class="shipping-level">
                ${pickup ? btnHTML(pickup, { checked: selectedType === 'pickup', sub: pickupSub }) : ''}
                <div class="shipping-btn shipping-home-toggle${homeSelected ? ' selected' : ''}"
                     role="button" tabindex="0" aria-expanded="${homeSelected}"
                     data-default-child="${checkedChild}">
                    ${btnBody('À domicile', '', `dès ${fmt(minHomePrice)}`)}
                </div>
            </div>
            <div class="shipping-level shipping-level-carriers" ${homeSelected ? '' : 'hidden'}>
                ${homeChildren.map(o => btnHTML(o, {
                    checked: homeSelected && o.type === selectedType,
                    sub: o.delay,
                    extraClass: ' shipping-btn--carrier',
                })).join('')}
            </div>`;
    }

    // Ouvrir le modal. Rendu immédiat sur les données en mémoire, puis recharge
    // de la charge queued (le poids a pu changer : produits ajoutés/retirés) et
    // re-render — le prix du relais (2,90€/5,80€) reflète toujours le poids réel.
    if (btnOpenShippingMethod) {
        btnOpenShippingMethod.addEventListener('click', async (e) => {
            e.preventDefault();
            console.log('[Modal Shipping] Ouverture');
            renderShippingOptions();
            shippingMethodModal.classList.add('active');
            modalOverlay.classList.add('active');
            document.body.style.overflow = 'hidden';

            const portal = window.rechargePortal;
            if (portal) {
                // Présélection posée par le rendu initial : si l'utilisateur clique
                // pendant le rafraîchissement ci-dessous, le re-render écraserait
                // silencieusement son choix -> on le restaure après coup.
                const selectionBefore = shippingOptionGroup
                    ?.querySelector('.shipping-radio:checked')?.value ?? null;
                try {
                    await portal.loadNextCharge();
                    await portal.autoRepriceStalePickup(); // corrige aussi un relais périmé
                    const selectionNow = shippingOptionGroup
                        ?.querySelector('.shipping-radio:checked')?.value ?? null;
                    renderShippingOptions();
                    if (selectionNow && selectionNow !== selectionBefore) {
                        // L'option peut avoir disparu (nouvelle adresse île) : dans
                        // ce cas on garde la présélection du re-render.
                        const radio = shippingOptionGroup?.querySelector(`#shipping-${selectionNow}`);
                        if (radio) {
                            radio.checked = true;
                            refreshShippingSelection();
                        }
                    }
                } catch (err) {
                    console.warn('[Modal Shipping] Rafraîchissement charge échoué:', err);
                }
            }
        });
    }

    // Fermer le modal (bouton X) — abandonne une saisie d'adresse non confirmée
    if (btnCloseShippingMethod) {
        btnCloseShippingMethod.addEventListener('click', () => {
            shippingMethodModal.classList.remove('active');
            modalOverlay.classList.remove('active');
            document.body.style.overflow = '';
            discardPendingAddress();
        });
    }

    // Fermer le modal (bouton Annuler) — idem
    if (btnCancelShippingMethod) {
        btnCancelShippingMethod.addEventListener('click', () => {
            shippingMethodModal.classList.remove('active');
            modalOverlay.classList.remove('active');
            document.body.style.overflow = '';
            discardPendingAddress();
        });
    }

    // Sélection : délégation sur le conteneur (boutons reconstruits à chaque
    // ouverture). Niveau 1 : [Point relais] [À domicile] ; niveau 2 (si
    // À domicile) : boutons transporteurs. Sélection = couleur du bouton.
    function refreshShippingSelection() {
        if (!shippingOptionGroup) return;
        const checked = shippingOptionGroup.querySelector('.shipping-radio:checked');
        shippingOptionGroup.querySelectorAll('.shipping-btn').forEach(el => el.classList.remove('selected'));

        const carriersRow = shippingOptionGroup.querySelector('.shipping-level-carriers');
        const homeToggle = shippingOptionGroup.querySelector('.shipping-home-toggle');
        if (!checked) return;

        const btn = checked.closest('.shipping-btn');
        if (btn) btn.classList.add('selected');

        if (checked.closest('.shipping-level-carriers')) {
            // Transporteur domicile choisi : "À domicile" actif + rangée visible.
            if (homeToggle) {
                homeToggle.classList.add('selected');
                homeToggle.setAttribute('aria-expanded', 'true');
            }
            if (carriersRow) carriersRow.hidden = false;
        } else {
            // Point relais (ou option unique île) : replier les transporteurs.
            if (carriersRow) carriersRow.hidden = true;
            if (homeToggle) homeToggle.setAttribute('aria-expanded', 'false');
        }
    }

    if (shippingOptionGroup) {
        shippingOptionGroup.addEventListener('change', (e) => {
            if (!e.target.closest('.shipping-radio')) return;
            refreshShippingSelection();
        });

        // Bouton "À domicile" : affiche les transporteurs + coche celui par
        // défaut (mode actuel s'il est domicile, sinon le moins cher).
        shippingOptionGroup.addEventListener('click', (e) => {
            const toggle = e.target.closest('.shipping-home-toggle');
            if (!toggle) return;
            const carriersRow = shippingOptionGroup.querySelector('.shipping-level-carriers');
            if (!carriersRow) return;

            carriersRow.hidden = false;
            const already = carriersRow.querySelector('.shipping-radio:checked');
            if (!already) {
                const defaultChild = carriersRow.querySelector(`#shipping-${toggle.dataset.defaultChild}`)
                    || carriersRow.querySelector('.shipping-radio');
                // Cocher décoche automatiquement le relais (même name).
                if (defaultChild) defaultChild.checked = true;
            }
            refreshShippingSelection();
        });

        // Accessibilité clavier sur le bouton "À domicile" (role=button).
        shippingOptionGroup.addEventListener('keydown', (e) => {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            const toggle = e.target.closest('.shipping-home-toggle');
            if (!toggle) return;
            e.preventDefault();
            toggle.click();
        });
    }

    // Confirmer la sélection. L'écriture se fait AVANT la fermeture du modal :
    // en cas d'échec il reste ouvert avec la sélection intacte (re-tentative
    // directe, pas de toast d'erreur sur page vide), et le bouton affiche un
    // état d'attente pendant l'aller-retour serveur.
    if (btnConfirmShippingMethod) {
        btnConfirmShippingMethod.addEventListener('click', async () => {
            if (btnConfirmShippingMethod.disabled) return;
            const selectedRadio = document.querySelector('.shipping-radio:checked');
            if (!selectedRadio) return;

            // 'pickup' | 'home_dpd' | 'home_gls' | 'home_colissimo' | 'express'
            const selectedValue = selectedRadio.value;
            console.log('[Modal Shipping] Mode sélectionné:', selectedValue);

            const closeShippingModal = () => {
                shippingMethodModal.classList.remove('active');
                modalOverlay.classList.remove('active');
                document.body.style.overflow = '';
            };

            const portal = window.rechargePortal;
            if (!portal) {
                closeShippingModal();
                showNotification('❌ Session Recharge non disponible', 'error');
                return;
            }

            // Adresse effective = saisie en attente si elle existe : un client qui
            // vient de saisir une adresse domicile ne doit pas être renvoyé vers le
            // formulaire parce que l'adresse ENREGISTRÉE est encore un relais.
            if (selectedValue !== 'pickup' && RechargePortal.isRelayAddress(portal.getEffectiveAddress())) {
                // Domicile / express MAIS l'adresse Recharge actuelle est un point
                // relais (le relais vit dans l'adresse) : il faut d'abord saisir la
                // vraie adresse domicile. La shipping_line du transporteur choisi est
                // écrite APRÈS la saisie (cf. bloc formData.isHomeDelivery).
                console.log('[Modal Shipping] → Adresse actuelle = relais, saisie de l\'adresse domicile');
                window.pendingHomeDelivery = { type: selectedValue };
                closeShippingModal();
                setTimeout(() => openAddressModalForHomeDelivery(), 300);
                return;
            }

            // Prix/titre dérivés server-side (île -> Colissimo forcé, relais ->
            // tarif selon le poids réel de la charge queued).
            const originalLabel = btnConfirmShippingMethod.textContent;
            btnConfirmShippingMethod.disabled = true;
            btnConfirmShippingMethod.textContent = 'Mise à jour…';
            let result;
            try {
                // Adresse modifiée mais pas encore écrite : elle part MAINTENANT,
                // avant la shipping_line (set-shipping relit le ZIP côté serveur).
                // Deux écritures distinctes, sans transaction : si la seconde
                // échoue, on garde le modal ouvert pour permettre un nouvel essai.
                if (window.pendingAddress) {
                    const addrResult = await commitPendingAddressSafely();
                    if (!addrResult.ok) {
                        showNotification('❌ Échec de l\'enregistrement de l\'adresse. Réessayez.', 'error');
                        return; // tampon conservé, modal ouvert
                    }
                }
                result = await portal.applyShippingType(selectedValue);
            } finally {
                btnConfirmShippingMethod.disabled = false;
                btnConfirmShippingMethod.textContent = originalLabel;
            }

            if (!result.ok) {
                if (result.error === 'auth') {
                    // Écran de reconnexion déjà affiché : pas de toast, on ferme.
                    closeShippingModal();
                } else if (result.error === 'weight_unavailable') {
                    showNotification(
                        '❌ Impossible de calculer le poids de votre commande pour le tarif Point relais. Contactez-nous et nous mettrons votre livraison à jour.',
                        'error',
                        10000
                    );
                } else {
                    showNotification('❌ Échec de la mise à jour du mode de livraison. Réessayez.', 'error');
                }
                return; // modal laissé ouvert, sélection conservée
            }

            closeShippingModal();

            if (selectedValue === 'pickup') {
                showNotification('✅ Mode de livraison mis à jour', 'success');
                const btnChoosePickup = document.getElementById('btn-choose-pickup-point');
                if (btnChoosePickup) {
                    btnChoosePickup.style.display = 'block';
                    // Laisser le modal se fermer, puis ouvrir Chronopost pour choisir le point.
                    setTimeout(() => btnChoosePickup.click(), 300);
                }
                return;
            }

            // Si le serveur a coercé le choix (adresse île) : l'annoncer
            // explicitement plutôt qu'un succès générique.
            const appliedLine = result.applied?.[0]?.shipping_line;
            const chosenOpt = RechargePortal.SHIPPING_OPTIONS.find(o => o.type === selectedValue);
            if (appliedLine && chosenOpt && appliedLine.title !== chosenOpt.serverTitle) {
                showNotification(
                    `ℹ️ Votre adresse est sur une île : livraison ajustée en Domicile - Colissimo (${Number(appliedLine.price).toFixed(2).replace('.', ',')}€), seule option disponible.`,
                    'success',
                    10000
                );
            } else {
                showNotification('✅ Mode de livraison mis à jour', 'success');
            }
            // On est en domicile : masquer le lien "Choisir un point relais".
            const btnChoosePickup = document.getElementById('btn-choose-pickup-point');
            if (btnChoosePickup) btnChoosePickup.style.display = 'none';
        });
    }

    // NB : les notifications passent par la fonction globale showNotification()
    // définie en bas de fichier (déclaration hoistée, une seule implémentation).

    // Fonction pour ouvrir le modal d'adresse pour livraison à domicile
    function openAddressModalForHomeDelivery() {
        console.log('[Address Modal] Ouverture pour saisir l\'adresse de domicile...');

        const addressModal = document.getElementById('address-modal');
        const modalOverlay = document.getElementById('modal-overlay');

        if (!addressModal || !modalOverlay) {
            console.error('[Address Modal] Éléments modal non trouvés');
            return;
        }

        // Pré-remplir le formulaire avec l'adresse actuelle
        if (window.rechargePortal && window.rechargePortal.addresses && window.rechargePortal.addresses[0]) {
            const currentAddress = window.rechargePortal.addresses[0];

            // Utiliser l'adresse Shopify d'origine si disponible
            let addressToUse = currentAddress;
            if (window.shopifyCustomerData && window.shopifyCustomerData.address) {
                addressToUse = window.shopifyCustomerData.address;
                console.log('[Address Modal] Utilisation de l\'adresse Shopify d\'origine');
            }

            document.getElementById('first-name').value = currentAddress.first_name || '';
            document.getElementById('last-name').value = currentAddress.last_name || '';
            document.getElementById('phone').value = currentAddress.phone || '';
            // Vider "Société" si c'est "Point Relais Chronopost" (livraison à domicile)
            const companyValue = addressToUse.company || '';
            document.getElementById('company').value = companyValue.includes('Chronopost') || companyValue.includes('Point Relais') ? '' : companyValue;
            document.getElementById('address').value = addressToUse.address1 || '';
            // Vider "Complément d'adresse" si c'est "Point Relais Chronopost"
            const address2Value = addressToUse.address2 || '';
            document.getElementById('address2').value = address2Value.includes('Chronopost') || address2Value.includes('Point Relais') ? '' : address2Value;
            document.getElementById('city').value = addressToUse.city || '';
            document.getElementById('province').value = addressToUse.province || '';
            document.getElementById('postal-code').value = addressToUse.zip || '';
            document.getElementById('country').value = addressToUse.country_code || 'FR';

            console.log('[Address Modal] Formulaire pré-rempli avec:', addressToUse);
        }

        // Marquer que c'est pour une livraison à domicile
        addressModal.dataset.isHomeDelivery = 'true';

        // Ouvrir le modal
        addressModal.classList.add('active');
        modalOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';

        console.log('[Address Modal] ✅ Modal ouvert');
    }

    console.log('[Modal Shipping] Initialisation terminée');
});

// ==========================================
// MODAL: Confirmation annulation abonnement
// ==========================================
document.addEventListener('DOMContentLoaded', function () {
    const cancelModal = document.getElementById('modal-cancel-subscription');
    const modalOverlay = document.getElementById('modal-overlay');
    const btnCloseCancelModal = document.getElementById('close-cancel-modal');
    const btnCancelModal = document.getElementById('cancel-cancel-modal');
    const btnConfirmCancel = document.getElementById('confirm-cancel-subscription');

    console.log('[Modal Cancel] Initialisation modal annulation');

    // Fonction pour fermer le modal
    function closeCancelModal() {
        cancelModal.classList.remove('active');
        if (modalOverlay) {
            modalOverlay.classList.remove('active');
        }
        document.body.style.overflow = '';
        resetCancelConsent();
    }

    // Remettre la case à cocher et son message d'erreur à zéro à chaque fermeture
    function resetCancelConsent() {
        const checkbox = document.getElementById('cancel-consent-checkbox');
        const error = document.getElementById('cancel-consent-error');
        if (checkbox) {
            checkbox.checked = false;
        }
        if (error) {
            error.hidden = true;
        }
    }

    // Fermer le modal (bouton X)
    if (btnCloseCancelModal) {
        btnCloseCancelModal.addEventListener('click', closeCancelModal);
    }

    // Fermer le modal (bouton "Retour")
    if (btnCancelModal) {
        btnCancelModal.addEventListener('click', closeCancelModal);
    }

    // Bouton "Décaler la prochaine livraison" → bascule vers le modal de date
    // sans toucher à l'abonnement (le client reste actif)
    const btnPostponeFromCancel = document.getElementById('postpone-from-cancel');
    if (btnPostponeFromCancel) {
        btnPostponeFromCancel.addEventListener('click', () => {
            const shipmentModal = document.getElementById('shipment-date-modal');
            if (!shipmentModal) {
                console.warn('[Modal Cancel] Modal de date introuvable');
                return;
            }

            console.log('[Modal Cancel] Bascule vers le modal de décalage de livraison');
            cancelModal.classList.remove('active');
            resetCancelConsent();

            // Même réinitialisation que l'ouverture depuis "Ma prochaine livraison"
            window.openShipmentCalendar?.();

            shipmentModal.classList.add('active');
            if (modalOverlay) {
                modalOverlay.classList.add('active');
            }
            document.body.style.overflow = 'hidden';
        });
    }

    // Fermer le modal si clic sur l'overlay
    if (modalOverlay) {
        modalOverlay.addEventListener('click', (e) => {
            if (e.target === modalOverlay && cancelModal.classList.contains('active')) {
                closeCancelModal();
            }
        });
    }

    // Case à cocher obligatoire avant de confirmer l'annulation
    const consentCheckbox = document.getElementById('cancel-consent-checkbox');
    const consentError = document.getElementById('cancel-consent-error');

    if (consentCheckbox && consentError) {
        consentCheckbox.addEventListener('change', () => {
            if (consentCheckbox.checked) {
                consentError.hidden = true;
            }
        });
    }

    // Confirmer l'annulation → redirection vers le flow Cancellation Prevention de Recharge
    if (btnConfirmCancel) {
        btnConfirmCancel.addEventListener('click', async () => {
            if (consentCheckbox && !consentCheckbox.checked) {
                console.log('[Modal Cancel] Case de consentement non cochée → blocage');
                if (consentError) {
                    consentError.hidden = false;
                }
                consentCheckbox.focus();
                return;
            }

            console.log('[Modal Cancel] Redirection vers Cancellation Prevention Recharge...');

            const originalText = btnConfirmCancel.textContent;
            btnConfirmCancel.disabled = true;
            btnConfirmCancel.textContent = 'Redirection...';

            try {
                const portal = window.rechargePortal;
                if (!portal || !portal.session || !portal.activeSubscriptions?.length) {
                    console.error('[Modal Cancel] Portail ou abonnements non disponibles');
                    return;
                }

                // Utiliser la première subscription active pour déclencher le flow
                const subscriptionId = portal.activeSubscriptions[0].id;
                const redirectURL = window.location.href;


                const churnURL = await window.recharge.customer.getActiveChurnLandingPageURL(
                    portal.session,
                    subscriptionId,
                    redirectURL
                );

                console.log('[Modal Cancel] URL Cancellation Prevention:', churnURL);
                window.location.href = churnURL;
            } catch (error) {
                console.error('[Modal Cancel] Erreur lors de la redirection:', error);
                // Fallback : annulation directe si le flow Recharge n'est pas disponible
                try {
                    if (window.rechargePortal) {
                        await window.rechargePortal.cancelSubscription();
                    }
                    closeCancelModal();
                } catch (fallbackError) {
                    console.error('[Modal Cancel] Erreur fallback:', fallbackError);
                }
            } finally {
                btnConfirmCancel.disabled = false;
                btnConfirmCancel.textContent = originalText;
            }
        });
    }

    console.log('[Modal Cancel] Initialisation terminée');
});

// ==========================================
// MODAL: Supprimer un produit one-time
// ==========================================
document.addEventListener('DOMContentLoaded', function () {
    const deleteOnetimeModal = document.getElementById('modal-delete-onetime');
    const btnCloseDeleteModal = document.getElementById('close-delete-onetime-modal');
    const btnCancelDeleteModal = document.getElementById('cancel-delete-onetime-modal');
    const btnConfirmDelete = document.getElementById('confirm-delete-onetime');

    console.log('[Modal Delete Onetime] Initialisation modal suppression one-time');

    // Fonction pour fermer le modal
    function closeDeleteOnetimeModal() {
        if (deleteOnetimeModal) {
            deleteOnetimeModal.classList.remove('active');
            document.body.style.overflow = '';
        }
    }

    // Fermer le modal (bouton X)
    if (btnCloseDeleteModal) {
        btnCloseDeleteModal.addEventListener('click', closeDeleteOnetimeModal);
    }

    // Fermer le modal (bouton "Annuler")
    if (btnCancelDeleteModal) {
        btnCancelDeleteModal.addEventListener('click', closeDeleteOnetimeModal);
    }

    // Confirmer la suppression
    if (btnConfirmDelete) {
        btnConfirmDelete.addEventListener('click', async () => {
            console.log('[Modal Delete Onetime] Confirmation suppression...');

            // Récupérer l'ID du one-time depuis l'attribut data
            const onetimeId = deleteOnetimeModal.getAttribute('data-onetime-id');

            if (!onetimeId) {
                console.error('[Modal Delete Onetime] Aucun ID one-time trouvé');
                return;
            }

            // Désactiver le bouton pour éviter les doubles clics
            btnConfirmDelete.disabled = true;
            btnConfirmDelete.textContent = 'Suppression en cours...';

            // Appeler la méthode du RechargePortal
            if (window.rechargePortal) {
                await window.rechargePortal.deleteOnetime(onetimeId);
            } else {
                console.error('[Modal Delete Onetime] RechargePortal non disponible');
            }

            // Réactiver le bouton et fermer le modal
            btnConfirmDelete.disabled = false;
            btnConfirmDelete.textContent = 'Confirmer la suppression';
            closeDeleteOnetimeModal();
        });
    }

    console.log('[Modal Delete Onetime] Initialisation terminée');
});

// ==========================================
// MODAL: Ajouter un produit (en abonnement ou achat unique)
// ==========================================

// Vignette de repli, encodée en data-URI : aucune requête réseau, aucun tiers.
const PRODUCT_IMAGE_FALLBACK =
    'data:image/svg+xml;charset=utf-8,' +
    encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80">' +
        '<rect width="80" height="80" fill="#f0f4f2"/>' +
        '<path d="M24 50l10-12 8 9 6-7 8 10z" fill="#c3d2cd"/>' +
        '<circle cx="30" cy="30" r="5" fill="#c3d2cd"/>' +
        '</svg>'
    );

document.addEventListener('DOMContentLoaded', function () {
    const addProductModal = document.getElementById('add-product-modal');
    const modalOverlay = document.getElementById('modal-overlay');
    const btnCloseAddProduct = document.getElementById('close-add-product-modal');
    const productsListContainer = document.getElementById('products-list-container');
    const filtersContainer = document.getElementById('product-filters-container');
    const modalTitle = document.getElementById('add-product-modal-title');
    const modalSubtitle = document.getElementById('add-product-modal-subtitle');

    // Toujours 'subscription' : l'ajout en achat unique a été retiré du portail
    // (un seul CTA "Ajouter un produit", qui applique la fréquence de la box).
    // Les achats uniques existants restent affichés et supprimables.
    let currentAddType = 'subscription';

    // Mode "remplacement" : non-null quand la modale sert à remplacer la dernière ligne
    // d'abonnement au lieu d'ajouter un produit.
    // currentAddType reste à 'subscription' : c'est lui qui filtre le catalogue
    // (getBaseFilteredProducts exclut les produits non abonnables), et ce filtrage est
    // exactement celui qu'on veut ici.
    let swapContext = null; // { subscriptionId, productTitle, variantId, quantity }

    // Incrémenté à chaque ouverture du modal. Sert de jeton pour qu'une attente
    // asynchrone lancée par une ouverture précédente ne rende pas par-dessus une
    // ouverture plus récente (cf. openAddProductModal).
    let openSequence = 0;

    // Filtre espèce à l'ouverture, déduit des animaux du client.
    // Un client qui n'a que des chats ne devrait pas ouvrir sur des croquettes
    // chien : le portail connaît déjà l'espèce, autant s'en servir.
    // C'est une PRÉ-POSITION, pas un verrou — la pastille « Tous » reste là.
    // Foyer mixte, espèce inconnue ou aucun animal renseigné -> aucun filtre :
    // on ne masque jamais du catalogue sur une déduction incertaine.
    function animalFilterFromSpecies(species) {
        if (species === 'dog') return 'Chien';
        if (species === 'cat') return 'Chat';
        return '';
    }

    function defaultAnimalFilter() {
        const pets = window.rechargePortal?.pets;
        if (!Array.isArray(pets) || pets.length === 0) return '';

        const species = new Set(pets.map(pet => pet?.species).filter(Boolean));
        if (species.size !== 1) return '';

        return animalFilterFromSpecies(species.values().next().value);
    }

    // État des filtres
    const activeFilters = {
        animal: '',      // '' = tous, 'Chien', 'Chat'
        category: '',    // '' = tous, ou valeur de product_type
        age: '',         // '' = tous, ou valeur de cat_age_group/dog_age_group
        flavor: ''       // '' = tous, ou valeur de pet_food_flavor
    };

    console.log('[Modal Add Product] Initialisation');

    // Fonction pour ouvrir le modal
    async function openAddProductModal(type, options = {}) {
        // Paiement en échec : la prochaine charge est déjà bloquée. Ajouter une
        // ligne augmente le montant qui échoue, sans rien livrer au client.
        // On l'oriente vers la mise à jour du moyen de paiement.
        // Le mode remplacement reste autorisé : ce n'est pas un ajout, c'est une
        // action de gestion sur une box existante.
        if (!options.keepSwapContext && window.rechargePortal?.paymentIssue === true) {
            showNotification(
                'Votre moyen de paiement doit être mis à jour avant d\'ajouter un produit : la préparation de votre prochaine box est actuellement bloquée.',
                'error',
                7000
            );
            document.getElementById('payment-issue-banner')
                ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
        }

        currentAddType = type;

        // Toute ouverture "normale" repart en mode ajout : seul openSwapProductModal
        // demande à conserver le contexte de remplacement.
        if (!options.keepSwapContext) {
            swapContext = null;
        }

        // Réinitialiser les filtres à chaque ouverture. L'espèce n'est pas remise
        // à « Tous » mais pré-positionnée : sur celle demandée par le point d'entrée
        // (« Ajouter un produit pour Pumpkin » depuis l'onglet Mes animaux), sinon
        // sur celle déduite des animaux du client.
        activeFilters.animal = options.animal
            ? animalFilterFromSpecies(options.animal)
            : defaultAnimalFilter();
        activeFilters.category = '';
        activeFilters.age = '';
        activeFilters.flavor = '';
        filtersSheetOpen = false; // le panneau mobile repart replié

        // IMPORTANT: Réinitialiser la sélection à chaque ouverture du modal
        selectedProducts = [];
        document.querySelectorAll('.product-item-modal').forEach(item => {
            item.classList.remove('selected');
        });
        // Vider, pas masquer : le compteur est une région `aria-live` masquée en
        // CSS (clip). Lui poser `display: none` le sortirait de l'arbre
        // d'accessibilité et supprimerait la seule chose qu'il fait encore.
        const counterElement = document.getElementById('selection-counter');
        if (counterElement) {
            counterElement.textContent = '';
        }

        // Réinitialiser le bouton Valider (au cas où il serait resté bloqué)
        // Le libellé passe par le helper : la sélection vient d'être vidée, et la
        // barre est de toute façon masquée tant que rien n'est sélectionné.
        const btnValidate = document.getElementById('btn-validate-product');
        if (btnValidate) {
            btnValidate.disabled = false;
            btnValidate.textContent = validateButtonLabel(0);
        }

        console.log('[Modal Add Product] Sélection et bouton réinitialisés à l\'ouverture');

        modalTitle.textContent = 'Compléter ma box';

        // Ajout simple : titre seul, plus de sous-titre. Vidé ET masqué, pas
        // seulement vidé — l'élément est réutilisé par le mode remplacement, et
        // une ouverture d'ajout après un remplacement rejouerait sinon sa phrase.
        modalSubtitle.textContent = '';
        modalSubtitle.hidden = true;

        if (swapContext) {
            modalTitle.textContent = 'Remplacer mon produit';
            modalSubtitle.textContent = `Choisissez le ou les produits qui remplaceront « ${swapContext.productTitle} »`;
            modalSubtitle.hidden = false;
        }

        // Ouvrir le modal
        addProductModal.classList.add('active');
        modalOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';

        // On attend les points de synchronisation posés par le snippet
        // portal-catalog-bootstrap. On NE sonde plus : l'ancien setInterval était
        // recréé à chaque ouverture sans que le précédent soit nettoyé, donc
        // ouvrir/fermer/rouvrir pendant le chargement empilait des intervalles
        // qui appelaient tous renderProductsList().
        //
        // portalContentReady() déclenche le chargement des metafields à la
        // PREMIÈRE ouverture (mémoïsé ensuite) et attend déjà le catalogue.
        // Rendre avant sa résolution afficherait des produits sans metafields,
        // et les filtres « Tranche d'âge » et « Saveur », construits sur ces
        // valeurs, disparaîtraient sans erreur.
        if (!window.shopifyAllProducts || window.shopifyAllProducts.length === 0) {
            productsListContainer.innerHTML = '<p style="text-align: center; color: #666; padding: 40px;">Chargement des produits...</p>';
        }

        // Jeton d'ouverture : si l'utilisateur ferme puis rouvre pendant l'attente,
        // seule la dernière ouverture a le droit de rendre. Sans ça, une attente
        // périmée réécrit la liste par-dessus une ouverture plus récente.
        const openToken = ++openSequence;

        // Aucune de ces promesses ne rejette (cf. snippet) ; le repli couvre le cas
        // où le snippet n'aurait pas été rendu, pour ne pas bloquer sur undefined.
        const ready = typeof window.portalContentReady === 'function'
            ? window.portalContentReady()
            : (window.portalCatalogReady || Promise.resolve(window.shopifyAllProducts || []));
        const products = await ready;

        if (openToken !== openSequence) return;            // ouverture périmée
        if (!addProductModal.classList.contains('active')) return; // modal refermé entre-temps

        if (!products || products.length === 0) {
            productsListContainer.innerHTML = '<p style="text-align: center; color: #666;">Erreur lors du chargement des produits. Veuillez réessayer.</p>';
            return;
        }

        renderProductsList();
    }

    // Fonction pour fermer le modal
    function closeAddProductModal(resetProduct = true) {
        // La fiche vit dans le drawer : elle ne doit pas rester ouverte pour la
        // prochaine ouverture du modal.
        closeProductDetail();
        addProductModal.classList.remove('active');
        modalOverlay.classList.remove('active');
        document.body.style.overflow = '';

        // Réinitialiser la sélection de produits uniquement si demandé
        // (ne pas réinitialiser si on passe au modal suivant dans le flux de création)
        if (resetProduct) {
            selectedProducts = [];
            swapContext = null;

            // Retirer les classes selected de tous les produits
            document.querySelectorAll('.product-item-modal').forEach(item => {
                item.classList.remove('selected');
            });

            // Vider le compteur (région aria-live masquée en CSS, cf. openAddProductModal)
            const counterElement = document.getElementById('selection-counter');
            if (counterElement) {
                counterElement.textContent = '';
            }

            // Les boutons restent créés mais ne sont plus cachés
            // Pas besoin de les manipuler ici

            // Réinitialiser AUSSI le contexte global de création
            if (window.subscriptionCreationContext) {
                window.subscriptionCreationContext.selectedProduct = null;
                window.subscriptionCreationContext.selectedFrequency = null;
                window.subscriptionCreationContext.isCreatingNewSubscription = false;
                console.log('[Modal Add Product] Contexte global réinitialisé à la fermeture');
            }
        } else {
            console.log('[Modal Add Product] Fermeture sans réinitialisation (passage au modal suivant)');
        }

        // Désélectionner visuellement tous les produits et réinitialiser les boutons
        document.querySelectorAll('.product-item-modal').forEach(item => {
            item.classList.remove('selected');
            const btn = item.querySelector('.btn-add-to-cart-modal');
            if (btn) btn.textContent = 'Ajouter';
        });

        // Cacher les boutons Valider/Annuler
        const confirmButtonsContainer = document.getElementById('confirm-buttons-container');
        if (confirmButtonsContainer) {
            confirmButtonsContainer.style.display = 'none';
        }
    }

    // Offres de bienvenue « Kit Découverte » : des essais réservés aux NOUVEAUX
    // clients, avec leur propre fréquence et leur propre remise. Un abonné qui
    // complète sa box n'a rien à en faire, et aucune collection ne les classe —
    // elles tombaient donc dans la section « Autres » du modal.
    //
    // Accents et casse neutralisés avant le test : le titre vient du catalogue
    // Shopify, un « Kit Decouverte » sans accent ne doit pas passer au travers.
    // Ancré en DÉBUT de titre, pas `includes` : un produit qui mentionnerait le
    // kit dans son nom sans en être un resterait proposé.
    const isWelcomeKit = product => /^kit\s+decouverte\b/.test(
        (product.title || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    );

    // Filtrer les produits selon le type d'ajout (subscription/onetime)
    function getBaseFilteredProducts() {
        if (!window.shopifyAllProducts || window.shopifyAllProducts.length === 0) return [];

        if (currentAddType === 'subscription') {
            return window.shopifyAllProducts.filter(product => {
                if (product.title.startsWith('Notre recommandation :')) return false;
                if (isWelcomeKit(product)) return false;
                if (product.tags && Array.isArray(product.tags)) {
                    const isExcluded = product.tags.some(tag => {
                        const tagLower = tag.toLowerCase();
                        return tagLower.includes('no-subscription') ||
                            tagLower.includes('one-time-only') ||
                            tagLower.includes('sans-abonnement');
                    });
                    if (isExcluded) return false;
                }
                return true;
            });
        } else {
            return window.shopifyAllProducts.filter(product =>
                !product.title.startsWith('Notre recommandation :') && !isWelcomeKit(product)
            );
        }
    }

    // Appliquer les filtres utilisateur (animal, catégorie, âge, saveur)
    function applyUserFilters(products) {
        return products.filter(product => {
            // Filtre animal. Un produit sans espèce est universel (huile de
            // saumon « chien et chat », litière, goodies) et n'est JAMAIS masqué
            // — même règle que petsForProduct() : on ne retire que les
            // incompatibilités prouvées. Sans ça, le pré-filtre espèce à
            // l'ouverture ferait disparaître une partie de la section
            // « Compléter ma box », c'est-à-dire exactement l'upsell visé.
            //
            // productAnimalType() et non animal_type brut : ce dernier est vide
            // pour les fiches absentes de produits-chiens / produits-chats, et
            // le « Coffret Pâtées Chiot » passait ainsi pour universel — il
            // s'affichait sous le filtre Chat, dans une section « Pâtées chien ».
            const animalType = window.rechargePortal?.productAnimalType?.(product) ?? product.animal_type;
            if (activeFilters.animal && animalType && animalType !== activeFilters.animal) return false;

            // Filtre catégorie (product_type)
            if (activeFilters.category && product.product_type !== activeFilters.category) return false;

            // Filtre tranche d'âge (valeurs = tableaux)
            if (activeFilters.age) {
                const ageArr = activeFilters.animal === 'Chat' ? product.cat_age_group :
                    activeFilters.animal === 'Chien' ? product.dog_age_group :
                        [...(product.cat_age_group || []), ...(product.dog_age_group || [])];
                if (!ageArr || !ageArr.includes(activeFilters.age)) return false;
            }

            // Filtre saveur (valeurs = tableau)
            if (activeFilters.flavor && (!product.pet_food_flavor || !product.pet_food_flavor.includes(activeFilters.flavor))) return false;

            return true;
        });
    }

    // Collecter les valeurs uniques pour les dropdowns de filtres
    function collectFilterValues(products) {
        const categories = new Set();
        const ages = new Set();
        const flavors = new Set();

        products.forEach(product => {
            if (product.product_type) categories.add(product.product_type);

            // Âge : selon le filtre animal actif (valeurs = tableaux)
            if (activeFilters.animal === 'Chat' && product.cat_age_group) {
                product.cat_age_group.forEach(v => ages.add(v));
            } else if (activeFilters.animal === 'Chien' && product.dog_age_group) {
                product.dog_age_group.forEach(v => ages.add(v));
            } else if (!activeFilters.animal) {
                if (product.cat_age_group) product.cat_age_group.forEach(v => ages.add(v));
                if (product.dog_age_group) product.dog_age_group.forEach(v => ages.add(v));
            }

            // Saveur (valeurs = tableau)
            if (product.pet_food_flavor) product.pet_food_flavor.forEach(v => flavors.add(v));
        });

        return {
            categories: [...categories].sort((a, b) => a.localeCompare(b, 'fr')),
            ages: [...ages].sort((a, b) => a.localeCompare(b, 'fr')),
            flavors: [...flavors].sort((a, b) => a.localeCompare(b, 'fr'))
        };
    }

    // Panneau de filtres secondaires (catégorie / âge / saveur) : replié derrière un
    // bouton « Filtrer » sous 600px. Sur desktop il n'existe pas — les selects sont
    // posés à plat dans la barre, via `display: contents`.
    //
    // L'état vit hors de renderFilters parce que celle-ci est rappelée à CHAQUE
    // renderProductsList(), donc à chaque changement de filtre : sans mémoire, le
    // panneau se refermerait après le premier select et poser deux critères
    // demanderait de le rouvrir entre les deux.
    let filtersSheetOpen = false;

    // Générer le HTML des filtres
    function renderFilters(baseProducts) {
        const values = collectFilterValues(baseProducts);

        // L'espèce n'est pas comptée : sa pastille reste visible sur sa propre ligne,
        // le badge ne doit annoncer que ce que le panneau replié cache.
        const advancedCount = ['category', 'age', 'flavor']
            .filter(key => activeFilters[key]).length;

        let filtersHTML = '<div class="product-filters">';

        // Filtre animal (pills)
        filtersHTML += '<div class="filter-pills">';
        filtersHTML += `<button class="filter-pill ${activeFilters.animal === '' ? 'active' : ''}" data-filter="animal" data-value="">Tous</button>`;
        filtersHTML += `<button class="filter-pill ${activeFilters.animal === 'Chien' ? 'active' : ''}" data-filter="animal" data-value="Chien">Chien</button>`;
        filtersHTML += `<button class="filter-pill ${activeFilters.animal === 'Chat' ? 'active' : ''}" data-filter="animal" data-value="Chat">Chat</button>`;
        filtersHTML += '</div>';

        const hasAdvanced = values.categories.length > 0 || values.ages.length > 0 || values.flavors.length > 0;

        if (hasAdvanced) {
            filtersHTML += `<button type="button" class="filter-sheet-toggle" aria-expanded="${filtersSheetOpen ? 'true' : 'false'}" aria-controls="filter-advanced">`;
            filtersHTML += '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 4h12M4.5 8h7M7 12h2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
            filtersHTML += 'Filtrer';
            if (advancedCount > 0) filtersHTML += `<span class="filter-count-badge">${advancedCount}</span>`;
            filtersHTML += '</button>';
        }

        filtersHTML += `<div class="filter-advanced${filtersSheetOpen ? ' open' : ''}" id="filter-advanced">`;

        // Catégorie
        if (values.categories.length > 0) {
            filtersHTML += '<select class="filter-select" data-filter="category">';
            filtersHTML += '<option value="">Catégorie</option>';
            values.categories.forEach(cat => {
                filtersHTML += `<option value="${cat}" ${activeFilters.category === cat ? 'selected' : ''}>${cat}</option>`;
            });
            filtersHTML += '</select>';
        }

        // Tranche d'âge
        if (values.ages.length > 0) {
            filtersHTML += '<select class="filter-select" data-filter="age">';
            filtersHTML += `<option value="">Tranche d'âge</option>`;
            values.ages.forEach(age => {
                filtersHTML += `<option value="${age}" ${activeFilters.age === age ? 'selected' : ''}>${age}</option>`;
            });
            filtersHTML += '</select>';
        }

        // Saveur
        if (values.flavors.length > 0) {
            filtersHTML += '<select class="filter-select" data-filter="flavor">';
            filtersHTML += '<option value="">Saveur</option>';
            values.flavors.forEach(flavor => {
                filtersHTML += `<option value="${flavor}" ${activeFilters.flavor === flavor ? 'selected' : ''}>${flavor}</option>`;
            });
            filtersHTML += '</select>';
        }

        // Sortie de secours : une fois le panneau replié, « Aucun produit ne correspond »
        // ne dit pas QUEL filtre exclut tout, et sur mobile les selects ne sont plus à
        // l'écran. Sans ce bouton, l'impasse se règle en refermant le modal.
        if (advancedCount > 0) {
            filtersHTML += '<button type="button" class="filter-reset">Tout effacer</button>';
        }

        filtersHTML += '</div>'; // .filter-advanced
        filtersHTML += '</div>'; // .product-filters

        if (!filtersContainer) return;
        filtersContainer.innerHTML = filtersHTML;

        // Attacher les événements aux filtres
        filtersContainer.querySelectorAll('.filter-pill').forEach(btn => {
            btn.addEventListener('click', function () {
                activeFilters.animal = this.dataset.value;
                // Réinitialiser le filtre âge quand on change d'animal (les valeurs changent)
                activeFilters.age = '';
                renderProductsList();
            });
        });

        filtersContainer.querySelectorAll('.filter-select').forEach(select => {
            select.addEventListener('change', function () {
                activeFilters[this.dataset.filter] = this.value;
                renderProductsList();
            });
        });

        // Bascule du panneau : pas de re-rendu, on ne touche pas aux filtres actifs.
        const sheetToggle = filtersContainer.querySelector('.filter-sheet-toggle');
        const sheet = filtersContainer.querySelector('.filter-advanced');
        if (sheetToggle && sheet) {
            sheetToggle.addEventListener('click', () => {
                filtersSheetOpen = !filtersSheetOpen;
                sheet.classList.toggle('open', filtersSheetOpen);
                sheetToggle.setAttribute('aria-expanded', filtersSheetOpen ? 'true' : 'false');
            });
        }

        const resetBtn = filtersContainer.querySelector('.filter-reset');
        if (resetBtn) {
            resetBtn.addEventListener('click', () => {
                activeFilters.category = '';
                activeFilters.age = '';
                activeFilters.flavor = '';
                renderProductsList();
            });
        }
    }

    // Raccourcis locaux vers la règle portée par RechargePortal : une seule
    // définition pour le modal ET l'encart de recommandation.
    const SUBSCRIBER_DISCOUNT_LABEL = RechargePortal.SUBSCRIBER_DISCOUNT_LABEL;
    const subscriberPriceCents = cents => RechargePortal.subscriberPriceCents(cents);

    // Fonction pour générer la liste des produits
    function renderProductsList() {
        if (!window.shopifyAllProducts || window.shopifyAllProducts.length === 0) {
            productsListContainer.innerHTML = '<p style="text-align: center; color: #666;">Aucun produit disponible</p>';
            if (filtersContainer) filtersContainer.innerHTML = '';
            return;
        }

        // 1. Filtrage de base (subscription/onetime)
        const baseProducts = getBaseFilteredProducts();

        // 2. Générer les filtres (basés sur les produits de base, avant filtres utilisateur)
        renderFilters(baseProducts);

        // 3. Appliquer les filtres utilisateur
        const filteredProducts = applyUserFilters(baseProducts);

        // Si aucun produit après filtrage
        if (filteredProducts.length === 0) {
            productsListContainer.innerHTML = '<p style="text-align: center; color: #666; padding: 40px;">Aucun produit ne correspond aux filtres sélectionnés</p>';
            return;
        }

        // Grouper les produits par collection Shopify (collection_name)
        const groupedProducts = {};
        filteredProducts.forEach(product => {
            const collection = product.collection_name || 'Autres';
            if (!groupedProducts[collection]) {
                groupedProducts[collection] = [];
            }
            groupedProducts[collection].push(product);
        });

        // Trier les sections avec la MÊME priorité que le bloc de recommandation
        // (cf. modalSectionOrder) : l'aliment manquant d'abord, l'espèce de la
        // box devant l'autre, « Compléter ma box » en dernier. Repli sur l'ordre
        // de déclaration si le portail n'est pas encore instancié.
        const sectionOrder = window.rechargePortal?.modalSectionOrder?.()
            || (window.shopifyProductCollections || []).map(c => c.name);
        const sortedSections = Object.keys(groupedProducts).sort((a, b) => {
            const indexA = sectionOrder.indexOf(a);
            const indexB = sectionOrder.indexOf(b);
            if (indexA !== -1 && indexB !== -1) return indexA - indexB;
            if (indexA !== -1) return -1;
            if (indexB !== -1) return 1;
            return a.localeCompare(b, 'fr');
        });

        // Au sein d'une section, les produits DÉJÀ dans la box passent en dernier :
        // ils portent le badge « Déjà dans votre box » et ne sont pas la cible de
        // l'upsell, mais rien ne les empêchait d'occuper le haut de section.
        // Le jeu d'ids est calculé UNE fois : subscribedVariantIds() reconstruit son
        // tableau à chaque appel, et un comparateur de tri l'appellerait O(n log n) fois.
        // Tri stable (spec ES2019) : à statut égal, l'ordre du catalogue est conservé.
        const subscribedIds = new Set(subscribedVariantIds());
        const alreadyInBox = (product) =>
            subscribedIds.size > 0 &&
            (product.variants || []).some(v => subscribedIds.has(String(v.id)));

        sortedSections.forEach(section => {
            groupedProducts[section].sort(
                (a, b) => (alreadyInBox(a) ? 1 : 0) - (alreadyInBox(b) ? 1 : 0)
            );
        });

        let productsHTML = '';
        sortedSections.forEach(section => {
            // Ajouter le titre de section
            productsHTML += `<div class="product-section-header">${section}</div>`;

            groupedProducts[section].forEach(product => {
                // Variante servant de référence pour la ligne : celle que le client
                // a déjà dans sa box, sinon la moins chère (cf. defaultVariantFor).
                // C'est aussi celle qu'ajoute le bouton raccourci.
                const refVariant = defaultVariantFor(product);
                const refPrice = refVariant ? refVariant.price : (product.price || 0);
                const price = (refPrice / 100).toFixed(2);
                const memberPrice = (subscriberPriceCents(refPrice) / 100).toFixed(2);

                // Repli local : une vignette manquante ne doit pas déclencher une
                // requête vers un tiers (via.placeholder.com) dans le chemin de rendu.
                const imageUrl = product.featured_image || PRODUCT_IMAGE_FALLBACK;

                // Le format se choisit DANS LA LIGNE, pas seulement dans la fiche :
                // c'est le chemin le plus court pour ajouter un produit à sa box —
                // dérouler, choisir, « Ajouter ». La fiche reste là pour qui veut
                // lire la composition, elle n'est plus un passage obligé.
                const variants = product.variants || [];
                const hasVariantChoice = variants.length > 1;

                // Plus de « dès X € » : le sélecteur nomme le format, donc le prix
                // affiché est celui d'une variante précise. Une fourchette à côté
                // d'un format choisi ne voudrait plus rien dire.
                const displayPrice = memberPrice;

                // Le barré est TOUJOURS le prix catalogue Shopify de la variante,
                // et jamais son `compare_at_price` : afficher deux barrés (le
                // volume ET l'abonnement) sur une ligne de liste rendrait la
                // remise annoncée illisible. L'économie de format reste chiffrée
                // dans la fiche produit, sur les boutons de format.
                const strike = `<span class="product-price-was">${price} €</span>`;
                // `discount-badge` est la pastille de remise de « Ma box » : classe
                // RÉUTILISÉE telle quelle, pas recopiée, pour que les deux surfaces
                // ne puissent pas diverger si la couleur change un jour.
                const memberBadge = `<span class="discount-badge">${SUBSCRIBER_DISCOUNT_LABEL}</span>`;

                const variantSelect = hasVariantChoice
                    ? `<select class="variant-selector" data-product-id="${product.id}" aria-label="Format — ${escapeHtml(product.title)}">
                            ${variants.map(v => {
                                const isRef = refVariant && String(v.id) === String(refVariant.id);
                                return `<option value="${v.id}" data-price="${v.price}" data-compare="${v.compare_at_price || ''}"${isRef ? ' selected' : ''}${v.available ? '' : ' disabled'}>${escapeHtml(v.title)}${v.available ? '' : ' — épuisé'}</option>`;
                            }).join('')}
                        </select>`
                    : '';

                const subtitle = product.subtitle
                    ? `<p class="product-subtitle-modal">${escapeHtml(product.subtitle)}</p>`
                    : '';

                // Déjà dans l'abonnement : le produit n'est pas la cible d'un ajout,
                // on le signale au lieu de le laisser se confondre avec le reste.
                const inBox = isVariantInSubscription(product);
                const inBoxBadge = inBox ? '<span class="product-inbox-badge">Déjà dans votre box</span>' : '';

                productsHTML += `
                <div class="product-item-modal${inBox ? ' in-box' : ''}" data-product-id="${product.id}" role="button" tabindex="0" aria-label="Voir le détail de ${escapeHtml(product.title)}">
                    <img src="${imageUrl}" alt="${escapeHtml(product.images?.[0]?.alt || product.title)}" class="product-image-modal" loading="lazy">
                    <div class="product-info-modal">
                        <h4 class="product-title-modal">${escapeHtml(product.title)}</h4>
                        ${subtitle}
                        <div class="product-meta-row">${inBoxBadge}</div>
                        <div class="product-price-variant-row">
                            <div class="product-price-line">
                                <p class="product-price-modal" data-base-price="${price}">${displayPrice} €</p>
                                ${strike}
                                ${memberBadge}
                                <span class="badge-added">Ajouté</span>
                            </div>
                        </div>
                        ${variantSelect ? `<div class="product-variant-row">${variantSelect}</div>` : ''}
                    </div>
                    <div class="product-actions-modal">
                        <button class="btn-add-to-cart-modal" data-product-id="${product.id}" title="Ajouter ce produit">
                            Ajouter
                        </button>
                        <span class="product-detail-hint" aria-hidden="true">Détails
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                    </div>
                </div>
            `;
            });
        });

        productsListContainer.innerHTML = productsHTML;

        // Attacher les événements aux boutons "Ajouter" et aux sélecteurs de variantes
        attachAddToCartListeners();
        attachVariantSelectorsListeners();
        attachProductRowListeners();

        // Le HTML vient d'être reconstruit : réappliquer l'état de sélection,
        // sinon changer un filtre efface le marquage des produits déjà choisis.
        syncListSelectionUI();

        // Créer les boutons de confirmation dès le départ
        showConfirmButtons();
    }

    // Array pour stocker les produits sélectionnés avec leurs variantes
    let selectedProducts = [];
    Object.defineProperty(window, '_addProductSelectedProducts', {
        get: function() { return selectedProducts; }
    });
    // Note: selectedFrequency et isCreatingNewSubscription sont maintenant dans window.subscriptionCreationContext

    // Écrit dans une ligne le prix (et le prix barré) de la variante donnée.
    // Extrait parce que trois chemins doivent produire exactement le même
    // affichage : le rendu initial, le changement de format dans la ligne, et la
    // resynchronisation après un choix fait dans la fiche produit.
    function paintRowPrice(productItem, priceCents) {
        if (!productItem || !Number.isFinite(priceCents)) return;

        const catalogPrice = (priceCents / 100).toFixed(2) + ' €';

        const priceElement = productItem.querySelector('.product-price-modal');
        if (priceElement) {
            priceElement.textContent = (subscriberPriceCents(priceCents) / 100).toFixed(2) + ' €';
            priceElement.setAttribute('data-base-price', (priceCents / 100).toFixed(2));
        }

        // Le prix barré est un élément SÉPARÉ, mais désormais TOUJOURS présent :
        // il vaut le prix catalogue de la variante, pas son `compare_at_price`.
        // Il n'y a donc plus rien à créer ni à supprimer, seulement à réécrire.
        const was = productItem.querySelector('.product-price-was');
        if (was) was.textContent = catalogPrice;
    }

    // Fonction pour attacher les listeners aux sélecteurs de variantes
    function attachVariantSelectorsListeners() {
        const variantSelectors = document.querySelectorAll('.variant-selector');
        variantSelectors.forEach(select => {
            select.addEventListener('change', function () {
                const productId = parseInt(this.getAttribute('data-product-id'));
                const selectedOption = this.options[this.selectedIndex];
                const variantPrice = parseInt(selectedOption.getAttribute('data-price'), 10);
                const newVariantId = parseInt(this.value, 10);

                paintRowPrice(this.closest('.product-item-modal'), variantPrice);

                // Si le produit est déjà sélectionné, mettre à jour la variante choisie
                const existing = selectedProducts.find(p => p.productId === productId);
                if (existing) {
                    existing.variantId = newVariantId;
                    console.log('[Modal Add Product] Variante mise à jour pour produit sélectionné:', { productId, variantId: newVariantId });
                }

                console.log('[Modal Add Product] Variante sélectionnée:', {
                    productId: productId,
                    variantId: newVariantId,
                    price: variantPrice
                });
            });
        });
    }

    // Fonction pour attacher les listeners aux boutons "Ajouter"
    function attachAddToCartListeners() {
        const addButtons = document.querySelectorAll('.btn-add-to-cart-modal');
        addButtons.forEach(btn => {
            btn.addEventListener('click', function () {
                const productId = parseInt(this.getAttribute('data-product-id'));
                addProductToSelection(productId, this);
            });
        });
    }

    // Toute la ligne ouvre la fiche produit, sauf les commandes qui ont déjà
    // leur propre action : le bouton « Ajouter » reste un raccourci pour le
    // format par défaut, et le sélecteur de variante doit rester manipulable.
    function attachProductRowListeners() {
        document.querySelectorAll('.product-item-modal').forEach(item => {
            const open = () => openProductDetail(parseInt(item.getAttribute('data-product-id'), 10));

            item.addEventListener('click', (event) => {
                if (event.target.closest('.btn-add-to-cart-modal, .variant-selector')) return;
                open();
            });

            // La ligne est annoncée role="button" : elle doit répondre au clavier
            // comme un bouton, sinon l'attribut ment aux technologies d'assistance.
            item.addEventListener('keydown', (event) => {
                if (event.key !== 'Enter' && event.key !== ' ') return;
                if (event.target.closest('.btn-add-to-cart-modal, .variant-selector')) return;
                event.preventDefault();
                open();
            });
        });
    }

    // Fonction pour ajouter un produit à la sélection
    // ======================================================================
    // FICHE PRODUIT (panneau détail)
    // ======================================================================

    const detailPanel = document.getElementById('product-detail-panel');
    const detailBody = document.getElementById('product-detail-body');
    const detailFooter = document.getElementById('product-detail-footer');
    const detailBackBtn = document.getElementById('product-detail-back');

    // Produit et variante actuellement affichés dans la fiche
    let detailProduct = null;
    let detailVariantId = null;
    let detailSlide = 0;

    const escapeHtml = (value) => String(value == null ? '' : value)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

    const formatPrice = (cents) => (cents / 100).toFixed(2).replace('.', ',') + ' €';

    // Échéance RÉELLE de la prochaine box, dérivée de next_charge_scheduled_at.
    // Une date vérifiable par le client dans son propre portail — c'est ce qui
    // remplace tout compte à rebours ou rareté fabriquée. On affiche la date de
    // LIVRAISON : « votre box du 19 » doit désigner le jour où elle arrive, pas
    // celui où Recharge débite.
    // Aucune date disponible -> on n'affiche rien plutôt qu'une approximation.
    function nextBoxLabel() {
        const raw = window.rechargePortal?.activeSubscriptions?.[0]?.next_charge_scheduled_at;
        const delivery = RechargePortal.chargeToDelivery(raw);
        if (!delivery) return '';
        const formatted = delivery.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' });
        return `<span class="detail-price-next">Ajouté à votre box du ${formatted}</span>`;
    }

    // Le contenu vient de body_html et de metafields rich text : du HTML rédigé
    // par le marketing, parfois via un page-builder (Shogun). On garde une mise
    // en forme minimale et on jette le reste — balises inconnues déballées,
    // attributs supprimés (donc styles inline, classes et handlers `on*`).
    const DESCRIPTION_ALLOWED = new Set(['P', 'BR', 'UL', 'OL', 'LI', 'STRONG', 'B', 'EM', 'I', 'H3', 'H4']);

    function sanitizeRichText(html) {
        if (!html) return '';
        const doc = new DOMParser().parseFromString(String(html), 'text/html');
        doc.body.querySelectorAll('script, style, iframe, noscript, link, meta, template').forEach(node => node.remove());
        doc.body.querySelectorAll('*').forEach(el => {
            if (!DESCRIPTION_ALLOWED.has(el.tagName)) {
                el.replaceWith(...el.childNodes); // déballe : <div data-shogun-*>, <span>, ...
                return;
            }
            [...el.attributes].forEach(attr => el.removeAttribute(attr.name));
        });
        return doc.body.innerHTML.trim();
    }

    function currentDetailVariant() {
        if (!detailProduct) return null;
        return detailProduct.variants.find(v => String(v.id) === String(detailVariantId))
            || detailProduct.variants[0]
            || null;
    }

    // Variante proposée à l'ouverture. Le format que le client a DÉJÀ dans sa
    // box passe devant : c'est celui qu'il reprendra le plus probablement.
    // Sinon la moins chère — un petit format se refuse moins qu'un 12 kg.
    // Ids de variantes déjà en abonnement. Deux formes selon l'ancienneté de la
    // ligne Recharge : external_variant_id.ecommerce ou shopify_variant_id.
    function subscribedVariantIds() {
        return (window.rechargePortal?.activeSubscriptions || [])
            .map(sub => String(sub.external_variant_id?.ecommerce || sub.shopify_variant_id || ''))
            .filter(Boolean);
    }

    function isVariantInSubscription(product) {
        const subscribed = subscribedVariantIds();
        if (subscribed.length === 0) return false;
        return (product.variants || []).some(v => subscribed.includes(String(v.id)));
    }

    function defaultVariantFor(product) {
        const variants = product.variants || [];
        if (variants.length === 0) return null;

        const subscribed = subscribedVariantIds();
        const alreadyInBox = variants.find(v => subscribed.includes(String(v.id)));
        if (alreadyInBox) return alreadyInBox;

        const available = variants.filter(v => v.available);
        const pool = available.length ? available : variants;
        return pool.reduce((cheapest, v) => (v.price < cheapest.price ? v : cheapest), pool[0]);
    }

    function renderDetailGallery(product) {
        const images = product.images || [];
        if (images.length === 0) {
            return `<div class="detail-gallery detail-gallery--empty">
                        <img src="${PRODUCT_IMAGE_FALLBACK}" alt="" class="detail-gallery-image">
                    </div>`;
        }

        const slides = images.map((image, i) => `
            <div class="detail-gallery-slide" data-slide="${i}">
                <img src="${escapeHtml(image.src)}"
                     alt="${escapeHtml(image.alt || product.title)}"
                     class="detail-gallery-image"
                     ${i === 0 ? '' : 'loading="lazy"'}>
            </div>`).join('');

        // Points et flèches masqués sur une image unique : ne pas simuler un
        // carrousel là où il n'y a rien à faire défiler (2 à 8 images selon les produits).
        const controls = images.length > 1 ? `
            <button type="button" class="detail-gallery-arrow detail-gallery-arrow--prev" data-gallery-prev aria-label="Image précédente">‹</button>
            <button type="button" class="detail-gallery-arrow detail-gallery-arrow--next" data-gallery-next aria-label="Image suivante">›</button>
            <div class="detail-gallery-dots" role="tablist">
                ${images.map((_, i) => `<button type="button" class="detail-gallery-dot${i === 0 ? ' active' : ''}" data-gallery-dot="${i}" aria-label="Image ${i + 1} sur ${images.length}"></button>`).join('')}
            </div>` : '';

        return `<div class="detail-gallery">
                    <div class="detail-gallery-track" data-gallery-track>${slides}</div>
                    ${controls}
                </div>`;
    }

    function renderDetailAccordions(product) {
        const info = product.info || {};
        const blocks = [
            { key: 'ingredients', label: 'Ingrédients', html: sanitizeRichText(info.ingredients) },
            { key: 'composition', label: 'Composition analytique', html: sanitizeRichText(info.composition) },
            { key: 'benefits', label: 'Les bienfaits de cette recette', html: sanitizeRichText(info.benefits) },
        ].filter(block => block.html);

        // Rendu conditionnel : un metafield vide ne produit AUCUN accordéon.
        // Le taux de remplissage n'est pas garanti sur tout le catalogue.
        if (blocks.length === 0) return '';

        return `<div class="detail-accordions">
            ${blocks.map((block, i) => `
                <details class="detail-accordion"${i === 0 ? ' open' : ''}>
                    <summary class="detail-accordion-summary">${block.label}</summary>
                    <div class="detail-accordion-content">${block.html}</div>
                </details>`).join('')}
        </div>`;
    }

    function renderDetailFooter(product) {
        const variant = currentDetailVariant();
        if (!variant) return '';

        const hasFormats = (product.variants || []).length > 1;

        // DEUX remises se cumulent, et elles n'ont ni la même source ni la même
        // visibilité. Les confondre est le piège de cet écran :
        //
        //  1. La remise QUANTITÉ, déjà dans le prix Shopify. `compare_at_price`
        //     vaut le prix du petit format multiplié : pâtée chat 20 × 80 g est à
        //     37,90 € contre 39,80 € (= 2 × 19,90 €), la 40 × 80 g à 72,90 €
        //     contre 79,60 € (= 4 × 19,90 €). C'est donc une comparaison « ce
        //     format contre le même volume en petits packs », pas une promotion.
        //     Chiffrable, et affichée telle quelle.
        //
        //  2. La remise ABONNÉ, annoncée ici à un taux FIXE de 15 % du prix
        //     catalogue (SUBSCRIBER_DISCOUNT_RATE). Ce n'est pas ce que Recharge
        //     facturera : la remise réelle n'est ni uniforme par produit ni par
        //     client, et n'est connue qu'après l'ajout. Choix assumé — la modale
        //     annonce un avantage lisible plutôt qu'une mention non chiffrée.
        //
        // Conséquence : la remise QUANTITÉ n'est plus affichée en prix barré ici,
        // le barré étant pris par le prix catalogue. Elle reste chiffrée sur les
        // boutons de format et dans la note ci-dessous, pour que les deux remises
        // ne se lisent pas comme une seule.
        const saving = variant.compare_at_price && variant.compare_at_price > variant.price
            ? variant.compare_at_price - variant.price
            : 0;

        const memberPrice = subscriberPriceCents(variant.price);

        const formats = hasFormats ? `
            <div class="detail-formats">
                <span class="detail-formats-label">Format</span>
                <div class="detail-formats-list">
                    ${product.variants.map(v => {
                        const economy = v.compare_at_price && v.compare_at_price > v.price
                            ? ` <span class="detail-format-economy">−${formatPrice(v.compare_at_price - v.price)}</span>`
                            : '';
                        return `<button type="button"
                                    class="detail-format${String(v.id) === String(variant.id) ? ' active' : ''}${v.available ? '' : ' unavailable'}"
                                    data-variant-id="${v.id}"
                                    ${v.available ? '' : 'disabled'}>
                                    ${escapeHtml(v.title)}${economy}
                                </button>`;
                    }).join('')}
                </div>
            </div>` : '';

        const selected = isProductSelected(product.id);

        return `
            ${formats}
            <div class="detail-cta-row">
                <div class="detail-price">
                    <div class="detail-price-line">
                        <span class="detail-price-now">${formatPrice(memberPrice)}</span>
                        <span class="detail-price-was">${formatPrice(variant.price)}</span>
                        <span class="discount-badge">${SUBSCRIBER_DISCOUNT_LABEL}</span>
                    </div>
                    ${saving ? `<span class="detail-price-note detail-price-note--qty">Grand format : ${formatPrice(saving)} d'économie sur le prix catalogue</span>` : ''}
                    <span class="detail-price-note">Prix abonné, remise de 15 % déjà déduite</span>
                    ${nextBoxLabel()}
                </div>
                <button type="button" class="detail-add-btn${selected ? ' selected' : ''}" data-detail-add>
                    ${selected ? 'Retirer de ma box' : 'Ajouter à ma box'}
                </button>
            </div>`;
    }

    function renderDetail() {
        const product = detailProduct;
        if (!product) return;

        const description = sanitizeRichText(product.description_html);
        const subtitle = product.subtitle ? `<p class="detail-subtitle">${escapeHtml(product.subtitle)}</p>` : '';

        detailBody.innerHTML = `
            ${renderDetailGallery(product)}
            <div class="detail-main">
                <h3 class="detail-title">${escapeHtml(product.title)}</h3>
                ${subtitle}
                ${description ? `<div class="detail-description">${description}</div>` : ''}
                ${renderDetailAccordions(product)}
            </div>`;

        detailFooter.innerHTML = renderDetailFooter(product);
        attachDetailListeners();
    }

    function goToSlide(index) {
        const track = detailBody.querySelector('[data-gallery-track]');
        if (!track) return;
        const slides = track.querySelectorAll('.detail-gallery-slide');
        if (slides.length === 0) return;

        detailSlide = (index + slides.length) % slides.length;
        track.scrollTo({ left: slides[detailSlide].offsetLeft, behavior: 'smooth' });
        detailBody.querySelectorAll('[data-gallery-dot]').forEach((dot, i) => {
            dot.classList.toggle('active', i === detailSlide);
        });
    }

    function attachDetailListeners() {
        const track = detailBody.querySelector('[data-gallery-track]');
        if (track) {
            // Le swipe est celui du système (scroll-snap) : on se contente de
            // suivre la position pour tenir les points à jour.
            track.addEventListener('scroll', () => {
                const slides = track.querySelectorAll('.detail-gallery-slide');
                if (!slides.length) return;
                const index = Math.round(track.scrollLeft / track.clientWidth);
                if (index === detailSlide) return;
                detailSlide = index;
                detailBody.querySelectorAll('[data-gallery-dot]').forEach((dot, i) => {
                    dot.classList.toggle('active', i === detailSlide);
                });
            }, { passive: true });
        }

        detailBody.querySelector('[data-gallery-prev]')?.addEventListener('click', () => goToSlide(detailSlide - 1));
        detailBody.querySelector('[data-gallery-next]')?.addEventListener('click', () => goToSlide(detailSlide + 1));
        detailBody.querySelectorAll('[data-gallery-dot]').forEach(dot => {
            dot.addEventListener('click', () => goToSlide(parseInt(dot.getAttribute('data-gallery-dot'), 10)));
        });

        detailFooter.querySelectorAll('.detail-format').forEach(btn => {
            btn.addEventListener('click', () => {
                detailVariantId = parseInt(btn.getAttribute('data-variant-id'), 10);
                // Changer de format alors que le produit est déjà sélectionné doit
                // mettre à jour la variante retenue, pas créer une seconde entrée.
                const entry = selectedProducts.find(p => p.productId === detailProduct.id);
                if (entry) entry.variantId = detailVariantId;
                detailFooter.innerHTML = renderDetailFooter(detailProduct);
                attachDetailListeners();
            });
        });

        detailFooter.querySelector('[data-detail-add]')?.addEventListener('click', () => {
            const result = toggleProductSelection(detailProduct.id, detailVariantId);
            if (result === null) return;
            detailFooter.innerHTML = renderDetailFooter(detailProduct);
            attachDetailListeners();
            // On revient à la liste plutôt que de fermer : fermer après un ajout,
            // c'est choisir d'avoir un seul produit ajouté par session.
            if (result === true) closeProductDetail();
        });
    }

    function openProductDetail(productId) {
        const product = window.shopifyAllProducts.find(p => p.id === productId);
        if (!product) return;

        clearTimeout(detailCloseTimer);
        detailProduct = product;
        detailSlide = 0;

        // Le bouton Retour du navigateur doit refermer la fiche, pas quitter le
        // portail. C'est le geste attendu sur mobile, et sans lui le client perd
        // sa sélection en cours et la position de scroll de la liste.
        // Une seule entrée d'historique, quel que soit le nombre de fiches
        // consultées : passer de fiche en fiche ne doit pas empiler des retours.
        if (!detailHistoryPushed) {
            try {
                history.pushState({ portalProductDetail: true }, '');
                detailHistoryPushed = true;
            } catch (err) {
                console.warn('[Modal Add Product] historique indisponible:', err);
            }
        }

        // Sur quelle variante ouvrir la fiche, par ordre de précision :
        //   1. celle déjà sélectionnée pour l'ajout ;
        //   2. celle que le client vient de dérouler dans la ligne — sans ça, choisir
        //      « 40 x 80g » dans la liste puis ouvrir la fiche pour vérifier la
        //      composition la ramènerait au format par défaut, en silence ;
        //   3. la variante de référence (déjà dans la box, sinon la moins chère).
        const existing = selectedProducts.find(p => p.productId === productId);
        const rowSelect = document.querySelector(
            `.product-item-modal[data-product-id="${productId}"] .variant-selector`
        );
        detailVariantId = existing
            ? existing.variantId
            : (rowSelect && rowSelect.value
                ? parseInt(rowSelect.value, 10)
                : (defaultVariantFor(product) || {}).id);

        renderDetail();
        detailPanel.hidden = false;
        detailBody.scrollTop = 0;
        // Démasquage et animation dans la même frame : la transition ne partirait
        // pas (l'élément passe de display:none à display:flex). On laisse le
        // navigateur calculer l'état initial avant de basculer la classe.
        requestAnimationFrame(() => detailPanel.classList.add('active'));
    }

    let detailCloseTimer = null;
    let detailHistoryPushed = false;

    // `fromPopstate` : l'entrée d'historique a déjà été consommée par le
    // navigateur, il ne faut surtout pas rappeler history.back() — ça remonterait
    // d'un cran de trop et ferait sortir le client du portail.
    function closeProductDetail(options = {}) {
        if (!detailPanel || detailPanel.hidden) return;
        detailPanel.classList.remove('active');
        detailProduct = null;

        if (detailHistoryPushed) {
            detailHistoryPushed = false;
            if (!options.fromPopstate) {
                try {
                    history.back();
                } catch (err) {
                    console.warn('[Modal Add Product] retour historique impossible:', err);
                }
            }
        }
        // On masque après l'animation de sortie. Le garde couvre le cas d'une
        // réouverture pendant les 300 ms : sans lui, le minuteur de la fermeture
        // précédente masquerait un panneau qu'on vient de rouvrir.
        clearTimeout(detailCloseTimer);
        detailCloseTimer = setTimeout(() => {
            if (!detailPanel.classList.contains('active')) detailPanel.hidden = true;
        }, 300);
    }

    detailBackBtn?.addEventListener('click', () => closeProductDetail());

    window.addEventListener('popstate', () => {
        if (detailPanel && !detailPanel.hidden) closeProductDetail({ fromPopstate: true });
    });

    // Échap referme la fiche avant le modal : on recule d'un cran, on ne perd
    // pas la sélection en cours ni la position de scroll de la liste.
    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        if (!detailPanel || detailPanel.hidden) return;
        event.stopPropagation();
        closeProductDetail();
    }, true);

    function isProductSelected(productId) {
        return selectedProducts.some(p => p.productId === productId);
    }

    // Remet l'état visuel des lignes en accord avec `selectedProducts`.
    // Appelée après tout changement de sélection ET après chaque rendu de la
    // liste : sans ça, changer un filtre reconstruit le HTML et fait disparaître
    // le marquage « Retirer » alors que le produit est toujours sélectionné.
    function syncListSelectionUI() {
        document.querySelectorAll('.product-item-modal').forEach(item => {
            const id = parseInt(item.getAttribute('data-product-id'), 10);
            const selected = isProductSelected(id);
            item.classList.toggle('selected', selected);
            const btn = item.querySelector('.btn-add-to-cart-modal');
            if (btn) btn.textContent = selected ? 'Retirer' : 'Ajouter';

            // Le format peut avoir été changé AILLEURS que dans ce menu — dans la
            // fiche produit, qui écrit directement dans selectedProducts. Sans cette
            // remise en phase, la ligne annoncerait un format et la validation en
            // ajouterait un autre.
            const select = item.querySelector('.variant-selector');
            if (!select) return;

            const entry = selectedProducts.find(p => p.productId === id);
            if (entry && String(select.value) !== String(entry.variantId)) {
                select.value = String(entry.variantId);
            }

            const opt = select.options[select.selectedIndex];
            if (!opt) return;
            paintRowPrice(item, parseInt(opt.getAttribute('data-price'), 10));
        });
    }

    // Bascule la sélection d'un produit pour une variante donnée.
    // État pur : aucun accès au DOM de la ligne, pour que la fiche produit
    // puisse l'appeler avec la variante choisie dans son propre sélecteur.
    // Retourne true si ajouté, false si retiré, null si refusé.
    function toggleProductSelection(productId, variantId) {
        const product = window.shopifyAllProducts.find(p => p.id === productId);
        if (!product) {
            console.error('[Modal Add Product] Produit non trouvé:', productId);
            return null;
        }

        // Mode remplacement : refuser la variante déjà en cours d'abonnement
        // (même produit dans une AUTRE taille reste autorisé : c'est un usage légitime)
        if (swapContext && String(variantId) === String(swapContext.variantId)) {
            showNotification("C'est déjà le produit de votre abonnement. Choisissez-en un autre ou une autre taille.", 'error', 4000);
            return null;
        }

        const existingIndex = selectedProducts.findIndex(p => p.productId === productId);
        let added;

        if (existingIndex >= 0) {
            selectedProducts.splice(existingIndex, 1);
            added = false;
        } else {
            selectedProducts.push({ productId: productId, variantId: variantId, product: product });
            added = true;
        }

        console.log('[Modal Add Product] Sélection:', added ? 'ajouté' : 'retiré', { productId, variantId });

        syncListSelectionUI();
        updateSelectionCounter();
        showConfirmButtons();
        return added;
    }

    function addProductToSelection(productId, buttonElement) {
        const product = window.shopifyAllProducts.find(p => p.id === productId);
        if (!product) {
            console.error('[Modal Add Product] Produit non trouvé:', productId);
            return;
        }

        const productItem = buttonElement.closest('.product-item-modal');

        // Le choix du format se fait dans la fiche produit. Le bouton de la liste
        // est un raccourci : il prend la variante de référence (celle déjà dans la
        // box, sinon la moins chère) — plus `variants[0]`, qui n'était que l'ordre
        // du catalogue. Le `<select>` inline reste géré s'il existe encore.
        const variantSelector = productItem ? productItem.querySelector('.variant-selector') : null;
        const selectedVariantId = variantSelector
            ? parseInt(variantSelector.value, 10)
            : (defaultVariantFor(product) || {}).id || null;

        toggleProductSelection(productId, selectedVariantId);
    }

    // Fonction pour mettre à jour le compteur de sélection
    function updateSelectionCounter() {
        const count = selectedProducts.length;

        // Le compteur vit dans la barre du bas, avec le bouton de validation :
        // c'est là que le client regarde avant de valider, et c'est ce qui rend
        // le multi-ajout visible.
        //
        // L'ancienne version le rattachait à `getElementById('products-list-modal')`
        // — or `products-list-modal` est une CLASSE, l'id étant
        // `products-list-container`. Le lookup renvoyait null et les deux branches
        // d'insertion exigeaient sa présence : l'élément était créé puis jeté, le
        // compteur ne s'est jamais affiché.
        const bar = document.getElementById('confirm-buttons-container');
        let counterElement = document.getElementById('selection-counter');

        if (!counterElement && bar) {
            counterElement = document.createElement('div');
            counterElement.id = 'selection-counter';
            counterElement.className = 'selection-counter';
            counterElement.setAttribute('aria-live', 'polite');
            bar.insertBefore(counterElement, bar.firstChild);
        }

        // Le compte est désormais DANS le libellé du bouton. Cette ligne ne sert
        // plus qu'aux lecteurs d'écran : elle reste dans le flux d'accessibilité
        // (`aria-live`) mais sort du flux visuel, sinon elle répète mot pour mot ce
        // que le bouton juste en dessous annonce déjà.
        if (counterElement) {
            counterElement.textContent = count > 0
                ? `${count} produit${count > 1 ? 's' : ''} sélectionné${count > 1 ? 's' : ''}`
                : '';
        }

        const btnValidate = document.getElementById('btn-validate-product');
        if (btnValidate && !btnValidate.disabled) {
            btnValidate.textContent = validateButtonLabel(count);
        }
    }

    // Un bouton doit dire ce qu'il fait, pas « Valider » dans le vide. Le compte y
    // figure : c'est la dernière chose lue avant le clic, et la seule qui rende le
    // multi-ajout visible maintenant que le compteur est masqué visuellement.
    function validateButtonLabel(count) {
        if (swapContext) return 'Valider le remplacement';
        if (count > 1) return `Valider l'ajout de ${count} produits`;
        return "Valider l'ajout du produit";
    }

    // Fonction pour créer/afficher les boutons Valider/Annuler
    function showConfirmButtons() {
        // Vérifier si les boutons existent déjà
        let confirmButtonsContainer = document.getElementById('confirm-buttons-container');

        if (!confirmButtonsContainer) {
            // Créer le conteneur des boutons
            confirmButtonsContainer = document.createElement('div');
            confirmButtonsContainer.id = 'confirm-buttons-container';
            confirmButtonsContainer.className = 'modal-actions';
            confirmButtonsContainer.innerHTML = `
                <button id="btn-validate-product" class="btn-modal btn-modal-primary">
                    Valider
                </button>
                <button id="btn-cancel-selection" class="btn-modal btn-modal-secondary">
                    Annuler
                </button>
            `;

            // Ajouter les boutons à la fin du modal-content
            const modalContent = addProductModal.querySelector('.modal-content');
            modalContent.appendChild(confirmButtonsContainer);

            // Attacher les événements
            document.getElementById('btn-validate-product').addEventListener('click', validateProductSelection);
            document.getElementById('btn-cancel-selection').addEventListener('click', cancelProductSelection);
        }

        // La barre n'apparaît qu'à partir du premier produit choisi. Elle était
        // affichée dès le rendu de la liste : « Valider l'ajout du produit »
        // s'offrait alors qu'aucun produit n'était sélectionné, et le clic ne
        // pouvait que tomber sur l'alerte « Veuillez sélectionner au moins un
        // produit ». Un bouton qui ne peut rien faire ne doit pas être là — il
        // mange en plus la hauteur de la liste, qui est la ressource rare ici.
        //
        // La condition est réévaluée à CHAQUE appel, donc la barre se referme
        // aussi toute seule quand on retire le dernier produit de la sélection.
        confirmButtonsContainer.style.display = selectedProducts.length > 0 ? 'flex' : 'none';

        // Le conteneur n'est créé qu'une fois : libellé ET compteur doivent être
        // réappliqués à chaque appel. updateSelectionCounter() porte les deux,
        // pour qu'ils ne puissent pas diverger.
        updateSelectionCounter();
    }

    // Fonction pour annuler la sélection
    function cancelProductSelection() {
        // Réinitialiser le tableau de sélection
        selectedProducts = [];
        swapContext = null;

        // Désélectionner tous les produits visuellement
        document.querySelectorAll('.product-item-modal').forEach(item => {
            item.classList.remove('selected');
        });

        // Vider le compteur (région aria-live masquée en CSS, cf. openAddProductModal)
        const counterElement = document.getElementById('selection-counter');
        if (counterElement) {
            counterElement.textContent = '';
        }

        // La sélection est vide : la barre doit se refermer. showConfirmButtons()
        // porte désormais la condition, on la laisse décider plutôt que de
        // dupliquer ici la règle d'affichage.
        showConfirmButtons();
        console.log('[Modal Add Product] Sélection annulée');
    }

    // Fonction pour valider et ajouter les produits sélectionnés à l'abonnement
    async function validateProductSelection() {
        if (!selectedProducts || selectedProducts.length === 0) {
            alert('Veuillez sélectionner au moins un produit');
            return;
        }

        // Mode remplacement : ajout puis suppression, via les chemins existants
        if (swapContext) {
            await executeProductSwap();
            return;
        }

        console.log(`[Modal Add Product] Validation ajout de ${selectedProducts.length} produit(s) en ${currentAddType}`, selectedProducts);

        // Si c'est un abonnement
        if (currentAddType === 'subscription') {
            // Vérifier si un abonnement actif existe déjà
            const hasActiveSubscription = window.rechargePortal &&
                window.rechargePortal.activeSubscriptions &&
                window.rechargePortal.activeSubscriptions.length > 0;

            if (hasActiveSubscription) {
                // Un abonnement existe déjà : ajouter les produits directement sans demander fréquence/date
                console.log('[Modal Add Product] ✅ Abonnement actif détecté, ajout direct des produits');

                const existingSubscription = window.rechargePortal.activeSubscriptions[0];
                const existingFrequency = existingSubscription.order_interval_frequency;
                const existingUnit = existingSubscription.order_interval_unit;
                const existingNextChargeDate = existingSubscription.next_charge_scheduled_at;

                console.log('[Modal Add Product] Utilisation des paramètres existants:', {
                    frequency: existingFrequency,
                    unit: existingUnit,
                    nextChargeDate: existingNextChargeDate
                });

                const btnValidate = document.getElementById('btn-validate-product');
                if (btnValidate) {
                    btnValidate.disabled = true;
                    btnValidate.textContent = 'Ajout en cours…';
                }

                // Ajouts séquentiels, chacun isolé. Chaque ligne créée l'est
                // RÉELLEMENT côté Recharge : on ne peut pas annuler les
                // précédentes si une suivante échoue. On tient donc le compte de
                // ce qui est passé, et on retire au fur et à mesure de la
                // sélection ce qui a réussi.
                //
                // Sans ça, un échec au 3e produit sur 5 laissait les deux premiers
                // créés, affichait une erreur muette sur le succès partiel, sautait
                // le rechargement des données (il était dans le même `try`), et un
                // second clic sur « Valider » réincrémentait les deux premiers via
                // le chemin `merged`. Double ajout silencieux.
                const succeeded = [];
                const failed = [];
                let mergedCount = 0;

                for (const selectedItem of selectedProducts) {
                    const productToAdd = {
                        ...selectedItem.product,
                        selectedVariantId: selectedItem.variantId
                    };
                    try {
                        console.log('[Modal Add Product] Ajout du produit:', productToAdd);
                        const result = await window.addProductToRechargeSubscription(
                            productToAdd,
                            existingFrequency,
                            existingNextChargeDate,
                            {
                                intervalUnit: existingUnit,
                                chargeIntervalFrequency: existingSubscription.charge_interval_frequency
                            }
                        );
                        if (result && result.merged) mergedCount++;
                        succeeded.push(selectedItem);
                    } catch (error) {
                        console.error('[Modal Add Product] Échec sur', selectedItem.product?.title, error);
                        failed.push({ item: selectedItem, error });
                    }
                }

                // La sélection ne garde que les échecs : recliquer « Valider » ne
                // peut donc plus recréer ni réincrémenter ce qui est déjà passé.
                selectedProducts = succeeded.length
                    ? selectedProducts.filter(item => !succeeded.includes(item))
                    : selectedProducts;
                syncListSelectionUI();
                updateSelectionCounter();

                // On rend la main AVANT de recharger. Les lignes existent déjà chez
                // Recharge : l'action du client est terminée, il n'a plus rien à
                // décider. Or la réconciliation qui suit enchaîne loadSubscriptions,
                // loadOnetimes, updateSubscriptionData puis syncChargeAfterMutation
                // (qui recharge la charge et peut repricer le relais) : quatre à six
                // allers-retours Recharge en série. Les attendre modale ouverte
                // laissait le client devant un bouton désactivé affichant
                // « Ajout d'un produit… » pendant toute la durée.
                if (failed.length === 0) {
                    showNotification(
                        mergedCount === succeeded.length
                            ? '✅ Quantité mise à jour dans votre abonnement !'
                            : `✅ ${succeeded.length} produit(s) ajouté(s) à votre abonnement !`,
                        'success',
                        4000
                    );
                    closeAddProductModal();
                } else if (succeeded.length > 0) {
                    // Succès partiel : on le dit explicitement et on laisse le modal
                    // ouvert avec les seuls produits en échec encore sélectionnés.
                    showNotification(
                        `${succeeded.length} produit(s) ajouté(s), ${failed.length} en échec. Les produits concernés sont toujours sélectionnés, vous pouvez réessayer.`,
                        'error',
                        7000
                    );
                } else {
                    showNotification(
                        `Aucun produit n'a pu être ajouté : ${failed[0].error?.message || 'erreur inconnue'}`,
                        'error',
                        6000
                    );
                }

                if (failed.length > 0 && btnValidate) {
                    btnValidate.disabled = false;
                    // Le libellé passe par le même helper que le compteur : la
                    // sélection ne contient plus que les échecs, il doit le refléter.
                    btnValidate.textContent = validateButtonLabel(selectedProducts.length);
                }

                // Réconciliation, une fois la main rendue. HORS du chemin d'erreur :
                // dès qu'une ligne a été créée, l'écran doit la refléter, même si une
                // autre a échoué. En succès complet la modale est déjà fermée, donc
                // le rendu se fait derrière ; en échec partiel elle est ouverte, et
                // c'est le portail derrière qui se met à jour.
                if (succeeded.length > 0) {
                    console.log('[Modal Add Product] Rechargement des données...');
                    try {
                        await window.rechargePortal.loadSubscriptions();
                        await window.rechargePortal.loadOnetimes();
                        window.rechargePortal.updateSubscriptionData();
                        // Charge queued : totaux + poids à jour, reprice relais si besoin
                        await window.rechargePortal.syncChargeAfterMutation();
                        console.log('[Modal Add Product] ✅ Interface mise à jour');
                    } catch (error) {
                        console.error('[Modal Add Product] Rechargement partiel:', error);
                    }
                }
                return;
            } else {
                // Pas d'abonnement actif : demander fréquence et date (flux normal)
                console.log('[Modal Add Product] ⚠️ Aucun abonnement actif, ouverture des modals fréquence/date');

                // Pour la création d'un nouvel abonnement, on ne peut ajouter qu'un seul produit à la fois
                // Si plusieurs produits sont sélectionnés, on prend le premier
                const firstProduct = selectedProducts[0];
                const productToAdd = {
                    ...firstProduct.product,
                    selectedVariantId: firstProduct.variantId
                };

                // Stocker le produit dans le contexte global AVANT de fermer
                window.subscriptionCreationContext.selectedProduct = productToAdd;
                console.log('[Modal Add Product] Produit stocké dans contexte global:', productToAdd);

                if (selectedProducts.length > 1) {
                    alert(`Note: Pour créer un nouvel abonnement, seul le premier produit sélectionné sera utilisé. Les autres produits peuvent être ajoutés après.`);
                }

                closeAddProductModal(false); // Ne PAS réinitialiser le produit, on passe au modal suivant
                openFrequencyModal();
                return;
            }
        }

    }

    // Fonction pour nettoyer les charges en erreur avant de créer un nouvel abonnement
    async function cleanupErrorCharges() {
        console.log('[Cleanup] Vérification des charges en erreur...');

        try {
            // Récupérer toutes les charges du client
            const chargesResponse = await window.recharge.charge.listCharges(
                window.rechargePortal.session,
                { status: 'error' }
            );

            if (chargesResponse && chargesResponse.charges && chargesResponse.charges.length > 0) {
                console.log('[Cleanup] ⚠️ Charges en erreur trouvées:', chargesResponse.charges.length);

                // Supprimer chaque charge en erreur
                for (const charge of chargesResponse.charges) {
                    try {
                        console.log('[Cleanup] Suppression de la charge en erreur:', charge.id);
                        await window.recharge.charge.deleteCharge(
                            window.rechargePortal.session,
                            charge.id
                        );
                        console.log('[Cleanup] ✅ Charge supprimée:', charge.id);
                    } catch (deleteError) {
                        console.warn('[Cleanup] ⚠️ Impossible de supprimer la charge:', charge.id, deleteError);
                    }
                }

                console.log('[Cleanup] ✅ Nettoyage des charges en erreur terminé');
            } else {
                console.log('[Cleanup] ✅ Aucune charge en erreur trouvée');
            }
        } catch (error) {
            console.warn('[Cleanup] ⚠️ Erreur lors de la vérification des charges:', error);
            // On ne bloque pas la création de l'abonnement si la vérification échoue
        }
    }

    // Fonction pour ajouter un produit à l'abonnement Recharge (GLOBALE pour accès depuis tous les modals)
    // Ouvre le catalogue en mode remplacement pour une ligne d'abonnement donnée.
    // Exposé globalement : appelé depuis handleAction() et depuis le garde-fou de
    // deleteSubscriptionProduct().
    window.openSwapProductModal = async function (subscriptionId) {
        const portal = window.rechargePortal;
        const subscription = portal?.activeSubscriptions?.find(sub => sub.id == subscriptionId);

        if (!subscription) {
            console.error('[Modal Swap] Subscription introuvable:', subscriptionId);
            showNotification('❌ Produit introuvable. Rechargez la page.', 'error');
            return;
        }

        swapContext = {
            subscriptionId: subscription.id,
            productTitle: subscription.product_title || subscription.shopify_product_title || 'votre produit',
            variantId: subscription.external_variant_id?.ecommerce || null,
            quantity: subscription.quantity || 1
        };

        console.log('[Modal Swap] Ouverture en mode remplacement:', swapContext);
        await openAddProductModal('subscription', { keepSwapContext: true });
    };

    // Remplacement d'un produit = ajout PUIS suppression, dans cet ordre.
    // L'inverse exposerait une fenêtre à zéro abonnement, exactement ce qu'on cherche à éviter.
    // Aucun appel API propre : on réutilise addProductToRechargeSubscription() et
    // deleteSubscriptionProduct(), qui gèrent déjà rechargements, sync de charge et toasts.
    async function executeProductSwap() {
        const portal = window.rechargePortal;
        const ctx = swapContext;
        const selection = [...selectedProducts];
        const oldSubscription = portal?.activeSubscriptions?.find(sub => sub.id == ctx.subscriptionId);

        if (selection.length === 0 || !oldSubscription) {
            console.error('[Modal Swap] Sélection ou abonnement source invalide');
            showNotification('❌ Sélection invalide. Rechargez la page.', 'error');
            return;
        }

        const newTitles = selection.map(item => item.product.title);
        const newLabel = newTitles.length === 1
            ? `« ${newTitles[0]} »`
            : `${newTitles.length} produits`;

        const btnValidate = document.getElementById('btn-validate-product');
        if (btnValidate) {
            btnValidate.disabled = true;
            btnValidate.textContent = 'Remplacement en cours...';
        }

        // 1. AJOUT : même boucle que "Ajouter un produit", en héritant fréquence et date.
        // Un produit peut être remplacé par plusieurs (le client répartit sa ration
        // entre deux références, par exemple).
        // La quantité de l'ancienne ligne n'est reportée que sur un remplacement
        // 1 pour 1 : la répartir entre plusieurs produits n'aurait pas de sens.
        // Elle est passée à la création (et non corrigée après) pour rester juste
        // quand le produit choisi est déjà dans la box : l'ajout devient alors un
        // incrément, qu'un update ultérieur écraserait.
        const quantityToCarry = selection.length === 1 ? (ctx.quantity || 1) : 1;
        const created = [];
        try {
            for (const item of selection) {
                created.push(await window.addProductToRechargeSubscription(
                    { ...item.product, selectedVariantId: item.variantId },
                    oldSubscription.order_interval_frequency,
                    oldSubscription.next_charge_scheduled_at,
                    {
                        quantity: quantityToCarry,
                        // L'unité suit la fréquence : un abonnement en 28 jours doit
                        // rester en jours, pas devenir 28 semaines.
                        intervalUnit: oldSubscription.order_interval_unit,
                        chargeIntervalFrequency: oldSubscription.charge_interval_frequency
                    }
                ));
            }
        } catch (error) {
            console.error('[Modal Swap] Échec de la création, ancien produit conservé:', error);
            if (btnValidate) {
                btnValidate.disabled = false;
                btnValidate.textContent = validateButtonLabel(selectedProducts.length);
            }
            // Échec au 1er produit : rien n'a changé. Échec au Nième : les précédents
            // sont créés, mais l'ancien produit n'est PAS supprimé — jamais de fenêtre à zéro.
            const partial = created.length > 0
                ? ` ${created.length} produit(s) ont été ajoutés, « ${ctx.productTitle} » est conservé.`
                : ' Votre abonnement n\'a pas été modifié.';
            showNotification(`❌ Le remplacement n'a pas abouti.${partial}`, 'error', 8000);
            await portal.loadSubscriptions();
            portal.updateSubscriptionData();
            return;
        }

        // 2. SUPPRESSION de l'ancienne ligne via le chemin existant (force : c'est un
        // remplacement, pas une sortie d'abonnement). Un échec ici laisse deux lignes
        // actives : la corbeille réapparaît et le client peut retirer l'ancienne.
        closeAddProductModal();
        await portal.deleteSubscriptionProduct(null, {
            subscriptionId: ctx.subscriptionId,
            skipConfirm: true,
            force: true,
            cancellationReason: 'Remplacement produit',
            cancellationComments: `Remplacé par ${newTitles.join(', ')} via le portail`,
            successMessage: `✅ « ${ctx.productTitle} » a été remplacé par ${newLabel}`,
            errorMessage: `⚠️ ${newLabel} bien ajouté, mais « ${ctx.productTitle} » n'a pas pu être retiré. Vous pouvez le supprimer manuellement.`
        });
    }

    // `intervalFrequency` s'interprète dans l'unité `options.intervalUnit`
    // ('week' par défaut : les fréquences proposées par le portail sont en semaines).
    // Un appelant qui hérite d'un abonnement existant DOIT passer son
    // `order_interval_unit`, sinon l'unité d'origine est écrasée.
    // `options.chargeIntervalFrequency` ne sert qu'aux abonnements prépayés, où le
    // rythme de prélèvement diffère du rythme de livraison. Par défaut les deux
    // sont alignés, ce qui est le cas de tous les abonnements standard.
    window.addProductToRechargeSubscription = async function (product, intervalFrequency = null, nextChargeDate = null, options = {}) {
        const quantityToAdd = Math.max(1, parseInt(options.quantity, 10) || 1);
        const intervalUnit = options.intervalUnit || 'week';
        const chargeIntervalFrequency = options.chargeIntervalFrequency || intervalFrequency;

        console.log('[Modal Add Product] Ajout à Recharge:', product);
        console.log(`[Modal Add Product] Fréquence demandée: ${intervalFrequency} (${intervalUnit})`);
        console.log('[Modal Add Product] Date personnalisée:', nextChargeDate);
        console.log('[Modal Add Product] Quantité à ajouter:', quantityToAdd);
        console.log('[Modal Add Product] SDK Recharge disponible:', window.recharge);

        if (!window.rechargePortal || !window.rechargePortal.session) {
            throw new Error('Session Recharge non disponible');
        }

        // IMPORTANT: Nettoyer les charges en erreur AVANT de créer un nouvel abonnement
        await cleanupErrorCharges();

        // Récupérer la première subscription active (si elle existe)
        const subscriptions = window.rechargePortal.activeSubscriptions;
        const subscription = subscriptions && subscriptions.length > 0 ? subscriptions[0] : null;

        // Trouver le variant ID Shopify
        // IMPORTANT : Utiliser selectedVariantId si présent, sinon prendre la première variante
        const variantId = product.selectedVariantId || (product.variants && product.variants.length > 0 ? product.variants[0].id : null);
        if (!variantId) {
            throw new Error('Aucun variant trouvé pour ce produit');
        }

        console.log('[Modal Add Product] Variant ID sélectionné:', variantId);

        // Variante DÉJÀ dans la box : on incrémente la ligne existante au lieu d'en
        // créer une seconde. Deux lignes pour le même variant sont illisibles côté
        // client, et les remises par quantité ne s'appliqueraient pas sur le total.
        // Même appel que les boutons +/- de la ligne produit (updateQuantity).
        const existingLine = (subscriptions || []).find(sub =>
            String(sub.external_variant_id?.ecommerce || sub.shopify_variant_id || '') === String(variantId)
        );

        if (existingLine) {
            const mergedQuantity = (existingLine.quantity || 1) + quantityToAdd;
            console.log(`[Modal Add Product] Variant déjà présent (subscription ${existingLine.id}) : quantité ${existingLine.quantity} → ${mergedQuantity}`);

            const mergeResponse = await window.recharge.subscription.updateSubscription(
                window.rechargePortal.session,
                existingLine.id,
                { quantity: mergedQuantity }
            );

            console.log('[Modal Add Product] ✅ Quantité incrémentée sur la ligne existante:', mergeResponse);
            // `merged` : l'appelant peut adapter son message (aucune ligne créée).
            return { ...mergeResponse, merged: true };
        }

        // Trouver l'objet complet de la variante sélectionnée
        const selectedVariant = product.variants.find(v => v.id == variantId) || product.variants[0];
        console.log('[Modal Add Product] Variante sélectionnée:', selectedVariant);

        // Déterminer les paramètres de la subscription
        let subscriptionParams;

        if (subscription) {
            // CAS 1 : Subscription active existe - Utiliser ses paramètres (ou la fréquence choisie)
            console.log('[Modal Add Product] Utilisation des paramètres de la subscription existante');

            if (intervalFrequency) {
                // Si une fréquence a été choisie, l'utiliser
                let computedNextChargeDate;

                if (nextChargeDate) {
                    // Si une date a été choisie par l'utilisateur, l'utiliser
                    computedNextChargeDate = new Date(nextChargeDate);
                    console.log('[Modal Add Product] Utilisation de la date choisie:', nextChargeDate);
                } else {
                    // Sinon, calculer automatiquement (date actuelle + fréquence)
                    computedNextChargeDate = addInterval(new Date(), intervalFrequency, intervalUnit);
                    console.log('[Modal Add Product] Calcul automatique de la date');
                }

                subscriptionParams = {
                    address_id: subscription.address_id,
                    order_interval_unit: intervalUnit,
                    order_interval_frequency: intervalFrequency,
                    charge_interval_frequency: chargeIntervalFrequency,
                    next_charge_scheduled_at: computedNextChargeDate.toISOString()
                };
                console.log('[Modal Add Product] Paramètres avec fréquence choisie:', subscriptionParams);
            } else {
                // Sinon, utiliser les paramètres existants
                subscriptionParams = {
                    address_id: subscription.address_id,
                    order_interval_unit: subscription.order_interval_unit,
                    order_interval_frequency: subscription.order_interval_frequency,
                    charge_interval_frequency: subscription.charge_interval_frequency,
                    next_charge_scheduled_at: subscription.next_charge_scheduled_at
                };
            }
        } else {
            // CAS 2 : Aucune subscription active - Créer avec fréquence choisie ou valeur par défaut
            console.log('[Modal Add Product] Aucune subscription active - Création nouvelle subscription');

            // Récupérer l'adresse du client
            const addresses = window.rechargePortal.addresses;
            if (!addresses || addresses.length === 0) {
                throw new Error('Aucune adresse trouvée. Veuillez d\'abord configurer une adresse de livraison.');
            }

            const address = addresses[0];

            if (intervalFrequency) {
                // Utiliser la fréquence choisie par l'utilisateur
                let computedNextChargeDate;

                if (nextChargeDate) {
                    // Si une date a été choisie par l'utilisateur, l'utiliser
                    computedNextChargeDate = new Date(nextChargeDate);
                    console.log('[Modal Add Product] Utilisation de la date choisie:', nextChargeDate);
                } else {
                    // Sinon, calculer automatiquement (date actuelle + fréquence)
                    computedNextChargeDate = addInterval(new Date(), intervalFrequency, intervalUnit);
                    console.log('[Modal Add Product] Calcul automatique de la date');
                }

                subscriptionParams = {
                    address_id: address.id,
                    order_interval_unit: intervalUnit,
                    order_interval_frequency: intervalFrequency,
                    charge_interval_frequency: chargeIntervalFrequency,
                    next_charge_scheduled_at: computedNextChargeDate.toISOString()
                };
                console.log(`[Modal Add Product] Nouvelle subscription avec fréquence ${intervalFrequency} ${intervalUnit}`);
            } else {
                // Fallback : valeur par défaut 4 semaines (si jamais appelé sans fréquence)
                const nextChargeDate = new Date();
                nextChargeDate.setDate(nextChargeDate.getDate() + 28); // 4 semaines = 28 jours

                subscriptionParams = {
                    address_id: address.id,
                    order_interval_unit: 'week',
                    order_interval_frequency: 4,
                    charge_interval_frequency: 4,
                    next_charge_scheduled_at: nextChargeDate.toISOString()
                };
                console.log('[Modal Add Product] Nouvelle subscription avec fréquence par défaut (4 semaines)');
            }

            console.log('[Modal Add Product] Paramètres finaux:', subscriptionParams);
        }

        // Créer une nouvelle subscription pour ce produit
        console.log('[Modal Add Product] Création d\'une nouvelle subscription');

        const response = await window.recharge.subscription.createSubscription(
            window.rechargePortal.session,
            {
                ...subscriptionParams,
                external_variant_id: { ecommerce: String(variantId) },
                external_product_id: { ecommerce: String(product.id) },
                quantity: quantityToAdd,
                product_title: product.title,
                variant_title: selectedVariant.title || 'Default',
                price: (selectedVariant.price / 100).toFixed(2) // Prix de la variante sélectionnée
            }
        );

        console.log('[Modal Add Product] ✅ Nouvelle subscription créée:', response);
        return response;
    }


    // Événements : Ouvrir le modal
    //
    // Délégation sur le document, et non un listener par bouton : les points d'entrée
    // vivent maintenant dans des zones re-rendues par JS (la tuile en fin de grille
    // produits est réécrite à chaque renderSubscriptionProducts, les boutons des fiches
    // animaux à chaque renderPetsTab). Un listener attaché à l'élément mourrait avec lui.
    //
    // `data-portal-species` (facultatif) pré-positionne le filtre espèce du modal :
    // c'est ce qui rend « Ajouter un produit pour Pumpkin » différent d'un simple ajout.
    document.addEventListener('click', (event) => {
        // `?.` : ce handler tourne sur CHAQUE clic du portail. Une cible sans
        // `closest` (document, nœud détaché) y lèverait une TypeError à répétition.
        const trigger = event.target?.closest?.('[data-recharge-action="add-subscription-product"]');
        if (!trigger) return;
        event.preventDefault();

        // Lu tout de suite : le changement d'onglet peut re-rendre la zone et
        // détacher `trigger` avant que le setTimeout ci-dessous ne se déclenche.
        const animal = trigger.dataset.portalSpecies || '';
        const open = () => openAddProductModal('subscription', { animal });

        // Entrée depuis un autre onglet (Mes animaux) : on bascule d'abord sur
        // l'abonnement. Sans ça, le modal se referme après l'ajout sur une page qui
        // ne montre pas la box — le client n'a aucune confirmation visuelle de ce
        // qu'il vient d'acheter. Même délai que le lien de réactivation ci-dessous :
        // switchTab anime la bascule.
        const gotoTab = trigger.dataset.portalGotoTab;
        if (gotoTab && typeof window.switchTab === 'function') {
            window.switchTab(gotoTab);
            setTimeout(open, 300);
            return;
        }

        open();
    });

    // Lien "(en cliquant ici)" dans la bannière abonnement désactivé
    const linkResubscribeBanner = document.getElementById('link-resubscribe-banner');
    if (linkResubscribeBanner) {
        linkResubscribeBanner.addEventListener('click', (e) => {
            e.preventDefault();
            openAddProductModal('subscription');
        });
    }

    // Lien "Réactiver mon abonnement" depuis la tab accueil
    const linkReactivate = document.getElementById('link-reactivate-subscription');
    if (linkReactivate) {
        linkReactivate.addEventListener('click', (e) => {
            e.preventDefault();
            if (window.switchTab) {
                window.switchTab('abonnement');
            }
            // Ouvrir la modal d'ajout en mode abonnement après le changement de tab
            setTimeout(() => openAddProductModal('subscription'), 300);
        });
    }

    // Fonction pour demander confirmation avant de fermer le modal
    function confirmCloseAddProductModal() {
        // Si la vue de confirmation est déjà affichée, ne rien faire
        const confirmView = document.getElementById('close-confirm-view');
        if (confirmView && confirmView.style.display === 'flex') {
            return;
        }

        if (selectedProducts.length > 0) {
            showCloseConfirmationView();
        } else {
            closeAddProductModal();
        }
    }

    // Afficher la vue de confirmation dans le drawer
    function showCloseConfirmationView() {
        const modalContent = addProductModal.querySelector('.modal-content');
        if (!modalContent) return;

        // Masquer tout le modal-content et la croix de fermeture
        modalContent.style.display = 'none';
        if (btnCloseAddProduct) btnCloseAddProduct.style.display = 'none';

        // Créer ou afficher la vue de confirmation (sibling de modal-content)
        let confirmView = document.getElementById('close-confirm-view');
        if (!confirmView) {
            confirmView = document.createElement('div');
            confirmView.id = 'close-confirm-view';
            confirmView.className = 'close-confirm-view';
            confirmView.innerHTML = `
                <h2 class="close-confirm-title">Souhaitez-vous valider vos changements ?</h2>
                <button id="btn-confirm-validate" class="btn-modal btn-modal-primary close-confirm-validate">Valider mes changements</button>
                <a href="#" id="link-cancel-changes" class="close-confirm-cancel-link">Ne pas valider mes changements</a>
            `;
            addProductModal.appendChild(confirmView);

            document.getElementById('btn-confirm-validate').addEventListener('click', function() {
                hideCloseConfirmationView();
                // Déclencher la validation (clic sur le bouton Valider existant)
                const validateBtn = document.getElementById('btn-validate-product');
                if (validateBtn) {
                    validateBtn.click();
                }
            });

            document.getElementById('link-cancel-changes').addEventListener('click', function(e) {
                e.preventDefault();
                hideCloseConfirmationView();
                closeAddProductModal();
            });
        }

        confirmView.style.display = 'flex';
    }

    // Restaurer le contenu du drawer
    function hideCloseConfirmationView() {
        const modalContent = addProductModal.querySelector('.modal-content');
        if (!modalContent) return;

        const confirmView = document.getElementById('close-confirm-view');
        if (confirmView) {
            confirmView.style.display = 'none';
        }

        // Restaurer le modal-content et la croix de fermeture
        modalContent.style.display = '';
        if (btnCloseAddProduct) btnCloseAddProduct.style.display = '';
    }

    // Événements : Fermer le modal
    if (btnCloseAddProduct) {
        btnCloseAddProduct.addEventListener('click', function() {
            // Si la vue de confirmation est affichée, fermer directement
            const confirmView = document.getElementById('close-confirm-view');
            if (confirmView && confirmView.style.display === 'flex') {
                hideCloseConfirmationView();
                closeAddProductModal();
            } else {
                confirmCloseAddProductModal();
            }
        });
    }

    if (modalOverlay) {
        modalOverlay.addEventListener('click', confirmCloseAddProductModal);
    }

    // ==========================================
    // MODAL: Sélection de fréquence
    // ==========================================
    const frequencyModal = document.getElementById('frequency-modal');
    const btnCloseFrequency = document.getElementById('close-frequency-modal');
    const frequencyOptions = document.querySelectorAll('.frequency-option');

    // Fonction pour ouvrir la modal de fréquence
    function openFrequencyModal() {
        console.log('[Frequency Modal] Ouverture de la modal de sélection de fréquence');

        // IMPORTANT : Marquer qu'on est en mode création dès l'ouverture
        if (window.subscriptionCreationContext.selectedProduct) {
            window.subscriptionCreationContext.isCreatingNewSubscription = true;
            console.log('[Frequency Modal] Mode création activé');
        }

        // Un seul modal pour deux flux : à la création, les boutons de validation
        // n'ont pas de sens (un clic sur une option enchaîne directement sur le
        // calendrier). Ils sont masqués par .mode-creation.
        //
        // On teste `selectedProduct`, PAS `isCreatingNewSubscription` : c'est la
        // condition exacte qu'utilise le listener des options plus bas. Les deux
        // doivent rester d'accord, sinon on masquerait les boutons de validation
        // alors que le clic sur une option n'enchaîne pas — modal sans issue.
        setFrequencyModalMode(!!window.subscriptionCreationContext.selectedProduct);

        // Réinitialiser : aucune fréquence pré-sélectionnée
        // L'utilisateur DOIT cliquer sur une option pour continuer
        document.querySelectorAll('.frequency-option').forEach(opt => opt.classList.remove('selected'));
        window.subscriptionCreationContext.selectedFrequency = null;
        console.log('[Frequency Modal] Aucune fréquence pré-sélectionnée');

        frequencyModal.classList.add('active');
        modalOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    // Fonction pour fermer la modal de fréquence
    function closeFrequencyModal(resetContext = false) {
        console.log('[Frequency Modal] Fermeture de la modal de fréquence');
        frequencyModal.classList.remove('active');
        modalOverlay.classList.remove('active');
        document.body.style.overflow = '';

        // Désélectionner visuellement toutes les options de fréquence
        document.querySelectorAll('.frequency-option').forEach(opt => {
            opt.classList.remove('selected');
        });
        console.log('[Frequency Modal] Sélections visuelles nettoyées');

        // Réinitialiser le contexte de création uniquement si demandé explicitement
        // (par exemple si l'utilisateur clique sur X ou Annuler)
        if (resetContext && window.subscriptionCreationContext && window.subscriptionCreationContext.isCreatingNewSubscription) {
            console.log('[Frequency Modal] Réinitialisation du contexte de création (modal fermé sans validation)');
            window.subscriptionCreationContext.selectedProduct = null;
            window.subscriptionCreationContext.selectedFrequency = null;
            window.subscriptionCreationContext.isCreatingNewSubscription = false;
        }
    }

    // Event listener pour le bouton de fermeture
    if (btnCloseFrequency) {
        btnCloseFrequency.addEventListener('click', () => closeFrequencyModal(true)); // Reset context si on ferme manuellement
    }

    // Event listeners pour les boutons de fréquence
    frequencyOptions.forEach(btn => {
        btn.addEventListener('click', function () {
            const frequency = parseInt(this.getAttribute('data-frequency'));
            console.log(`[Frequency Modal] Fréquence sélectionnée: ${frequency} semaines`);

            // Vérifier que ce listener ne doit s'exécuter QUE si on est en mode création
            // (c'est-à-dire qu'on vient du modal d'ajout de produit)
            const selectedProduct = window.subscriptionCreationContext.selectedProduct;
            if (!selectedProduct) {
                console.log('[Frequency Modal] Pas de produit sélectionné, mode modification normale');
                return; // Ne pas continuer si pas de produit (mode modification normale)
            }

            // Stocker la fréquence dans le contexte global
            window.subscriptionCreationContext.selectedFrequency = frequency;
            window.subscriptionCreationContext.isCreatingNewSubscription = true;

            console.log('[Frequency Modal] Contexte global mis à jour:', window.subscriptionCreationContext);

            // Fermer le modal de fréquence
            closeFrequencyModal();

            // Ouvrir le modal de date pour que le client choisisse sa date de première livraison
            console.log('[Frequency Modal] Ouverture du modal de date pour choisir la date de livraison');
            const shipmentModal = document.getElementById('shipment-date-modal');
            const shipmentOverlay = document.getElementById('modal-overlay');

            if (shipmentModal) {
                // Réinitialise l'état ET l'affichage du calendrier AVANT d'ouvrir
                window.openShipmentCalendar?.();
                console.log('[Frequency Modal] Calendrier réinitialisé avant ouverture');

                shipmentModal.classList.add('active');
                if (shipmentOverlay) {
                    shipmentOverlay.classList.add('active');
                }
                document.body.style.overflow = 'hidden';

                // Mettre à jour le titre du modal pour indiquer qu'on choisit la première livraison
                const modalTitle = shipmentModal.querySelector('.modal-title');
                if (modalTitle) {
                    modalTitle.textContent = 'Choisir ma date de première livraison';
                }

                // Seul le LIBELLÉ change — cf. commentaire du flux jumeau plus haut :
                // réécrire le paragraphe entier supprimerait le span de la date.
                const modalLabel = shipmentModal.querySelector('[data-recharge="delivery_date_label"]');
                if (modalLabel) {
                    modalLabel.textContent = 'Première livraison :';
                }
            }
        });
    });

    console.log('[Modal Add Product] Initialisation terminée');
});

// ==========================================
// CHRONOPOST SHOP2SHOP INTEGRATION - API VERCEL
// ==========================================

class ChronopostIntegration {
    constructor() {
        this.apiUrl = 'https://chronopost-shop2shop.vercel.app/api/get-places';
        this.map = null;
        this.markers = [];
        this.points = [];
        this.selectedPoint = null;
        this.infoWindow = null;
    }

    init() {
        console.log('[Chronopost] Initialisation...');
        this.waitForGoogleMaps().then(() => {
            this.setupEventListeners();
            console.log('[Chronopost] ✅ Prêt');
        });
    }

    waitForGoogleMaps() {
        return new Promise((resolve) => {
            if (window.google && window.google.maps) {
                resolve();
            } else {
                const checkInterval = setInterval(() => {
                    if (window.google && window.google.maps) {
                        clearInterval(checkInterval);
                        resolve();
                    }
                }, 100);
            }
        });
    }

    setupEventListeners() {
        const btnOpenChronopost = document.getElementById('btn-choose-pickup-point');
        if (btnOpenChronopost) {
            btnOpenChronopost.addEventListener('click', (e) => {
                e.preventDefault();
                this.openModal();
            });
        }

        const closeBtn = document.querySelector('.chronopost-modal-close');
        if (closeBtn) {
            closeBtn.addEventListener('click', () => this.closeModal());
        }

        const overlay = document.querySelector('.chronopost-modal-overlay');
        if (overlay) {
            overlay.addEventListener('click', () => this.closeModal());
        }

        const searchBtn = document.getElementById('chronopost-search-btn');
        if (searchBtn) {
            searchBtn.addEventListener('click', () => this.searchPoints());
        }

        ['chronopost-city', 'chronopost-postal'].forEach(id => {
            const input = document.getElementById(id);
            if (input) {
                input.addEventListener('keypress', (e) => {
                    if (e.key === 'Enter') this.searchPoints();
                });
            }
        });

        const validateBtn = document.getElementById('chronopost-validate-btn');
        if (validateBtn) {
            validateBtn.addEventListener('click', () => this.validateSelection());
        }
    }

    openModal() {
        const modal = document.getElementById('chronopost-modal');
        if (modal) {
            modal.style.display = 'flex';
            document.body.style.overflow = 'hidden';
            setTimeout(() => {
                this.initMap();
                this.searchPoints();
            }, 100);
        }
    }

    // `validated` : fermeture après choix d'un point (validateSelection). Toute
    // autre fermeture (X, overlay) alors que le mode est Point relais et que
    // l'adresse n'est pas un relais déclenche le rappel IMMÉDIATEMENT — sans
    // cela, aucun signal avant la prochaine session (garde once-per-session).
    closeModal(validated = false) {
        const modal = document.getElementById('chronopost-modal');
        if (modal) {
            modal.style.display = 'none';
            document.body.style.overflow = '';
        }
        if (!validated && window.rechargePortal) {
            window.rechargePortal._relayReminderShown = false;
            window.rechargePortal.warnIfPickupWithoutRelay();
        }
    }

    initMap() {
        if (this.map) return;

        const mapElement = document.getElementById('chronopost-map');
        if (!mapElement) return;

        this.map = new google.maps.Map(mapElement, {
            center: { lat: 48.8566, lng: 2.3522 },
            zoom: 13,
            styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }]
        });

        this.infoWindow = new google.maps.InfoWindow();
        console.log('[Chronopost] Carte initialisée');
    }

    async searchPoints() {
        const city = document.getElementById('chronopost-city').value.trim();
        const postalCode = document.getElementById('chronopost-postal').value.trim();

        if (!city || !postalCode) {
            alert('Veuillez renseigner la ville et le code postal');
            return;
        }

        const loading = document.getElementById('chronopost-loading');
        if (loading) loading.style.display = 'flex';

        console.log('[Chronopost] Recherche:', { city, postalCode });

        try {
            const response = await fetch(this.apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ city, postalCode })
            });

            const data = await response.json();
            console.log('[Chronopost] Résultats:', data);

            if (data.points && data.points.length > 0) {
                this.points = data.points;
                this.displayPoints();
                this.updateResultsCount(data.points.length);
            } else {
                alert('Aucun point relais trouvé pour cette recherche');
                this.updateResultsCount(0);
            }
        } catch (error) {
            console.error('[Chronopost] Erreur:', error);
            alert('Erreur lors de la recherche des points relais');
        } finally {
            if (loading) loading.style.display = 'none';
        }
    }

    displayPoints() {
        this.markers.forEach(marker => marker.setMap(null));
        this.markers = [];

        const container = document.getElementById('chronopost-points-container');
        if (container) container.innerHTML = '';

        if (this.points.length === 0) return;

        const bounds = new google.maps.LatLngBounds();

        this.points.forEach((point, index) => {
            const position = { lat: point.lat, lng: point.lng };
            const marker = new google.maps.Marker({
                position,
                map: this.map,
                title: point.nom,
                label: { text: String(index + 1), color: 'white', fontWeight: 'bold' },
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 20,
                    fillColor: '#47605B',
                    fillOpacity: 1,
                    strokeColor: 'white',
                    strokeWeight: 3
                }
            });

            marker.addListener('click', () => {
                this.selectPoint(point, marker);
            });

            this.markers.push(marker);
            bounds.extend(position);

            this.createPointCard(point, index, marker);
        });

        this.map.fitBounds(bounds);
    }

    createPointCard(point, index, marker) {
        const container = document.getElementById('chronopost-points-container');
        if (!container) return;

        const card = document.createElement('div');
        card.className = 'chronopost-point-card';
        card.dataset.pointId = point.id;

        card.innerHTML = `
            <div class="chronopost-point-name">${index + 1}. ${point.nom}</div>
            <div class="chronopost-point-address">
                ${point.adresse}<br>
                ${point.cp} ${point.ville}
            </div>
            <div class="chronopost-point-distance">
                📍 ${point.distance_km ? point.distance_km.toFixed(2) + ' km' : 'Distance inconnue'}
            </div>
        `;

        card.addEventListener('click', () => {
            this.selectPoint(point, marker);
            this.map.panTo({ lat: point.lat, lng: point.lng });
            this.map.setZoom(15);
        });

        container.appendChild(card);
    }

    selectPoint(point, marker) {
        this.selectedPoint = point;

        document.querySelectorAll('.chronopost-point-card').forEach(card => {
            card.classList.remove('selected');
        });
        const selectedCard = document.querySelector(`[data-point-id="${point.id}"]`);
        if (selectedCard) {
            selectedCard.classList.add('selected');
        }

        const validateBtn = document.getElementById('chronopost-validate-btn');
        if (validateBtn) {
            validateBtn.disabled = false;
        }

        if (this.infoWindow) {
            this.infoWindow.setContent(`
                <div style="padding: 8px; max-width: 250px;">
                    <h3 style="margin: 0 0 8px 0; color: #47605B;">${point.nom}</h3>
                    <p style="margin: 0 0 4px 0; font-size: 13px;">${point.adresse}</p>
                    <p style="margin: 0; font-size: 13px;">${point.cp} ${point.ville}</p>
                </div>
            `);
            this.infoWindow.open(this.map, marker);
        }

        console.log('[Chronopost] Point sélectionné:', point);
    }

    updateResultsCount(count) {
        const header = document.getElementById('chronopost-results-count');
        if (header) {
            header.textContent = count > 0
                ? `${count} point${count > 1 ? 's' : ''} relais disponible${count > 1 ? 's' : ''}`
                : 'Aucun point relais trouvé';
        }
    }

    validateSelection() {
        if (!this.selectedPoint) return;

        console.log('[Chronopost] Validation du point:', this.selectedPoint);

        // Stocker le point sélectionné globalement
        window.selectedChronopostPoint = this.selectedPoint;

        // NOTE: on ne pose PLUS de titre de mode à la main ici. Le titre affiché
        // vient de la charge Recharge (applyShippingMethodDisplay), déjà mis à jour
        // par applyShippingType('pickup'). Choisir le point ne change que l'adresse,
        // pas la shipping_line -> pas de réécriture du mode (évite la divergence).
        const deliveryAddressEl = document.querySelector('[data-recharge="delivery_address"]');
        if (deliveryAddressEl) {
            deliveryAddressEl.innerHTML = `
                <strong>${this.selectedPoint.nom}</strong><br>
                ${this.selectedPoint.adresse}<br>
                ${this.selectedPoint.cp} ${this.selectedPoint.ville}
            `;
        }

        // Fermer le modal (validated : un point a été choisi, pas de rappel)
        this.closeModal(true);

        // Appeler la sauvegarde avec un délai pour éviter les conflits
        console.log('[Chronopost] Programmation de la sauvegarde...');
        setTimeout(() => {
            this.saveToRecharge();
        }, 1000);
    }

    async saveToRecharge() {
        const point = window.selectedChronopostPoint;
        if (!point) {
            console.error('[Chronopost] Aucun point à sauvegarder');
            return;
        }

        console.log('[Chronopost] Sauvegarde du point:', point);

        // Vérifier que window.rechargePortal existe
        if (!window.rechargePortal) {
            console.error('[Chronopost] ❌ window.rechargePortal non disponible');
            alert('Erreur: Session Recharge non disponible');
            return;
        }

        const session = window.rechargePortal.session;
        const address = window.rechargePortal.addresses?.[0];

        if (!session || !address) {
            console.error('[Chronopost] ❌ Données Recharge manquantes');
            alert('Erreur: Données non disponibles');
            return;
        }

        const addressId = address.id;
        console.log('[Chronopost] Address ID:', addressId);

        try {
            // Préparer les données pour Recharge
            const updateData = {
                first_name: address.first_name,
                last_name: address.last_name,
                phone: address.phone,
                // Nom ET code : le transporteur identifie le relais par son code.
                // Sans lui, le colis arrive à une adresse que le réseau lit comme
                // un domicile et n'est pas déposé. Le suffixe "- Point Relais
                // Chronopost" nomme explicitement le réseau sur la ligne société,
                // là où le préparateur la lit : "NOM DU MAG (CODE) - Point Relais
                // Chronopost".
                company: `${point.id ? `${point.nom} (${point.id})` : point.nom} - Point Relais Chronopost`,
                address1: point.adresse,
                address2: 'Point Relais Chronopost',
                city: point.ville,
                province: address.province || '',
                zip: point.cp,
                country_code: address.country_code || 'FR'
            };

            console.log('[Chronopost] Données à envoyer:', updateData);

            // Appeler l'API Recharge pour mettre à jour l'adresse
            console.log('[Chronopost] Appel updateAddress...');
            const response = await window.recharge.address.updateAddress(session, addressId, updateData);
            console.log('[Chronopost] ✅ Réponse API:', response);

            // Rafraîchir les données après un court délai
            setTimeout(async () => {
                console.log('[Chronopost] Rafraîchissement des données...');
                await window.rechargePortal.loadAddresses();
                await window.rechargePortal.updateUI();
                console.log('[Chronopost] ✅ Point relais sauvegardé dans Recharge');
            }, 500);

            showNotification('✅ Point relais enregistré avec succès !', 'success', 4000);

        } catch (error) {
            if (window.rechargePortal?.handleAuthError(error)) return;
            console.error('[Chronopost] ❌ Erreur lors de la sauvegarde:', error);
            console.error('[Chronopost] Message:', error.message);

            // Afficher notification d'erreur
            let errorMessage = '❌ Erreur lors de l\'enregistrement. ';
            if (error.errors) {
                errorMessage += Object.values(error.errors).flat().join(', ');
            } else if (error.error) {
                errorMessage += error.error;
            } else {
                errorMessage += 'Veuillez réessayer.';
            }

            showNotification(errorMessage, 'error');
        }
    }
}

// ==========================================
// FONCTION ENVOI EMAIL MISE À JOUR PAIEMENT
// ==========================================

// Garde anti-spam de l'endpoint Vercel (chaque appel envoie un vrai email) :
// verrou pendant l'envoi + cooldown de 60s après un envoi réussi.
// Pire cas en cliquant frénétiquement : 1 appel réseau par minute.
let _paymentEmailInFlight = false;
let _paymentEmailCooldownUntil = 0;

// Applique un état visuel à TOUS les déclencheurs (bouton facturation + lien bandeau)
function setPaymentEmailTriggersState(disabled, label) {
    document.querySelectorAll('[data-recharge-action="send-payment-email"]').forEach(el => {
        if (el.tagName === 'BUTTON') {
            el.disabled = disabled;
        } else {
            el.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        }
        if (label) {
            if (!el.dataset.originalLabel) el.dataset.originalLabel = el.textContent;
            el.textContent = label;
        } else if (el.dataset.originalLabel) {
            el.textContent = el.dataset.originalLabel;
        }
    });
}

async function sendPaymentUpdateEmail() {
    console.log('[Payment Email] Envoi de l\'email de mise à jour du moyen de paiement...');

    if (_paymentEmailInFlight) {
        console.log('[Payment Email] ⏳ Envoi déjà en cours, clic ignoré');
        return;
    }
    if (Date.now() < _paymentEmailCooldownUntil) {
        console.log('[Payment Email] 🕐 Cooldown actif, clic ignoré');
        showNotification('📧 Email déjà envoyé ! Vérifiez votre boîte de réception (et vos spams).', 'success');
        return;
    }
    _paymentEmailInFlight = true;
    setPaymentEmailTriggersState(true, 'Envoi en cours...');

    try {
        // Récupérer le customer ID et l'address ID depuis le portail
        const rechargeCustomerId = window.rechargePortal?.customerId;
        const addressId = window.rechargePortal?.addresses?.[0]?.id;

        if (!rechargeCustomerId) {
            console.error('[Payment Email] ❌ Customer ID introuvable');
            showNotification('❌ Impossible de récupérer vos informations. Veuillez rafraîchir la page.', 'error');
            setPaymentEmailTriggersState(false, null);
            return;
        }

        if (!addressId) {
            console.error('[Payment Email] ❌ Address ID introuvable');
            showNotification('❌ Impossible de récupérer votre adresse. Veuillez réessayer.', 'error');
            setPaymentEmailTriggersState(false, null);
            return;
        }

        console.log('[Payment Email] 📧 Envoi de l\'email pour customer ID:', rechargeCustomerId, 'address ID:', addressId);

        // Afficher un message de chargement
        showNotification('📧 Envoi de l\'email en cours...', 'success');

        // Appel à l'API Vercel qui utilise Shopify Admin API avec scopes PCI Level 2
        const response = await fetch('https://recharge-payment-email-app.vercel.app/api/send-shopify-payment-email', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                recharge_customer_id: rechargeCustomerId
            })
        });

        const data = await response.json();
        console.log('[Payment Email] 📊 Réponse complète:', data);

        if (response.ok && data.success) {
            console.log('[Payment Email] ✅ Email envoyé avec succès');
            showNotification('✅ Email envoyé avec succès ! Vérifiez votre boîte de réception.', 'success');

            // Cooldown 60s : déclencheurs neutralisés, ré-activation UI différée
            _paymentEmailCooldownUntil = Date.now() + 60000;
            setPaymentEmailTriggersState(true, 'Email envoyé ✓');
            setTimeout(() => {
                setPaymentEmailTriggersState(false, null);
            }, 60000);
        } else {
            console.error('[Payment Email] ❌ Erreur API:', data);
            const errorMsg = data.message || data.error || data.details || 'Erreur inconnue';
            showNotification(`❌ Erreur: ${errorMsg}`, 'error');
            setPaymentEmailTriggersState(false, null);
        }

    } catch (error) {
        console.error('[Payment Email] ❌ Erreur:', error);
        showNotification('❌ Erreur lors de l\'envoi de l\'email. Veuillez réessayer.', 'error');
        setPaymentEmailTriggersState(false, null);
    } finally {
        _paymentEmailInFlight = false;
    }
}

// Fonction UNIQUE pour afficher les notifications toast.
// duration en ms ; 0 = notification persistante (pas de masquage auto).
// Le timer précédent est annulé à chaque appel : deux toasts rapprochés ne se
// masquent plus mutuellement au mauvais moment.
let _notificationHideTimer = null;
function showNotification(message, type = 'success', duration = 5000) {
    const notificationToast = document.getElementById('notification-toast');
    if (!notificationToast) {
        console.warn('[Notification] Toast element not found');
        return;
    }

    const notificationText = notificationToast.querySelector('.notification-text');
    if (!notificationText) {
        console.warn('[Notification] Text element not found');
        return;
    }

    // Retirer les anciennes classes
    notificationToast.classList.remove('show', 'success', 'error', 'info');

    // Définir le message
    notificationText.textContent = message;

    // Ajouter les nouvelles classes
    notificationToast.classList.add(type, 'show');

    // Masquer après `duration` ms (0 = persistant)
    if (_notificationHideTimer) {
        clearTimeout(_notificationHideTimer);
        _notificationHideTimer = null;
    }
    if (duration > 0) {
        _notificationHideTimer = setTimeout(() => {
            notificationToast.classList.remove('show');
        }, duration);
    }
}

// Initialiser Chronopost
window.chronopostIntegration = new ChronopostIntegration();

document.addEventListener('DOMContentLoaded', () => {
    console.log('[Chronopost] Initialisation au chargement...');
    setTimeout(() => {
        if (window.chronopostIntegration) {
            window.chronopostIntegration.init();
        }
    }, 500);

    // Event listener pour le bouton "Recevoir l'email" (mise à jour paiement)
    console.log('[Email Payment] Initialisation event listener...');

    // querySelectorAll : le déclencheur existe à deux endroits (bouton de la
    // card facturation + lien du bandeau paiement). Le débounce/cooldown est
    // géré dans sendPaymentUpdateEmail(), pas ici.
    const emailTriggers = document.querySelectorAll('[data-recharge-action="send-payment-email"]');
    if (emailTriggers.length > 0) {
        emailTriggers.forEach(trigger => {
            trigger.addEventListener('click', async (e) => {
                e.preventDefault();
                console.log('[Email Payment] Déclencheur cliqué');
                await sendPaymentUpdateEmail();
            });
        });
        console.log(`[Email Payment] ✅ ${emailTriggers.length} event listener(s) attaché(s)`);
    } else {
        console.warn('[Email Payment] ⚠️ Aucun déclencheur trouvé');
    }
});
